export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Represents the `ContentType` or `MIME-Type` of a file that is send over an http-request. */
  ContentType: { input: string; output: string; }
  /**
   * Represents a two-letter country-code that can be used to uniquely identify a country.
   *
   * Values of these type only contain uppercase letters.
   */
  CountryCode: { input: string; output: string; }
  /**
   * Cursors are strings that track the position of a pagination.
   *
   * They are usually defined on `Edge`-types and the `PageInfo`-type.
   */
  Cursor: { input: string|number; output: string; }
  /** A datetime string with format `Y-m-d H:i:s`, e.g. `2018-05-23 13:43:32`. */
  DateTime: { input: string; output: string; }
  /**
   * An time interval, expressed in English.
   *
   * Examples:
   * - `2 weeks`
   * - `1 day`
   * - `4 hours, 2 minutes`
   *
   * When this value is used as an output, it will be a string containing the millisecond in the interval.
   */
  DateTimeInterval: { input: string; output: string; }
  /**
   * A URL string containing the full URL to some external source.
   *
   * Examples:
   * - `https://shared.nl/`
   * - `https://graphql.org/`
   */
  Email: { input: string; output: string; }
  /** Keys that refer to external entities. */
  ExternalKey: { input: string; output: string; }
  /** The size of a file, as a string. It is formatted as `{value} {unit}`. */
  FileSize: { input: string; output: string; }
  /** A string containing an `HTML`-snippet. Can be included in an HTML-page. */
  HTML: { input: string; output: string; }
  /**
   * An opaque string that is (as good as) unique for every object in the database.
   *
   * `Hash` is similar to `ID`, only it cannot be used to retrieve an object from the server. Can be used
   * for cashing on the frontend.
   */
  Hash: { input: string; output: string; }
  /** Represents an IPv4 address with a standard string format (Example: `"127.0.0.1"`) */
  IpAddress: { input: string; output: string; }
  /** An arbitrary json value, unmanaged by GraphQL. */
  JSON: { input: unknown; output: unknown; }
  JoinExpression: { input: string|boolean|number|unknown[]; output: string; }
  KeyValuePairs: { input: Record<string, string|number|boolean>; output: Record<string, string|number|boolean>; }
  /** A string containing `LaTeX`-code. */
  LaTeX: { input: string; output: string; }
  /** A string containing `LaTeX`-math code. */
  LaTeXMath: { input: string; output: string; }
  MeetExpression: { input: string|boolean|number|unknown[]; output: string; }
  /**
   * Values that uniquely identify a record, similar to the `ID`-scalar type. The main difference is that
   * these values give a faithful representation of the primary key in the main database.
   *
   * These can be extremely useful during the development of the server and the GraphQL-API, as it is easy to
   * translate between the API and the database-records. However, they could also introduce security-holes if
   * used irresponsibly.
   *
   * Therefore, fields or arguments with this type **FOR DEBUG PURPOSES ONLY!**.
   * If the application is not running in *debug*-mode, it will immediately throw an exception when a value
   * of this type is resolved or read.
   */
  PK: { input: string; output: string; }
  /**
   * The `String` scalar type represents textual data, represented as UTF-8
   * character sequences. The String type is most often used by GraphQL to
   * represent free-form human-readable text.
   */
  Permission: { input: string; output: string; }
  /** An map between strings and predicate values. */
  PredicateValueMap: { input: Record<string, PredicateValue|string>; output: Record<string, PredicateValue>; }
  /** A string that contains a regular expression. */
  RegExp: { input: string; output: string; }
  /**
   * The `String` scalar type represents textual data, represented as UTF-8
   * character sequences. The String type is most often used by GraphQL to
   * represent free-form human-readable text.
   */
  Scope: { input: string; output: string; }
  /**
   * Slugs are *URL*- and *filename*-safe `String`s that can be used to identify an entity of a certain
   * type. They can be seen as a more *'human-readable'* alternative for the values of the build-in
   * `ID`-type.
   *
   * A slug string may only contain:
   *  - Numbers: `[0-9]`,
   *  - Lower-case letters: `[a-z]`,
   *  - The ASCII 'minus'-sign: `-`.
   *
   * Any input to an argument of this type will be converted to this format.
   *
   * See the `Sluggable`-interface and the `Sluggable.slug`-field for more information.
   */
  Slug: { input: string; output: string; }
  /**
   * An E-mail address string.
   *
   * Examples:
   * - `roel@shared.nl`
   */
  URL: { input: string; output: string; }
  /**
   * The `String` scalar type represents textual data, represented as UTF-8
   * character sequences. The String type is most often used by GraphQL to
   * represent free-form human-readable text.
   */
  UserAgent: { input: string; output: string; }
};

/**
 * Object that contains the information about an access-token used to query the GraphQL-API. It also provides some
 * entry points into the data-graph.
 */
export type AccessToken = {
  __typename: 'AccessToken';
  /** The client-roles associated with this token. */
  clientRoles?: Maybe<Array<ClientRole>>;
  /** Whether this access token has the provided permission. */
  hasPermission: Scalars['Boolean']['output'];
  /** Whether the provided role is associated with this token. */
  hasRole: Scalars['Boolean']['output'];
  /** Whether this `AccessToken` has an team associated with it. */
  hasTeam: Scalars['Boolean']['output'];
  /** Whether the `AccessToken` is associated with an user. */
  hasUser: Scalars['Boolean']['output'];
  /**
   * The job associated with this `AccessToken`.
   * @deprecated Tokens won't have jobs.
   */
  job?: Maybe<Job>;
  /** The permissions of this access token. */
  permissions?: Maybe<Array<Scalars['Permission']['output']>>;
  /** The roles associated with this token. */
  roles?: Maybe<Array<Role>>;
  /** The scopes of the current access token. */
  scopes?: Maybe<Array<Scalars['Scope']['output']>>;
  /** The current team of this `AccessToken`. */
  team?: Maybe<Team>;
  /** The roles that the `user` of this access token has in the `team` of this access token. */
  teamRoles?: Maybe<Array<TeamRole>>;
  /** The user represented by this `AccessToken`. */
  user?: Maybe<User>;
  /** The user-roles associated with this token. */
  userRoles?: Maybe<Array<UserRole>>;
};


/**
 * Object that contains the information about an access-token used to query the GraphQL-API. It also provides some
 * entry points into the data-graph.
 */
export type AccessTokenHasPermissionArgs = {
  permission: Scalars['Permission']['input'];
};


/**
 * Object that contains the information about an access-token used to query the GraphQL-API. It also provides some
 * entry points into the data-graph.
 */
export type AccessTokenHasRoleArgs = {
  role: Role;
};

export type AccountConnection = Connection & ConnectionWithTotal & {
  __typename: 'AccountConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<AccountEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AccountEdge = Edge & {
  __typename: 'AccountEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /**
   * The node at the end of this edge.
   *
   * This value is `null` iff the current access token has no permission to see the value of this node, but does have
   * the permission to see the values on the edges.
   */
  node?: Maybe<User>;
};

export enum ActionAssignmentType {
  /** The action must be excluded. */
  Exclude = 'EXCLUDE',
  /** The action must be included. */
  Include = 'INCLUDE'
}

export type ActivateMany_SuccessResult = MutationPayload & {
  __typename: 'ActivateMany_SuccessResult';
  nodes: Array<Activateable>;
  query: Query;
};

export type Activate_SuccessResult = MutationPayload & {
  __typename: 'Activate_SuccessResult';
  node: Activateable;
  query: Query;
};

/**
 * Interface for nodes that have a concept of being "active".
 *
 * Nodes are always "active" by default. The moment at which it was deactivated is stored with the node.
 */
export type Activateable = {
  /** The moment at which this node was deactivated. This value is always `null` if `isActive == true`. */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that deactivated this node. */
  deactivator?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether the node is currently "active". */
  isActive?: Maybe<Scalars['Boolean']['output']>;
};

export type Address = {
  __typename: 'Address';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  administrativeArea?: Maybe<Scalars['String']['output']>;
  country: Country;
  dependentLocality?: Maybe<Scalars['String']['output']>;
  /** Gives the fully formatted version of this address. */
  full?: Maybe<Scalars['String']['output']>;
  /** Gives the HTML-formatted address. */
  html?: Maybe<Scalars['HTML']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  sortingCode?: Maybe<Scalars['String']['output']>;
};


export type AddressHtmlArgs = {
  wrappingTag?: InputMaybe<HtmlTag>;
};

/**
 * This is an enum that was imported from the `AdministrativeAreaType`-type of the `Addressing`-library.
 *
 * This enum is only added for compatibility-reasons. In most cases, you can just ignore these values.
 */
export enum AddressAdministrativeAreaType {
  /** Represents the value `area` in the `Addressing`-library. */
  Area = 'AREA',
  /** Represents the value `canton` in the `Addressing`-library. */
  Canton = 'CANTON',
  /** Represents the value `county` in the `Addressing`-library. */
  County = 'COUNTY',
  /** Represents the value `department` in the `Addressing`-library. */
  Department = 'DEPARTMENT',
  /** Represents the value `district` in the `Addressing`-library. */
  District = 'DISTRICT',
  /** Represents the value `do_si` in the `Addressing`-library. */
  DoSi = 'DO_SI',
  /** Represents the value `emirate` in the `Addressing`-library. */
  Emirate = 'EMIRATE',
  /** Represents the value `island` in the `Addressing`-library. */
  Island = 'ISLAND',
  /** Represents the value `oblast` in the `Addressing`-library. */
  Oblast = 'OBLAST',
  /** Represents the value `parish` in the `Addressing`-library. */
  Parish = 'PARISH',
  /** Represents the value `prefecture` in the `Addressing`-library. */
  Prefecture = 'PREFECTURE',
  /** Represents the value `province` in the `Addressing`-library. */
  Province = 'PROVINCE',
  /** Represents the value `state` in the `Addressing`-library. */
  State = 'STATE'
}

/**
 * This is an enum that was imported from the `DependentLocalityType`-type of the `Addressing`-library.
 *
 * This enum is only added for compatibility-reasons. In most cases, you can just ignore these values.
 */
export enum AddressDependentLocalityType {
  /** Represents the value `district` in the `Addressing`-library. */
  District = 'DISTRICT',
  /** Represents the value `neighborhood` in the `Addressing`-library. */
  Neighborhood = 'NEIGHBORHOOD',
  /** Represents the value `suburb` in the `Addressing`-library. */
  Suburb = 'SUBURB',
  /** Represents the value `townland` in the `Addressing`-library. */
  Townland = 'TOWNLAND',
  /** Represents the value `village_township` in the `Addressing`-library. */
  VillageTownship = 'VILLAGE_TOWNSHIP'
}

/**
 * This is an enum that was imported from the `AddressField`-type of the `Addressing`-library.
 *
 * This enum is only added for compatibility-reasons. In most cases, you can just ignore these values.
 */
export enum AddressField {
  /** Represents the value `additionalName` in the `Addressing`-library. */
  AdditionalName = 'ADDITIONAL_NAME',
  /** Represents the value `addressLine1` in the `Addressing`-library. */
  AddressLine1 = 'ADDRESS_LINE1',
  /** Represents the value `addressLine2` in the `Addressing`-library. */
  AddressLine2 = 'ADDRESS_LINE2',
  /** Represents the value `administrativeArea` in the `Addressing`-library. */
  AdministrativeArea = 'ADMINISTRATIVE_AREA',
  /** Represents the value `dependentLocality` in the `Addressing`-library. */
  DependentLocality = 'DEPENDENT_LOCALITY',
  /** Represents the value `familyName` in the `Addressing`-library. */
  FamilyName = 'FAMILY_NAME',
  /** Represents the value `givenName` in the `Addressing`-library. */
  GivenName = 'GIVEN_NAME',
  /** Represents the value `locality` in the `Addressing`-library. */
  Locality = 'LOCALITY',
  /** Represents the value `organization` in the `Addressing`-library. */
  Organization = 'ORGANIZATION',
  /** Represents the value `postalCode` in the `Addressing`-library. */
  PostalCode = 'POSTAL_CODE',
  /** Represents the value `sortingCode` in the `Addressing`-library. */
  SortingCode = 'SORTING_CODE'
}

/**
 * This is an enum that was imported from the `FieldOverride`-type of the `Addressing`-library.
 *
 * This enum is only added for compatibility-reasons. In most cases, you can just ignore these values.
 */
export enum AddressFieldOverride {
  /** Represents the value `hidden` in the `Addressing`-library. */
  Hidden = 'HIDDEN',
  /** Represents the value `optional` in the `Addressing`-library. */
  Optional = 'OPTIONAL',
  /** Represents the value `required` in the `Addressing`-library. */
  Required = 'REQUIRED'
}

/**
 * Node that contains information on how an `Address` should be formatted.
 *
 * See the [commerceguys/addressing](https://github.com/commerceguys/addressing) library for more information.
 */
export type AddressFormat = Node & {
  __typename: 'AddressFormat';
  administrativeAreaType?: Maybe<AddressAdministrativeAreaType>;
  country?: Maybe<Country>;
  dependentLocalityType?: Maybe<AddressDependentLocalityType>;
  format: Scalars['String']['output'];
  formatFields: Array<Array<AddressField>>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  localFormat?: Maybe<Scalars['String']['output']>;
  localFormatFields?: Maybe<Array<Array<AddressField>>>;
  locale?: Maybe<Scalars['String']['output']>;
  localityType?: Maybe<AddressLocalityType>;
  postalCodePattern?: Maybe<Scalars['RegExp']['output']>;
  postalCodePrefix?: Maybe<Scalars['String']['output']>;
  postalCodeType?: Maybe<AddressPostalCodeType>;
  requiredFields: Array<AddressField>;
  subdivisionDepth?: Maybe<Scalars['Int']['output']>;
  uppercaseFields: Array<AddressField>;
  usedFields: Array<AddressField>;
  usedSubdivisionFields: Array<AddressField>;
};

export type AddressInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  administrativeArea?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['CountryCode']['input'];
  dependentLocality?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  sortingCode?: InputMaybe<Scalars['String']['input']>;
};

/**
 * This is an enum that was imported from the `LocalityType`-type of the `Addressing`-library.
 *
 * This enum is only added for compatibility-reasons. In most cases, you can just ignore these values.
 */
export enum AddressLocalityType {
  /** Represents the value `city` in the `Addressing`-library. */
  City = 'CITY',
  /** Represents the value `district` in the `Addressing`-library. */
  District = 'DISTRICT',
  /** Represents the value `post_town` in the `Addressing`-library. */
  PostTown = 'POST_TOWN',
  /** Represents the value `suburb` in the `Addressing`-library. */
  Suburb = 'SUBURB'
}

/**
 * This is an enum that was imported from the `PostalCodeType`-type of the `Addressing`-library.
 *
 * This enum is only added for compatibility-reasons. In most cases, you can just ignore these values.
 */
export enum AddressPostalCodeType {
  /** Represents the value `eircode` in the `Addressing`-library. */
  Eir = 'EIR',
  /** Represents the value `pin` in the `Addressing`-library. */
  Pin = 'PIN',
  /** Represents the value `postal` in the `Addressing`-library. */
  Postal = 'POSTAL',
  /** Represents the value `zip` in the `Addressing`-library. */
  Zip = 'ZIP'
}

export type AffineTransformation = {
  __typename: 'AffineTransformation';
  factor?: Maybe<Scalars['Float']['output']>;
  scalar?: Maybe<Scalars['Float']['output']>;
  vector?: Maybe<Scalars['Float']['output']>;
};

export type AnalysisEntry = {
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Checks whether this node is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this node is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this node is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this node has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /** A reference to the owner of this node. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this node can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(ownable: $ownable)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /** The product-object on which this `AnalysisRow` is based. */
  product?: Maybe<Product>;
  /** The risk-object on which this `AnalysisRow` is based. */
  risk?: Maybe<Risk>;
  /** The risk-configuration used in this analysis-row to determine the `riskProbability` and `riskSeverity` fields. */
  riskConfiguration?: Maybe<RiskConfiguration>;
  /** The risk level. Could be the same value as in the `risk`-field or a custom value. */
  riskLevel?: Maybe<AnalysisReportEntryRiskValue>;
  /** The risk probability. Could be the same value as in the `risk`-field or a custom value. */
  riskProbability?: Maybe<AnalysisReportEntryRiskValue>;
  /** The risk severity. Could be the same value as in the `risk`-field or a custom value. */
  riskSeverity?: Maybe<AnalysisReportEntryRiskValue>;
  /** The supplier-branch on which this `AnalysisRow` is based. */
  supplierBranch?: Maybe<SupplierBranch>;
  /** The reliability of the supplierBranch, or a custom reliability. */
  supplierReliability?: Maybe<SupplierReliability>;
};


export type AnalysisEntryIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type AnalysisEntryIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type AnalysisEntryOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};

export type AnalysisEntryPredicate = {
  /**
   * The default value for a node that has no explicit value for this predicate set.
   *
   * See the `Predicate.defaultPredicateValue` field for more information.
   */
  defaultPredicateValue?: Maybe<PredicateValue>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * This `id` is also used to reference to this predicate in a predicate-expression.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Checks whether this node is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this node is usable by the common GINO library team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this node is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this node is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id, which can save
   * an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * An HTML-formatted field with a closed-form question to the user to explain the predicate.
   *
   * This value is always safe to show in the GUI.
   *
   * See the `Predicate.predicateQuestion` field for more information.
   */
  predicateQuestion?: Maybe<Scalars['HTML']['output']>;
  /** Connection to the verification configuration rules that use this predicate. */
  usedByVerificationConfigurationRules?: Maybe<VerificationConfigurationRuleConnection>;
  /** Connection to the verification configurations that use this verification predicate. */
  usedByVerificationConfigurations?: Maybe<VerificationConfigurationConnection>;
};


export type AnalysisEntryPredicateIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type AnalysisEntryPredicateIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type AnalysisEntryPredicateUsedByVerificationConfigurationRulesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationRuleOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationRuleWhereClause>>;
};


export type AnalysisEntryPredicateUsedByVerificationConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationWhereClause>>;
};

export type AnalysisEntryPredicateConnection = {
  __typename: 'AnalysisEntryPredicateConnection';
  edges?: Maybe<Array<AnalysisEntryPredicateEdge>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<AnalysisEntryPredicate>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AnalysisEntryPredicateEdge = {
  __typename: 'AnalysisEntryPredicateEdge';
  cursor: Scalars['Cursor']['output'];
  node?: Maybe<AnalysisEntryPredicate>;
};

export type AnalysisEntryPredicateExpression = Hashed & PredicateExpression & {
  __typename: 'AnalysisEntryPredicateExpression';
  /** The PredicateValue to which this predicate expression evaluates. */
  evaluatesTo?: Maybe<PredicateValue>;
  /** The predicate expression string defining this `AnalysisEntryPredicateExpression`. */
  expression?: Maybe<Scalars['String']['output']>;
  /**
   * A value that uniquely identifies this object like `id`-field for `Node`-objects, but cannot be used to retrieve
   * this object from the database. Mainly used for caching purposes.
   *
   * See the `Hashed.hash` field for more information.
   */
  hash: Scalars['Hash']['output'];
  /** The predicates that occur in this predicate expression. */
  predicates?: Maybe<Array<Maybe<AnalysisEntryPredicate>>>;
};

export type AnalysisReport = Commentable & Named & Node & Ownable & Selectable & Taggable & Timestamped & Userstamped & {
  __typename: 'AnalysisReport';
  /** The `VerificationConfigurationRule`s of the `VerificationConfiguration` are applicable in this `AnalysisReport`. */
  applicableVerificationRules?: Maybe<VerificationConfigurationRuleConnection>;
  /** The comments for this `AnalysisReport`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `AnalysisReport`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `AnalysisReport`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** The full-text searchable description of this `AnalysisReport`. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _updated_ this `AnalysisReport`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * The entries of this `AnalysisReport`, which are all the combinations between `Product`s, `Risk`s and
   * `SupplierBranch`es that are analysed by this `AnalysisReport`.
   */
  entries?: Maybe<AnalysisReportEntryConnection>;
  /** Whether the entries were generated for this `AnalysisReport`. */
  entriesGenerated?: Maybe<Scalars['Boolean']['output']>;
  /** The moment on which the entries were generated. */
  entriesGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the job to generate the entries was queued. */
  generateEntriesQueued?: Maybe<Scalars['Boolean']['output']>;
  /** The moment on which the job to generate the entries was queued. */
  generateEntriesQueuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the job to generate product risks was queued. */
  generateProductRisksQueued?: Maybe<Scalars['Boolean']['output']>;
  /** The moment on which the job to generate the product risks was queued. */
  generateProductRisksQueuedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `AnalysisReport`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Will be `true` if the analysis report is considered to be outdated. */
  isOutdated?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `AnalysisReport` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `AnalysisReport` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `AnalysisReport` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `AnalysisReport` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `AnalysisReport`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** The name of this `AnalysisReport`. */
  name?: Maybe<Name>;
  /** The moment after which this `AnalysisReport` is considered to be outdated. */
  outdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A reference to the owner that owns this `AnalysisReport`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `AnalysisReport` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /** The `Product`, `Risk` combinations that are analysed in this `AnalysisReport`. */
  productRisks?: Maybe<AnalysisReportProductRiskConnection>;
  /** Whether the products risks are generated for this `AnalysisReport`. */
  productRisksGenerated?: Maybe<Scalars['Boolean']['output']>;
  /** The moment on which the product risks were generated. */
  productRisksGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The products that were selected in this `AnalysisReport`. */
  products?: Maybe<ProductConnection>;
  /** Will be `true` if the products were selected for this `AnalysisReport`. */
  productsSelected?: Maybe<Scalars['Boolean']['output']>;
  /** The moment at which the products were selected. */
  productsSelectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The `RiskConfiguration` used in this `AnalysisReport`. */
  riskConfiguration?: Maybe<RiskConfiguration>;
  /**
   * The `RiskConfiguration`s used in this `AnalysisReport`.
   *
   * Will always give one entry which is the value of `riskConfiguration`.
   * @deprecated Use `riskConfiguration` instead.
   */
  riskConfigurations?: Maybe<AnalysisReport_RiskConfigurationConnection>;
  /** @deprecated Irrelevant. Always `true`. */
  riskConfigurationsSelected?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Irrelevant. Always the value of `createdAt` */
  riskConfigurationsSelectedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The risks that occur in the `productRisks` of this `AnalysisReport` */
  risks?: Maybe<RiskConnection>;
  /**
   * The current state of this analysis report. It summarises the values of the `productsSelected`,
   * `productRisksGenerated` and `entriesGenerated` fields.
   */
  state?: Maybe<AnalysisReportState>;
  /** Connection to the tags that are assigned to this `AnalysisReport`. */
  tags?: Maybe<TagConnection>;
  /** Connection to the todo items that need to be resolved before the analysis report can be generated. */
  todos?: Maybe<AnalysisReportTodoConnection>;
  /** Gives the most recent moment on which this `AnalysisReport`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Will be `true` if the verification actions were successfully generated for each `AnalysisReportEntry` of this
   * `AnalysisReport`.
   */
  verificationActionsGenerated?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The moment on which the verification actions were generated for the entries on this analysis report.
   * @deprecated use verificationActionsGeneratedBetween instead
   */
  verificationActionsGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The period in between which the verification actions of the entries were generated. */
  verificationActionsGeneratedBetween?: Maybe<DateTimePeriod>;
  /** The selected verification configuration of this `AnalysisReport`. */
  verificationConfiguration?: Maybe<VerificationConfiguration>;
  /** @deprecated Irrelevant. Always `true`. */
  verificationConfigurationSelected?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Irrelevant. Always the value of `createdAt` */
  verificationConfigurationSelectedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Whether the needed verification predicates were generated on the entries of this analysis report.
   * @deprecated Irrelevant. Always has the same value as entries generated.
   */
  verificationPredicatesGenerated?: Maybe<Scalars['Boolean']['output']>;
  /** The moment on which the verification predicates were initialized with the default values. */
  verificationPredicatesGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gives a list of warnings that the user should consider while using this analysis report. */
  warnings?: Maybe<Array<AnalysisReportWarning>>;
};


export type AnalysisReportApplicableVerificationRulesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationRuleOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationRuleWhereClause>>;
};


export type AnalysisReportCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type AnalysisReportEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AnalysisReportEntryOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<AnalysisReportEntryWhereClause>>;
};


export type AnalysisReportIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type AnalysisReportIsOutdatedArgs = {
  at?: InputMaybe<Scalars['DateTime']['input']>;
};


export type AnalysisReportIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type AnalysisReportIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type AnalysisReportIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type AnalysisReportOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type AnalysisReportProductRisksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AnalysisReportProductRiskOrderByClause>>;
  where?: InputMaybe<Array<AnalysisReportProductRiskWhereClause>>;
};


export type AnalysisReportProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductOrderByClause>>;
  where?: InputMaybe<Array<ProductWhereClause>>;
};


export type AnalysisReportRiskConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Array<RiskConfigurationWhereClause>>;
};


export type AnalysisReportRisksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskOrderByClause>>;
  where?: InputMaybe<Array<RiskWhereClause>>;
};


export type AnalysisReportTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};


export type AnalysisReportTodosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A paged connection with `AnalysisReportEdge` edges to `AnalysisReport` nodes.
 *
 * This type was automatically generated from the `AnalysisReportEdge` edge-type for the
 * `Team.analysisReports` field. (It might be possible that it is reused by other fields.)
 */
export type AnalysisReportConnection = Connection & ConnectionWithTotal & {
  __typename: 'AnalysisReportConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<AnalysisReportEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<AnalysisReport>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `AnalysisReportConnection` connection that points to a `AnalysisReport` node.
 *
 * This type was automatically generated from the `AnalysisReport` node-type of the
 * `Team.analysisReports` field. (It might be possible that it is reused by other fields.)
 */
export type AnalysisReportEdge = Edge & {
  __typename: 'AnalysisReportEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: AnalysisReport;
};

export type AnalysisReportEntry = AnalysisEntry & Commentable & Node & Ownable & Timestamped & Userstamped & {
  __typename: 'AnalysisReportEntry';
  /** The analysis report to which this entry belongs to. */
  analysisReport?: Maybe<AnalysisReport>;
  /** The comments for this `AnalysisReportEntry`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `AnalysisReportEntry`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `AnalysisReportEntry`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `AnalysisReportEntry`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `AnalysisReportEntry`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `AnalysisReportEntry` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `AnalysisReportEntry` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `AnalysisReportEntry` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `AnalysisReportEntry` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `AnalysisReportEntry`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** A reference to the owner that owns this `AnalysisReportEntry`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `AnalysisReportEntry` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /** The probability overwrite events of this `AnalysisReportEntry`. */
  probabilityOverwriteEvents?: Maybe<AnalysisReportEntry_ProbabilityOverwriteEventConnection>;
  /** The product of this entry. This value is always the same as `productRisk.product`. */
  product?: Maybe<Product>;
  /** The productRisk on which this entry is based on. */
  productRisk?: Maybe<AnalysisReportProductRisk>;
  /** The risk of this entry. This value is always the same as `productRisk.risk`. */
  risk?: Maybe<Risk>;
  /** The risk-configuration used in this analysis-row to determine the `riskSeverity`, `riskProbability` and `riskLevel`. */
  riskConfiguration?: Maybe<RiskConfiguration>;
  /** The risk level. Could be the same value as in the `risk`-field or a custom value. */
  riskLevel?: Maybe<AnalysisReportEntryRiskLevel>;
  /** The entry risk probability. */
  riskProbability?: Maybe<AnalysisReportEntryProbability>;
  /** The entry risk severity. */
  riskSeverity?: Maybe<AnalysisReportEntrySeverity>;
  /** The severity overwrite events of this `AnalysisReportEntry`. */
  severityOverwriteEvents?: Maybe<AnalysisReportEntry_SeverityOverwriteEventConnection>;
  /** The supplier of this analysis-entry. This value is always the same as `supplierBranch.supplier`. */
  supplier?: Maybe<Supplier>;
  /** The supplier-branch on which this `AnalysisRow` is based. */
  supplierBranch?: Maybe<SupplierBranch>;
  /** The reliability of the `supplierBranch`, or a custom reliability. */
  supplierReliability?: Maybe<SupplierReliability>;
  /**
   * The threat of this entry. This value is always the same as `risk.threat`.
   *
   * For the best performance, use `risk.threat` if you also need other values from `risk`. Otherwise, use `threat`.
   */
  threat?: Maybe<Threat>;
  /** Gives the most recent moment on which this `AnalysisReportEntry`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  verificationActionValues?: Maybe<Scalars['PredicateValueMap']['output']>;
  /** The verification action of this `AnalysisReportEntry`. */
  verificationActions?: Maybe<AnalysisReportEntry_VerificationActionConnection>;
  verificationPredicateValues?: Maybe<Scalars['PredicateValueMap']['output']>;
  /** The verification predicates of this `AnalysisReportEntry`. The values can be found on the edges. */
  verificationPredicates?: Maybe<AnalysisReportEntry_VerificationPredicateConnection>;
};


export type AnalysisReportEntryCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type AnalysisReportEntryIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type AnalysisReportEntryIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type AnalysisReportEntryIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type AnalysisReportEntryIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type AnalysisReportEntryOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type AnalysisReportEntryProbabilityOverwriteEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AnalysisReportEntryProbabilityOverwriteEventOrderByClause>>;
  where?: InputMaybe<Array<AnalysisReportEntryProbabilityOverwriteEventWhereClause>>;
};


export type AnalysisReportEntrySeverityOverwriteEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AnalysisReportEntrySeverityOverwriteEventOrderByClause>>;
  where?: InputMaybe<Array<AnalysisReportEntrySeverityOverwriteEventWhereClause>>;
};


export type AnalysisReportEntryVerificationActionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationActionOrderByClause>>;
  where?: InputMaybe<Array<VerificationActionWhereClause>>;
};


export type AnalysisReportEntryVerificationPredicatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationPredicateOrderByClause>>;
  where?: InputMaybe<Array<VerificationPredicateWhereClause>>;
};

/**
 * A paged connection with `AnalysisReportEntryEdge` edges to `AnalysisReportEntry` nodes.
 *
 * This type was automatically generated from the `AnalysisReportEntryEdge` edge-type for the
 * `AnalysisReport.entries` field. (It might be possible that it is reused by other fields.)
 */
export type AnalysisReportEntryConnection = Connection & ConnectionWithTotal & {
  __typename: 'AnalysisReportEntryConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<AnalysisReportEntryEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<AnalysisReportEntry>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `AnalysisReportEntryConnection` connection that points to a `AnalysisReportEntry` node.
 *
 * This type was automatically generated from the `AnalysisReportEntry` node-type of the
 * `AnalysisReport.entries` field. (It might be possible that it is reused by other fields.)
 */
export type AnalysisReportEntryEdge = Edge & {
  __typename: 'AnalysisReportEntryEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: AnalysisReportEntry;
};

/**
 * Specifies how the edges to a `AnalysisReportEntry` will be ordered in a connection.
 *
 * This type was automatically generated from the `AnalysisReportEntryOrderByColumn` column-type used in the
 * `orderBy` argument of the `AnalysisReport.entries` field. (It might be possible that it is reused by
 * other fields.)
 */
export type AnalysisReportEntryOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: AnalysisReportEntryOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `AnalysisReportEntryOrderByColumn`. */
export enum AnalysisReportEntryOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /**
   * Alias for `PRODUCT_CLIENT_REF`.
   *
   *  Form owner-type `AnalysisReportProductRisk`.
   */
  ProductClientRef = 'PRODUCT_CLIENT_REF',
  /**
   * Alias for `PRODUCT_NAME_FULL`.
   *
   *  Form owner-type `AnalysisReportProductRisk`.
   */
  ProductNameFull = 'PRODUCT_NAME_FULL',
  /**
   * Alias for `PRODUCT_NAME_SHORT`.
   *
   *  Form owner-type `AnalysisReportProductRisk`.
   */
  ProductNameShort = 'PRODUCT_NAME_SHORT',
  /**
   * Alias for `NAME_FULL`.
   *
   *  Form owner-type `RiskConfiguration`.
   */
  RiskConfigurationNameFull = 'RISK_CONFIGURATION_NAME_FULL',
  /**
   * Alias for `NAME_SHORT`.
   *
   *  Form owner-type `RiskConfiguration`.
   */
  RiskConfigurationNameShort = 'RISK_CONFIGURATION_NAME_SHORT',
  /** Orders by the product of the custom `riskSeverity` and `riskProbability` values. */
  RiskLevelValue = 'RISK_LEVEL_VALUE',
  RiskProbabilityValue = 'RISK_PROBABILITY_VALUE',
  RiskSeverityValue = 'RISK_SEVERITY_VALUE',
  /**
   * Alias for `SUPPLIER_ADDRESS_LINE_1`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierAddressLine_1 = 'SUPPLIER_ADDRESS_LINE_1',
  /**
   * Alias for `SUPPLIER_ADDRESS_LINE_2`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierAddressLine_2 = 'SUPPLIER_ADDRESS_LINE_2',
  /**
   * Alias for `SUPPLIER_ADMINISTRATIVE_AREA`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierAdministrativeArea = 'SUPPLIER_ADMINISTRATIVE_AREA',
  /**
   * Alias for `ADDRESS_LINE_1`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierBranchAddressLine_1 = 'SUPPLIER_BRANCH_ADDRESS_LINE_1',
  /**
   * Alias for `ADDRESS_LINE_2`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierBranchAddressLine_2 = 'SUPPLIER_BRANCH_ADDRESS_LINE_2',
  /**
   * Alias for `ADMINISTRATIVE_AREA`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierBranchAdministrativeArea = 'SUPPLIER_BRANCH_ADMINISTRATIVE_AREA',
  /**
   * Alias for `COUNTRY`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierBranchCountry = 'SUPPLIER_BRANCH_COUNTRY',
  /**
   * Alias for `DEPENDENT_LOCALITY`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierBranchDependentLocality = 'SUPPLIER_BRANCH_DEPENDENT_LOCALITY',
  /**
   * Alias for `LOCALITY`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierBranchLocality = 'SUPPLIER_BRANCH_LOCALITY',
  /**
   * Alias for `NAME_FULL`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierBranchNameFull = 'SUPPLIER_BRANCH_NAME_FULL',
  /**
   * Alias for `NAME_SHORT`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierBranchNameShort = 'SUPPLIER_BRANCH_NAME_SHORT',
  /**
   * Alias for `POSTAL_CODE`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierBranchPostalCode = 'SUPPLIER_BRANCH_POSTAL_CODE',
  /**
   * Orders by the value of the `supplierBranchReliability`.
   *
   * (This is the value defined on the `AnalysisReportEntry` itself that might be overwritten by the user.)
   */
  SupplierBranchReliability = 'SUPPLIER_BRANCH_RELIABILITY',
  /**
   * Alias for `SORTING_CODE`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierBranchSortingCode = 'SUPPLIER_BRANCH_SORTING_CODE',
  /**
   * Alias for `SUPPLIER_CLIENT_REF`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierClientRef = 'SUPPLIER_CLIENT_REF',
  /**
   * Alias for `SUPPLIER_COUNTRY`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierCountry = 'SUPPLIER_COUNTRY',
  /**
   * Alias for `SUPPLIER_DEPENDENT_LOCALITY`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierDependentLocality = 'SUPPLIER_DEPENDENT_LOCALITY',
  /**
   * Alias for `SUPPLIER_LOCALITY`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierLocality = 'SUPPLIER_LOCALITY',
  /**
   * Alias for `SUPPLIER_NAME_FULL`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierNameFull = 'SUPPLIER_NAME_FULL',
  /**
   * Alias for `SUPPLIER_NAME_SHORT`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierNameShort = 'SUPPLIER_NAME_SHORT',
  /**
   * Alias for `SUPPLIER_POSTAL_CODE`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierPostalCode = 'SUPPLIER_POSTAL_CODE',
  /**
   * Alias for `SUPPLIER_SORTING_CODE`.
   *
   *  Form owner-type `SupplierBranch`.
   */
  SupplierSortingCode = 'SUPPLIER_SORTING_CODE',
  /**
   * Alias for `THREAT_NAME_FULL`.
   *
   *  Form owner-type `AnalysisReportProductRisk`.
   */
  ThreatNameFull = 'THREAT_NAME_FULL',
  /**
   * Alias for `THREAT_NAME_SHORT`.
   *
   *  Form owner-type `AnalysisReportProductRisk`.
   */
  ThreatNameShort = 'THREAT_NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type AnalysisReportEntryProbability = AnalysisReportEntryRiskValue & {
  __typename: 'AnalysisReportEntryProbability';
  /**
   * The RiskProbability that is currently in use.
   * This value starts out the same as the initial value, but can be changed using a AnalysisReportEntryRiskProbabilityOverwriteEvent.
   */
  current?: Maybe<RiskProbability>;
  /** The RiskProbability as determined by the system upon generating the AnalysisReportEntries. */
  initial?: Maybe<RiskProbability>;
  /** Indicates if the inital value has been overwritten. */
  isOverwritten?: Maybe<Scalars['Boolean']['output']>;
  /** The event responsible for the current value. Empty if the initial value is not overwritten. */
  overwriteEvent?: Maybe<AnalysisReportEntryProbabilityOverwriteEvent>;
};

export type AnalysisReportEntryProbabilityOverwriteEvent = AnalysisReportEntryRiskValueOverwriteEvent & Commentable & Node & Taggable & Timestamped & {
  __typename: 'AnalysisReportEntryProbabilityOverwriteEvent';
  /** The comments assigned to this node. */
  comments?: Maybe<CommentConnection>;
  /** `DateTime` on which this node was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that created this object. This value is always in sync with the `createdAt`-field. */
  creator?: Maybe<User>;
  /** The last user that edited this object. This value is always in sync with the `updatedAt`-field. */
  editor?: Maybe<User>;
  /** The AnalysisReportEntry affected by this event. */
  entry?: Maybe<AnalysisReportEntry>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Whether this node is considered to be new.
   *
   * This feature was inherited from the `Shared Robotics`-project. It is left in as it might be useful in the future.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this node is considered to be updated.
   *
   * This feature was inherited from the `Shared Robotics`-project. It is left in as it might be useful in the future.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** The reason for overwriting the RiskProbabilityValue. */
  reason?: Maybe<Scalars['HTML']['output']>;
  /** The tags assigned to this node. */
  tags?: Maybe<TagConnection>;
  /** `DateTime` of the last moment on which this node was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The RiskProbabilityValue set by this event. */
  value?: Maybe<Scalars['Float']['output']>;
};


export type AnalysisReportEntryProbabilityOverwriteEventCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type AnalysisReportEntryProbabilityOverwriteEventIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type AnalysisReportEntryProbabilityOverwriteEventIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type AnalysisReportEntryProbabilityOverwriteEventTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

/**
 * Specifies how the edges to a `AnalysisReportEntryProbabilityOverwriteEvent` will be ordered in a connection.
 *
 * This type was automatically generated from the `AnalysisReportEntryProbabilityOverwriteEventOrderByColumn` column-type used in the
 * `orderBy` argument of the `AnalysisReportEntry.probabilityOverwriteEvents` field. (It might be possible that it is reused by
 * other fields.)
 */
export type AnalysisReportEntryProbabilityOverwriteEventOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: AnalysisReportEntryProbabilityOverwriteEventOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `AnalysisReportEntryProbabilityOverwriteEventOrderByColumn`. */
export enum AnalysisReportEntryProbabilityOverwriteEventOrderByColumn {
  CreatedAt = 'CREATED_AT'
}

export type AnalysisReportEntryProbabilityOverwriteEventWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
};

export type AnalysisReportEntryRiskLevel = AnalysisReportEntryRiskValue & {
  __typename: 'AnalysisReportEntryRiskLevel';
  /**
   * The RiskLevel that is currently in use.
   * This value starts out the same as the initial value, but can be changed using a AnalysisReportEntryRiskSeverityOverwriteEvent or AnalysisReportEntryRiskProbabilityOverwriteEvent.
   */
  current?: Maybe<RiskLevel>;
  /** The RiskLevel as determined by the system upon generating the AnalysisReportEntries. */
  initial?: Maybe<RiskLevel>;
  /** Indicates if the inital value has been overwritten. */
  isOverwritten?: Maybe<Scalars['Boolean']['output']>;
  /** The event responsible for the current RiskProbabilityValue. Empty if the initial RiskProbabilityValue is not overwritten. */
  probability?: Maybe<AnalysisReportEntryProbability>;
  /** Indicates if the inital RiskProbabilityValue has been overwritten. */
  probabilityOverwritten?: Maybe<Scalars['Boolean']['output']>;
  /** The event responsible for the current RiskSeverityValue. Empty if the initial RiskSeverityValue is not overwritten. */
  severity?: Maybe<AnalysisReportEntrySeverity>;
  /** Indicates if the inital RiskSeverityValue has been overwritten. */
  severityOverwritten?: Maybe<Scalars['Boolean']['output']>;
};

export type AnalysisReportEntryRiskValue = {
  /**
   * The RiskValue that is currently in use.
   * This value starts out the same as the initial value, but can be changed using a AnalysisReportEntryRiskValueOverwriteEvent.
   */
  current?: Maybe<RiskValue>;
  /** The RiskValue as determined by the system upon generating the AnalysisReportEntries. */
  initial?: Maybe<RiskValue>;
  /** Indicates if the inital value has been overwritten. */
  isOverwritten?: Maybe<Scalars['Boolean']['output']>;
};

export type AnalysisReportEntryRiskValueInput = {
  reason: Scalars['HTML']['input'];
  value: Scalars['Float']['input'];
};

export type AnalysisReportEntryRiskValueOverwriteEvent = {
  /** The comments assigned to this node. */
  comments?: Maybe<CommentConnection>;
  /** `DateTime` on which this node was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that created this object. This value is always in sync with the `createdAt`-field. */
  creator?: Maybe<User>;
  /** The last user that edited this object. This value is always in sync with the `updatedAt`-field. */
  editor?: Maybe<User>;
  /** The AnalysisReportEntry affected by this event */
  entry?: Maybe<AnalysisReportEntry>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Whether this node is considered to be new.
   *
   * This feature was inherited from the `Shared Robotics`-project. It is left in as it might be useful in the future.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this node is considered to be updated.
   *
   * This feature was inherited from the `Shared Robotics`-project. It is left in as it might be useful in the future.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** The reason for overwriting the RiskValue */
  reason?: Maybe<Scalars['HTML']['output']>;
  /** The tags assigned to this node. */
  tags?: Maybe<TagConnection>;
  /** `DateTime` of the last moment on which this node was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The RiskValue set by this event. */
  value?: Maybe<Scalars['Float']['output']>;
};


export type AnalysisReportEntryRiskValueOverwriteEventCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type AnalysisReportEntryRiskValueOverwriteEventIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type AnalysisReportEntryRiskValueOverwriteEventIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type AnalysisReportEntryRiskValueOverwriteEventTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

export type AnalysisReportEntrySelectionInput = {
  /** The ids of the entries you want to include in this selection. Defaults to all analysis reports when omitted. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filters the analysis reports in the results.
   *
   * These filters will be applied **after** the `ids` argument. (So the `ids` will be affected by this `where`-field.)
   */
  where?: InputMaybe<Array<AnalysisReportEntryWhereClause>>;
};

export type AnalysisReportEntrySeverity = AnalysisReportEntryRiskValue & {
  __typename: 'AnalysisReportEntrySeverity';
  /**
   * The RiskSeverity that is currently in use.
   * This value starts out the same as the initial value, but can be changed using a AnalysisReportEntryRiskSeverityOverwriteEvent.
   */
  current?: Maybe<RiskSeverity>;
  /** The RiskSeverity as determined by the system upon generating the AnalysisReportEntries. */
  initial?: Maybe<RiskSeverity>;
  /** Indicates if the inital value has been overwritten. */
  isOverwritten?: Maybe<Scalars['Boolean']['output']>;
  /** The event responsible for the current value. Empty if the initial value is not overwritten. */
  overwriteEvent?: Maybe<AnalysisReportEntrySeverityOverwriteEvent>;
};

export type AnalysisReportEntrySeverityOverwriteEvent = AnalysisReportEntryRiskValueOverwriteEvent & Commentable & Node & Taggable & Timestamped & {
  __typename: 'AnalysisReportEntrySeverityOverwriteEvent';
  /** The comments assigned to this node. */
  comments?: Maybe<CommentConnection>;
  /** `DateTime` on which this node was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that created this object. This value is always in sync with the `createdAt`-field. */
  creator?: Maybe<User>;
  /** The last user that edited this object. This value is always in sync with the `updatedAt`-field. */
  editor?: Maybe<User>;
  /** The AnalysisReportEntry affected by this event. */
  entry?: Maybe<AnalysisReportEntry>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Whether this node is considered to be new.
   *
   * This feature was inherited from the `Shared Robotics`-project. It is left in as it might be useful in the future.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this node is considered to be updated.
   *
   * This feature was inherited from the `Shared Robotics`-project. It is left in as it might be useful in the future.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** The reason for overwriting the RiskSeverityValue. */
  reason?: Maybe<Scalars['HTML']['output']>;
  /** The tags assigned to this node. */
  tags?: Maybe<TagConnection>;
  /** `DateTime` of the last moment on which this node was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The RiskSeverityValue set by this event. */
  value?: Maybe<Scalars['Float']['output']>;
};


export type AnalysisReportEntrySeverityOverwriteEventCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type AnalysisReportEntrySeverityOverwriteEventIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type AnalysisReportEntrySeverityOverwriteEventIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type AnalysisReportEntrySeverityOverwriteEventTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

/**
 * Specifies how the edges to a `AnalysisReportEntrySeverityOverwriteEvent` will be ordered in a connection.
 *
 * This type was automatically generated from the `AnalysisReportEntrySeverityOverwriteEventOrderByColumn` column-type used in the
 * `orderBy` argument of the `AnalysisReportEntry.severityOverwriteEvents` field. (It might be possible that it is reused by
 * other fields.)
 */
export type AnalysisReportEntrySeverityOverwriteEventOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: AnalysisReportEntrySeverityOverwriteEventOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `AnalysisReportEntrySeverityOverwriteEventOrderByColumn`. */
export enum AnalysisReportEntrySeverityOverwriteEventOrderByColumn {
  CreatedAt = 'CREATED_AT'
}

export type AnalysisReportEntrySeverityOverwriteEventWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
};

export type AnalysisReportEntryWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `verificationActions`. */
  totalVerificationActions?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `verificationPredicates`. */
  totalVerificationPredicates?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnalysisReportEntry_ProbabilityOverwriteEventConnection = Connection & ConnectionWithTotal & {
  __typename: 'AnalysisReportEntry_ProbabilityOverwriteEventConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<AnalysisReportEntry_ProbabilityOverwriteEventEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<AnalysisReportEntryProbabilityOverwriteEvent>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AnalysisReportEntry_ProbabilityOverwriteEventEdge = Edge & {
  __typename: 'AnalysisReportEntry_ProbabilityOverwriteEventEdge';
  cursor: Scalars['Cursor']['output'];
  node?: Maybe<AnalysisReportEntryProbabilityOverwriteEvent>;
};

export type AnalysisReportEntry_SeverityOverwriteEventConnection = Connection & ConnectionWithTotal & {
  __typename: 'AnalysisReportEntry_SeverityOverwriteEventConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<AnalysisReportEntry_SeverityOverwriteEventEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<AnalysisReportEntrySeverityOverwriteEvent>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AnalysisReportEntry_SeverityOverwriteEventEdge = Edge & {
  __typename: 'AnalysisReportEntry_SeverityOverwriteEventEdge';
  cursor: Scalars['Cursor']['output'];
  node?: Maybe<AnalysisReportEntrySeverityOverwriteEvent>;
};

/**
 * A paged connection with `AnalysisReportEntry_VerificationActionEdge` edges to `VerificationAction` nodes.
 *
 * This type was automatically generated from the `AnalysisReportEntry_VerificationActionEdge` edge-type for the
 * `AnalysisReportEntry.verificationActions` field. (It might be possible that it is reused by other fields.)
 */
export type AnalysisReportEntry_VerificationActionConnection = Connection & ConnectionWithTotal & {
  __typename: 'AnalysisReportEntry_VerificationActionConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<AnalysisReportEntry_VerificationActionEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<VerificationAction>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AnalysisReportEntry_VerificationActionEdge = Edge & {
  __typename: 'AnalysisReportEntry_VerificationActionEdge';
  /**
   * The boolean value of this product for the predicate in `node`. **ONLY USE THIS VALUE ABSOLUTELY NESSICARY!**
   * The value of the `value` is preferred as `null` can mean different things here!
   */
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  cursor: Scalars['Cursor']['output'];
  /** The verification action at the end of this edge. */
  node?: Maybe<VerificationAction>;
  /**
   * The value of this product for the predicate in `node`. This value is only `null` if the database could not retrieve
   * this value in the query or or if the user has no permission to see this value.
   */
  value?: Maybe<PredicateValue>;
  /** The rule that set the value of the action. */
  verificationRule?: Maybe<VerificationConfigurationRule>;
};

export type AnalysisReportEntry_VerificationPredicateConnection = Connection & ConnectionWithTotal & {
  __typename: 'AnalysisReportEntry_VerificationPredicateConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<AnalysisReportEntry_VerificationPredicateEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<VerificationPredicate>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AnalysisReportEntry_VerificationPredicateEdge = Edge & {
  __typename: 'AnalysisReportEntry_VerificationPredicateEdge';
  /**
   * The boolean value of this entry for the predicate in `node`. **ONLY USE THIS VALUE ABSOLUTELY NESSICARY!**
   * The value of the `value` is preferred as `null` can mean different things here!
   */
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  cursor: Scalars['Cursor']['output'];
  /** The verification action at the end of this edge. */
  node?: Maybe<VerificationPredicate>;
  /** Some custom, html-formatted remarks about this predicate value for the `AnalysisEntry`. */
  remarks?: Maybe<Scalars['HTML']['output']>;
  /**
   * A list of possible predicate values for that this entry must have to decide for all rules that depend on
   * the predicate in `node` if they apply to the entry.
   * @deprecated irrelevant, Actions will just become undecidable
   */
  requires?: Maybe<PredicateValueSet>;
  /**
   * The value of this entry for the predicate in `node`. This value is only `null` if the database could not retrieve
   * this value in the query or or if the user has no permission to see this value.
   */
  value?: Maybe<PredicateValue>;
};

export type AnalysisReportInvalidStateException = Exception & MutationPayload & {
  __typename: 'AnalysisReportInvalidStateException';
  /** The allowed states of analysis reports to run the mutation. */
  allowedStates?: Maybe<Array<AnalysisReportState>>;
  /** The analysis report that has the invalid state. */
  analysisReport?: Maybe<AnalysisReport>;
  /** The message of the exception. */
  message?: Maybe<Message>;
  query: Query;
};

/**
 * Specifies how the edges to a `AnalysisReport` will be ordered in a connection.
 *
 * This type was automatically generated from the `AnalysisReportOrderByColumn` column-type used in the
 * `orderBy` argument of the `Team.analysisReports` field. (It might be possible that it is reused by
 * other fields.)
 */
export type AnalysisReportOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: AnalysisReportOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `AnalysisReportOrderByColumn`. */
export enum AnalysisReportOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type AnalysisReportProductRisk = Commentable & Node & Ownable & {
  __typename: 'AnalysisReportProductRisk';
  analysisReport?: Maybe<AnalysisReport>;
  /** The comments for this `AnalysisReportProductRisk`-object. */
  comments?: Maybe<CommentConnection>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Checks whether this `AnalysisReportProductRisk` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `AnalysisReportProductRisk` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `AnalysisReportProductRisk` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `AnalysisReportProductRisk` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /** A reference to the owner that owns this `AnalysisReportProductRisk`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `AnalysisReportProductRisk` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The predicate value of this product risk.
   *
   * This is normally the evaluated value of the `riskPredicateExpression` using the values from `productPredicates`.
   * Note that this value can be overwritten by a user.
   */
  predicateValue?: Maybe<PredicateValue>;
  /** Whether the `predicateValue` was overwritten after this product risk was generated. */
  predicateValueUpdated?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The moment on which the `predicateValue` was overwritten after the product risk was generated.
   *
   * This value will always be `null` when `predicateValueUpdated` is `false`.
   */
  predicateValueUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The user that overwrote the `predicateValue` after the product risks were generated.
   *
   * This value will always be `null` when `predicateValueUpdated` is `false`.
   */
  predicateValueUpdatedBy?: Maybe<User>;
  product?: Maybe<Product>;
  /**
   * A list of product predicates that contributed to the choice of this `AnalysisReportProductRisk`.
   *
   * Could be used to determine why this `AnalysisReportProductRisk` is in an analysis report.
   *
   * This value is cached, which means that it will not change if the predicate expression of the risk
   * is changed after the `AnalysisReportProductRisk` was generated.
   */
  productPredicates?: Maybe<AnalysisReportProductRisk_ProductPredicateConnection>;
  /**
   * The `ProductCategory` of the product in the `AnalysisReportProductRisk.product` field via which the risk in
   * `AnalysisReportProductRisk.risk` was an possible risk.
   *
   * Could be used to determine why this `AnalysisReportProductRisk` is in an analysis report.
   *
   * This value is cached, which means that it will not change if the product-categories of the product or risk
   * is changed after the `AnalysisReportProductRisk` was generated.
   */
  productProductCategory?: Maybe<ProductCategory>;
  risk?: Maybe<Risk>;
  /**
   * The predicate expression of the risk at the time that the `AnalysisReportProductRisk` was generated.
   *
   * Could be used to determine why this `AnalysisReportProductRisk` is in an analysis report.
   *
   * This value is cached, which means that it will not change if the predicate expression of the risk
   * is changed after the `AnalysisReportProductRisk` was generated.
   */
  riskPredicateExpression?: Maybe<ProductPredicateExpression>;
  /**
   * The `ProductCategory` of the risk in the `AnalysisReportProductRisk.risk` field via which the risk was relevant for
   * the product in `AnalysisReportProductRisk.product`.
   *
   * Could be used to determine why this `AnalysisReportProductRisk` is in an analysis report.
   *
   * This value is cached, which means that it will not change if the product-categories of the product or risk
   * is changed after the `AnalysisReportProductRisk` was generated.
   */
  riskProductCategory?: Maybe<ProductCategory>;
  threat?: Maybe<Threat>;
};


export type AnalysisReportProductRiskCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type AnalysisReportProductRiskIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type AnalysisReportProductRiskIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type AnalysisReportProductRiskOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type AnalysisReportProductRiskProductPredicatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A paged connection with `AnalysisReportProductRiskEdge` edges to `AnalysisReportProductRisk` nodes.
 *
 * This type was automatically generated from the `AnalysisReportProductRiskEdge` edge-type for the
 * `AnalysisReport.productRisks` field. (It might be possible that it is reused by other fields.)
 */
export type AnalysisReportProductRiskConnection = Connection & ConnectionWithTotal & {
  __typename: 'AnalysisReportProductRiskConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<AnalysisReportProductRiskEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<AnalysisReportProductRisk>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `AnalysisReportProductRiskConnection` connection that points to a `AnalysisReportProductRisk` node.
 *
 * This type was automatically generated from the `AnalysisReportProductRisk` node-type of the
 * `AnalysisReport.productRisks` field. (It might be possible that it is reused by other fields.)
 */
export type AnalysisReportProductRiskEdge = Edge & {
  __typename: 'AnalysisReportProductRiskEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: AnalysisReportProductRisk;
};

/**
 * Determines how a set of `AnalysisReportProductRisk` should be handled when generating the
 * `AnalysisReportEntry`-entities.
 */
export enum AnalysisReportProductRiskIncludeMethod {
  /** Throw an error when one of these product risks are encountered. */
  Error = 'ERROR',
  /** Ignore the product risks when generating the entries. (No entries will be created from these product risks.) */
  Ignore = 'IGNORE',
  /** Include product risks when generating the entries. */
  Include = 'INCLUDE'
}

/**
 * Specifies how the edges to a `AnalysisReportProductRisk` will be ordered in a connection.
 *
 * This type was automatically generated from the `AnalysisReportProductRiskOrderByColumn` column-type used in the
 * `orderBy` argument of the `AnalysisReport.productRisks` field. (It might be possible that it is reused by
 * other fields.)
 */
export type AnalysisReportProductRiskOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: AnalysisReportProductRiskOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `AnalysisReportProductRiskOrderByColumn`. */
export enum AnalysisReportProductRiskOrderByColumn {
  AnalysisReport = 'ANALYSIS_REPORT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  PredicateValue = 'PREDICATE_VALUE',
  Product = 'PRODUCT',
  /**
   * Alias for `CLIENT_REF`.
   *
   *  Form owner-type `Product`.
   */
  ProductClientRef = 'PRODUCT_CLIENT_REF',
  /**
   * Alias for `NAME_FULL`.
   *
   *  Form owner-type `Product`.
   */
  ProductNameFull = 'PRODUCT_NAME_FULL',
  /**
   * Alias for `NAME_SHORT`.
   *
   *  Form owner-type `Product`.
   */
  ProductNameShort = 'PRODUCT_NAME_SHORT',
  Risk = 'RISK',
  /**
   * Alias for `THREAT_NAME_FULL`.
   *
   *  Form owner-type `Risk`.
   */
  ThreatNameFull = 'THREAT_NAME_FULL',
  /**
   * Alias for `THREAT_NAME_SHORT`.
   *
   *  Form owner-type `Risk`.
   */
  ThreatNameShort = 'THREAT_NAME_SHORT'
}

export type AnalysisReportProductRiskWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on the predicate value of the product risks itself. */
  predicateValue?: InputMaybe<PredicateValue>;
  /** Filters on the moment that the predicate value was updated after this product risk was generated. */
  predicateValueUpdated?: InputMaybe<StampedEventConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `analysisReportEntries`. */
  totalAnalysisReportEntries?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `productRiskPredicateValues`. */
  totalProductRiskPredicateValues?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnalysisReportProductRisk_ProductPredicateConnection = {
  __typename: 'AnalysisReportProductRisk_ProductPredicateConnection';
  edges?: Maybe<Array<Maybe<AnalysisReportProductRisk_ProductPredicateEdge>>>;
  nodes?: Maybe<Array<Maybe<ProductPredicate>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AnalysisReportProductRisk_ProductPredicateEdge = {
  __typename: 'AnalysisReportProductRisk_ProductPredicateEdge';
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  cursor: Scalars['Cursor']['output'];
  node?: Maybe<ProductPredicate>;
  value?: Maybe<PredicateValue>;
};

/** Warning that indicates that the risk configuration has changed after the product risks were generated. */
export type AnalysisReportRiskConfigurationChangedWarning = Warning & {
  __typename: 'AnalysisReportRiskConfigurationChangedWarning';
  message: Message;
};

/** Represents the current state of an analysis report. */
export enum AnalysisReportState {
  /**
   * State where the analysis report exists, but no products are selected.
   *
   * User interaction is required to proceed to the next state.
   */
  AwaitingSelection = 'AWAITING_SELECTION',
  /**
   * State where both product risks and entries have been generated.
   *
   * This is the final state for the analysis report.
   */
  EntriesGenerated = 'ENTRIES_GENERATED',
  /**
   * State where the job to generate the entries is queued (and might be running).
   *
   * Patience is required to proceed to the next state.
   */
  GeneratingEntries = 'GENERATING_ENTRIES',
  /**
   * State where the job to generate the product risks is queued (and might be running).
   *
   * Patience is required to proceed to the next state.
   */
  GeneratingProductRisks = 'GENERATING_PRODUCT_RISKS',
  /**
   * State where products are selected, but the product risks are not yet generated.
   *
   * User interaction is required to proceed to the next state.
   */
  ProductsSelectedProductRiskPending = 'PRODUCTS_SELECTED__PRODUCT_RISK_PENDING',
  /**
   * State where product risks have been generated, but not the entries.
   *
   * User interaction is required to proceed to the next state.
   */
  ProductRisksGeneratedEntriesPending = 'PRODUCT_RISKS_GENERATED__ENTRIES_PENDING'
}

export type AnalysisReportTodoConnection = {
  __typename: 'AnalysisReportTodoConnection';
  edges: Array<AnalysisReportTodoEdge>;
  nodes: Array<Todo>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AnalysisReportTodoEdge = {
  __typename: 'AnalysisReportTodoEdge';
  cursor: Scalars['Cursor']['output'];
  node: Todo;
};

/**
 * Exception that is returned when there are new todo items for the analysis report that need to be resolved before
 * the analysis report can be generated.
 */
export type AnalysisReportTodoListNotEmptyException = Exception & MutationPayload & {
  __typename: 'AnalysisReportTodoListNotEmptyException';
  analysisReport?: Maybe<AnalysisReport>;
  message?: Maybe<Message>;
  query: Query;
};

/** Warning that indicates that the verification configuration has changed after the verification actions were generated. */
export type AnalysisReportVerificationConfigurationChangedWarning = Warning & {
  __typename: 'AnalysisReportVerificationConfigurationChangedWarning';
  message: Message;
};

export type AnalysisReportWarning = AnalysisReportRiskConfigurationChangedWarning | AnalysisReportVerificationConfigurationChangedWarning;

export type AnalysisReportWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries on the meta-data of the `entriesGenerated`-event. */
  entriesGenerated?: InputMaybe<DateTimeEventConstraints>;
  /** Filters the entries on the meta-data of the `generateEntriesQueued`-event. */
  generateEntriesQueued?: InputMaybe<DateTimeEventConstraints>;
  /** Filters the entries on the meta-data of the `generateProductRisksQueued`-event. */
  generateProductRisksQueued?: InputMaybe<DateTimeEventConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries on the meta-data of the `outdated`-event. */
  outdated?: InputMaybe<DateTimeEventConstraints>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters the entries on the meta-data of the `productRisksGenerated`-event. */
  productRisksGenerated?: InputMaybe<DateTimeEventConstraints>;
  /** Filters the entries on the meta-data of the `productsSelected`-event. */
  productsSelected?: InputMaybe<DateTimeEventConstraints>;
  /** Filters analysis reports are in the provided state. */
  state?: InputMaybe<AnalysisReportState>;
  /** Filters the entries by the total amount of related items they have in the relation `entries`. */
  totalAnalysisReportEntries?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `productRisks`. */
  totalAnalysisReportProductRisks?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `verificationRules`. */
  totalApplicableVerificationConfigurationRules?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters on the total amount of selected products in this analysis-report. */
  totalSelectedProducts?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters the entries on the meta-data of the `verificationActionsGenerated`-event. */
  verificationActionsGenerated?: InputMaybe<DateTimeEventConstraints>;
  /** Filters the entries on the meta-data of the `verificationPredicateValuesGenerated`-event. */
  verificationPredicateValuesGenerated?: InputMaybe<DateTimeEventConstraints>;
};

export type AnalysisReport_RiskConfigurationConnection = Connection & ConnectionWithTotal & {
  __typename: 'AnalysisReport_RiskConfigurationConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<AnalysisReport_RiskConfigurationEdge>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<RiskConfiguration>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AnalysisReport_RiskConfigurationEdge = Edge & {
  __typename: 'AnalysisReport_RiskConfigurationEdge';
  cursor: Scalars['Cursor']['output'];
  /**
   * The order in which the preferred configuration is picked in case there is no preference found otherwise.
   *
   * The lowest number will be tried first.
   */
  fallbackOrder: Scalars['Int']['output'];
  /** The `RiskConfiguration` selected for the `AnalysisReport`. */
  node?: Maybe<RiskConfiguration>;
};

/** Todo item that can be resolved by assigning a product to the product the the `product` field. */
export type AssignProductCategoryToProductTodo = Node & Todo & {
  __typename: 'AssignProductCategoryToProductTodo';
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this `Todo` item is considered to be done. */
  isDone?: Maybe<Scalars['Boolean']['output']>;
  /** The product that needs at least one assigned product category. */
  product?: Maybe<Product>;
  /** The title for this todo item that can be used to display it in a todo list. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Todo item that can be resolved by assigning a supplier branch to the product in the `product` field. */
export type AssignSupplierBranchToProductTodo = Node & Todo & {
  __typename: 'AssignSupplierBranchToProductTodo';
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this `Todo` item is considered to be done. */
  isDone?: Maybe<Scalars['Boolean']['output']>;
  /** The product that needs to have at least one assigned supplier branch. */
  product?: Maybe<Product>;
  /** The title for this todo item that can be used to display it in a todo list. */
  title?: Maybe<Scalars['String']['output']>;
};

export type AssignTeamRoleInput = {
  role: TeamRole;
  team: Scalars['ID']['input'];
  user: Scalars['ID']['input'];
};

export type AssignTeamRole_SuccessResult = MutationPayload & {
  __typename: 'AssignTeamRole_SuccessResult';
  assignedRole: TeamRole;
  query: Query;
  team: Team;
  user: User;
};

export type AssignTeamRolesInput = {
  roles: Array<TeamRole>;
  team: Scalars['ID']['input'];
  user: Scalars['ID']['input'];
};

export type AssignTeamRoles_SuccessResult = MutationPayload & {
  __typename: 'AssignTeamRoles_SuccessResult';
  assignedRoles: Array<TeamRole>;
  query: Query;
  team: Team;
  user: User;
};

export type AssignUserRoleInput = {
  role: UserRole;
  user: Scalars['ID']['input'];
};

export type AssignUserRole_SuccessResult = MutationPayload & {
  __typename: 'AssignUserRole_SuccessResult';
  assignedRole: UserRole;
  query: Query;
  user: User;
};

export type AssignUserRolesInput = {
  roles: Array<UserRole>;
  user: Scalars['ID']['input'];
};

export type AssignUserRoles_SuccessResult = MutationPayload & {
  __typename: 'AssignUserRoles_SuccessResult';
  assignedRoles: Array<UserRole>;
  query: Query;
  user: User;
};

export type AttachCommentsInput = {
  attach?: Array<AttachCommentsInputAttach>;
};

export type AttachCommentsInputAttach = {
  comment?: InputMaybe<Scalars['HTML']['input']>;
  isPublic?: Scalars['Boolean']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AttachProductCategoriesInput = {
  attach?: InputMaybe<Array<ConnectProductCategoryInput>>;
};

export type AttachProductsInput = {
  attach?: InputMaybe<Array<ConnectProductInput>>;
};

export type AttachRegionsInput = {
  attach?: InputMaybe<Array<ConnectRegionInput>>;
};

export type AttachRiskValueInput = {
  configuration: ConnectRiskConfigurationInput;
  remarks?: InputMaybe<Scalars['HTML']['input']>;
  value: Scalars['Float']['input'];
};

export type AttachRiskValuesInput = {
  attach?: Array<AttachRiskValueInput>;
};

export type AttachSupplierBranchesInput = {
  attach?: InputMaybe<Array<ConnectSupplierBranchInput>>;
};

export type AttachTagsInput = {
  /** The IDs of the `Taggable` nodes to which you want to attach the tags. */
  taggables: Array<Scalars['ID']['input']>;
  /** The IDs of the tags you want to attach. */
  tags: Array<Scalars['ID']['input']>;
};

export type AttachTagsPayload = AttachTags_SuccessResult;

export type AttachTags_SuccessResult = MutationPayload & {
  __typename: 'AttachTags_SuccessResult';
  query: Query;
};

/** Represents an audited change by a successfully executed mutation. */
export type Audit = {
  /** The comments assigned to this node. */
  comments?: Maybe<CommentConnection>;
  /** `DateTime` on which this `Audit`-node was generated. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The user that performed the mutation that generated this `Audit`-node.
   *
   * This value is always in sync with the `createdAt`-field.
   */
  creator?: Maybe<User>;
  /** The client-application that the `creator` used at the moment when he/she generated this `Audit`-node. */
  creatorClient?: Maybe<Client>;
  /** The IP-address of the `creator` at the moment when he/she generated this `Audit`-node. */
  creatorIpAddress?: Maybe<Scalars['IpAddress']['output']>;
  /**
   * The team of the `creator` at the moment when he/she generated this `Audit`-node.
   *
   * See the `Audit.creator`-field for more information.
   */
  creatorTeam?: Maybe<Team>;
  /** The user-agent of the `creator` at the moment when he/she generated this `Audit`-node. */
  creatorUserAgent?: Maybe<Scalars['UserAgent']['output']>;
  /** The last user that edited this audit. This value is always in sync with the `updatedAt`-field. */
  editor?: Maybe<User>;
  /** The event type for which this `Audit`-node was generated. */
  event?: Maybe<AuditedEvent>;
  /**
   * The name of the GraphQL operation that was responsible for this `Audit`-node.
   *
   * Use this value in combination with the `client`-field to derive how this audit was created.
   */
  graphqlOperation?: Maybe<Scalars['String']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   */
  id: Scalars['ID']['output'];
  /**
   * Whether this node is considered to be new.
   *
   * This feature was inherited from the `Shared Robotics`-project. It is left in as it might be useful in the future.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this node is considered to be updated.
   *
   * This feature was inherited from the `Shared Robotics`-project. It is left in as it might be useful in the future.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** An HTML-formatted text containing some remarks about the mutation that generated this audit-node. */
  remarks?: Maybe<Scalars['HTML']['output']>;
  /** The tags assigned to this node. */
  tags?: Maybe<TagConnection>;
  /** `DateTime` of the last moment on which this node was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** Represents an audited change by a successfully executed mutation. */
export type AuditCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


/** Represents an audited change by a successfully executed mutation. */
export type AuditIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** Represents an audited change by a successfully executed mutation. */
export type AuditIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** Represents an audited change by a successfully executed mutation. */
export type AuditTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

export type AuditConnection = {
  __typename: 'AuditConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<AuditEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Audit>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AuditEdge = {
  __typename: 'AuditEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /** The audit at the end of this edge. */
  node?: Maybe<Audit>;
};

export type AuditMessageInput = {
  /** The public info of the audit message. */
  publicInfo?: InputMaybe<Scalars['HTML']['input']>;
  /** Whether this audit message should be published in an update-email. */
  publishable: Scalars['Boolean']['input'];
  /** The moment after which this audit message is allowed to be published. */
  publishableAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** The title for the audit message. */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type AuditOrderByClause = {
  /** The column on which you want to order the audit entries. */
  column: AuditOrderByColumn;
  /** The sorting order of the column. */
  sortOrder?: SortOrder;
};

export enum AuditOrderByColumn {
  /** Orders by the moment on which the audit entries were generated. */
  CreatedAt = 'CREATED_AT'
}

export type AuditWhereClause = {
  /** Filters the audit entries on the moment they were created/generated. */
  created?: InputMaybe<DateTimeConstraints>;
  /** Filters the audit entries on the event type. */
  event?: InputMaybe<AuditedEvent>;
};

/** Represents the type of event that could generate an `Audit`-node. */
export enum AuditedEvent {
  /** Represents the event where a new node or edge was created. */
  Created = 'CREATED',
  /** Represents the event where a node or edge was (soft)deleted. */
  Deleted = 'DELETED',
  /** Represents the event where a soft-deleted node or edge was restored. */
  Restored = 'RESTORED',
  /** Represents the event where the attributes on an existing node or edge were edited. */
  Updated = 'UPDATED'
}

export type AzureBlobStorageFileUploadRequest = FileUploadRequest & {
  __typename: 'AzureBlobStorageFileUploadRequest';
  /** The name of the blob to which the file should be uploaded. */
  blobName?: Maybe<Scalars['String']['output']>;
  /** The name of the container in which the blob will be stored. */
  containerName?: Maybe<Scalars['String']['output']>;
  /** The content type that the file must have. */
  contentType: Scalars['ContentType']['output'];
  /** The moment after which this request is no longer valid. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The sasToken to authorize the upload request. */
  sasToken?: Maybe<Scalars['String']['output']>;
  /** The public endpoint of the Azure BlobStorage service. */
  serviceUri: Scalars['URL']['output'];
  /** The moment after which the request is valid. */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The uri for the blob or container targeted by this request without the signing part. */
  storageObjectUri: Scalars['URL']['output'];
  /** The endpoint to upload the file to. */
  uri: Scalars['URL']['output'];
};

export type BlobClientRequest = {
  __typename: 'BlobClientRequest';
  blob?: Maybe<Scalars['String']['output']>;
  container: Scalars['String']['output'];
  contentType?: Maybe<Scalars['ContentType']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  sasToken: Scalars['String']['output'];
  signedUrl: Scalars['URL']['output'];
  startsAt: Scalars['DateTime']['output'];
  url: Scalars['URL']['output'];
};

export type CancelUserInvitationInput = {
  /** The id of the user invitation you want to cancel. */
  id: Scalars['ID']['input'];
};

export type CancelUserInvitation_SuccessResult = MutationPayload & {
  __typename: 'CancelUserInvitation_SuccessResult';
  /** The user invitation that was cancelled by this mutation. */
  node: UserInvitation;
  query: Query;
};

export type ClearAnalysisReportEntries_SuccessResult = MutationPayload & {
  __typename: 'ClearAnalysisReportEntries_SuccessResult';
  node: AnalysisReport;
  query: Query;
};

export type ClearAnalysisReportEntryVerificationActionsResult = {
  __typename: 'ClearAnalysisReportEntryVerificationActionsResult';
  node: AnalysisReport;
};

export type ClearAnalysisReportEntryVerificationPredicateValues_SuccessResult = MutationPayload & {
  __typename: 'ClearAnalysisReportEntryVerificationPredicateValues_SuccessResult';
  node: AnalysisReport;
  query: Query;
};

export type ClearAnalysisReportProductRisks_SuccessResult = MutationPayload & {
  __typename: 'ClearAnalysisReportProductRisks_SuccessResult';
  node: AnalysisReport;
  query: Query;
};

export type ClearAnalysisReportProducts_SuccessResult = MutationPayload & {
  __typename: 'ClearAnalysisReportProducts_SuccessResult';
  node: AnalysisReport;
  query: Query;
};

export type ClearAnalysisReportRiskConfigurations_SuccessResult = MutationPayload & {
  __typename: 'ClearAnalysisReportRiskConfigurations_SuccessResult';
  node: AnalysisReport;
  query: Query;
};

/** Represents an Azure B2C client application that communicates with this GraphQL-API. */
export type Client = Node & {
  __typename: 'Client';
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   */
  id: Scalars['ID']['output'];
  /** The UUID of the client. */
  uuid?: Maybe<Scalars['ExternalKey']['output']>;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `ClientOrderByColumn`. */
export enum ClientOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

/** The explicit roles that can be assigned to Client-applications of this GraphQL API. */
export enum ClientRole {
  /**
   * ### Job Worker *[Client]*
   *
   * Applicatie die achtergrondtaken afhandeld.
   */
  JobWorker = 'JOB_WORKER',
  /**
   * ### Export-applicatie van systeemgegevens *[Client]*
   *
   * Export-applicatie die de globale data kan exporteren.
   */
  SystemExportApp = 'SYSTEM_EXPORT_APP',
  /**
   * ### Test-data zaaimachine *[Client]*
   *
   * Applicatie die gegevens klaarzet in de database voor testdoeleinden.
   */
  TestDataSeeder = 'TEST_DATA_SEEDER',
  /**
   * ### Test applicatie *[Client]*
   *
   * Applicatie die de test-gegevens in de database manipuleert en beweringen over test-gegevens controleert.
   */
  TestExecutor = 'TEST_EXECUTOR',
  /**
   * ### Export-applicatie van gebruikersgegevens *[Client]*
   *
   * Applicatie die namens een gebruiker data exporteert.
   */
  UserExportApp = 'USER_EXPORT_APP',
  /**
   * ### Import-applicatie van gebruikersgegevens *[Client]*
   *
   * Applicatie die namens een gebruiker data kan importeert.
   */
  UserImportApp = 'USER_IMPORT_APP'
}

/**
 * The color-values that may be chosen by the user.
 *
 * A GUI-application should determine for itself how to map these values to actual color-codes.
 */
export enum Color {
  Avocado = 'AVOCADO',
  Black = 'BLACK',
  Blue = 'BLUE',
  Bluegray = 'BLUEGRAY',
  Cyan = 'CYAN',
  Gray = 'GRAY',
  Green = 'GREEN',
  Indigo = 'INDIGO',
  Orange = 'ORANGE',
  Pink = 'PINK',
  Purple = 'PURPLE',
  Red = 'RED',
  Teal = 'TEAL',
  White = 'WHITE',
  Yellow = 'YELLOW'
}

export type Comment = Commentable & Node & Timestamped & Userstamped & {
  __typename: 'Comment';
  /** The node to which this comment was made. */
  about?: Maybe<Commentable>;
  /** The HTML-formatted content of the comment. */
  comment?: Maybe<Scalars['HTML']['output']>;
  /** The comments for this `Comment`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `Comment`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `Comment`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `Comment`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `Comment`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this Comment is considered to be public. Public comments are meant to be shown by all users that are
   * allowed to see the node in the `about` field. Internal comments are only visible to the the Précon staff.
   */
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `Comment`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** The title of the comment. */
  title?: Maybe<Scalars['String']['output']>;
  /** Gives the most recent moment on which this `Comment`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CommentCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type CommentIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type CommentIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};

/**
 * A paged connection with `CommentEdge` edges to `Comment` nodes.
 *
 * This type was automatically generated from the `CommentEdge` edge-type for the
 * `AnalysisReport.comments` field. (It might be possible that it is reused by other fields.)
 */
export type CommentConnection = Connection & ConnectionWithTotal & {
  __typename: 'CommentConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<CommentEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Comment>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `CommentConnection` connection that points to a `Comment` node.
 *
 * This type was automatically generated from the `Comment` node-type of the
 * `AnalysisReport.comments` field. (It might be possible that it is reused by other fields.)
 */
export type CommentEdge = Edge & {
  __typename: 'CommentEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: Comment;
};

/**
 * Specifies how the edges to a `Comment` will be ordered in a connection.
 *
 * This type was automatically generated from the `CommentOrderByColumn` column-type used in the
 * `orderBy` argument of the `AnalysisReport.comments` field. (It might be possible that it is reused by
 * other fields.)
 */
export type CommentOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: CommentOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `CommentOrderByColumn`. */
export enum CommentOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Order by the titles of the comments. */
  Title = 'TITLE',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type CommentWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
};

/** Interface for objects that can have comments assigned to them. */
export type Commentable = {
  /** The comments assigned to this node. */
  comments?: Maybe<CommentConnection>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
};


/** Interface for objects that can have comments assigned to them. */
export type CommentableCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};

export type Company = Activateable & Commentable & Named & Node & Selectable & Sluggable & Taggable & Timestamped & Userstamped & {
  __typename: 'Company';
  /** The comments for this `Company`-object. */
  comments?: Maybe<CommentConnection>;
  /** The contact-persons that belong to this company. */
  contacts?: Maybe<Company_ContactConnection>;
  /** Gives the `DateTime` on which this `Company`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `Company`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** Timestamp of when this `Company`-object was deactivated. */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that deactivated this `Company`-object. */
  deactivator?: Maybe<User>;
  /**
   * A description of this company. This field is also used for full-text searches.
   *
   * This value is safe to display to the user in a GUI.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _updated_ this `Company`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /** The general e-mail address for the company as a whole. (Usually some `info@...` address.) */
  email?: Maybe<Scalars['Email']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this `Company`-object is considered to be active. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `Company`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `Company`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of this company.
   *
   * This value is safe to display to the user in a GUI.
   */
  name?: Maybe<Name>;
  /** A unique identifier for this company. */
  number?: Maybe<Scalars['Int']['output']>;
  /** The main phone number of the company as a whole. */
  phone: PhoneNumber;
  /** The address of the company. */
  postalAddress: Address;
  /**
   * The `slug`, which is an *url-* and *filename-*safe string that uniquely identifies a node with a specific type.
   * It's value is usually derived from the initial data of the node (so the data it had when it was created).
   *
   * There are some important differences with the `id`-field:
   * 1. The value of `id` is always set, the value of `slug` might sometimes be `null` even if the node itself does
   *    exists. This happens for instance when the node is soft-deleted.
   * 2. The value of `id` is globally unique, the value of `slug` is only unique in combination with the `__typename`.
   * 3. The value of `id` always refers to the **current node and only the current node**. The value of `slug` might
   *    refer to a different node over time. (Example: when an old node is soft-deleted and a new node with the same
   *    name is created. The new node will have the same `slug`-value as the older node.)
   * 4. The `slug` is guaranteed to be *url-* and *filename-*safe. The `id`-field does not have these guarantees.
   *
   * When available, prefer the `slug`-field over the `id`-field for usage in urls. For caching and communication with
   * the api, you should always use the `id`-field over the `slug`-field.
   */
  slug?: Maybe<Scalars['Slug']['output']>;
  /** Connection to the tags that are assigned to this `Company`. */
  tags?: Maybe<TagConnection>;
  /** The teams of this company. */
  teams?: Maybe<TeamConnection>;
  /** Gives the most recent moment on which this `Company`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The main website of this company. */
  website?: Maybe<Scalars['URL']['output']>;
};


export type CompanyCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type CompanyContactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContactOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<ContactWhereClause>>;
};


export type CompanyIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type CompanyIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type CompanyTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};


export type CompanyTeamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<TeamWhereClause>>;
};

/**
 * A paged connection with `CompanyEdge` edges to `Company` nodes.
 *
 * This type was automatically generated from the `CompanyEdge` edge-type for the
 * `Query.companies` field. (It might be possible that it is reused by other fields.)
 */
export type CompanyConnection = Connection & ConnectionWithTotal & {
  __typename: 'CompanyConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<CompanyEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Company>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CompanyEdge = Edge & {
  __typename: 'CompanyEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node at the end of this edge. */
  node: Company;
};

/**
 * Specifies how the edges to a `Company` will be ordered in a connection.
 *
 * This type was automatically generated from the `CompanyOrderByColumn` column-type used in the
 * `orderBy` argument of the `Query.companies` field. (It might be possible that it is reused by
 * other fields.)
 */
export type CompanyOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: CompanyOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `CompanyOrderByColumn`. */
export enum CompanyOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which an entity was deactivated. */
  DeactivatedAt = 'DEACTIVATED_AT',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /** Orders by the company client-number. */
  Number = 'NUMBER',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type CompanyWhereClause = {
  /** Filter entries based on the current active state. See the `WhereActive`-enum for more information. */
  active?: InputMaybe<WhereActive>;
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were deactivated. */
  deactivated?: InputMaybe<StampedEventConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `contacts`. */
  totalContacts?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `teams`. */
  totalTeams?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
};

export type Company_ContactConnection = Connection & ConnectionWithTotal & {
  __typename: 'Company_ContactConnection';
  /**
   * The default contact for this company.
   *
   * ### TODO: Not implemented
   *
   * *This feature is not (fully) implemented yet!*
   */
  defaultContact?: Maybe<Contact>;
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<Company_ContactEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Contact>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Company_ContactEdge = Edge & {
  __typename: 'Company_ContactEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /**
   * Whether this contact is the default contact for the company at the start of this edge.
   *
   * ### TODO: Not implemented
   *
   * *This feature is not (fully) implemented yet!*
   */
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** The node at the end of this edge. */
  node: Contact;
};

export type ConnectCommentsInput = {
  attach?: Array<AttachCommentsInputAttach>;
};

export type ConnectCompanyInput = {
  connect: Scalars['ID']['input'];
};

export type ConnectContactInput = {
  connect?: InputMaybe<Scalars['ID']['input']>;
  create?: InputMaybe<CreateContactInput>;
};

export type ConnectContactInputWithUpsert = {
  connect?: InputMaybe<Scalars['ID']['input']>;
  create?: InputMaybe<CreateContactInput>;
  upsert?: InputMaybe<UpsertContactInput>;
};

export type ConnectProductCategoriesInput = {
  attach?: InputMaybe<Array<ConnectProductCategoryInput>>;
  detach?: InputMaybe<Array<Scalars['ID']['input']>>;
  sync?: InputMaybe<Array<ConnectProductCategoryInput>>;
};

export type ConnectProductCategoryInput = {
  connect?: InputMaybe<Scalars['ID']['input']>;
  create?: InputMaybe<CreateProductCategoryInput>;
};

export type ConnectProductInput = {
  connect?: InputMaybe<Scalars['ID']['input']>;
  create?: InputMaybe<CreateProductInput>;
};

export type ConnectProductsInput = {
  attach?: InputMaybe<Array<ConnectProductInput>>;
  detach?: InputMaybe<Array<Scalars['ID']['input']>>;
  sync?: InputMaybe<Array<ConnectProductInput>>;
};

export type ConnectRegionInput = {
  connect?: InputMaybe<Scalars['ID']['input']>;
  create?: InputMaybe<CreateRegionInput>;
};

export type ConnectRegionsInput = {
  attach?: InputMaybe<Array<ConnectRegionInput>>;
  detach?: InputMaybe<Array<Scalars['ID']['input']>>;
  sync?: InputMaybe<Array<ConnectRegionInput>>;
};

export type ConnectRiskColumnInput = {
  connect?: InputMaybe<Scalars['ID']['input']>;
  create?: InputMaybe<CreateRiskColumnInput>;
};

export type ConnectRiskConfigurationInput = {
  connect: Scalars['ID']['input'];
};

export type ConnectRiskConfigurationsInput = {
  attach?: InputMaybe<Array<ConnectRiskConfigurationInput>>;
};

export type ConnectRiskInput = {
  connect?: InputMaybe<Scalars['ID']['input']>;
  create?: InputMaybe<CreateRiskInput>;
};

export type ConnectRiskValuesInput = {
  attach?: InputMaybe<Array<AttachRiskValueInput>>;
  detach?: InputMaybe<Array<Scalars['ID']['input']>>;
  update?: InputMaybe<Array<UpdateRiskValueInput>>;
};

export type ConnectRisksInput = {
  attach?: InputMaybe<Array<ConnectRiskInput>>;
  detach?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ConnectSupplierBranchInput = {
  connect?: InputMaybe<Scalars['ID']['input']>;
  create?: InputMaybe<CreateSupplierBranchInput>;
};

export type ConnectSupplierBranchesInput = {
  attach?: InputMaybe<Array<ConnectSupplierBranchInput>>;
  detach?: InputMaybe<Array<Scalars['ID']['input']>>;
  sync?: InputMaybe<Array<ConnectSupplierBranchInput>>;
};

export type ConnectSupplierInput = {
  connect?: InputMaybe<Scalars['ID']['input']>;
  create?: InputMaybe<CreateSupplierInput>;
};

/**
 * Connects a `SupplierReliability`-node.
 *
 * IMPORTANT: You MUST specify exactly one field.
 */
export type ConnectSupplierReliabilityInput = {
  /** Connects a `SupplierReliability` by id. Cannot be uses in combination with the `connectValue` field. */
  connect?: InputMaybe<Scalars['ID']['input']>;
  /** Connects a `SupplierReliability` by its value. Cannot be used in combination with the `connect` field. */
  connectValue?: InputMaybe<SupplierReliabilityValue>;
};

export type ConnectTeamInput = {
  connect: Scalars['ID']['input'];
};

export type ConnectThreatCategoryInput = {
  connect?: InputMaybe<Scalars['ID']['input']>;
  create?: InputMaybe<CreateThreatCategoryInput>;
};

export type ConnectThreatInput = {
  connect?: InputMaybe<Scalars['ID']['input']>;
  create?: InputMaybe<CreateThreatInput>;
};

export type ConnectUserInput = {
  connect: Scalars['ID']['input'];
};

export type ConnectVerificationAction = {
  connect?: InputMaybe<Scalars['ID']['input']>;
  create?: InputMaybe<CreateVerificationActionInput>;
};

export type ConnectVerificationConfigurationInput = {
  connect: Scalars['ID']['input'];
};

export type ConnectVerificationConfigurationsInput = {
  attach?: InputMaybe<Array<ConnectVerificationConfigurationInput>>;
};

/**
 * Objects that implement this interface represent a collection of connections to another node.
 *
 * **Important!** Due to the limitations of the GraphQL-language, it is not possible to have every connection-field
 * implementing this interface. This might result in some confusing behavior when relying on fragments that use this
 * interface.
 *
 * In general, every type that ends with "Connection" are considered to be connections.
 */
export type Connection = {
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<Edge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Node>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
};

/**
 * Objects that implement this interface represent a collection of connections to another node for which it could be
 * possible to get the total amount of edges.
 */
export type ConnectionWithTotal = {
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<Edge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Node>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Represents a "real-world" individual. */
export type Contact = Activateable & Commentable & Named & Node & Selectable & Taggable & Timestamped & Userstamped & {
  __typename: 'Contact';
  /** Connection to the accounts that are associated with this contact. */
  accounts?: Maybe<AccountConnection>;
  /** The comments for this `Contact`-object. */
  comments?: Maybe<CommentConnection>;
  /** The company to which this contact is associated. */
  company?: Maybe<Company>;
  /** Gives the `DateTime` on which this `Contact`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `Contact`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** Timestamp of when this `Contact`-object was deactivated. */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that deactivated this `Contact`-object. */
  deactivator?: Maybe<User>;
  /** A human-readable string description of this contact. This value is also used in full-text searches. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _updated_ this `Contact`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /** The email address of this contact. Is always `null` if `Contact.hasEmail` is `false`. */
  email?: Maybe<Scalars['Email']['output']>;
  /** Whether this contact has it's email address set. */
  hasEmail?: Maybe<Scalars['Boolean']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this `Contact`-object is considered to be active. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `Contact`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `Contact`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** The position of this contact in relation to its `Company`. (See the `Contact.company` field) */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** The name of this contact for formal conversation. */
  name?: Maybe<ContactName>;
  /** The nickname of this contact used for informal conversation. */
  nickname?: Maybe<Scalars['String']['output']>;
  /** The phone number of this contact. */
  phone: PhoneNumber;
  /** Connection to the tags that are assigned to this `Contact`. */
  tags?: Maybe<TagConnection>;
  /** Gives the most recent moment on which this `Contact`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Connection to the user invitations sent to this contact. */
  userInvitations?: Maybe<UserInvitationConnection>;
};


/** Represents a "real-world" individual. */
export type ContactAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a "real-world" individual. */
export type ContactCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


/** Represents a "real-world" individual. */
export type ContactIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** Represents a "real-world" individual. */
export type ContactIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** Represents a "real-world" individual. */
export type ContactTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};


/** Represents a "real-world" individual. */
export type ContactUserInvitationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserInvitationOrderByClause>>;
  where?: InputMaybe<Array<UserInvitationWhereClause>>;
};

/**
 * A paged connection with `ContactEdge` edges to `Contact` nodes.
 *
 * This type was automatically generated from the `ContactEdge` edge-type for the
 * `Query.contacts` field. (It might be possible that it is reused by other fields.)
 */
export type ContactConnection = Connection & ConnectionWithTotal & {
  __typename: 'ContactConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<ContactEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Contact>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `ContactConnection` connection that points to a `Contact` node.
 *
 * This type was automatically generated from the `Contact` node-type of the
 * `Query.contacts` field. (It might be possible that it is reused by other fields.)
 */
export type ContactEdge = Edge & {
  __typename: 'ContactEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: Contact;
};

export type ContactName = EntityName & PersonName & {
  __typename: 'ContactName';
  casual?: Maybe<Scalars['String']['output']>;
  first?: Maybe<Scalars['String']['output']>;
  formal?: Maybe<Scalars['String']['output']>;
  full?: Maybe<Scalars['String']['output']>;
  honorific: ContactNameHonorific;
  initials?: Maybe<Scalars['String']['output']>;
  last: ContactNameLast;
  middle?: Maybe<Scalars['String']['output']>;
  short?: Maybe<Scalars['String']['output']>;
};

export type ContactNameHonorific = PersonNameHonorific & {
  __typename: 'ContactNameHonorific';
  prefix?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export type ContactNameHonorificInput = {
  prefix?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
};

export type ContactNameInput = {
  first?: InputMaybe<Scalars['String']['input']>;
  honorific?: InputMaybe<ContactNameHonorificInput>;
  initials?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<ContactNameLastInput>;
  middle?: InputMaybe<Scalars['String']['input']>;
};

export type ContactNameLast = PersonNameLast & {
  __typename: 'ContactNameLast';
  full?: Maybe<Scalars['String']['output']>;
  main?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
};

export type ContactNameLastInput = {
  main?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Specifies how the edges to a `Contact` will be ordered in a connection.
 *
 * This type was automatically generated from the `ContactOrderByColumn` column-type used in the
 * `orderBy` argument of the `Company.contacts` field. (It might be possible that it is reused by
 * other fields.)
 */
export type ContactOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: ContactOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `ContactOrderByColumn`. */
export enum ContactOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which an entity was deactivated. */
  DeactivatedAt = 'DEACTIVATED_AT',
  /** Orders by the `jobTitle` of this contact. */
  JobTitle = 'JOB_TITLE',
  /** Orders by first/given name. */
  NameFirst = 'NAME_FIRST',
  /** Orders by last name, excluding their prefixes. */
  NameLast = 'NAME_LAST',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type ContactWhereClause = {
  /** Filter entries based on the current active state. See the `WhereActive`-enum for more information. */
  active?: InputMaybe<WhereActive>;
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were deactivated. */
  deactivated?: InputMaybe<StampedEventConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter on whether this contact has an email address. */
  hasEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `contactAccounts`. */
  whereTotalAccounts?: InputMaybe<IntLinearOrderConstraints>;
};

/**
 * Represents the meta-data of a country.
 *
 * See the [commerceguys/addressing](https://github.com/commerceguys/addressing) library for more information.
 */
export type Country = Node & {
  __typename: 'Country';
  addressFormat?: Maybe<AddressFormat>;
  code?: Maybe<Scalars['CountryCode']['output']>;
  currencyCode?: Maybe<Scalars['String']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  numericCode?: Maybe<Scalars['Int']['output']>;
  phoneNumberFormat?: Maybe<PhoneNumberFormat>;
  supportedByAddress?: Maybe<Scalars['Boolean']['output']>;
  supportedByPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
  threeLetterCode?: Maybe<Scalars['String']['output']>;
};


/**
 * Represents the meta-data of a country.
 *
 * See the [commerceguys/addressing](https://github.com/commerceguys/addressing) library for more information.
 */
export type CountryNameArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type CountryEdge = Edge & {
  __typename: 'CountryEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node at the end of this edge. */
  node: Country;
};

export type CountryWhereClause = {
  supportedByAddress?: InputMaybe<WhereCountrySupport>;
  supportedByPhoneNumber?: InputMaybe<WhereCountrySupport>;
};

export type CreateAnalysisReportInput = {
  comments?: InputMaybe<AttachCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: NameInput;
  /** The moment after which the `AnalysisReport` is considered to be outdated. */
  outdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Selects the products that will be analysed in the new `AnalysisReport`. */
  products?: InputMaybe<SelectProductsInput>;
  team?: InputMaybe<ConnectTeamInput>;
  verificationConfiguration?: InputMaybe<ConnectVerificationConfigurationInput>;
};

export type CreateAnalysisReport_SuccessResult = MutationPayload & {
  __typename: 'CreateAnalysisReport_SuccessResult';
  node: AnalysisReport;
  query: Query;
};

export type CreateCommentInput = {
  about: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['HTML']['input']>;
  isPublic?: Scalars['Boolean']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateComment_SuccessResult = MutationPayload & {
  __typename: 'CreateComment_SuccessResult';
  node: Comment;
  query: Query;
};

export type CreateCompanyInput = {
  comments?: InputMaybe<AttachCommentsInput>;
  contacts?: InputMaybe<CreateCompanyInputContacts>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: NameInput;
  number?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['URL']['input']>;
  withTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateCompanyInputContacts = {
  attach: Array<CreateCompanyInputContactsAttach>;
};

export type CreateCompanyInputContactsAttach = {
  accounts?: InputMaybe<ManageContactAccountsInput>;
  comments?: InputMaybe<AttachCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
  fromAccount?: InputMaybe<Scalars['ID']['input']>;
  isActive?: Scalars['Boolean']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<ContactNameInput>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompany_SuccessResult = MutationPayload & {
  __typename: 'CreateCompany_SuccessResult';
  node: Company;
  query: Query;
};

export type CreateContactInput = {
  accounts?: InputMaybe<ManageContactAccountsInput>;
  comments?: InputMaybe<AttachCommentsInput>;
  company?: InputMaybe<ConnectCompanyInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
  /**
   * The id of an existing user account. When set, it will create an account with the same name and email address as
   * that account.
   *
   * It will also set that account as the base account so that later syncing may be possible in the future.
   */
  fromAccount?: InputMaybe<Scalars['ID']['input']>;
  isActive?: Scalars['Boolean']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<ContactNameInput>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContact_SuccessResult = MutationPayload & {
  __typename: 'CreateContact_SuccessResult';
  node: Contact;
  query: Query;
};

export type CreateMeiliSearch_SuccessResult = MutationPayload & {
  __typename: 'CreateMeiliSearch_SuccessResult';
  query: Query;
  response: MeiliSearchTokenResponse;
};

export type CreateProductCategoryInput = {
  comments?: InputMaybe<AttachCommentsInput>;
  /**
   * Whether this product-category should be added as a default tree.
   *
   * Note that this input-field is mutually exclusive with the `parent`-property because it will always have the same
   * default-state as it's parent.
   */
  default?: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: NameInput;
  /** The parent of this product category in the nested-set structure. */
  parent?: InputMaybe<ConnectProductCategoryInput>;
  risks?: InputMaybe<ConnectRisksInput>;
  /**
   * The team to which the new product category should be added. Defaults to the current team.
   *
   * This argument cannot be used in combination with `CreateProductCategoryInput.parent`.
   */
  team?: InputMaybe<ConnectTeamInput>;
};

export type CreateProductCategory_SuccessResult = MutationPayload & {
  __typename: 'CreateProductCategory_SuccessResult';
  node: ProductCategory;
  query: Query;
};

export type CreateProductInput = {
  clientRef?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<AttachCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  name: NameInput;
  predicateValues?: InputMaybe<ManageProductPredicateValuesInput>;
  productCategories?: InputMaybe<AttachProductCategoriesInput>;
  supplierBranches?: InputMaybe<AttachSupplierBranchesInput>;
  team?: InputMaybe<ConnectTeamInput>;
};

export type CreateProduct_SuccessResult = MutationPayload & {
  __typename: 'CreateProduct_SuccessResult';
  node: Product;
  query: Query;
};

export type CreateQuestionPredicateInput = {
  defaultPredicateValue?: InputMaybe<PredicateValue>;
  predicateQuestion: Scalars['HTML']['input'];
};

export type CreateQuestionPredicate_SuccessResult = MutationPayload & {
  __typename: 'CreateQuestionPredicate_SuccessResult';
  node: QuestionPredicate;
  query: Query;
};

export type CreateRegionInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: NameInput;
};

export type CreateRegion_SuccessResult = MutationPayload & {
  __typename: 'CreateRegion_SuccessResult';
  node: Region;
  query: Query;
};

export type CreateRiskColumnInput = {
  /** The color of the column that may be in the GUI or a generated spreadsheet. */
  color?: InputMaybe<Color>;
  /** An optional argument to attach comments to this risk column. */
  comments?: InputMaybe<AttachCommentsInput>;
  /** A short description about the values that should be stored in risk column. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether the values of this risk column should be visible to all users (that are also allowed to see the risk
   * that has a value in this column.)
   * @deprecated use owner instead
   */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name for the risk column. Should also be used as the header of the column when generating a spreadsheet. */
  name: NameInput;
  owner: Scalars['ID']['input'];
};

export type CreateRiskColumn_SuccessResult = MutationPayload & {
  __typename: 'CreateRiskColumn_SuccessResult';
  node: RiskColumn;
  query: Query;
};

export type CreateRiskConfigurationInput = {
  comments?: InputMaybe<ConnectCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  levels: Array<SetRiskConfigurationLevelInput>;
  name: NameInput;
  probabilities: Array<SetRiskConfigurationProbabilityInput>;
  severities: Array<SetRiskConfigurationSeverityInput>;
};

export type CreateRiskConfigurationTeamInput = {
  connect: Scalars['ID']['input'];
};

export type CreateRiskConfiguration_SuccessResult = MutationPayload & {
  __typename: 'CreateRiskConfiguration_SuccessResult';
  node: RiskConfiguration;
  query: Query;
};

export type CreateRiskInput = {
  /** An optional argument to attach comments to this risk. */
  comments?: InputMaybe<AttachCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  predicateExpression?: InputMaybe<Scalars['MeetExpression']['input']>;
  probabilities?: InputMaybe<AttachRiskValuesInput>;
  /** The product categories to which this `risk` applies. */
  productCategories?: InputMaybe<ConnectProductCategoriesInput>;
  publicInfo?: InputMaybe<Scalars['HTML']['input']>;
  publicTopicalInfo?: InputMaybe<Scalars['HTML']['input']>;
  riskColumnValues?: InputMaybe<Array<RiskColumnValueInput>>;
  /** The `Threat` that caused this risk. */
  threat: ConnectThreatInput;
};

export type CreateRisk_SuccessResult = MutationPayload & {
  __typename: 'CreateRisk_SuccessResult';
  node: Risk;
  query: Query;
};

export type CreateSupplierBranchInput = {
  address?: InputMaybe<AddressInput>;
  comments?: InputMaybe<ConnectCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
  isActive?: Scalars['Boolean']['input'];
  name: NameInput;
  phone?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<ConnectProductsInput>;
  reliability: ConnectSupplierReliabilityInput;
  supplier: ConnectSupplierInput;
  website?: InputMaybe<Scalars['URL']['input']>;
};

export type CreateSupplierBranch_SuccessResult = MutationPayload & {
  __typename: 'CreateSupplierBranch_SuccessResult';
  node: SupplierBranch;
  query: Query;
};

export type CreateSupplierInput = {
  clientRef?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<AttachCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
  isActive?: Scalars['Boolean']['input'];
  name: NameInput;
  phone?: InputMaybe<Scalars['String']['input']>;
  supplierBranches?: InputMaybe<CreateSupplierInputBranches>;
  team?: InputMaybe<ConnectTeamInput>;
  website?: InputMaybe<Scalars['URL']['input']>;
};

export type CreateSupplierInputBranches = {
  attach: Array<CreateSupplierInputBranchesAttach>;
};

export type CreateSupplierInputBranchesAttach = {
  address?: InputMaybe<AddressInput>;
  comments?: InputMaybe<ConnectCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
  isActive?: Scalars['Boolean']['input'];
  name: NameInput;
  phone?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<ConnectProductsInput>;
  reliability: ConnectSupplierReliabilityInput;
  website?: InputMaybe<Scalars['URL']['input']>;
};

export type CreateSupplier_SuccessResult = MutationPayload & {
  __typename: 'CreateSupplier_SuccessResult';
  node: Supplier;
  query: Query;
};

export type CreateTagInput = {
  color?: Color;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: TagIcon;
  name: NameInput;
  owner: Scalars['ID']['input'];
};

export type CreateTagPayload = CreateTag_SuccessResult;

export type CreateTag_SuccessResult = MutationPayload & {
  __typename: 'CreateTag_SuccessResult';
  node: Tag;
  query: Query;
};

export type CreateTeamInput = {
  analysisReports?: InputMaybe<Array<CreateTeam_AnalysisReportsInput>>;
  company?: InputMaybe<ConnectCompanyInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  name: NameInput;
  /** Create products for the team. */
  products?: InputMaybe<Array<CreateTeam_ProductsInput>>;
  /** Create suppliers for the team. */
  suppliers?: InputMaybe<Array<CreateTeam_SuppliersInput>>;
  /** The type of the team. This modifies the UI when a user logs in with this type. */
  teamType?: InputMaybe<TeamType>;
  users?: InputMaybe<Array<SyncUserTeamRolesInput>>;
};

export type CreateTeamLicenseClassInput = {
  /** The default time-period in which a license of this class is valid. */
  defaultValidityPeriod?: InputMaybe<Scalars['DateTimeInterval']['input']>;
  /** A description for the license class. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name for the license class. */
  name: NameInput;
};

export type CreateTeamLicenseClass_SuccessResult = MutationPayload & {
  __typename: 'CreateTeamLicenseClass_SuccessResult';
  node: TeamLicenseClass;
  query: Query;
};

export type CreateTeamLicenseInput = {
  /** The class of the new license. */
  class: CreateTeamLicenseInput_Class;
  /** Attach comments to the team license. */
  comments?: InputMaybe<AttachCommentsInput>;
  /** The team that will own this new license. */
  team: ConnectTeamInput;
  /** The moment after which this license is valid. Defaults to now. */
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The moment when this license will expire. Defaults to the value of `validFrom` plus the `defaultValidityPeriod`
   * of the `class`.
   */
  validTill?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateTeamLicenseInput_Class = {
  connect: Scalars['ID']['input'];
};

export type CreateTeamLicense_SuccessResult = MutationPayload & {
  __typename: 'CreateTeamLicense_SuccessResult';
  node: TeamLicense;
  query: Query;
};

export type CreateTeam_AnalysisReportsInput = {
  comments?: InputMaybe<AttachCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: NameInput;
  /** The moment after which the `AnalysisReport` is considered to be outdated. */
  outdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Selects the products that will be analysed in the new `AnalysisReport`. */
  products?: InputMaybe<SelectProductsInput>;
  verificationConfiguration?: InputMaybe<ConnectVerificationConfigurationInput>;
};

export type CreateTeam_ProductsInput = {
  clientRef?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<AttachCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  name: NameInput;
  predicateValues?: InputMaybe<ManageProductPredicateValuesInput>;
  productCategories?: InputMaybe<AttachProductCategoriesInput>;
  supplierBranches?: InputMaybe<AttachSupplierBranchesInput>;
};

export type CreateTeam_SuccessResult = MutationPayload & {
  __typename: 'CreateTeam_SuccessResult';
  node: Team;
  query: Query;
};

export type CreateTeam_SuppliersInput = {
  clientRef?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<AttachCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
  isActive?: Scalars['Boolean']['input'];
  name: NameInput;
  phone?: InputMaybe<Scalars['String']['input']>;
  supplierBranches?: InputMaybe<CreateSupplierInputBranches>;
  website?: InputMaybe<Scalars['URL']['input']>;
};

export type CreateThreatCategoryInput = {
  comments?: InputMaybe<AttachCommentsInput>;
  /**
   * Whether this threat-category should be added as a default tree.
   *
   * Note that this input-field is mutually exclusive with the `parent`-property because it will always have the same
   * default-state as it's parent.
   */
  default?: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: NameInput;
  parent?: InputMaybe<ConnectThreatCategoryInput>;
  /**
   * The team to which the new product category should be added. Defaults to the current team.
   *
   * This argument cannot be used in combination with `CreateThreatCategoryInput.parent`.
   */
  team?: InputMaybe<ConnectTeamInput>;
};

export type CreateThreatCategory_SuccessResult = MutationPayload & {
  __typename: 'CreateThreatCategory_SuccessResult';
  node: ThreatCategory;
  query: Query;
};

export type CreateThreatInput = {
  comments?: InputMaybe<AttachCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  name: NameInput;
  publicInfo?: InputMaybe<Scalars['HTML']['input']>;
  severities?: InputMaybe<AttachRiskValuesInput>;
  threatCategory: ConnectThreatCategoryInput;
};

export type CreateThreat_SuccessResult = MutationPayload & {
  __typename: 'CreateThreat_SuccessResult';
  node: Threat;
  query: Query;
};

export type CreateUserInput = {
  contact?: InputMaybe<ConnectContactInput>;
  name: Scalars['String']['input'];
};

export type CreateUserInvitationInput = {
  /** Attaches commands to this user invitation. */
  comments?: InputMaybe<AttachCommentsInput>;
  /** The contact that should receive this user invitation. */
  contact: ConnectContactInput;
  /** An description for internal use. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** A message that will be displayed in the invitation email that will be send to the contact. */
  message?: InputMaybe<Scalars['HTML']['input']>;
  /** The team that will be assigned to the user that accepts this user invitation. */
  teams?: InputMaybe<Array<UserInvitationTeamInput>>;
  /** The email to which the invitation will be send. Defaults to the email address of the contact. */
  toEmail?: InputMaybe<Scalars['Email']['input']>;
  /** The user roles that will be assigned to the user that accepts this user invitation. */
  userRoles?: InputMaybe<Array<UserRole>>;
};

export type CreateUserInvitation_SuccessResult = MutationPayload & {
  __typename: 'CreateUserInvitation_SuccessResult';
  node: UserInvitation;
  query: Query;
};

export type CreateUser_SuccessResult = MutationPayload & {
  __typename: 'CreateUser_SuccessResult';
  node: User;
  query: Query;
};

export type CreateVerificationActionInput = {
  comments?: InputMaybe<AttachCommentsInput>;
  /** Whether this new verification action should be a globally available verification action. */
  default?: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  name: NameInput;
  /**
   * The team to which this verification action should be added. Defaults to the current team.
   *
   * Note that this does not have an effect if `CreateVerificationActionInput.default` is `true`.
   */
  team?: InputMaybe<ConnectTeamInput>;
};

export type CreateVerificationAction_SuccessResult = MutationPayload & {
  __typename: 'CreateVerificationAction_SuccessResult';
  node: VerificationAction;
  query: Query;
};

export type CreateVerificationConfigurationInput = {
  /** THE ORDER HERE DOES MATTER! */
  actions?: InputMaybe<Array<CreateVerificationConfigurationInput_Action>>;
  comments?: InputMaybe<AttachCommentsInput>;
  default?: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: NameInput;
  riskConfiguration?: InputMaybe<ConnectRiskConfigurationInput>;
  rules?: InputMaybe<Array<InsertVerificationConfigurationRuleInput>>;
  team?: InputMaybe<ConnectTeamInput>;
};

export type CreateVerificationConfigurationInput_Action = {
  action: ConnectVerificationAction;
  defaultValue?: InputMaybe<PredicateValue>;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type CreateVerificationConfiguration_SuccessResult = MutationPayload & {
  __typename: 'CreateVerificationConfiguration_SuccessResult';
  node: VerificationConfiguration;
  query: Query;
};

/** The input for the `createVerificationPredicate` mutation. */
export type CreateVerificationPredicateInput = {
  /** Whether this new verification action should be a globally available verification action. */
  default?: Scalars['Boolean']['input'];
  /** The default value of the verification predicate. */
  defaultPredicateValue?: InputMaybe<PredicateValue>;
  /** A short description of the verification predicate. Will be used in the search engine. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name for the verification predicate. */
  name?: InputMaybe<NameInputOptional>;
  /** A question representing the verification predicate. */
  predicateQuestion?: InputMaybe<Scalars['String']['input']>;
  /**
   * The team to which this verification action should be added. Defaults to the current team.
   *
   * Note that this does not have an effect if `CreateVerificationActionInput.default` is `true`.
   */
  team?: InputMaybe<ConnectTeamInput>;
};

export type CreateVerificationPredicate_SuccessResult = MutationPayload & {
  __typename: 'CreateVerificationPredicate_SuccessResult';
  /** The newly created verification predicate. */
  node: VerificationPredicate;
  query: Query;
};

export type DateTimeConstraints = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Constraint for events that has a recorded `DateTime` and that might not have happened yet. */
export type DateTimeEventConstraints = {
  /**
   * Filters only the entries where this event occurred after the provided timestamp.
   *
   * This field has no effect when `is` is set to `false`.
   */
  after?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Filters only the entries where this event occurred before the provided timestamp.
   *
   * This field has no effect when `is` is set to `false`.
   */
  before?: InputMaybe<Scalars['DateTime']['input']>;
  /** When set to `false`, it will only show entries where the event didn't happen yet. */
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DateTimePeriod = {
  __typename: 'DateTimePeriod';
  end?: Maybe<Scalars['DateTime']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
};

export type DeactivateMany_SuccessResult = MutationPayload & {
  __typename: 'DeactivateMany_SuccessResult';
  nodes: Array<Activateable>;
  query: Query;
};

export type Deactivate_SuccessResult = MutationPayload & {
  __typename: 'Deactivate_SuccessResult';
  node: Activateable;
  query: Query;
};

export type Delete_SuccessResult = MutationPayload & {
  __typename: 'Delete_SuccessResult';
  node: Node;
  query: Query;
};

export type DetachTagsInput = {
  /** The IDs of the `Taggable` nodes from which you want to detach the tags */
  taggables: Array<Scalars['ID']['input']>;
  /** The IDs of the tags you want to detach. */
  tags: Array<Scalars['ID']['input']>;
};

export type DetachTagsPayload = DetachTags_SuccessResult;

export type DetachTags_SuccessResult = MutationPayload & {
  __typename: 'DetachTags_SuccessResult';
  query: Query;
};

/** A `Job` that just generates some files in the description. This job mainly exists for e2e-testing purposes. */
export type EchoFilesJob = HasFiles & Job & Node & Timestamped & Userstamped & {
  __typename: 'EchoFilesJob';
  /**
   * The moment on which this `EchoFilesJob` was cancelled. Will be `null` if this job wasn't cancelled.
   *
   * A cancelled job won't be executed.
   */
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that cancelled this `EchoFilesJob`. See the `cancelledAt`-field for more information. */
  cancellor?: Maybe<User>;
  /** Gives the `DateTime` on which this `EchoFilesJob`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `EchoFilesJob`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `EchoFilesJob`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * The moment on which this `EchoFilesJob` will expire on the queue.
   *
   * If the job hasn't been started before this moment, it won't be executed anymore.
   */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The moment on which the this `EchoFilesJob` failed. */
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The description of the files that should be echoed. */
  fileDescriptions?: Maybe<Array<EchoFiles_FileDescription>>;
  /** The files associated with this `EchoFilesJob`. */
  files?: Maybe<FileConnection>;
  /** The moment on which the this `EchoFilesJob` finished executing. */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The global ID of this `EchoFilesJob`-node which uniquely identifies this object.
   *
   * You can use this value with the `node`-query to access this `EchoFilesJob`-object from the root.
   *
   * See the `Node` interface for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `EchoFilesJob`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `EchoFilesJob`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The moment on which this `EchoFilesJob` was dispatched on the queue (and thus been made available for
   * the workers).
   */
  queuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The moment on which the execution of this `EchoFilesJob` was started. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The curent state of this `EchoFilesJob`. */
  state?: Maybe<JobState>;
  /** The `Team` for which this `EchoFilesJob` will be executed. */
  team?: Maybe<Team>;
  /** Gives the most recent moment on which this `EchoFilesJob`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The `User` for which this `EchoFilesJob` will be executed. */
  user?: Maybe<User>;
};


/** A `Job` that just generates some files in the description. This job mainly exists for e2e-testing purposes. */
export type EchoFilesJobFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** A `Job` that just generates some files in the description. This job mainly exists for e2e-testing purposes. */
export type EchoFilesJobIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** A `Job` that just generates some files in the description. This job mainly exists for e2e-testing purposes. */
export type EchoFilesJobIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};

export type EchoFilesOptions = {
  /** The description of the files to be echoed by this job. */
  fileDescriptions: Array<EchoFilesOptions_FileDescription>;
  /** The Team-id of the Team for whom the job is created. Defaults to the team in the access token. */
  team?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the User for whom the job is created. Defaults to the user in the access token. */
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type EchoFilesOptions_FileDescription = {
  /** The contents of the file. */
  content: Scalars['String']['input'];
  /** The `ContentType` (Also known as *MIME-type*) that the file should have. */
  contentType: Scalars['ContentType']['input'];
  /** The name that the file should have after it is downloaded. */
  filename: Scalars['String']['input'];
};

/** A description of a file to be echoed by a `EchoFilesJob`. */
export type EchoFiles_FileDescription = {
  __typename: 'EchoFiles_FileDescription';
  /** The contents of the generated file. */
  content: Scalars['String']['output'];
  /** The content type of the generated file. */
  contentType: Scalars['ContentType']['output'];
  /** The filename the the generated file should have. */
  filename: Scalars['String']['output'];
};

/** Objects that implement this interface represents an edge of to a node. */
export type Edge = {
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /**
   * The node at the end of this edge.
   *
   * This value is `null` iff the current access token has no permission to see the value of this node, but does have
   * the permission to see the values on the edges.
   */
  node?: Maybe<Node>;
};

export type EntityName = {
  full?: Maybe<Scalars['String']['output']>;
  short?: Maybe<Scalars['String']['output']>;
};

export type Exception = {
  message?: Maybe<Message>;
  query: Query;
};

export type ExportAnalysisReportEntriesJob = HasFiles & Job & Node & Timestamped & Userstamped & {
  __typename: 'ExportAnalysisReportEntriesJob';
  /** Reference to the analysis report of this job. */
  analysisReport?: Maybe<AnalysisReport>;
  /**
   * A connection the the analysis report entries that should be exported.
   *
   * This list is pre-filtered and pre-ordered based on the job configuration.
   */
  analysisReportEntries?: Maybe<AnalysisReportEntryConnection>;
  /**
   * The moment on which this `ExportAnalysisReportEntriesJob` was cancelled. Will be `null` if this job wasn't cancelled.
   *
   * A cancelled job won't be executed.
   */
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that cancelled this `ExportAnalysisReportEntriesJob`. See the `cancelledAt`-field for more information. */
  cancellor?: Maybe<User>;
  /** Gives the `DateTime` on which this `ExportAnalysisReportEntriesJob`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `ExportAnalysisReportEntriesJob`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `ExportAnalysisReportEntriesJob`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * The moment on which this `ExportAnalysisReportEntriesJob` will expire on the queue.
   *
   * If the job hasn't been started before this moment, it won't be executed anymore.
   */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The moment on which the this `ExportAnalysisReportEntriesJob` failed. */
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The files associated with this `ExportAnalysisReportEntriesJob`. */
  files?: Maybe<FileConnection>;
  /** The moment on which the this `ExportAnalysisReportEntriesJob` finished executing. */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The global ID of this `ExportAnalysisReportEntriesJob`-node which uniquely identifies this object.
   *
   * You can use this value with the `node`-query to access this `ExportAnalysisReportEntriesJob`-object from the root.
   *
   * See the `Node` interface for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `ExportAnalysisReportEntriesJob`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `ExportAnalysisReportEntriesJob`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The moment on which this `ExportAnalysisReportEntriesJob` was dispatched on the queue (and thus been made available for
   * the workers).
   */
  queuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The moment on which the execution of this `ExportAnalysisReportEntriesJob` was started. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The curent state of this `ExportAnalysisReportEntriesJob`. */
  state?: Maybe<JobState>;
  /** The `Team` for which this `ExportAnalysisReportEntriesJob` will be executed. */
  team?: Maybe<Team>;
  /** Gives the most recent moment on which this `ExportAnalysisReportEntriesJob`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The `User` for which this `ExportAnalysisReportEntriesJob` will be executed. */
  user?: Maybe<User>;
  /** Also include the actions of the entries in the analysis report (if available). */
  withVerificationActions?: Maybe<Scalars['Boolean']['output']>;
};


export type ExportAnalysisReportEntriesJobAnalysisReportEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ExportAnalysisReportEntriesJobFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ExportAnalysisReportEntriesJobIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type ExportAnalysisReportEntriesJobIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};

export type ExportAnalysisReportEntriesOptions = {
  /** The ID of the analysis report for which the entries will be generated. */
  analysisReport: Scalars['ID']['input'];
  /** Defines which entries should be exported. Defaults to the whole */
  analysisReportEntrySelection?: InputMaybe<AnalysisReportEntrySelectionInput>;
  /** The Team-id of the Team for whom the job is created. Defaults to the team in the access token. */
  team?: InputMaybe<Scalars['ID']['input']>;
  /** The user for whom the job will be created. */
  user?: InputMaybe<Scalars['ID']['input']>;
  /** Also include the actions of the entries in the report (if available). */
  withVerificationActions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExportProductsSpreadsheetJob = HasFiles & Job & Node & Timestamped & Userstamped & {
  __typename: 'ExportProductsSpreadsheetJob';
  /**
   * The moment on which this `ExportProductsSpreadsheetJob` was cancelled. Will be `null` if this job wasn't cancelled.
   *
   * A cancelled job won't be executed.
   */
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that cancelled this `ExportProductsSpreadsheetJob`. See the `cancelledAt`-field for more information. */
  cancellor?: Maybe<User>;
  /** Gives the `DateTime` on which this `ExportProductsSpreadsheetJob`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `ExportProductsSpreadsheetJob`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `ExportProductsSpreadsheetJob`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * The moment on which this `ExportProductsSpreadsheetJob` will expire on the queue.
   *
   * If the job hasn't been started before this moment, it won't be executed anymore.
   */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The moment on which the this `ExportProductsSpreadsheetJob` failed. */
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The files associated with this `ExportProductsSpreadsheetJob`. */
  files?: Maybe<FileConnection>;
  /** The moment on which the this `ExportProductsSpreadsheetJob` finished executing. */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The global ID of this `ExportProductsSpreadsheetJob`-node which uniquely identifies this object.
   *
   * You can use this value with the `node`-query to access this `ExportProductsSpreadsheetJob`-object from the root.
   *
   * See the `Node` interface for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `ExportProductsSpreadsheetJob`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `ExportProductsSpreadsheetJob`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Connection to the products that should be included in the exported spreadsheet.
   *
   * This list is pre-filtered and pre-ordered based on the job configuration.
   */
  products?: Maybe<ProductConnection>;
  /**
   * The moment on which this `ExportProductsSpreadsheetJob` was dispatched on the queue (and thus been made available for
   * the workers).
   */
  queuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The moment on which the execution of this `ExportProductsSpreadsheetJob` was started. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The curent state of this `ExportProductsSpreadsheetJob`. */
  state?: Maybe<JobState>;
  /** The `Team` for which this `ExportProductsSpreadsheetJob` will be executed. */
  team?: Maybe<Team>;
  /** Gives the most recent moment on which this `ExportProductsSpreadsheetJob`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The `User` for which this `ExportProductsSpreadsheetJob` will be executed. */
  user?: Maybe<User>;
};


export type ExportProductsSpreadsheetJobFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ExportProductsSpreadsheetJobIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type ExportProductsSpreadsheetJobIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type ExportProductsSpreadsheetJobProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The options for creating a `ExportProductsSpreadsheetJob`.
 *
 * Used by the `exportProductsMutation` mutation.
 */
export type ExportProductsSpreadsheetOptions = {
  /** Selects the products that should be in the result. */
  productSelection?: InputMaybe<ExportProductsSpreadsheetOptions_ProductSelection>;
  /**
   * The Team-id of the Team for whom the job is created.
   *
   * Defaults to the team in the access token.
   */
  team?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The user for whom this job is created. The result will only contain the products that this user can see.
   *
   * Defaults to the user in the access token.
   */
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type ExportProductsSpreadsheetOptions_ProductSelection = {
  /** The ids of the products you want to include in this selection. Defaults to all products of the team when omitted. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filters the products in the results.
   *
   * These filters will be applied **after** the `ids` argument. (So the `ids` will be affected by this `where`-field.)
   */
  where?: InputMaybe<Array<ProductWhereClause>>;
};

export type ExportSupplierBranchesSpreadsheetJob = HasFiles & Job & Node & Timestamped & Userstamped & {
  __typename: 'ExportSupplierBranchesSpreadsheetJob';
  /**
   * The moment on which this `ExportSupplierBranchesSpreadsheetJob` was cancelled. Will be `null` if this job wasn't cancelled.
   *
   * A cancelled job won't be executed.
   */
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that cancelled this `ExportSupplierBranchesSpreadsheetJob`. See the `cancelledAt`-field for more information. */
  cancellor?: Maybe<User>;
  /** Gives the `DateTime` on which this `ExportSupplierBranchesSpreadsheetJob`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `ExportSupplierBranchesSpreadsheetJob`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `ExportSupplierBranchesSpreadsheetJob`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * The moment on which this `ExportSupplierBranchesSpreadsheetJob` will expire on the queue.
   *
   * If the job hasn't been started before this moment, it won't be executed anymore.
   */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The moment on which the this `ExportSupplierBranchesSpreadsheetJob` failed. */
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The files associated with this `ExportSupplierBranchesSpreadsheetJob`. */
  files?: Maybe<FileConnection>;
  /** The moment on which the this `ExportSupplierBranchesSpreadsheetJob` finished executing. */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The global ID of this `ExportSupplierBranchesSpreadsheetJob`-node which uniquely identifies this object.
   *
   * You can use this value with the `node`-query to access this `ExportSupplierBranchesSpreadsheetJob`-object from the root.
   *
   * See the `Node` interface for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `ExportSupplierBranchesSpreadsheetJob`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `ExportSupplierBranchesSpreadsheetJob`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The moment on which this `ExportSupplierBranchesSpreadsheetJob` was dispatched on the queue (and thus been made available for
   * the workers).
   */
  queuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The moment on which the execution of this `ExportSupplierBranchesSpreadsheetJob` was started. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The curent state of this `ExportSupplierBranchesSpreadsheetJob`. */
  state?: Maybe<JobState>;
  /**
   * Connection to the supplier-branches that should be included in the exported spreadsheet.
   *
   * This list is pre-filtered and pre-ordered based on the job configuration.
   */
  supplierBranches?: Maybe<SupplierBranchConnection>;
  /** The `Team` for which this `ExportSupplierBranchesSpreadsheetJob` will be executed. */
  team?: Maybe<Team>;
  /** Gives the most recent moment on which this `ExportSupplierBranchesSpreadsheetJob`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The `User` for which this `ExportSupplierBranchesSpreadsheetJob` will be executed. */
  user?: Maybe<User>;
};


export type ExportSupplierBranchesSpreadsheetJobFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ExportSupplierBranchesSpreadsheetJobIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type ExportSupplierBranchesSpreadsheetJobIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type ExportSupplierBranchesSpreadsheetJobSupplierBranchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The options for creating a `ExportSupplierBranchesSpreadsheetJob`.
 *
 * Used by the `exportSupplierBranchesSpreadsheet` mutation.
 */
export type ExportSupplierBranchesSpreadsheetOptions = {
  /** Selects the suppliers that should be in the result. */
  supplierBranchSelection?: InputMaybe<ExportSuppliersBranchesSpreadsheetOptions_SupplierBranchSelection>;
  /**
   * The Team-id of the Team for whom the job is created.
   *
   * Defaults to the team in the access token.
   */
  team?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The user for whom this job is created. The result will only contain the suppliers that this user can see.
   *
   * Defaults to the user in the access token.
   */
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type ExportSupplierVCardsJob = HasFiles & Job & Node & Timestamped & Userstamped & {
  __typename: 'ExportSupplierVCardsJob';
  /**
   * The moment on which this `ExportSupplierVCardsJob` was cancelled. Will be `null` if this job wasn't cancelled.
   *
   * A cancelled job won't be executed.
   */
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that cancelled this `ExportSupplierVCardsJob`. See the `cancelledAt`-field for more information. */
  cancellor?: Maybe<User>;
  /** Gives the `DateTime` on which this `ExportSupplierVCardsJob`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `ExportSupplierVCardsJob`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `ExportSupplierVCardsJob`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * The moment on which this `ExportSupplierVCardsJob` will expire on the queue.
   *
   * If the job hasn't been started before this moment, it won't be executed anymore.
   */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The moment on which the this `ExportSupplierVCardsJob` failed. */
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The files associated with this `ExportSupplierVCardsJob`. */
  files?: Maybe<FileConnection>;
  /** The moment on which the this `ExportSupplierVCardsJob` finished executing. */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The global ID of this `ExportSupplierVCardsJob`-node which uniquely identifies this object.
   *
   * You can use this value with the `node`-query to access this `ExportSupplierVCardsJob`-object from the root.
   *
   * See the `Node` interface for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether the `SupplierBranch`es are included in the result. */
  includeBranches?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `ExportSupplierVCardsJob`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `ExportSupplierVCardsJob`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The moment on which this `ExportSupplierVCardsJob` was dispatched on the queue (and thus been made available for
   * the workers).
   */
  queuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The moment on which the execution of this `ExportSupplierVCardsJob` was started. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The curent state of this `ExportSupplierVCardsJob`. */
  state?: Maybe<JobState>;
  /** The `Team` for which this `ExportSupplierVCardsJob` will be executed. */
  team?: Maybe<Team>;
  /** Gives the most recent moment on which this `ExportSupplierVCardsJob`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The `User` for which this `ExportSupplierVCardsJob` will be executed. */
  user?: Maybe<User>;
};


export type ExportSupplierVCardsJobFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ExportSupplierVCardsJobIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type ExportSupplierVCardsJobIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};

export type ExportSupplierVCardsOptions = {
  includeBranches?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ExportSuppliersBranchesSpreadsheetOptions_SupplierBranchSelection = {
  /**
   * The ids of the supplier-branches you want to include in this selection. Defaults to all supplier-branches of the
   * team when omitted.
   */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filters the suppliers in the results.
   *
   * These filters will be applied **after** the `ids` argument. (So the `ids` will be affected by this `where`-field.)
   */
  where?: InputMaybe<Array<SupplierWhereClause>>;
};

export type ExportSuppliersSpreadsheetJob = HasFiles & Job & Node & Timestamped & Userstamped & {
  __typename: 'ExportSuppliersSpreadsheetJob';
  /**
   * The moment on which this `ExportSuppliersSpreadsheetJob` was cancelled. Will be `null` if this job wasn't cancelled.
   *
   * A cancelled job won't be executed.
   */
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that cancelled this `ExportSuppliersSpreadsheetJob`. See the `cancelledAt`-field for more information. */
  cancellor?: Maybe<User>;
  /** Gives the `DateTime` on which this `ExportSuppliersSpreadsheetJob`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `ExportSuppliersSpreadsheetJob`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `ExportSuppliersSpreadsheetJob`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * The moment on which this `ExportSuppliersSpreadsheetJob` will expire on the queue.
   *
   * If the job hasn't been started before this moment, it won't be executed anymore.
   */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The moment on which the this `ExportSuppliersSpreadsheetJob` failed. */
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The files associated with this `ExportSuppliersSpreadsheetJob`. */
  files?: Maybe<FileConnection>;
  /** The moment on which the this `ExportSuppliersSpreadsheetJob` finished executing. */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The global ID of this `ExportSuppliersSpreadsheetJob`-node which uniquely identifies this object.
   *
   * You can use this value with the `node`-query to access this `ExportSuppliersSpreadsheetJob`-object from the root.
   *
   * See the `Node` interface for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `ExportSuppliersSpreadsheetJob`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `ExportSuppliersSpreadsheetJob`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The moment on which this `ExportSuppliersSpreadsheetJob` was dispatched on the queue (and thus been made available for
   * the workers).
   */
  queuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The moment on which the execution of this `ExportSuppliersSpreadsheetJob` was started. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The curent state of this `ExportSuppliersSpreadsheetJob`. */
  state?: Maybe<JobState>;
  /**
   * Connection to the suppliers that should be included in the exported spreadsheet.
   *
   * This list is pre-filtered and pre-ordered based on the job configuration.
   */
  suppliers?: Maybe<SupplierConnection>;
  /** The `Team` for which this `ExportSuppliersSpreadsheetJob` will be executed. */
  team?: Maybe<Team>;
  /** Gives the most recent moment on which this `ExportSuppliersSpreadsheetJob`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The `User` for which this `ExportSuppliersSpreadsheetJob` will be executed. */
  user?: Maybe<User>;
};


export type ExportSuppliersSpreadsheetJobFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type ExportSuppliersSpreadsheetJobIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type ExportSuppliersSpreadsheetJobIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type ExportSuppliersSpreadsheetJobSuppliersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The options for creating a `ExportSuppliersSpreadsheetJob`.
 *
 * Used by the `exportSuppliersSpreadsheet` mutation.
 */
export type ExportSuppliersSpreadsheetOptions = {
  /** Selects the suppliers that should be in the result. */
  supplierSelection?: InputMaybe<ExportSuppliersSpreadsheetOptions_SupplierSelection>;
  /**
   * The Team-id of the Team for whom the job is created.
   *
   * Defaults to the team in the access token.
   */
  team?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The user for whom this job is created. The result will only contain the suppliers that this user can see.
   *
   * Defaults to the user in the access token.
   */
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type ExportSuppliersSpreadsheetOptions_SupplierSelection = {
  /** The ids of the suppliers you want to include in this selection. Defaults to all suppliers of the team when omitted. */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filters the suppliers in the results.
   *
   * These filters will be applied **after** the `ids` argument. (So the `ids` will be affected by this `where`-field.)
   */
  where?: InputMaybe<Array<SupplierWhereClause>>;
};

/**
 * For an external user invited to the tenant using the invitation API, this value represents the invited
 * user's invitation status.
 */
export enum ExternalUserState {
  Accepted = 'ACCEPTED',
  PendingAcceptance = 'PENDING_ACCEPTANCE'
}

export type FailJobInput = {
  /** The ID of the job to fail. */
  id: Scalars['ID']['input'];
};

export type FailJob_SuccessResult = {
  __typename: 'FailJob_SuccessResult';
  node: Job;
};

/** Node that represents a (downloadable) file in the storage. */
export type File = Node & Timestamped & {
  __typename: 'File';
  /** The content type of the file. */
  contentType?: Maybe<Scalars['ContentType']['output']>;
  /** Gives the `DateTime` on which this `File`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The name of file. */
  filename?: Maybe<Scalars['String']['output']>;
  /** If this file is an image, this will give the height. */
  height?: Maybe<Scalars['Int']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `File`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `File`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  size?: Maybe<Scalars['FileSize']['output']>;
  /** Gives the most recent moment on which this `File`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The `URL` to retrieve this file. */
  url?: Maybe<Scalars['URL']['output']>;
  /** If this file is an image, this will give the width. */
  width?: Maybe<Scalars['Int']['output']>;
};


/** Node that represents a (downloadable) file in the storage. */
export type FileIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** Node that represents a (downloadable) file in the storage. */
export type FileIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** Node that represents a (downloadable) file in the storage. */
export type FileSizeArgs = {
  decimalSeparator?: InputMaybe<Scalars['String']['input']>;
  decimals?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<FileSizeFormat>;
  showUnit?: InputMaybe<Scalars['Boolean']['input']>;
  thousandSeparator?: InputMaybe<Scalars['String']['input']>;
  unitSeparator?: InputMaybe<Scalars['String']['input']>;
};


/** Node that represents a (downloadable) file in the storage. */
export type FileUrlArgs = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  direct?: InputMaybe<Scalars['Boolean']['input']>;
  download?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
};

export type FileConnection = Connection & {
  __typename: 'FileConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<FileEdge>>>;
  /**
   * The (paged) nodes in this connection. Equivalent to `edges.node`.
   *
   * ### UNTESTED
   *
   * **This feature hasn't been tested jet and might not behave as expected!**
   */
  nodes?: Maybe<Array<Maybe<File>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
};

export type FileEdge = Edge & {
  __typename: 'FileEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node at the end of this edge. */
  node: File;
};

/**
 * The format in which the size of a file will be returned.
 *
 * This functionality was inherited from the `Shared Robotics`-project.
 */
export enum FileSizeFormat {
  B = 'B',
  /**
   * Formats the file size as a string of normal, base-10 digits.
   *
   * A value formatted like this is usable for further parsing.
   *
   * DO NOT SHOW THE VALUE WITH THIS FORMAT TO THE USER!
   * It is better to show the `EIC` or `SI` formats for those cases.
   * If you really want to show the value in bytes to the user, use the `B` format with the `showUnit`-argument on `false`.
   */
  Dec = 'DEC',
  Eb = 'EB',
  EiB = 'EiB',
  Gb = 'GB',
  GiB = 'GiB',
  /**
   * Formats the file size as a string of base-16 digits.
   *
   * A value formatted like this is usable for further parsing.
   */
  Hex = 'HEX',
  /**
   * Formats the file size as a human-readable number using the IEC-unit that is the best fit for the value.
   *
   * IEC-units are the units that divide the number of bytes by some power of 1024 (2^10, or the nearest power of 2 that
   * approximates 1000).
   *
   * The possible IEC-units are `B`, `KiB`, `MiB`, `GiB`, `TiB`, `PiB` and `EiB`.
   *
   * This format safe to display to the user in a GUI directly. You should not use this format to do further parsing. Use
   * `DEC`, `OCT`, `HEX` or one of the fixed unit formats instead.
   */
  Iec = 'IEC',
  Kb = 'KB',
  KiB = 'KiB',
  Mb = 'MB',
  MiB = 'MiB',
  /**
   * Formats the file size as a string of base-8 digits.
   *
   * A value formatted like this is usable for further parsing.
   */
  Oct = 'OCT',
  Pb = 'PB',
  PiB = 'PiB',
  /**
   * Formats the file size as a human-readable number using the SI-unit that is the best fit for the value.
   *
   * SI-units are the units that divide the number of bytes by some power of 1000.
   *
   * The possible SI-units are `B`, `KB`, `MB`, `GB`, `TB`, `PB` and `EB`.
   *
   * This format safe to display to the user in a GUI directly. You should not use this format to do further parsing. Use
   * `DEC`, `OCT`, `HEX` or one of the fixed unit formats instead.
   */
  Si = 'SI',
  Tb = 'TB',
  TiB = 'TiB'
}

/** A description for an client-side request to upload a file. */
export type FileUploadRequest = {
  /** The content type that the file must have. */
  contentType: Scalars['ContentType']['output'];
  /** The moment after which this request is no longer valid. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The moment after which the request is valid. */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The endpoint to upload the file to. */
  uri: Scalars['URL']['output'];
};

export type FinishJobInput = {
  /** The ID of the job to finish. */
  id: Scalars['ID']['input'];
};

export type FinishJob_SuccessResult = {
  __typename: 'FinishJob_SuccessResult';
  node: Job;
};

export type FloatLinearBoundsInput = {
  lowerBound?: InputMaybe<Scalars['Float']['input']>;
  upperBound?: InputMaybe<Scalars['Float']['input']>;
};

export type FloatLinearOrderConstraints = {
  /** Corresponds to `value = x`, where `value` is the provided value and `x` the value to search for. */
  equalTo?: InputMaybe<Scalars['Float']['input']>;
  /** Corresponds to `value < x`, where `value` is the provided value and `x` the value to search for. */
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  /** Corresponds to `value <= x`, where `value` is the provided value and `x` the value to search for. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Corresponds to `x < value`, where `value` is the provided value and `x` the value to search for. */
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  /** Corresponds to `x <= value`, where `value` is the provided value and `x` the value to search for. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
};

export type ForceDelete_SuccessResult = MutationPayload & {
  __typename: 'ForceDelete_SuccessResult';
  node: Node;
  query: Query;
};

/** A general `Audit`-node that tracks mutations to the database. */
export type GeneralAudit = Audit & Commentable & Node & Taggable & Timestamped & Userstamped & {
  __typename: 'GeneralAudit';
  /** The comments for this `GeneralAudit`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `GeneralAudit`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `GeneralAudit`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** The client-application that the `creator` used at the moment when he/she generated this `GeneralAudit`. */
  creatorClient?: Maybe<Client>;
  /** The IP-address of the `creator` at the moment when he/she generated this `GeneralAudit`. */
  creatorIpAddress?: Maybe<Scalars['IpAddress']['output']>;
  /**
   * The team of the `creator` at the moment when he/she generated this `GeneralAudit`.
   *
   * See the `Audit.creator`-field for more information.
   */
  creatorTeam?: Maybe<Team>;
  /** The user-agent of the `creator` at the moment when he/she generated this `GeneralAudit`-node. */
  creatorUserAgent?: Maybe<Scalars['UserAgent']['output']>;
  /**
   * Gives the `User` that _updated_ this `GeneralAudit`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /** The event type for which this `GeneralAudit` was generated. */
  event?: Maybe<AuditedEvent>;
  /**
   * The name of the GraphQL operation that was responsible for this `GeneralAudit`-node.
   *
   * Use this value in combination with the `client`-field to derive how this audit was created.
   */
  graphqlOperation?: Maybe<Scalars['String']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `GeneralAudit`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `GeneralAudit`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** An HTML-formatted text containing some remarks about the mutation that generated this `GeneralAudit`. */
  remarks?: Maybe<Scalars['HTML']['output']>;
  /** Connection to the tags that are assigned to this `GeneralAudit`. */
  tags?: Maybe<TagConnection>;
  /** Gives the most recent moment on which this `GeneralAudit`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** A general `Audit`-node that tracks mutations to the database. */
export type GeneralAuditCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


/** A general `Audit`-node that tracks mutations to the database. */
export type GeneralAuditIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** A general `Audit`-node that tracks mutations to the database. */
export type GeneralAuditIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** A general `Audit`-node that tracks mutations to the database. */
export type GeneralAuditTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `GeneralAuditOrderByColumn`. */
export enum GeneralAuditOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type GenerateAnalysisReportEntriesInput = {
  /** The ID of the `AnalysisReport` for which you want to generate the entries. */
  id: Scalars['ID']['input'];
  /** Determines how product-risks with predicate value `INDETERMINATE` should be handled. */
  indeterminateProductRisks?: InputMaybe<AnalysisReportProductRiskIncludeMethod>;
  /** Determines how product-risks with predicate value `NO` should be handled. */
  noProductRisks?: InputMaybe<AnalysisReportProductRiskIncludeMethod>;
  /** Determines how product-risks with predicate value `UNDECIDABLE` should be handled. */
  undecidableProductRisks?: InputMaybe<AnalysisReportProductRiskIncludeMethod>;
  /** Determines how product-risks with predicate value `YES` should be handled. */
  yesProductRisks?: InputMaybe<AnalysisReportProductRiskIncludeMethod>;
};

export type GenerateAnalysisReportEntriesResult = {
  __typename: 'GenerateAnalysisReportEntriesResult';
  node: AnalysisReport;
};

export type GenerateAnalysisReportEntryVerificationActionsInput = {
  id: Scalars['ID']['input'];
};

export type GenerateAnalysisReportEntryVerificationActionsResult = {
  __typename: 'GenerateAnalysisReportEntryVerificationActionsResult';
  node: AnalysisReport;
};

export type GenerateAnalysisReportInput = {
  /**
   * Specifies the behaviour for when the analysis report already has some previously generated items.
   *
   * IMPORTANT: This mutation will only be idempotent if this value is set to `NONE`!
   */
  beforeGeneratingClear?: GenerateAnalysisReport_BeforeGeneratingClear;
  id: Scalars['ID']['input'];
  /**
   * Specifies the behaviour if the provided analysis report does not yet have the products selected state.
   *
   * An analysis report is in the products selected state if `AnalysisReport.productsSelected == true`.
   */
  onNoProductsSelected?: GenerateAnalysisReport_NoProductsSelectedHandler;
};

export type GenerateAnalysisReportPayload = AnalysisReportInvalidStateException | AnalysisReportTodoListNotEmptyException | GenerateAnalysisReport_SuccessResult;

export type GenerateAnalysisReportProductRisksInput = {
  /**
   * Allows risk predicate expressions to evaluate to `INDETERMINATE`.
   *
   * An error will be thrown if a product risk evaluates to `INDETERMINATE` and this value is `false`.
   */
  allowIndeterminate?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Allows risk predicate expressions to evaluate to `UNDECIDABLE`.
   *
   * An error will be thrown if a product risk evaluates to `UNDECIDABLE` and this value is `false`.
   */
  allowUndecidable?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  /** Also generate product risks that evaluate to `NO`. */
  includeNo?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GenerateAnalysisReportProductRisksResult = {
  __typename: 'GenerateAnalysisReportProductRisksResult';
  node: AnalysisReport;
  totalIndeterminateProductRisks?: Maybe<Scalars['Int']['output']>;
  totalNoProductRisk?: Maybe<Scalars['Int']['output']>;
  totalUndecidableProductRisks?: Maybe<Scalars['Int']['output']>;
  totalYesProductRisks?: Maybe<Scalars['Int']['output']>;
};

export enum GenerateAnalysisReport_BeforeGeneratingClear {
  /** Clear all previously generated analysis report entries before generating new ones. */
  Entries = 'ENTRIES',
  /** Do not clear any previously generated analysis report items. */
  None = 'NONE',
  /** Clear all previously generated product-risks and entries before generating this analysis report. */
  ProductRisksAndEntries = 'PRODUCT_RISKS_AND_ENTRIES'
}

export enum GenerateAnalysisReport_NoProductsSelectedHandler {
  /**
   * Return an error response if the analysis report is not in the products selected state.
   *
   * This behaviour is preferable for cli- and background-clients, as it rolls back any potential changes made
   * my this mutation.
   */
  Error = 'ERROR',
  /**
   * Generate a todo item in the todo list of the analysis report and return an `AnalysisReportTodoListNotEmptyException`
   * if the analysis report has no selected products.
   */
  GenerateTodo = 'GENERATE_TODO',
  /**
   * Select the active products of the team that owns the analysis report if the analysis report has no selected
   * products.
   */
  UseActiveProducts = 'USE_ACTIVE_PRODUCTS',
  /**
   * Use an empty selection of products for the analysis report if the analysis report has no selected products.
   *
   * This handler is mostly for testing purposes, as it will always result in an empty analysis report.
   */
  UseEmptySelection = 'USE_EMPTY_SELECTION'
}

/** Result of the `generateAnalysisReport` mutation if it was fully generated. */
export type GenerateAnalysisReport_SuccessResult = MutationPayload & {
  __typename: 'GenerateAnalysisReport_SuccessResult';
  node: AnalysisReport;
  query: Query;
};

export type GenerateNeededAnalysisReportEntryVerificationPredicateValuesInput = {
  id: Scalars['ID']['input'];
  /**
   * Determines how product-risks with predicate value `INDETERMINATE` should be handled.
   *
   * This field only has an effect if the entries of the analysis report have not been generated yet.
   */
  indeterminateProductRisks?: InputMaybe<AnalysisReportProductRiskIncludeMethod>;
  /**
   * Determines how product-risks with predicate value `NO` should be handled.
   *
   * This field only has an effect if the entries of the analysis report have not been generated yet.
   */
  noProductRisks?: InputMaybe<AnalysisReportProductRiskIncludeMethod>;
  /**
   * Determines how product-risks with predicate value `UNDECIDABLE` should be handled.
   *
   * This field only has an effect if the entries of the analysis report have not been generated yet.
   */
  undecidableProductRisks?: InputMaybe<AnalysisReportProductRiskIncludeMethod>;
  /**
   * Determines how product-risks with predicate value `YES` should be handled.
   *
   * This field only has an effect if the entries of the analysis report have not been generated yet.
   */
  yesProductRisks?: InputMaybe<AnalysisReportProductRiskIncludeMethod>;
};

export type GenerateNeededAnalysisReportEntryVerificationPredicateValuesResult = {
  __typename: 'GenerateNeededAnalysisReportEntryVerificationPredicateValuesResult';
  node: AnalysisReport;
};

export type GenerateNeededAnalysisReportProductPredicateValuesInput = {
  id: Scalars['ID']['input'];
};

export type GenerateNeededAnalysisReportProductPredicateValuesResult = {
  __typename: 'GenerateNeededAnalysisReportProductPredicateValuesResult';
  node: AnalysisReport;
  notSatisfiedCount: Scalars['Int']['output'];
  valid: Scalars['Boolean']['output'];
};

export type GenericFileUploadRequest = FileUploadRequest & {
  __typename: 'GenericFileUploadRequest';
  /** The content type that the file must have. */
  contentType: Scalars['ContentType']['output'];
  /** The moment after which this request is no longer valid. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The moment after which the request is valid. */
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  /** The endpoint to upload the file to. */
  uri: Scalars['URL']['output'];
};

export type HtmlTag = {
  /** The attributes to set on an HTML-tag. */
  attributes?: InputMaybe<Array<HtmlTagAttribute>>;
  /** The name of an HTML-tag. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type HtmlTagAttribute = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** Interface implemented by nodes that can have files associated with hem */
export type HasFiles = {
  /**
   * The associated files.
   *
   * *NOTE:* There is no backwards pagination or ordering possible for files, as they use a different kind of database.
   */
  files?: Maybe<FileConnection>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
};


/** Interface implemented by nodes that can have files associated with hem */
export type HasFilesFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Objects that implement this interface have a `hash`-field uniquely identifies this object. It is a bit weaker than
 * `Node`, as it is not possible to "jump" to this object (like the `node` query for nodes). They are usually defined on
 * objects that are dynamically created based on the current query.
 *
 * See the `hash`-field on this interface for more information about the difference between `Hashed.hash` and `Node.id`.
 */
export type Hashed = {
  /**
   * A value that uniquely identifies this object like `id`-field for `Node`-objects, but cannot be used to retrieve
   * this object from the database. Mainly used for caching purposes.
   *
   * The `hash` field is similar to the `id` field in the following ways:
   *   1. Both `hash` and `id` are always available and are globally unique.
   *   2. Both `hash` and `id` refer to **this object and only this object.**
   *   3. In a single query, `X.hash == Y.hash` implies `X == Y` and `X.id == Y.id` implies `X == Y`, which makes them
   *      ideal for caching.
   *
   * That said, there are some important differences between `hash` and `id` you should keep in mind:
   *   1. Objects that have `Node.id` can always be retrieved using the `node(id: $id)`-query. It is not possible to
   *      construct a similar query for the `Hashed.hash` field. (So `Hashed` is a bit weaker than `Node`.)
   *   2. The fields of `Node` can differ over time between two queries, even if they have the same `id`. This happens if
   *      a mutation was performed on the node in-between those requests. For a `Hashed` field, this never happens.
   *      If two objects have the same `hash`, they **always** have the same value for **all** of there fields.
   *      (So in this way, `Hashed` is a bit stronger than `Node`).
   *   3. The `Node.id` field can be used to refer to a node in callback-requests. The `Hashed.hash` field can only be
   *      used as a fast way to check that two object are equal.
   *
   * If both `Node.id` and `Hashed.hash` are available, you should prefer `Node.id` over `Hashed.hash` for communication
   * and storage purposes. `Hashed.hash` should be preferred over `Node.id` when checking for exact matches and changes.
   * You may generally use `Hashed.hash` for a substitute of `Node.id` if `Node.id` is not available.
   */
  hash: Scalars['Hash']['output'];
};

export type InsertVerificationConfigurationRuleInput = {
  actions?: InputMaybe<Array<UpsertVerificationConfigurationRuleAction>>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  name?: InputMaybe<NameInput>;
  precedence?: InputMaybe<Scalars['Int']['input']>;
  predicateExpression?: InputMaybe<Scalars['MeetExpression']['input']>;
};

export type IntLinearOrderConstraints = {
  /** Corresponds to `value = x`, where `value` is the provided value and `x` the value to search for. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Corresponds to `value < x`, where `value` is the provided value and `x` the value to search for. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Corresponds to `value <= x`, where `value` is the provided value and `x` the value to search for. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Corresponds to `x < value`, where `value` is the provided value and `x` the value to search for. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Corresponds to `x <= value`, where `value` is the provided value and `x` the value to search for. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Nodes that implement this interface represent longer-running jobs triggered by a user. The interface provides fields
 * to track of these jobs while they are running.
 */
export type Job = {
  /**
   * The moment on which this `Job` was cancelled. Will be `null` if this job wasn't cancelled.
   *
   * A cancelled job won't be executed.
   */
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that cancelled this `Job`. See the `cancelledAt`-field for more information. */
  cancellor?: Maybe<User>;
  /** Gives the `DateTime` on which this `Job`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `Job`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `Job`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * The moment on which this `Job` will expire on the queue.
   *
   * If the job hasn't been started before this moment, it won't be executed anymore.
   */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The moment on which the this `Job` failed. */
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The associated files of this `Job`. */
  files?: Maybe<FileConnection>;
  /** The moment on which the this `Job` finished executing. */
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `Job`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `Job`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The moment on which this `Job` was dispatched on the queue (and thus been made available for
   * the workers).
   */
  queuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The moment on which the execution of this `Job` was started. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The current state of this `Job`. */
  state?: Maybe<JobState>;
  /** The `Team` for which this `Job` will be executed. */
  team?: Maybe<Team>;
  /** Gives the most recent moment on which this `Job`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The `User` for which this `Job` will be executed. */
  user?: Maybe<User>;
};


/**
 * Nodes that implement this interface represent longer-running jobs triggered by a user. The interface provides fields
 * to track of these jobs while they are running.
 */
export type JobFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Nodes that implement this interface represent longer-running jobs triggered by a user. The interface provides fields
 * to track of these jobs while they are running.
 */
export type JobIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/**
 * Nodes that implement this interface represent longer-running jobs triggered by a user. The interface provides fields
 * to track of these jobs while they are running.
 */
export type JobIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};

/**
 * A paged connection with `JobEdge` edges to `Job` nodes.
 *
 * This type was automatically generated from the `JobEdge` edge-type for the
 * `Team.jobs` field. (It might be possible that it is reused by other fields.)
 */
export type JobConnection = {
  __typename: 'JobConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<JobEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Job>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `JobConnection` connection that points to a `Job` node.
 *
 * This type was automatically generated from the `Job` node-type of the
 * `Team.jobs` field. (It might be possible that it is reused by other fields.)
 */
export type JobEdge = {
  __typename: 'JobEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: Job;
};

/**
 * Specifies how the edges to a `Job` will be ordered in a connection.
 *
 * This type was automatically generated from the `JobOrderByColumn` column-type used in the
 * `orderBy` argument of the `Team.jobs` field. (It might be possible that it is reused by
 * other fields.)
 */
export type JobOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: JobOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `JobOrderByColumn`. */
export enum JobOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

/** Represents the state of a background-job. */
export enum JobState {
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Queued = 'QUEUED',
  Ready = 'READY',
  Running = 'RUNNING'
}

export type JobWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries on the meta-data of the `cancelled`-event. */
  cancelled?: InputMaybe<DateTimeEventConstraints>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries on the meta-data of the `expires`-event. */
  expires?: InputMaybe<DateTimeEventConstraints>;
  /** Filters the entries on the meta-data of the `failed`-event. */
  failed?: InputMaybe<DateTimeEventConstraints>;
  /** Filters the entries on the meta-data of the `finished`-event. */
  finished?: InputMaybe<DateTimeEventConstraints>;
  /** Filters the entries on the meta-data of the `finishing`-event. */
  finishing?: InputMaybe<DateTimeEventConstraints>;
  /** Filters the entries on the meta-data of the `queued`-event. */
  queued?: InputMaybe<DateTimeEventConstraints>;
  /** Filters the entries on the meta-data of the `started`-event. */
  started?: InputMaybe<DateTimeEventConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
};

/** Input for the `makeFileUploadRequest` mutation. */
export type MakeFileUploadRequestInput = {
  /** The `Content-Type` (also known as *MIME-type*) of the file you want to upload. */
  contentType?: InputMaybe<Scalars['ContentType']['input']>;
};

export type ManageAnalysisReportEntriesInput = {
  /** Deletes entries from the report. (in bulk) */
  delete?: InputMaybe<Array<ManageAnalysisReportEntriesInput_Delete>>;
  /** Updates the existing values of the analysis report entries in bulk. */
  update?: InputMaybe<Array<ManageAnalysisReportEntriesInput_Update>>;
  /** Adds or updates entries. (one by one) */
  upsert?: InputMaybe<Array<ManageAnalysisReportEntriesInput_Upsert>>;
};

/**
 * ### TODO: Not implemented
 *
 * *This feature is not (fully) implemented yet!*
 */
export type ManageAnalysisReportEntriesInput_Delete = {
  /**
   * A list of ids of entries you want to delete.
   *
   * Only entries of the `AnalysisReport` itself can be updated. Other entries will be ignored!
   */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filters the entries that will be deleted.
   *
   * The filters will be applied *after* the `ids`-field!
   */
  where?: InputMaybe<Array<AnalysisReportEntryWhereClause>>;
};

export type ManageAnalysisReportEntriesInput_Update = {
  /**
   * A list of ids of entries you want to update. Will use all entries of the AnalysisReport when omitted.
   *
   * Only entries of the `AnalysisReport` itself can be updated. Other entries will be ignored!
   */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The new values for the entry-set specified by the `id` and `where` fields. */
  values: ManageAnalysisReportEntriesInput_Update_Values;
  /**
   * Filters the entries that will be affected.
   *
   * The filters will be applied *after* the `ids`-field!
   */
  where?: InputMaybe<Array<AnalysisReportEntryWhereClause>>;
};

export type ManageAnalysisReportEntriesInput_Update_Values = {
  /** Manages the predicate values for the selected entries. */
  predicateValues?: InputMaybe<ManageAnalysisReportEntryPredicateValuesInput>;
  /**
   * Sets the risk configuration for the selected entries.
   *
   * Only accepts risk configurations that were selected in the `AnalysisReport` beforehand.
   */
  riskConfiguration?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Overwrite the risk probability value.
   * This will create a RiskProbabilityValueOverwriteEvent for the selected entries and not affect the risk associated with this entry.
   */
  riskProbability?: InputMaybe<AnalysisReportEntryRiskValueInput>;
  /**
   * Sets the risk probability value for the selected entries.
   * @deprecated Use riskProbability instead
   */
  riskProbabilityValue?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Overwrite the risk severity value.
   * This will create a RiskSeverityValueOverwriteEvent for the selected entries and not affect the risk associated with this entry.
   */
  riskSeverity?: InputMaybe<AnalysisReportEntryRiskValueInput>;
  /**
   * Sets the risk severity value for the selected entries.
   * @deprecated Use riskSeverity instead
   */
  riskSeverityValue?: InputMaybe<Scalars['Float']['input']>;
  /** Sets the supplier reliability for the selected entries. */
  supplierReliability?: InputMaybe<ConnectSupplierReliabilityInput>;
};

/**
 * ### TODO: Not implemented
 *
 * *This feature is not (fully) implemented yet!*
 */
export type ManageAnalysisReportEntriesInput_Upsert = {
  comments?: InputMaybe<ConnectCommentsInput>;
  predicateValues?: InputMaybe<ManageAnalysisReportEntryPredicateValuesInput>;
  product: ConnectProductInput;
  risk: ConnectRiskInput;
  riskConfiguration?: InputMaybe<Scalars['ID']['input']>;
  riskProbabilityValue?: InputMaybe<Scalars['Float']['input']>;
  riskSeverityValue?: InputMaybe<Scalars['Float']['input']>;
  supplierBranch: ConnectSupplierBranchInput;
  supplierReliabilityValue?: InputMaybe<ConnectSupplierReliabilityInput>;
};

export type ManageAnalysisReportEntryPredicateValuesInput = {
  upsert: Array<UpsertAnalysisReportEntryPredicateValueInput>;
};

export type ManageContactAccountsInput = {
  attach?: InputMaybe<Array<Scalars['ID']['input']>>;
  detach?: InputMaybe<Array<Scalars['ID']['input']>>;
  sync?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ManageProductPredicateValuesInput = {
  /** Removes the set predicate values for the predicates with the provided ids. */
  delete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Sets the predicate values of the product. */
  upsert?: InputMaybe<Array<UpsertProductPredicateValueInput>>;
};

export type ManageTagsInput = {
  attach?: InputMaybe<Array<Scalars['ID']['input']>>;
  detach?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MeiliSearchTokenResponse = {
  __typename: 'MeiliSearchTokenResponse';
  accessToken: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  expiresIn?: Maybe<Scalars['DateTimeInterval']['output']>;
  tokenType: Scalars['String']['output'];
};

/** A message that should be shown to the user of a frontend application. */
export type Message = {
  __typename: 'Message';
  /** Detail content of the message. */
  detail?: Maybe<Scalars['String']['output']>;
  /** Severity level of the message. */
  severity: MessageSeverity;
  /** Summary content of the message. */
  summary: Scalars['String']['output'];
};

/** The severity of a message. Should be mapped to one of the PrimeVue severities. */
export enum MessageSeverity {
  /** Should be mapped to the 'contrast' severity of PrimeVue. */
  Contrast = 'CONTRAST',
  /** Should be mapped to the 'error' severity of PrimeVue. */
  Error = 'ERROR',
  /** Should be mapped to the 'info' severity of PrimeVue. */
  Info = 'INFO',
  /** Should be mapped to the 'secondary' severity of PrimeVue. */
  Secondary = 'SECONDARY',
  /** Should be mapped to the 'success' severity of PrimeVue. */
  Success = 'SUCCESS',
  /** Should be mapped to the 'warn' severity of PrimeVue. */
  Warn = 'WARN'
}

export type Mutation = {
  __typename: 'Mutation';
  /** Activates an `Activateable`-node. */
  activate: Activate_SuccessResult;
  /** Activates a list of `Activatable`-nodes. */
  activateMany: ActivateMany_SuccessResult;
  /** Assigns a team role to a user. */
  assignTeamRole?: Maybe<AssignTeamRole_SuccessResult>;
  /** Assigns multiple team roles to a user. */
  assignTeamRoles?: Maybe<AssignTeamRoles_SuccessResult>;
  /** Assign a user role to a user. */
  assignUserRole?: Maybe<AssignUserRole_SuccessResult>;
  /** Assign multiple user roles to a user. */
  assignUserRoles?: Maybe<AssignUserRoles_SuccessResult>;
  /** Attach tags to `Taggable` nodes. */
  attachTags: AttachTagsPayload;
  cancelJob?: Maybe<Job>;
  /**
   * Cancels a user invitation.
   *
   * This mutation will always fail if the user invitation is in the `ACCEPTED`, `EXPIRED` or `FAILED` state.
   * Nothing will happen if the user invitation is in the `CANCELLED` state (which makes this mutation idempotent.)
   */
  cancelUserInvitation?: Maybe<CancelUserInvitation_SuccessResult>;
  checkHealth?: Maybe<Scalars['Boolean']['output']>;
  /** Clears the `AnalysisReportEntry`-items of the `AnalysisReport` with the provided `ID`. */
  clearAnalysisReportEntries?: Maybe<ClearAnalysisReportEntries_SuccessResult>;
  /**
   * Clears/removes all the generated verification actions from the `AnalysisReportEntry`s of the `AnalysisReport` with the provided id.
   * @deprecated Use refreshAnalysisReportEntryVerificationActions instead.
   */
  clearAnalysisReportEntryVerificationActions?: Maybe<ClearAnalysisReportEntryVerificationActionsResult>;
  /** Clears/removes all the verification predicate values from the `AnalysisReportEntry`s of the `AnalysisReport` with the provided id. */
  clearAnalysisReportEntryVerificationPredicateValues?: Maybe<ClearAnalysisReportEntryVerificationPredicateValues_SuccessResult>;
  /** Clears/removes all the generated `Product` to `Risk` combinations of the `AnalysisReport` with the provided id. */
  clearAnalysisReportProductRisks?: Maybe<ClearAnalysisReportProductRisks_SuccessResult>;
  /** Clears/removes the selected `Product`s of the `AnalysisReport` with the provided id. */
  clearAnalysisReportProducts?: Maybe<ClearAnalysisReportProducts_SuccessResult>;
  /**
   * Does nothing.
   * @deprecated Irrelevant. Does Nothing.
   */
  clearAnalysisReportRiskConfigurations?: Maybe<ClearAnalysisReportRiskConfigurations_SuccessResult>;
  createAnalysisReport: CreateAnalysisReport_SuccessResult;
  createComment: CreateComment_SuccessResult;
  createCompany: CreateCompany_SuccessResult;
  createContact: CreateContact_SuccessResult;
  /**
   * Creates a new [MeiliSearch tenant token](https://www.meilisearch.com/docs/learn/security/tenant_tokens) for the
   * current access token.
   */
  createMeiliSearchToken?: Maybe<CreateMeiliSearch_SuccessResult>;
  createProduct: CreateProduct_SuccessResult;
  createProductCategory: CreateProductCategory_SuccessResult;
  createQuestionPredicate: CreateQuestionPredicate_SuccessResult;
  createRegion: CreateRegion_SuccessResult;
  createRisk: CreateRisk_SuccessResult;
  createRiskColumn?: Maybe<CreateRiskColumn_SuccessResult>;
  /**
   * Creates a new **GLOBALLY AVAILABLE** risk configuration.
   *
   * Use the `updateTeam` mutation to create team-specific risk configurations.
   *
   * ### TODO: Not implemented
   *
   * *This feature is not (fully) implemented yet!*
   */
  createRiskConfiguration?: Maybe<CreateRiskConfiguration_SuccessResult>;
  createSupplier: CreateSupplier_SuccessResult;
  createSupplierBranch: CreateSupplierBranch_SuccessResult;
  /** Creates a new `Tag`. */
  createTag: CreateTagPayload;
  createTeam: CreateTeam_SuccessResult;
  /** Creates a new license for a team. */
  createTeamLicense?: Maybe<CreateTeamLicenseClass_SuccessResult>;
  /** Creates a new team license class. */
  createTeamLicenseClass?: Maybe<CreateTeamLicenseClass_SuccessResult>;
  createThreat: CreateThreat_SuccessResult;
  createThreatCategory: CreateThreatCategory_SuccessResult;
  createUser: CreateUser_SuccessResult;
  /** Creates a new user invitation. */
  createUserInvitation?: Maybe<CreateUserInvitation_SuccessResult>;
  createVerificationAction: CreateVerificationAction_SuccessResult;
  createVerificationConfiguration: CreateVerificationConfiguration_SuccessResult;
  /** Creates a new verification predicate. */
  createVerificationPredicate?: Maybe<CreateVerificationPredicate_SuccessResult>;
  /** Deactivates an `Activateable`-node. */
  deactivate: Deactivate_SuccessResult;
  /** Deactivates a list of `Activateable`-nodes. */
  deactivateMany: DeactivateMany_SuccessResult;
  /** Deletes a node from the database. If the node supports soft-deletes, it will be soft-deleted. */
  delete: Delete_SuccessResult;
  /** Detach tags to `Taggable` nodes. */
  detachTags: DetachTagsPayload;
  /**
   * Creates a new `EchoFilesJob`. This mutation for e2e-testing purposes and should not be used to implement other
   * features.
   */
  echoFiles?: Maybe<EchoFilesJob>;
  /** Starts an export-job of the entries of an `AnalysisReport`. */
  exportAnalysisReportEntries?: Maybe<ExportAnalysisReportEntriesJob>;
  /** Starts an export-job to export products in a spreadsheet. */
  exportProductsSpreadsheet?: Maybe<ExportProductsSpreadsheetJob>;
  /** Starts an export-job to export suppliers in a spreadsheet. */
  exportSupplierBranchesSpreadsheet?: Maybe<ExportSupplierBranchesSpreadsheetJob>;
  /**
   * ### UNTESTED
   *
   * **This feature hasn't been tested jet and might not behave as expected!**
   */
  exportSupplierVCards?: Maybe<ExportSupplierVCardsJob>;
  /** Starts an export-job to export suppliers in a spreadsheet. */
  exportSuppliersSpreadsheet?: Maybe<ExportSuppliersSpreadsheetJob>;
  /**
   * Marks a running job as `FAILED`.
   *
   * Should be called by a job-worker after it successfully finished the execution of a job.
   */
  failJob?: Maybe<FailJob_SuccessResult>;
  /**
   * Marks a running job as `FINISHED`.
   *
   * Should be called by a job-worker after it successfully finished the execution of a job.
   */
  finishJob?: Maybe<FinishJob_SuccessResult>;
  /** Force-deletes a node from the database, even if it supports soft-deletes. */
  forceDelete: ForceDelete_SuccessResult;
  /** Generates the entries for an analysis report. */
  generateAnalysisReport?: Maybe<GenerateAnalysisReportPayload>;
  /**
   * Selects which `Product`s should be analysed in an `AnalysisReport`.
   * @deprecated Use generateAnalysisReport instead
   */
  generateAnalysisReportEntries?: Maybe<GenerateAnalysisReportEntriesResult>;
  /** @deprecated use generateAnalysisReport instead */
  generateAnalysisReportEntryVerificationActions?: Maybe<GenerateAnalysisReportEntryVerificationActionsResult>;
  /** @deprecated use generateAnalysisReport instead. */
  generateAnalysisReportProductRisks?: Maybe<GenerateAnalysisReportProductRisksResult>;
  /** @deprecated use generateAnalysisReport instead */
  generateNeededAnalysisReportEntryVerificationPredicateValues?: Maybe<GenerateNeededAnalysisReportEntryVerificationPredicateValuesResult>;
  /** @deprecated use generateAnalysisReport instead. */
  generateNeededAnalysisReportProductPredicateValues?: Maybe<GenerateNeededAnalysisReportProductPredicateValuesResult>;
  /** Creates a new request to upload files from the client. */
  makeFileUploadRequest?: Maybe<FileUploadRequest>;
  pruneMyJobs?: Maybe<User>;
  queueJob?: Maybe<Job>;
  rebuildSearchIndexes?: Maybe<RebuildSearchIndexes_SuccessResult>;
  /** Restores a soft-deleted node. */
  restore: Restore_SuccessResult;
  /**
   * Retracts all team roles of a user for a specific team.
   *
   * This essentially removes the user from that team.
   */
  retractAllTeamRoles?: Maybe<RetractTeamRoles_SuccessResult>;
  retractAllUserRoles?: Maybe<RetractUserRoles_SuccessResult>;
  /** Retracts one team role of a user. */
  retractTeamRole?: Maybe<RetractTeamRole_SuccessResult>;
  /** Retracts many team roles of a user. */
  retractTeamRoles?: Maybe<RetractTeamRoles_SuccessResult>;
  retractUserRole?: Maybe<RetractUserRole_SuccessResult>;
  retractUserRoles?: Maybe<RetractUserRoles_SuccessResult>;
  sendNotification?: Maybe<SendNotification_SuccessResult>;
  /**
   * Enqueues sending a user invitation.
   *
   * Will fail if the user invitation is not in the `READY` state.
   */
  sendUserInvitation?: Maybe<SendUserInvitation_SuccessResult>;
  /** Marks a queued job as `RUNNING`. */
  startJob?: Maybe<StartJob_SuccessResult>;
  updateAnalysisReport: UpdateAnalysisReport_SuccessResult;
  /**
   * Update the values of one `AnalysisReportEntry`.
   *
   * ### UNTESTED
   *
   * **This feature hasn't been tested jet and might not behave as expected!**
   */
  updateAnalysisReportEntry: UpdateAnalysisReportEntry_SuccessResult;
  updateAnalysisReportProductRisk: UpdateAnalysisReportProductRisk_SuccessResult;
  updateAnalysisReportProductRisks: UpdateAnalysisReportProductRisks_SuccessResult;
  /** Update an `Audit`-node. */
  updateAudit?: Maybe<UpdateAudit_SuccessResult>;
  /** Update multiple `Audit`-nodes. */
  updateAudits?: Maybe<UpdateAudits_SuccessResult>;
  updateComment: UpdateComment_SuccessResult;
  updateComments: UpdateComments_SuccessResult;
  updateCompanies: UpdateCompanies_SuccessResult;
  updateCompany: UpdateCompanies_SuccessResult;
  updateContact: UpdateContact_SuccessResult;
  updateContacts: UpdateContacts_SuccessResult;
  updateProduct: UpdateProduct_SuccessResult;
  updateProductCategory: UpdateProductCategory_SuccessResult;
  updateProducts: UpdateProducts_SuccessResult;
  updateQuestionPredicate: UpdateQuestionPredicate_SuccessResult;
  updateRegion: UpdateRegion_SuccessResult;
  updateRisk: UpdateRisk_SuccessResult;
  updateRiskColumn?: Maybe<UpdateRiskColumn_SuccessResult>;
  /**
   * ### TODO: Not implemented
   *
   * *This feature is not (fully) implemented yet!*
   */
  updateRiskConfiguration?: Maybe<UpdateRiskConfiguration_SuccessResult>;
  updateRisks: UpdateRisks_SuccessResult;
  updateSupplier: UpdateSupplier_SuccessResult;
  updateSupplierBranch: UpdateSupplierBranch_SuccessResult;
  updateSupplierBranches: UpdateSupplierBranches_SuccessResult;
  updateSuppliers: UpdateSuppliers_SuccessResult;
  /** Updates a `Tag`. */
  updateTag: UpdateTagPayload;
  updateTeam: UpdateTeam_SuccessResult;
  updateTeamLicense?: Maybe<UpdateTeamLicense_SuccessResult>;
  /** Updates a team license class. */
  updateTeamLicenseClass?: Maybe<UpdateTeamLicenseClass_SuccessResult>;
  updateTeams: UpdateTeams_SuccessResult;
  updateThreat: UpdateThreat_SuccessResult;
  updateThreatCategory: UpdateThreatCategory_SuccessResult;
  updateThreats: UpdateThreats_SuccessResult;
  updateUser: UpdateUser_SuccessResult;
  /**
   * Updates a user invitation.
   *
   * **IMPORTANT!** The properties of a user invitation that can be updated depend on the state of the user invitation.
   * See the documentation on the fields of `UpdateUserInvitationInput` for more information.
   */
  updateUserInvitation?: Maybe<UpdateUserInvitation_SuccessResult>;
  updateUsers: UpdateUsers_SuccessResult;
  updateVerificationAction: UpdateVerificationAction_SuccessResult;
  updateVerificationConfiguration?: Maybe<UpdateVerificationConfiguration_SuccessResult>;
  updateVerificationConfigurationRule: UpdateVerificationConfigurationRule_SuccessResult;
  /** Updates an verification predicate. */
  updateVerificationPredicate?: Maybe<UpdateVerificationPredicate_SuccessResult>;
  uploadFile?: Maybe<UploadFile_SuccessResult>;
  /**
   * Checks if each of the `AnalysisReportEntry`s of the `AnalysisReport` with the provided `id` has all the neccesary `VerificationPredicate`-values
   * to generate the `VerificationAction`s. It will return an verification error if this is not the case.
   * @deprecated irrelevant. Use Analysis Report todos instead.
   */
  verifyAnalysisReportEntriesHaveNeededVerificationPredicateValues?: Maybe<VerifyAnalysisReportEntriesHaveNeededVerificationPredicateValuesResult>;
  /**
   * Checks if each of the `Product`-`Risk` combinations of the `AnalysisReport` with the provided `id` have a `RiskProbability` and `RiskSeverity`
   * set for one of the `RiskConfiguration`s that was selected in the `AnalysisReport`.
   * @deprecated irrelevant. Use Analysis Report todos instead.
   */
  verifyAnalysisReportProductRiskValues?: Maybe<VerifyAnalysisReportProductRiskValuesResult>;
  /**
   * Checks if each of the `Product`s selected in the `AnalysisReport` with the provided `id`
   * belong to at least one `ProductCategory`.
   *
   * It will return a verification error if this is not the case.
   * @deprecated irrelevant. Use Analysis Report todos instead.
   */
  verifyAnalysisReportProductsBelongToProductCategories?: Maybe<VerifyAnalysisReportProductsBelongToProductCategoriesResult>;
  /**
   * Checks if each of the `Product`s selected in the `AnalysisReport` with the provided `id` have a the needed `ProductPredicate`-values
   * to determine which `Risk`s apply to those products.
   *
   * It will return a verification error if this is not the case.
   * @deprecated irrelevant. Use Analysis Report todos instead.
   */
  verifyAnalysisReportProductsHaveNeededPredicateValues?: Maybe<VerifyAnalysisReportProductsHaveNeededPredicateValuesResult>;
  /**
   * Checks if each of the `Product`s selected in the `AnalysisReport` with the provided `id` have at
   * least one `SupplierBranch` assicated with it.
   *
   * It will return a verification error if this is not the case.
   * @deprecated irrelevant. Use Analysis Report todos instead.
   */
  verifyAnalysisReportProductsHaveSupplierBranches?: Maybe<VerifyAnalysisReportProductsHaveSupplierBranchesResult>;
};


export type MutationActivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationActivateManyArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationAssignTeamRoleArgs = {
  input: AssignTeamRoleInput;
};


export type MutationAssignTeamRolesArgs = {
  input: AssignTeamRolesInput;
};


export type MutationAssignUserRoleArgs = {
  input: AssignUserRoleInput;
};


export type MutationAssignUserRolesArgs = {
  input: AssignUserRolesInput;
};


export type MutationAttachTagsArgs = {
  input: AttachTagsInput;
};


export type MutationCancelJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelUserInvitationArgs = {
  input: CancelUserInvitationInput;
};


export type MutationClearAnalysisReportEntriesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationClearAnalysisReportEntryVerificationActionsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationClearAnalysisReportEntryVerificationPredicateValuesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationClearAnalysisReportProductRisksArgs = {
  id: Scalars['ID']['input'];
};


export type MutationClearAnalysisReportProductsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationClearAnalysisReportRiskConfigurationsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateAnalysisReportArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: CreateAnalysisReportInput;
};


export type MutationCreateCommentArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: CreateCommentInput;
};


export type MutationCreateCompanyArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: CreateCompanyInput;
};


export type MutationCreateContactArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: CreateContactInput;
};


export type MutationCreateProductArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: CreateProductInput;
};


export type MutationCreateProductCategoryArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: CreateProductCategoryInput;
};


export type MutationCreateQuestionPredicateArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: CreateQuestionPredicateInput;
};


export type MutationCreateRegionArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: CreateRegionInput;
};


export type MutationCreateRiskArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: CreateRiskInput;
};


export type MutationCreateRiskColumnArgs = {
  input: CreateRiskColumnInput;
};


export type MutationCreateRiskConfigurationArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: CreateRiskConfigurationInput;
};


export type MutationCreateSupplierArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: CreateSupplierInput;
};


export type MutationCreateSupplierBranchArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: CreateSupplierBranchInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationCreateTeamArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: CreateTeamInput;
};


export type MutationCreateTeamLicenseArgs = {
  input: CreateTeamLicenseInput;
};


export type MutationCreateTeamLicenseClassArgs = {
  input: CreateTeamLicenseClassInput;
};


export type MutationCreateThreatArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: CreateThreatInput;
};


export type MutationCreateThreatCategoryArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: CreateThreatCategoryInput;
};


export type MutationCreateUserArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: CreateUserInput;
};


export type MutationCreateUserInvitationArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: CreateUserInvitationInput;
  sendImmediately?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateVerificationActionArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: CreateVerificationActionInput;
};


export type MutationCreateVerificationConfigurationArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: CreateVerificationConfigurationInput;
};


export type MutationCreateVerificationPredicateArgs = {
  input: CreateVerificationPredicateInput;
};


export type MutationDeactivateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeactivateManyArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteArgs = {
  node: Scalars['ID']['input'];
};


export type MutationDetachTagsArgs = {
  input: DetachTagsInput;
};


export type MutationEchoFilesArgs = {
  options: EchoFilesOptions;
  queueImmediately?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationExportAnalysisReportEntriesArgs = {
  options: ExportAnalysisReportEntriesOptions;
  queueImmediately?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationExportProductsSpreadsheetArgs = {
  options?: InputMaybe<ExportProductsSpreadsheetOptions>;
  queueImmediately?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationExportSupplierBranchesSpreadsheetArgs = {
  options?: InputMaybe<ExportSupplierBranchesSpreadsheetOptions>;
  queueImmediately?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationExportSupplierVCardsArgs = {
  options?: InputMaybe<ExportSupplierVCardsOptions>;
  queueImmediately?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationExportSuppliersSpreadsheetArgs = {
  options?: InputMaybe<ExportSuppliersSpreadsheetOptions>;
  queueImmediately?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationFailJobArgs = {
  input: FailJobInput;
};


export type MutationFinishJobArgs = {
  input: FinishJobInput;
};


export type MutationForceDeleteArgs = {
  node: Scalars['ID']['input'];
};


export type MutationGenerateAnalysisReportArgs = {
  input: GenerateAnalysisReportInput;
};


export type MutationGenerateAnalysisReportEntriesArgs = {
  input: GenerateAnalysisReportEntriesInput;
};


export type MutationGenerateAnalysisReportEntryVerificationActionsArgs = {
  input: GenerateAnalysisReportEntryVerificationActionsInput;
};


export type MutationGenerateAnalysisReportProductRisksArgs = {
  input: GenerateAnalysisReportProductRisksInput;
};


export type MutationGenerateNeededAnalysisReportEntryVerificationPredicateValuesArgs = {
  input: GenerateNeededAnalysisReportEntryVerificationPredicateValuesInput;
};


export type MutationGenerateNeededAnalysisReportProductPredicateValuesArgs = {
  input: GenerateNeededAnalysisReportProductPredicateValuesInput;
};


export type MutationMakeFileUploadRequestArgs = {
  input?: InputMaybe<MakeFileUploadRequestInput>;
};


export type MutationQueueJobArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRebuildSearchIndexesArgs = {
  input: RebuildSearchIndexesInput;
};


export type MutationRestoreArgs = {
  node: Scalars['ID']['input'];
};


export type MutationRetractAllTeamRolesArgs = {
  input: RetractAllTeamRolesInput;
};


export type MutationRetractAllUserRolesArgs = {
  input: RetractAllUserRolesInput;
};


export type MutationRetractTeamRoleArgs = {
  input: RetractTeamRoleInput;
};


export type MutationRetractTeamRolesArgs = {
  input: RetractTeamRolesInput;
};


export type MutationRetractUserRoleArgs = {
  input: RetractUserRoleInput;
};


export type MutationRetractUserRolesArgs = {
  input: RetractUserRolesInput;
};


export type MutationSendNotificationArgs = {
  input: SendNotificationInput;
};


export type MutationSendUserInvitationArgs = {
  input: SendUserInvitationInput;
};


export type MutationStartJobArgs = {
  input: StartJobInput;
};


export type MutationUpdateAnalysisReportArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateAnalysisReportInput;
};


export type MutationUpdateAnalysisReportEntryArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateAnalysisReportEntryInput;
};


export type MutationUpdateAnalysisReportProductRiskArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateAnalysisReportProductRiskInput;
};


export type MutationUpdateAnalysisReportProductRisksArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateAnalysisReportProductRisksInput;
};


export type MutationUpdateAuditArgs = {
  input: UpdateAuditInput;
};


export type MutationUpdateAuditsArgs = {
  input: UpdateAuditsInput;
};


export type MutationUpdateCommentArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateCommentInput;
};


export type MutationUpdateCommentsArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateCommentsInput;
};


export type MutationUpdateCompaniesArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateCompaniesInput;
};


export type MutationUpdateCompanyArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateCompanyInput;
};


export type MutationUpdateContactArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateContactInput;
};


export type MutationUpdateContactsArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateContactsInput;
};


export type MutationUpdateProductArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateProductInput;
};


export type MutationUpdateProductCategoryArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateProductCategoryInput;
};


export type MutationUpdateProductsArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateProductsInput;
};


export type MutationUpdateQuestionPredicateArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateQuestionPredicateInput;
};


export type MutationUpdateRegionArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateRegionInput;
};


export type MutationUpdateRiskArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateRiskInput;
};


export type MutationUpdateRiskColumnArgs = {
  input: UpdateRiskColumnInput;
};


export type MutationUpdateRiskConfigurationArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateRiskConfigurationInput;
};


export type MutationUpdateRisksArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateRisksInput;
};


export type MutationUpdateSupplierArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateSupplierInput;
};


export type MutationUpdateSupplierBranchArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateSupplierBranchInput;
};


export type MutationUpdateSupplierBranchesArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateSupplierBranchesInput;
};


export type MutationUpdateSuppliersArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateSuppliersInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};


export type MutationUpdateTeamArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateTeamInput;
};


export type MutationUpdateTeamLicenseArgs = {
  input: UpdateTeamLicenseInput;
};


export type MutationUpdateTeamLicenseClassArgs = {
  input: UpdateTeamLicenseClassInput;
};


export type MutationUpdateTeamsArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateTeamsInput;
};


export type MutationUpdateThreatArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateThreatInput;
};


export type MutationUpdateThreatCategoryArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateThreatCategoryInput;
};


export type MutationUpdateThreatsArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateThreatsInput;
};


export type MutationUpdateUserArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateUserInput;
};


export type MutationUpdateUserInvitationArgs = {
  input: UpdateUserInvitationInput;
};


export type MutationUpdateUsersArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateUsersInput;
};


export type MutationUpdateVerificationActionArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateVerificationActionInput;
};


export type MutationUpdateVerificationConfigurationArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateVerificationConfigurationInput;
};


export type MutationUpdateVerificationConfigurationRuleArgs = {
  auditRemarks?: InputMaybe<Scalars['HTML']['input']>;
  input: UpdateVerificationConfigurationRuleInput;
};


export type MutationUpdateVerificationPredicateArgs = {
  input: UpdateVerificationPredicateInput;
};


export type MutationUploadFileArgs = {
  contentType?: InputMaybe<Scalars['ContentType']['input']>;
};


export type MutationVerifyAnalysisReportEntriesHaveNeededVerificationPredicateValuesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationVerifyAnalysisReportProductRiskValuesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationVerifyAnalysisReportProductsBelongToProductCategoriesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationVerifyAnalysisReportProductsHaveNeededPredicateValuesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationVerifyAnalysisReportProductsHaveSupplierBranchesArgs = {
  id: Scalars['ID']['input'];
};

export type MutationPayload = {
  query: Query;
};

export type Name = EntityName & {
  __typename: 'Name';
  full?: Maybe<Scalars['String']['output']>;
  short?: Maybe<Scalars['String']['output']>;
};

export type NameInput = {
  full: Scalars['String']['input'];
  short?: InputMaybe<Scalars['String']['input']>;
};

export type NameInputOptional = {
  full?: InputMaybe<Scalars['String']['input']>;
  short?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Interface implemented by nodes that have a `name`. This `name` should be enough for a user (that is familiar with the
 * data) to identify the node.
 */
export type Named = {
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * The name of this named node. This value should have enough information (in context) so that a user that is
   * familiar with the data to know what this node represents.
   */
  name?: Maybe<EntityName>;
};

export type NestedSetConnection = {
  edges?: Maybe<Array<Maybe<NestedSetEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<NestedSetNode>>>;
  pageInfo: PageInfo;
};

export type NestedSetEdge = {
  cursor: Scalars['Cursor']['output'];
  node?: Maybe<NestedSetNode>;
};

export enum NestedSetIncludeSelf {
  /** Include the current nested set node in the result of a connection. */
  With = 'WITH',
  /** Exclude the current nested set node in the result of a connection. */
  Without = 'WITHOUT'
}

/**
 * Represents a node in a [nested-set](https://en.wikipedia.org/wiki/Nested_set_model) data-structure, which is a
 * read-efficient way to represent large trees.
 */
export type NestedSetNode = {
  /**
   * The ancestors of node `X`, which is the [transitive closure](https://en.wikipedia.org/wiki/Transitive_closure)
   * of nodes that can be reach from `X` using the `parent`-field, without 'X' itself.
   */
  ancestors?: Maybe<NestedSetConnection>;
  /** The bloodline of node `X`, which is the union of `ancestors`, `descendants` and `X` itself. */
  bloodline?: Maybe<NestedSetConnection>;
  /** The children of this node `X`, which are all the nodes `N` such that `N.parent == X`. */
  children?: Maybe<NestedSetConnection>;
  /**
   * The depth of this node in the tree. It is defined by `depth := 0` if this node is a root node and
   * `depth := parent.depth + 1` if it has a parent.
   */
  depth?: Maybe<Scalars['Int']['output']>;
  /**
   * The ancestors of node `X`, which is the [transitive closure](https://en.wikipedia.org/wiki/Transitive_closure)
   * of nodes that can be reach from `X` using the `children`-field, without 'X' itself.
   */
  descendants?: Maybe<NestedSetConnection>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * `true` when this node has no children.
   *
   * This value will also be `false` if the current access-token is not allowed to see the children of this node.
   */
  isLeaf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * `true` when this node has no parent.
   *
   * When this value is `false` and `parent` is `null`, it means that the current access-token has no access to
   * the parent of this node.
   */
  isRoot?: Maybe<Scalars['Boolean']['output']>;
  /** The parent of this node. */
  parent?: Maybe<NestedSetNode>;
  /** The siblings of this node `X`, which are all the nodes `X` such that `N.parent == X.parent` except X itself. */
  siblings?: Maybe<NestedSetConnection>;
};


/**
 * Represents a node in a [nested-set](https://en.wikipedia.org/wiki/Nested_set_model) data-structure, which is a
 * read-efficient way to represent large trees.
 */
export type NestedSetNodeAncestorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  self?: InputMaybe<NestedSetIncludeSelf>;
};


/**
 * Represents a node in a [nested-set](https://en.wikipedia.org/wiki/Nested_set_model) data-structure, which is a
 * read-efficient way to represent large trees.
 */
export type NestedSetNodeBloodlineArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Represents a node in a [nested-set](https://en.wikipedia.org/wiki/Nested_set_model) data-structure, which is a
 * read-efficient way to represent large trees.
 */
export type NestedSetNodeChildrenArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Represents a node in a [nested-set](https://en.wikipedia.org/wiki/Nested_set_model) data-structure, which is a
 * read-efficient way to represent large trees.
 */
export type NestedSetNodeDescendantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  self?: InputMaybe<NestedSetIncludeSelf>;
};


/**
 * Represents a node in a [nested-set](https://en.wikipedia.org/wiki/Nested_set_model) data-structure, which is a
 * read-efficient way to represent large trees.
 */
export type NestedSetNodeSiblingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  self?: InputMaybe<NestedSetIncludeSelf>;
};

/**
 * Represents a node in the data-graph that is queried by this GraphQL-API.
 *
 * Each node is uniquely (and globally) identified by the value of its `id`-field. This value can be used in the
 * `node` and `nodes` queries to retrieve this object.
 */
export type Node = {
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   */
  id: Scalars['ID']['output'];
};

/** Interface for nodes that can have notifications. */
export type Notifiable = {
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** The stored notifications for this node. */
  notifications?: Maybe<NotificationConnection>;
};


/** Interface for nodes that can have notifications. */
export type NotifiableNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationOrderByClause>>;
};

/** Node that represents a stored notification. */
export type Notification = Node & Timestamped & {
  __typename: 'Notification';
  /** Gives the `DateTime` on which this `Notification`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** A detailed explanation of this notification. */
  detail?: Maybe<Scalars['String']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `Notification`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this notification is read. */
  isRead?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `Notification`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** The notifiable object to which this notification was made. */
  notifiable?: Maybe<Notifiable>;
  /** The moment on which the notification was read. */
  readAt?: Maybe<Scalars['DateTime']['output']>;
  /** The severity if this notification. Used to color the notification. */
  severity?: Maybe<NotificationSeverity>;
  /** A short message containing the summary of this notification. */
  summary?: Maybe<Scalars['String']['output']>;
  /** Gives the most recent moment on which this `Notification`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** Node that represents a stored notification. */
export type NotificationIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** Node that represents a stored notification. */
export type NotificationIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};

/**
 * A paged connection with `NotificationEdge` edges to `Notification` nodes.
 *
 * This type was automatically generated from the `NotificationEdge` edge-type for the
 * `Team.notifications` field. (It might be possible that it is reused by other fields.)
 */
export type NotificationConnection = Connection & ConnectionWithTotal & {
  __typename: 'NotificationConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<NotificationEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Notification>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `NotificationConnection` connection that points to a `Notification` node.
 *
 * This type was automatically generated from the `Notification` node-type of the
 * `Team.notifications` field. (It might be possible that it is reused by other fields.)
 */
export type NotificationEdge = Edge & {
  __typename: 'NotificationEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: Notification;
};

/**
 * Specifies how the edges to a `Notification` will be ordered in a connection.
 *
 * This type was automatically generated from the `NotificationOrderByColumn` column-type used in the
 * `orderBy` argument of the `Team.notifications` field. (It might be possible that it is reused by
 * other fields.)
 */
export type NotificationOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: NotificationOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `NotificationOrderByColumn`. */
export enum NotificationOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

/**
 * Represents the severity of a notification.
 *
 * Can be used by a GUI-application to alter the appearance of a Notification.
 */
export enum NotificationSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Success = 'SUCCESS',
  Warn = 'WARN'
}

export type NotificationWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the meta-data about the moment they were created. */
  created?: InputMaybe<DateTimeConstraints>;
  /** Filters the entries on the meta-data of the `read`-event. */
  read?: InputMaybe<DateTimeEventConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<DateTimeConstraints>;
};

/**
 * Represents an identity used to sign in to a user account. An identity can be provided by Microsoft, by organizations,
 * or by social identity providers such as Facebook, Google, or Microsoft, that are tied to a user account.
 * This enables the user to sign in to the user account with any of those associated identities.
 *
 * For more information, see the [Microsoft Graph API Documentation](https://learn.microsoft.com/en-us/graph/api/resources/objectidentity?view=graph-rest-1.0).
 */
export type ObjectIdentity = {
  __typename: 'ObjectIdentity';
  /**
   * Specifies the issuer of the identity, for example facebook.com.
   * For local accounts (where signInType is not federated), this property is the local B2C tenant default domain name,
   * for example contoso.onmicrosoft.com. For external users from other Azure AD organization, this will be the domain
   * of the federated organization, for example contoso.com.
   */
  issuer?: Maybe<Scalars['String']['output']>;
  /**
   * Specifies the unique identifier assigned to the user by the issuer. The combination of issuer and issuerAssignedId
   * must be unique within the organization. Represents the sign-in name for the user, when signInType is set to
   * `emailAddress` or `userName` (also known as local accounts).
   *
   * When signInType is set to:
   *   - `emailAddress`, (or a custom string that starts with `emailAddress` like `emailAddress1`) `issuerAssignedId`
   *     must be a valid email address.
   *   - `userName`, issuerAssignedId must begin with alphabetical character or number, and can only contain alphanumeric
   *     characters and the following symbols: `-` or `_`.
   */
  issuerAssignedId?: Maybe<Scalars['String']['output']>;
  /**
   * Specifies the user sign-in types in your directory, such as emailAddress, userName, federated, or userPrincipalName.
   * federated represents a unique identifier for a user from an issuer, that can be in any format chosen by the issuer.
   * Setting or updating a userPrincipalName identity will update the value of the userPrincipalName property on the user
   * object. The validations performed on the userPrincipalName property on the user object, for example, verified
   * domains and acceptable characters, will be performed when setting or updating a userPrincipalName identity.
   * Additional validation is enforced on issuerAssignedId when the sign-in type is set to emailAddress or userName.
   * This property can also be set to any custom string.
   */
  signInType?: Maybe<Scalars['String']['output']>;
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

/**
 * Interface for nodes that has the concept of an `owner`.
 *
 * Also see the `Usable` interface for more context.
 */
export type Ownable = {
  /**
   * The globally unique identifier that can be used in the `node` and `nodes` queries to retrieve this
   * object. See the `Node` interface for more information.
   */
  id: Scalars['ID']['output'];
  /** Checks whether this node is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this node is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this node is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this node has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /** A reference to the owner of this node. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this node can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(ownable: $ownable)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
};


/**
 * Interface for nodes that has the concept of an `owner`.
 *
 * Also see the `Usable` interface for more context.
 */
export type OwnableIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


/**
 * Interface for nodes that has the concept of an `owner`.
 *
 * Also see the `Usable` interface for more context.
 */
export type OwnableIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


/**
 * Interface for nodes that has the concept of an `owner`.
 *
 * Also see the `Usable` interface for more context.
 */
export type OwnableOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};

/** Represents a node that can 'own' other `Ownable` nodes. */
export type Owner = {
  /** Whether this owner can use the provided usable node. */
  canUse?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A longer, plain-text value that helps the user to identify this node. When a collection of these nodes are
   * full-text searchable, it will also search over the values in this field.
   *
   * It is always safe to show in the GUI.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The globally unique identifier that can be used in the `node` and `nodes` queries to retrieve this
   * object. See the `Node` interface for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * The name of the node, which should be enough for the user that is familiar with the data to identify this node.
   *
   * It is always safe to show in the GUI.
   */
  name?: Maybe<EntityName>;
};


/** Represents a node that can 'own' other `Ownable` nodes. */
export type OwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};

export type PageInfo = {
  __typename: 'PageInfo';
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export type PersonName = {
  casual?: Maybe<Scalars['String']['output']>;
  first?: Maybe<Scalars['String']['output']>;
  formal?: Maybe<Scalars['String']['output']>;
  full?: Maybe<Scalars['String']['output']>;
  honorific: PersonNameHonorific;
  initials?: Maybe<Scalars['String']['output']>;
  last: PersonNameLast;
  middle?: Maybe<Scalars['String']['output']>;
  short?: Maybe<Scalars['String']['output']>;
};

export type PersonNameHonorific = {
  prefix?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
};

export type PersonNameLast = {
  full?: Maybe<Scalars['String']['output']>;
  main?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
};

/** Node that represents a phone number. It's value is completely determined by the `e164`-field. */
export type PhoneNumber = {
  __typename: 'PhoneNumber';
  country: Country;
  e164?: Maybe<Scalars['String']['output']>;
  international?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  national?: Maybe<Scalars['String']['output']>;
  rfc3966?: Maybe<Scalars['String']['output']>;
};


/** Node that represents a phone number. It's value is completely determined by the `e164`-field. */
export type PhoneNumberLocationArgs = {
  locale?: InputMaybe<Scalars['String']['input']>;
  userCountryCode?: InputMaybe<Scalars['CountryCode']['input']>;
};

/** Node that contains meta-data on how to format/validate a `PhoneNumber`. */
export type PhoneNumberFormat = Node & {
  __typename: 'PhoneNumberFormat';
  country?: Maybe<Country>;
  example?: Maybe<PhoneNumber>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  prefix?: Maybe<Scalars['String']['output']>;
};

/** Node that represents a predicate about some other node. */
export type Predicate = {
  /** The default value for a node that has no explicit value for this predicate set. */
  defaultPredicateValue?: Maybe<PredicateValue>;
  /**
   * The `Node` global-id. Used to uniquely identify this node.
   *
   * This `id` is also be used in `PredicateExpression`s to refer to this node.
   */
  id: Scalars['ID']['output'];
  /** Checks whether this node is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this node is usable by the common GINO library team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this node is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this node is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id, which can save
   * an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * An HTML-formatted field with a closed-form question to the user to explain the predicate.
   *
   * This value is always safe to show in the GUI.
   */
  predicateQuestion?: Maybe<Scalars['HTML']['output']>;
};


/** Node that represents a predicate about some other node. */
export type PredicateIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


/** Node that represents a predicate about some other node. */
export type PredicateIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};

export type PredicateExpression = {
  /** The PredicateValue to which this predicate expression evaluates. */
  evaluatesTo?: Maybe<PredicateValue>;
  /** The predicate expression string defining this `PredicateExpression`. */
  expression?: Maybe<Scalars['String']['output']>;
  /**
   * A value that uniquely identifies this object like `id`-field for `Node`-objects, but cannot be used to retrieve
   * this object from the database. Mainly used for caching purposes.
   *
   * See the `Hashed.hash` field for more information.
   */
  hash: Scalars['Hash']['output'];
  /**
   * The predicate nodes that refer to this `PredicateExpression`.
   *
   * ### TODO: Not implemented
   *
   * *This feature is not (fully) implemented yet!*
   */
  predicates?: Maybe<Array<Maybe<Predicate>>>;
};

export type PredicateExpressionTermSubstitution = {
  term: Scalars['ID']['input'];
  with: Scalars['JoinExpression']['input'];
};

export type PredicateProductConnection = {
  edges?: Maybe<Array<Maybe<PredicateProductEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Product>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PredicateProductEdge = {
  /**
   * The boolean value of the product in `node` for this predicate. **ONLY USE THIS VALUE ABSOLUTELY NESSICARY!**
   * The value of the `value` is preferred as `null` can mean different things here!
   */
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  cursor: Scalars['Cursor']['output'];
  node: Product;
  /**
   * A list of possible predicate values for this predicate to decide for all risks that depend on this predicate if
   * they apply to the product.
   * @deprecated Use the predicateRequirements of the product instead
   */
  requires?: Maybe<PredicateValueSet>;
  /**
   * The value of the product in `node` for this predicate. This value is only `null` if the database could not retrieve
   * this value in the query or or if the user has no permission to see this value.
   */
  value?: Maybe<PredicateValue>;
};

export type PredicateRequirement = {
  /** The predicate that requires a determinate value. */
  predicate: Predicate;
  /**
   * The (simplified) expressions for which the predicate is required.
   *
   * Can be used to re-determine the significance of this predicate requirement when
   */
  requiredExpressions: Array<PredicateExpression>;
  significance: Scalars['Float']['output'];
};

export type PredicateRiskConnection = {
  edges?: Maybe<Array<Maybe<PredicateRiskEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Risk>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type PredicateRiskEdge = {
  cursor: Scalars['Cursor']['output'];
  node: Risk;
  requires?: Maybe<PredicateValueSet>;
};

/**
 * Represents some knowledge about an object `x` for a predicate `P`. A combination of these values can
 * be used to proof a logical expression.
 *
 * We use these values instead of just `true` and `false` so that we can know for sure that we don't know the
 * answer to a logical expression.
 *
 * **NOTE:** There are an infinite number of possibilities for knowledge about `P(x)`. Therefore, this
 * enum only represents the knowledge that the backend can understand. However, this means that the amount of cases
 * in this enum will grow in the future in necessary!
 */
export enum PredicateValue {
  /**
   * Value that represents the case where none of the other knowledge about `P(x)` is known at the current timeframe.
   *
   * This value is similar to `null` in JavaScript, though it is a bit stronger!
   * This is because `null` represents something like *"No idea"* while `INDETERMINATE` represents the phrase
   * *"We know for sure that cannot derive anything about `P(x)` at te moment"* . This distinction is important, as
   * it allows us to determine if a logical expression is determinable.
   *
   * If an expression evaluates to `INDETERMINATE`, it means that the value of that expression can change if more
   * information is provided. To keep this logic consistent, we need that `INDETERMINATE == X`
   * rewrites to `INDETERMINATE` for all values of `X` (And in particular `INDETERMINATE == INDETERMINATE` also
   * rewrites to `INDETERMINATE`)!
   */
  Indeterminate = 'INDETERMINATE',
  /**
   * Value that represents the case that `¬P(x)` is known for predicate `P` and object `x`, or in other words:
   * *We know for sure that `P(x)` will **never** become true.*
   *
   * This value is analogue to the classical boolean-value `false`.
   */
  No = 'NO',
  /**
   * Value that represents the case where we are certain that we will never know the value of `P(x)`.
   *
   * You can also read this value as the phrase *"We know for sure that we will never be able to answer `P(x)`
   * with `YES` or `NO`"*.
   *
   * If an expression evaluates to `UNDECIDABLE`, it means that it will always be `UNDECIDABLE`, even if you add
   * more information to the expression. Therefore, we do have that `UNDECIDABLE == UNDECIDABLE`.
   */
  Undecidable = 'UNDECIDABLE',
  /**
   * Value that represents the case that `P(x)` is known for predicate `P` and object `x`, or in other words:
   * *We know that `P(x)` is true.*
   *
   * This value is analogue to the classical boolean-value `true`.
   */
  Yes = 'YES'
}

export type PredicateValueSet = {
  __typename: 'PredicateValueSet';
  contains: Scalars['Boolean']['output'];
  indeterminate: Scalars['Boolean']['output'];
  no: Scalars['Boolean']['output'];
  undecidable: Scalars['Boolean']['output'];
  yes: Scalars['Boolean']['output'];
};


export type PredicateValueSetContainsArgs = {
  value: PredicateValue;
};

export type Product = Activateable & Commentable & Named & Node & Ownable & Selectable & SoftDelete & SoftDeleteUserstamped & Taggable & Timestamped & Usable & Userstamped & {
  __typename: 'Product';
  /** A reference for the client-company. Unique for the product in this team. */
  clientRef?: Maybe<Scalars['String']['output']>;
  /** The comments for this `Product`-object. */
  comments?: Maybe<CommentConnection>;
  company?: Maybe<Company>;
  /** Gives the `DateTime` on which this `Product`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `Product`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** Timestamp of when this `Product`-object was deactivated. */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that deactivated this `Product`-object. */
  deactivator?: Maybe<User>;
  /** Gives the moment on which this `Product`-object was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _deleted_ this `Product`-object.
   *
   * When this field is `null`, it can be the case that this object was not deleted or not deleted by a `User`. It will also
   * be `null` when the current user is not allowed to see the `User` that deleted this object.
   */
  destroyer?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `Product`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this `Product`-object is considered to be active. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `Product`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Product` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Product` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Product` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `Product` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `Product`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Product` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Product` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Product` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `Product` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Name>;
  /** A reference to the owner that owns this `Product`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `Product` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /** Gives information about requirement of the provided predicate for this product. */
  predicateRequirementFor?: Maybe<ProductPredicateRequirement>;
  /**
   * The connection to the requirement nodes that describe for which predicates a value is required to give all
   * risk expressions a determinate value.
   */
  predicateRequirements?: Maybe<ProductPredicateRequirementConnection>;
  predicateValues?: Maybe<Scalars['PredicateValueMap']['output']>;
  /** A union of both the Regions and the QuestionPredicates */
  predicates?: Maybe<Product_PredicateConnection>;
  productCategories?: Maybe<ProductCategoryConnection>;
  questionPredicates?: Maybe<Product_QuestionPredicateConnection>;
  regions?: Maybe<Product_RegionConnection>;
  risks?: Maybe<Product_RiskConnection>;
  supplierBranches?: Maybe<SupplierBranchConnection>;
  suppliers?: Maybe<SupplierConnection>;
  /** Connection to the tags that are assigned to this `Product`. */
  tags?: Maybe<TagConnection>;
  /** Will be `true` if this `Product` is soft-deleted, `false` otherwise. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** Gives the most recent moment on which this `Product`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ProductCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type ProductIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type ProductIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type ProductIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type ProductIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type ProductIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type ProductIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type ProductOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type ProductPredicateRequirementForArgs = {
  predicate: Scalars['ID']['input'];
};


export type ProductPredicateRequirementsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductPredicatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Array<Product_PredicateWhereClause>>;
};


export type ProductProductCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  ancestors?: InputMaybe<Product_WithProductCategoryAncestors>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductCategoryOrderByClause>>;
  where?: InputMaybe<Array<ProductCategoryWhereClause>>;
};


export type ProductQuestionPredicatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QuestionPredicateOrderByClause>>;
  where?: InputMaybe<Array<Product_QuestionPredicateWhereClause>>;
};


export type ProductRegionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegionOrderByClause>>;
  where?: InputMaybe<Array<Product_RegionWhereClause>>;
};


export type ProductRisksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskOrderByClause>>;
  where?: InputMaybe<Array<RiskWhereClause>>;
};


export type ProductSupplierBranchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SupplierBranchOrderByClause>>;
  where?: InputMaybe<Array<SupplierBranchWhereClause>>;
};


export type ProductSuppliersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SupplierOrderByClause>>;
  where?: InputMaybe<Array<SupplierWhereClause>>;
};


export type ProductTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

export type ProductCategory = Activateable & Commentable & Named & NestedSetNode & Node & Ownable & Selectable & SoftDelete & SoftDeleteUserstamped & Taggable & Timestamped & Usable & Userstamped & {
  __typename: 'ProductCategory';
  /**
   * The ancestors of this `ProductCategory`-node are all the parents, parents of parents etc.
   *
   * > This field is part of the `NestedSetNode`-behavior of `ProductCategory` and was added by the
   * > `NestedSetMixin`. See the `NestedSetNode`-interface for more information.
   */
  ancestors?: Maybe<ProductCategoryConnection>;
  /**
   * Union of all descendants and siblings of this `ProductCategory`.
   *
   * This connection always contains this `ProductCategory` itself.
   *
   * > This field is part of the `NestedSetNode`-behavior of `ProductCategory` and was added by the
   * > `NestedSetMixin`. See the `NestedSetNode`-interface for more information.
   */
  bloodline?: Maybe<ProductCategoryConnection>;
  /**
   * The direct children of this `ProductCategory`.
   *
   * > This field is part of the `NestedSetNode`-behavior of `ProductCategory` and was added by the
   * > `NestedSetMixin`. See the `NestedSetNode`-interface for more information.
   */
  children?: Maybe<ProductCategoryConnection>;
  /** The comments for this `ProductCategory`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `ProductCategory`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `ProductCategory`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** Timestamp of when this `ProductCategory`-object was deactivated. */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that deactivated this `ProductCategory`-object. */
  deactivator?: Maybe<User>;
  /** Gives the moment on which this `ProductCategory`-object was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The depth of this `ProductCategory`-object in its nested set as an integer.
   *
   * The following rules hold for this value:
   * - `depth == 0` **iff** `isRoot == true`
   * - `depth == parentKey.depth + 1`
   *
   * Therefore, you could also see this value *the amount of ancestors* of this object in the tree.
   *
   * > This field is part of the `NestedSetNode`-behavior of `ProductCategory` and was added by the
   * > `NestedSetMixin`. See the `NestedSetNode`-interface for more information.
   */
  depth?: Maybe<Scalars['Int']['output']>;
  /**
   * The descendants of this `ProductCategory`-node are all the children, children of children etc.
   *
   * > This field is part of the `NestedSetNode`-behavior of `ProductCategory` and was added by the
   * > `NestedSetMixin`. See the `NestedSetNode`-interface for more information.
   */
  descendants?: Maybe<ProductCategoryConnection>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _deleted_ this `ProductCategory`-object.
   *
   * When this field is `null`, it can be the case that this object was not deleted or not deleted by a `User`. It will also
   * be `null` when the current user is not allowed to see the `User` that deleted this object.
   */
  destroyer?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `ProductCategory`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this `ProductCategory`-object is considered to be active. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Wheter this `ProductCategory` is a *leaf*-node (or in other words, it has no children.)
   *
   * > This field is part of the `NestedSetNode`-behavior of `ProductCategory` and was added by the
   * > `NestedSetMixin`. See the `NestedSetNode`-interface for more information.
   */
  isLeaf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `ProductCategory`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ProductCategory` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ProductCategory` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ProductCategory` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `ProductCategory` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Wheter this `ProductCategory` is a *root*-node (or in other words, when it has no parents.)
   *
   * > This field is part of the `NestedSetNode`-behavior of `ProductCategory` and was added by the
   * > `NestedSetMixin`. See the `NestedSetNode`-interface for more information.
   */
  isRoot?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `ProductCategory`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ProductCategory` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ProductCategory` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ProductCategory` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `ProductCategory` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Name>;
  /** A reference to the owner that owns this `ProductCategory`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `ProductCategory` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The direct parent of this `ProductCategory`.
   *
   * > This field is part of the `NestedSetNode`-behavior of `ProductCategory` and was added by the
   * > `NestedSetMixin`. See the `NestedSetNode`-interface for more information.
   */
  parent?: Maybe<ProductCategory>;
  products?: Maybe<ProductConnection>;
  risks?: Maybe<ProductCategory_RiskConnection>;
  /**
   * The siblings of this `ProductCategory`. These the nodes that have the same parentKey as the current node, excluding
   * the current node itself.
   *
   * > This field is part of the `NestedSetNode`-behavior of `ProductCategory` and was added by the
   * > `NestedSetMixin`. See the `NestedSetNode`-interface for more information.
   */
  siblings?: Maybe<ProductCategoryConnection>;
  /** Connection to the tags that are assigned to this `ProductCategory`. */
  tags?: Maybe<TagConnection>;
  /** Will be `true` if this `ProductCategory` is soft-deleted, `false` otherwise. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** Gives the most recent moment on which this `ProductCategory`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ProductCategoryAncestorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductCategoryOrderByClause>>;
  self?: InputMaybe<NestedSetIncludeSelf>;
  where?: InputMaybe<Array<ProductCategoryWhereClause>>;
};


export type ProductCategoryBloodlineArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductCategoryOrderByClause>>;
  where?: InputMaybe<Array<ProductCategoryWhereClause>>;
};


export type ProductCategoryChildrenArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductCategoryOrderByClause>>;
  where?: InputMaybe<Array<ProductCategoryWhereClause>>;
};


export type ProductCategoryCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type ProductCategoryDescendantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductCategoryOrderByClause>>;
  self?: InputMaybe<NestedSetIncludeSelf>;
  where?: InputMaybe<Array<ProductCategoryWhereClause>>;
};


export type ProductCategoryIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type ProductCategoryIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type ProductCategoryIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type ProductCategoryIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type ProductCategoryIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type ProductCategoryIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type ProductCategoryOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type ProductCategoryProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductOrderByClause>>;
  where?: InputMaybe<Array<ProductWhereClause>>;
};


export type ProductCategoryRisksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskOrderByClause>>;
  where?: InputMaybe<Array<RiskWhereClause>>;
};


export type ProductCategorySiblingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductCategoryOrderByClause>>;
  self?: InputMaybe<NestedSetIncludeSelf>;
  where?: InputMaybe<Array<ProductCategoryWhereClause>>;
};


export type ProductCategoryTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

/** An `Audit`-node that tracks mutations of a `ProductCategory`-node. */
export type ProductCategoryAudit = Audit & Commentable & Node & Ownable & Taggable & Timestamped & Userstamped & {
  __typename: 'ProductCategoryAudit';
  /** The comments for this `ProductCategoryAudit`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `ProductCategoryAudit`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `ProductCategoryAudit`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** The client-application that the `creator` used at the moment when he/she generated this `ProductCategoryAudit`. */
  creatorClient?: Maybe<Client>;
  /** The IP-address of the `creator` at the moment when he/she generated this `ProductCategoryAudit`. */
  creatorIpAddress?: Maybe<Scalars['IpAddress']['output']>;
  /**
   * The team of the `creator` at the moment when he/she generated this `ProductCategoryAudit`.
   *
   * See the `Audit.creator`-field for more information.
   */
  creatorTeam?: Maybe<Team>;
  /** The user-agent of the `creator` at the moment when he/she generated this `ProductCategoryAudit`-node. */
  creatorUserAgent?: Maybe<Scalars['UserAgent']['output']>;
  /**
   * Gives the `User` that _updated_ this `ProductCategoryAudit`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /** The event type for which this `ProductCategoryAudit` was generated. */
  event?: Maybe<AuditedEvent>;
  /**
   * The name of the GraphQL operation that was responsible for this `ProductCategoryAudit`-node.
   *
   * Use this value in combination with the `client`-field to derive how this audit was created.
   */
  graphqlOperation?: Maybe<Scalars['String']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `ProductCategoryAudit`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ProductCategoryAudit` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ProductCategoryAudit` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ProductCategoryAudit` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `ProductCategoryAudit` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `ProductCategoryAudit`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** The parent of the product category after the mutation was executed. */
  newParent?: Maybe<ProductCategory>;
  /** The parent of the product category before the mutation was executed. */
  oldParent?: Maybe<ProductCategory>;
  /** A reference to the owner that owns this `ProductCategoryAudit`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `ProductCategoryAudit` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the mutation represented by this `Audit`-node changed the parent of the product category in the
   * `ProductCategoryAudit.productCategory` field.
   *
   * This property implies that `ProductCategoryAudit.oldParent == ProductCategoryAudit.newParent`. Note that this
   * property is available, even if the current access token is not allowed to read the parent.
   */
  parentChanged?: Maybe<Scalars['Boolean']['output']>;
  /** The product category for which this `Audit`-node was generated. */
  productCategory?: Maybe<ProductCategory>;
  /** An HTML-formatted text containing some remarks about the mutation that generated this `ProductCategoryAudit`. */
  remarks?: Maybe<Scalars['HTML']['output']>;
  /** Connection to the tags that are assigned to this `ProductCategoryAudit`. */
  tags?: Maybe<TagConnection>;
  /** Gives the most recent moment on which this `ProductCategoryAudit`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** An `Audit`-node that tracks mutations of a `ProductCategory`-node. */
export type ProductCategoryAuditCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


/** An `Audit`-node that tracks mutations of a `ProductCategory`-node. */
export type ProductCategoryAuditIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** An `Audit`-node that tracks mutations of a `ProductCategory`-node. */
export type ProductCategoryAuditIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


/** An `Audit`-node that tracks mutations of a `ProductCategory`-node. */
export type ProductCategoryAuditIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


/** An `Audit`-node that tracks mutations of a `ProductCategory`-node. */
export type ProductCategoryAuditIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** An `Audit`-node that tracks mutations of a `ProductCategory`-node. */
export type ProductCategoryAuditOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


/** An `Audit`-node that tracks mutations of a `ProductCategory`-node. */
export type ProductCategoryAuditTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

/**
 * A paged connection with `ProductCategoryAuditEdge` edges to `ProductCategoryAudit` nodes.
 *
 * This type was automatically generated from the `ProductCategoryAuditEdge` edge-type for the
 * `Query.productCategoryAudits` field. (It might be possible that it is reused by other fields.)
 */
export type ProductCategoryAuditConnection = Connection & ConnectionWithTotal & {
  __typename: 'ProductCategoryAuditConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<ProductCategoryAuditEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<ProductCategoryAudit>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `ProductCategoryAuditConnection` connection that points to a `ProductCategoryAudit` node.
 *
 * This type was automatically generated from the `ProductCategoryAudit` node-type of the
 * `Query.productCategoryAudits` field. (It might be possible that it is reused by other fields.)
 */
export type ProductCategoryAuditEdge = Edge & {
  __typename: 'ProductCategoryAuditEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: ProductCategoryAudit;
};

/**
 * Specifies how the edges to a `ProductCategoryAudit` will be ordered in a connection.
 *
 * This type was automatically generated from the `ProductCategoryAuditOrderByColumn` column-type used in the
 * `orderBy` argument of the `Query.productCategoryAudits` field. (It might be possible that it is reused by
 * other fields.)
 */
export type ProductCategoryAuditOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: ProductCategoryAuditOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `ProductCategoryAuditOrderByColumn`. */
export enum ProductCategoryAuditOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type ProductCategoryAuditWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters on the event type of the audit entry. */
  event?: InputMaybe<AuditedEvent>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A paged connection with `ProductCategoryEdge` edges to `ProductCategory` nodes.
 *
 * This type was automatically generated from the `ProductCategoryEdge` edge-type for the
 * `Product.productCategories` field. (It might be possible that it is reused by other fields.)
 */
export type ProductCategoryConnection = Connection & ConnectionWithTotal & NestedSetConnection & {
  __typename: 'ProductCategoryConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<ProductCategoryEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<ProductCategory>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `ProductCategoryConnection` connection that points to a `ProductCategory` node.
 *
 * This type was automatically generated from the `ProductCategory` node-type of the
 * `Product.productCategories` field. (It might be possible that it is reused by other fields.)
 */
export type ProductCategoryEdge = Edge & NestedSetEdge & {
  __typename: 'ProductCategoryEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: ProductCategory;
};

/**
 * Specifies how the edges to a `ProductCategory` will be ordered in a connection.
 *
 * This type was automatically generated from the `ProductCategoryOrderByColumn` column-type used in the
 * `orderBy` argument of the `Product.productCategories` field. (It might be possible that it is reused by
 * other fields.)
 */
export type ProductCategoryOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: ProductCategoryOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `ProductCategoryOrderByColumn`. */
export enum ProductCategoryOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which an entity was deactivated. */
  DeactivatedAt = 'DEACTIVATED_AT',
  /** Orders by the moment on which the entities were deleted. */
  DeletedAt = 'DELETED_AT',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  /** Orders the nodes of a nested set by their *right value*, which corresponds to the post-order traversal of a tree. */
  PostOrderTraversal = 'POST_ORDER_TRAVERSAL',
  /** Orders the nodes of a nested set by their *left value*, which corresponds to the pre-order traversal of a tree. */
  PreOrderTraversal = 'PRE_ORDER_TRAVERSAL',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type ProductCategoryWhereClause = {
  /** Filter entries based on the current active state. See the `WhereActive`-enum for more information. */
  active?: InputMaybe<WhereActive>;
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were deactivated. */
  deactivated?: InputMaybe<StampedEventConstraints>;
  /** Filters the entries by the meta-data about the moment they were soft-deleted. */
  deleted?: InputMaybe<StampedEventConstraints>;
  /**
   * Filter on the absolute depth in the tree (of nested-set nodes). This is equivalent to the total number of
   * ancestors.
   *
   * The absolute depth of a node X is defined by:
   *     - `X.depth := 0` if `X` has no parent (`X` is a root node)
   *     - `X.depth := X.parent.depth + 1` if `X` has a parent.
   *
   * Set this filter to `{equalTo: 0}` to get all root nodes.
   */
  depth?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filters on whether the `NestedSetNode` is a leaf-node or not.
   *
   * A node is considered to be a leaf-node if it has no children.
   */
  leaves?: InputMaybe<WhereLeaves>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Filters on whether the `NestedSetNode` is a root-node or not.
   *
   * A node is considered to be a root-node if it has no parent.
   */
  roots?: InputMaybe<WhereRoots>;
  /**
   * Filters the entries by the total amount child-nodes.
   *
   * You get the leaves if you set this constraint to `{equalTo: 0 }`.
   *
   * See the `NestedSetNode.children`-field for more information.
   */
  totalChildren?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /**
   * Filters the entries by the total amount descendant-nodes. See the `descendants`-field of the `NestedSet` interface
   * for more information.
   *
   * This total does not include the node itself as its descendant! **Example:** You get the leaves if you set this
   * constraint to `{equalTo: 0 }`.
   *
   * See the `NestedSetNode.descendants`-field for more information.
   */
  totalDescendants?: InputMaybe<IntLinearOrderConstraints>;
  /**
   * Filters the entries by the total amount nodes in the bloodline. See the `bloodline`-field of the `NestedSet`
   * interface for more information.
   *
   * This total does include the node itself! **Example:** You no results if you set this constraint to `{equalTo: 0 }`.
   *
   * See the `NestedSetNode.bloodline`-field for more information.
   */
  totalNodesInBloodline?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `risks`. */
  totalRisks?: InputMaybe<IntLinearOrderConstraints>;
  /**
   * Filters the entries by the total amount sibling-nodes.
   *
   * This total does not include the node itself as its sibling! **Example:** You get all nodes without siblings when
   * you set the constraints to `{equalTo: 0 }`.
   *
   * See the `NestedSetNode.siblings`-field for more information.
   */
  totalSiblings?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A paged connection with `ProductCategory_RiskEdge` edges to `Risk` nodes.
 *
 * This type was automatically generated from the `ProductCategory_RiskEdge` edge-type for the
 * `ProductCategory.risks` field. (It might be possible that it is reused by other fields.)
 */
export type ProductCategory_RiskConnection = Connection & ConnectionWithTotal & {
  __typename: 'ProductCategory_RiskConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<ProductCategory_RiskEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Risk>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProductCategory_RiskEdge = Edge & {
  __typename: 'ProductCategory_RiskEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node at the end of this edge. */
  node: Risk;
};

/**
 * A paged connection with `ProductEdge` edges to `Product` nodes.
 *
 * This type was automatically generated from the `ProductEdge` edge-type for the
 * `AnalysisReport.products` field. (It might be possible that it is reused by other fields.)
 */
export type ProductConnection = Connection & ConnectionWithTotal & {
  __typename: 'ProductConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<ProductEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Product>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `ProductConnection` connection that points to a `Product` node.
 *
 * This type was automatically generated from the `Product` node-type of the
 * `AnalysisReport.products` field. (It might be possible that it is reused by other fields.)
 */
export type ProductEdge = Edge & {
  __typename: 'ProductEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: Product;
};

/**
 * Specifies how the edges to a `Product` will be ordered in a connection.
 *
 * This type was automatically generated from the `ProductOrderByColumn` column-type used in the
 * `orderBy` argument of the `AnalysisReport.products` field. (It might be possible that it is reused by
 * other fields.)
 */
export type ProductOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: ProductOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `ProductOrderByColumn`. */
export enum ProductOrderByColumn {
  /** Orders by the reference that the customer uses. */
  ClientRef = 'CLIENT_REF',
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which an entity was deactivated. */
  DeactivatedAt = 'DEACTIVATED_AT',
  /** Orders by the moment on which the entities were deleted. */
  DeletedAt = 'DELETED_AT',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type ProductPredicate = {
  /**
   * The default value for a node that has no explicit value for this predicate set.
   *
   * See the `Predicate.defaultPredicateValue` field for more information.
   */
  defaultPredicateValue?: Maybe<PredicateValue>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * This `id` is also used to refer to this `ProductPredicate` in a predicate expression.
   */
  id: Scalars['ID']['output'];
  /** Checks whether this node is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this node is usable by the common GINO library team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this node is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this node is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id, which can save
   * an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * An HTML-formatted field with a closed-form question to the user to explain the predicate.
   *
   * This value is always safe to show in the GUI.
   *
   * See the `Predicate.predicateQuestion` field for more information.
   */
  predicateQuestion?: Maybe<Scalars['HTML']['output']>;
  /** Connection to the risks that uses this product predicate in its predicate expression. */
  usedByRisks?: Maybe<RiskConnection>;
  /** Connection to the verification configuration rules that use this predicate. */
  usedByVerificationConfigurationRules?: Maybe<VerificationConfigurationRuleConnection>;
  /** Connection to the verification configurations that use this verification predicate. */
  usedByVerificationConfigurations?: Maybe<VerificationConfigurationConnection>;
};


export type ProductPredicateIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type ProductPredicateIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type ProductPredicateUsedByRisksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type ProductPredicateUsedByVerificationConfigurationRulesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationRuleOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationRuleWhereClause>>;
};


export type ProductPredicateUsedByVerificationConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationWhereClause>>;
};

export type ProductPredicateConnection = {
  edges?: Maybe<Array<Maybe<ProductPredicateEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<ProductPredicate>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProductPredicateEdge = {
  /**
   * The boolean value of this product for the predicate in `node`. **ONLY USE THIS VALUE ABSOLUTELY NESSICARY!**
   * The value of the `value` is preferred as `null` can mean different things here!
   */
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  cursor: Scalars['Cursor']['output'];
  node?: Maybe<ProductPredicate>;
  /** Some custom, html-formatted remarks about this predicate value for the `Product`. */
  remarks?: Maybe<Scalars['HTML']['output']>;
  /**
   * A list of possible predicate values for that this product must have to decide for all risks that depend on
   * the predicate in `node` if they apply to the product.
   * @deprecated Use the predicateRequirements of the product instead
   */
  requires?: Maybe<PredicateValueSet>;
  /**
   * The value of this product for the predicate in `node`. This value is only `null` if the database could not retrieve
   * this value in the query or or if the user has no permission to see this value.
   */
  value?: Maybe<PredicateValue>;
};

export type ProductPredicateExpression = Hashed & PredicateExpression & {
  __typename: 'ProductPredicateExpression';
  /** The PredicateValue to which this predicate expression evaluates. */
  evaluatesTo?: Maybe<PredicateValue>;
  /** The predicate expression string defining this `ProductPredicateExpression`. */
  expression?: Maybe<Scalars['String']['output']>;
  /**
   * A value that uniquely identifies this object like `id`-field for `Node`-objects, but cannot be used to retrieve
   * this object from the database. Mainly used for caching purposes.
   *
   * See the `Hashed.hash` field for more information.
   */
  hash: Scalars['Hash']['output'];
  /** The predicates that occur in this predicate expression. */
  predicates?: Maybe<Array<Maybe<ProductPredicate>>>;
};

export type ProductPredicateRequirement = Node & {
  __typename: 'ProductPredicateRequirement';
  /** Connection to the nodes that demanded a value for this predicate. */
  demandingContext?: Maybe<ProductPredicateRequirementDemandingContextConnection>;
  /** The simplified expressions that demand a value. The current predicate values of the product are pre-substituted. */
  demandingExpressions: Array<Scalars['String']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** The predicate for which a value is required. */
  predicate?: Maybe<ProductPredicate>;
  /** The product for which a predicate value is required for the predicate in the `predicate` field. */
  product?: Maybe<Product>;
  /**
   * A value that expresses how important the predicate value is.
   *
   * A higher significance means that more predicate requirements can potentially disappear when a value for this
   * predicate is provided.
   */
  significance: Scalars['Float']['output'];
  /**
   * The string in the demandingExpressions that represents the predicate of this requirement.
   *
   * This value is equal to `predicate.id` in almost all cases. It is preferred to use this value over
   * `predicate.id`, as the `predicate` field can be `null` if the user is not allowed to see the meta-information
   * of the predicate.
   */
  term: Scalars['String']['output'];
};


export type ProductPredicateRequirementDemandingContextArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductPredicateRequirementConnection = Connection & ConnectionWithTotal & {
  __typename: 'ProductPredicateRequirementConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<ProductPredicateRequirementEdge>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<ProductPredicateRequirement>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProductPredicateRequirementDemandingContextConnection = {
  __typename: 'ProductPredicateRequirementDemandingContextConnection';
  edges?: Maybe<Array<ProductPredicateRequirementDemandingContextEdge>>;
  nodes?: Maybe<Array<Maybe<Risk>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProductPredicateRequirementDemandingContextEdge = {
  __typename: 'ProductPredicateRequirementDemandingContextEdge';
  cursor: Scalars['Cursor']['output'];
  node?: Maybe<Risk>;
  /** The simplified predicate expression of the risk with the current predicate values of this products filled in. */
  predicateExpression?: Maybe<ProductPredicateExpression>;
  /** The product category of the risk which matched one of the product categories of the product. */
  riskProductCategory?: Maybe<ProductCategory>;
};

export type ProductPredicateRequirementEdge = Edge & {
  __typename: 'ProductPredicateRequirementEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /**
   * The node at the end of this edge.
   *
   * This value is `null` iff the current access token has no permission to see the value of this node, but does have
   * the permission to see the values on the edges.
   */
  node?: Maybe<ProductPredicateRequirement>;
};

export type ProductWhereClause = {
  /** Filter entries based on the current active state. See the `WhereActive`-enum for more information. */
  active?: InputMaybe<WhereActive>;
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on the reference that the customer uses. */
  clientRefIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were deactivated. */
  deactivated?: InputMaybe<StampedEventConstraints>;
  /** Filters the entries by the meta-data about the moment they were soft-deleted. */
  deleted?: InputMaybe<StampedEventConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters the entries by the total amount of related items they have in the relation `analysisReports`. */
  totalAnalysisReports?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `predicateValues`. */
  totalPredicateValues?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `categories`. */
  totalProductCategories?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `branches`. */
  totalSupplierBranches?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Product_PredicateConnection = {
  __typename: 'Product_PredicateConnection';
  edges?: Maybe<Array<Maybe<Product_PredicateEdge>>>;
  nodes?: Maybe<Array<Maybe<ProductPredicate>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Product_PredicateEdge = ProductPredicateEdge & {
  __typename: 'Product_PredicateEdge';
  /**
   * The boolean value of this product for the predicate in `node`. **ONLY USE THIS VALUE ABSOLUTELY NESSICARY!**
   * The value of the `value` is preferred as `null` can mean different things here!
   */
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  cursor: Scalars['Cursor']['output'];
  /** The Predicate at the end of this node. */
  node?: Maybe<ProductPredicate>;
  /** Some custom, html-formatted remarks about this predicate value for the `Product`. */
  remarks?: Maybe<Scalars['HTML']['output']>;
  /**
   * A list of possible predicate values for that this product must have to decide for all risks that depend on
   * the predicate in `node` if they apply to the product.
   * @deprecated use the predicate requirements of the product instead.
   */
  requires?: Maybe<PredicateValueSet>;
  /**
   * The risks for which a value for the predicate is relevant.
   * @deprecated Use the predicate requirements of the product instead.
   */
  risks?: Maybe<Array<Risk>>;
  /**
   * The value of this product for the predicate in `node`. This value is only `null` if the database could not retrieve
   * this value in the query or or if the user has no permission to see this value.
   */
  value?: Maybe<PredicateValue>;
};

export type Product_PredicateWhereClause = {
  predicateValue?: InputMaybe<PredicateValue>;
};

export type Product_QuestionPredicateConnection = Connection & ConnectionWithTotal & ProductPredicateConnection & {
  __typename: 'Product_QuestionPredicateConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Product_QuestionPredicateEdge>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<QuestionPredicate>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Product_QuestionPredicateEdge = Edge & ProductPredicateEdge & {
  __typename: 'Product_QuestionPredicateEdge';
  /**
   * The boolean value of this product for the predicate in `node`. **ONLY USE THIS VALUE ABSOLUTELY NESSICARY!**
   * The value of the `value` is preferred as `null` can mean different things here!
   */
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  cursor: Scalars['Cursor']['output'];
  node: QuestionPredicate;
  /** Some custom, html-formatted remarks about this predicate value for the `Product`. */
  remarks?: Maybe<Scalars['HTML']['output']>;
  /**
   * A list of possible predicate values for that this product must have to decide for all risks that depend on
   * the predicate in `node` if they apply to the product.
   * @deprecated use the predicate requirements of the product instead.
   */
  requires?: Maybe<PredicateValueSet>;
  /**
   * The value of this product for the predicate in `node`. This value is only `null` if the database could not retrieve
   * this value in the query or or if the user has no permission to see this value.
   */
  value?: Maybe<PredicateValue>;
};

export type Product_QuestionPredicateWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were soft-deleted. */
  deleted?: InputMaybe<StampedEventConstraints>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  predicateValue?: InputMaybe<PredicateValue>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters on the total amount of risks that use this predicate. */
  totalUsedByRisks?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters on the total amount of verification configuration rules that use this predicate. */
  totalUsedByVerificationConfigurationRules?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Product_RegionConnection = Connection & ConnectionWithTotal & ProductPredicateConnection & {
  __typename: 'Product_RegionConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Product_RegionEdge>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Region>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Product_RegionEdge = Edge & ProductPredicateEdge & {
  __typename: 'Product_RegionEdge';
  /**
   * The boolean value of this product for the predicate in `node`. **ONLY USE THIS VALUE ABSOLUTELY NESSICARY!**
   * The value of the `value` is preferred as `null` can mean different things here!
   */
  booleanValue?: Maybe<Scalars['Boolean']['output']>;
  cursor: Scalars['Cursor']['output'];
  node: Region;
  /** Some custom, html-formatted remarks about this predicate value for the `Product`. */
  remarks?: Maybe<Scalars['HTML']['output']>;
  /**
   * A list of possible predicate values for that this product must have to decide for all risks that depend on
   * the predicate in `node` if they apply to the product.
   * @deprecated use the predicate requirements of the product instead.
   */
  requires?: Maybe<PredicateValueSet>;
  /**
   * The value of this product for the predicate in `node`. This value is only `null` if the database could not retrieve
   * this value in the query or or if the user has no permission to see this value.
   */
  value?: Maybe<PredicateValue>;
};

export type Product_RegionWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were soft-deleted. */
  deleted?: InputMaybe<StampedEventConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  predicateValue?: InputMaybe<PredicateValue>;
  /** Filters on the total amount of risks that use this predicate. */
  totalUsedByRisks?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters on the total amount of verification configuration rules that use this predicate. */
  totalUsedByVerificationConfigurationRules?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
};

export type Product_RiskConnection = Connection & ConnectionWithTotal & {
  __typename: 'Product_RiskConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Product_RiskEdge>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Risk>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Product_RiskEdge = Edge & {
  __typename: 'Product_RiskEdge';
  cursor: Scalars['Cursor']['output'];
  node: Risk;
  predicateExpression?: Maybe<ProductPredicateExpression>;
};


export type Product_RiskEdgePredicateExpressionArgs = {
  substitute?: InputMaybe<Array<PredicateExpressionTermSubstitution>>;
};

export enum Product_WithProductCategoryAncestors {
  /**
   * Show both the product categories that are connected to the product, as well as the the ancestors of those
   * product categories.
   */
  With = 'WITH',
  /** Only show product categories that are directly connected to the product. */
  Without = 'WITHOUT'
}

/**
 * Todo item that can be resolved by specifying a determinate value for all predicate requirements for the Product of the
 * `product` field.
 */
export type ProvideRequiredProductPredicateValuesTodo = Node & Todo & {
  __typename: 'ProvideRequiredProductPredicateValuesTodo';
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this `Todo` item is considered to be done. */
  isDone?: Maybe<Scalars['Boolean']['output']>;
  /** The product for which all predicate requirements should be resolved. */
  product?: Maybe<Product>;
  /** The title for this todo item that can be used to display it in a todo list. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Indicates what fields are available at the top level of a query operation. */
export type Query = {
  __typename: 'Query';
  accountsWithRole?: Maybe<AccountConnection>;
  /** Entry point for the audit entries in the database. */
  audits?: Maybe<AuditConnection>;
  /** Entry point for the common GINO team. */
  commonGinoTeam: Team;
  /** Lists all the companies. */
  companies?: Maybe<CompanyConnection>;
  /** Lists all the contacts. */
  contacts?: Maybe<ContactConnection>;
  /**
   * Gives a list of all the country meta-data. This can be useful for generating input-fields for addresses or
   * phone-numbers.
   */
  countries: Query_CountryConnection;
  /**
   * Entry point for the current access token. This value will be `null` if the request to the GraphQL API did not have
   * an access token in the `Authorization`-header.
   */
  me?: Maybe<AccessToken>;
  /**
   * Gets the node with the provided `id`.
   *
   * This query-value will be `null` if no node with the provided id was found *or* if the the current access-token has
   * no permission to retrieve the node.
   */
  node?: Maybe<Node>;
  /**
   * Resolves multiple nodes at the same time. This is equivalent with calling the `node`-field multiple times.
   *
   * In almost every case, it is more efficient to retrieve multiple nodes with this field compared to multiple
   * `node`-queries, as the backend can optimize the retrieval of the related nodes. This is especially the case when
   * you retrieve multiple nodes of the same type.
   *
   * The response-array always has the same length as the array of the provided `ids`-parameter. The values can however
   * be `null` if the node is not found or if the current access-token has no permission to retrieve that node.
   */
  nodes: Array<Maybe<Node>>;
  /**
   * Gives the product categories that are shared by all teams.
   * @deprecated Use the product categories via a team instead.
   */
  productCategories?: Maybe<ProductCategoryConnection>;
  productCategoryAudits?: Maybe<ProductCategoryAuditConnection>;
  productPredicates?: Maybe<Query_ProductPredicateConnection>;
  /** Connection to all the questionPredicates defined in the database (that the current user is allowed to see.) */
  questionPredicates?: Maybe<QuestionPredicateConnection>;
  /** Entry point to the regions in the data-graph. */
  regions?: Maybe<Query_RegionConnection>;
  riskAudits?: Maybe<RiskAuditConnection>;
  /** Connection to all risk columns. */
  riskColumns?: Maybe<RiskColumnConnection>;
  /** The risk configurations that are currently available. */
  riskConfigurations?: Maybe<Query_RiskConfigurationConnection>;
  /** Retrieve the `RiskProbabilityAudit`-nodes. */
  riskProbabilityAudits?: Maybe<RiskProbabilityAuditConnection>;
  /**
   * Entry point to the risks.
   * @deprecated Use the risks via a team instead.
   */
  risks?: Maybe<RiskConnection>;
  /** Connection to the list of possible SupplierBranchReliabilities. */
  supplierReliabilities?: Maybe<Query_SupplierReliabilityConnection>;
  /** Entry point all team license classes. */
  teamLicenseClasses?: Maybe<TeamLicenseClassConnection>;
  /** Entry point to all team licenses. */
  teamLicenses?: Maybe<TeamLicenseConnection>;
  /** Lists the teams. */
  teams?: Maybe<Query_TeamConnection>;
  threatAudits?: Maybe<ThreatAuditConnection>;
  threatCategoryAudits?: Maybe<ThreatCategoryAuditConnection>;
  threatSeverityAudits?: Maybe<ThreatSeverityAuditConnection>;
  /**
   * Gives all the threats.
   * @deprecated Use the threat via a team instead.
   */
  threats?: Maybe<ThreatConnection>;
  userInvitations?: Maybe<UserInvitationConnection>;
  /** Lists the known users in the database. */
  users?: Maybe<UserConnection>;
  /**
   * The available verification actions
   * @deprecated Use the usableVerificationActions of a team instead.
   */
  verificationActions?: Maybe<Query_VerificationActionConnection>;
  /**
   * The verification configurations that are available to the current access token.
   * @deprecated Use the usableVerificationConfigurations of a team instead
   */
  verificationConfigurations?: Maybe<Query_VerificationConfigurationConnection>;
  /**
   * Connection to the verification predicates that the current access token can access.
   * @deprecated Use the usableVerificationPredicates of a team instead.
   */
  verificationPredicates?: Maybe<VerificationPredicateConnection>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryAccountsWithRoleArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  role: UserRole;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryAuditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuditOrderByClause>>;
  where?: InputMaybe<Array<AuditWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryCompaniesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompanyOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CompanyWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryContactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContactOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<ContactWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryCountriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Array<CountryWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryProductCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductCategoryOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<ProductCategoryWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryProductCategoryAuditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductCategoryAuditOrderByClause>>;
  where?: InputMaybe<Array<ProductCategoryAuditWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryProductPredicatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryQuestionPredicatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QuestionPredicateOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<QuestionPredicateWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryRegionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegionOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<RegionWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryRiskAuditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskAuditOrderByClause>>;
  where?: InputMaybe<Array<RiskAuditWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryRiskColumnsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskColumnOrderByClause>>;
  where?: InputMaybe<Array<RiskColumnWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryRiskConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskConfigurationOrderByClause>>;
  where?: InputMaybe<Array<RiskConfigurationWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryRiskProbabilityAuditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskProbabilityAuditOrderByClause>>;
  where?: InputMaybe<Array<RiskProbabilityAuditWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryRisksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<RiskWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryTeamLicenseClassesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamLicenseClassOrderByClause>>;
  where?: InputMaybe<Array<TeamLicenseClassWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryTeamLicensesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamLicenseOrderByClause>>;
  where?: InputMaybe<Array<TeamLicenseWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryTeamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<TeamWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryThreatAuditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ThreatAuditOrderByClause>>;
  where?: InputMaybe<Array<ThreatAuditWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryThreatCategoryAuditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ThreatCategoryAuditOrderByClause>>;
  where?: InputMaybe<Array<ThreatCategoryAuditWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryThreatSeverityAuditsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ThreatSeverityAuditOrderByClause>>;
  where?: InputMaybe<Array<ThreatSeverityAuditWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryThreatsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ThreatOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<ThreatWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryUserInvitationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserInvitationOrderByClause>>;
  where?: InputMaybe<Array<UserInvitationWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserOrderByClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryVerificationActionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationActionOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<VerificationActionWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryVerificationConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationWhereClause>>;
};


/** Indicates what fields are available at the top level of a query operation. */
export type QueryVerificationPredicatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationPredicateOrderByClause>>;
  where?: InputMaybe<Array<VerificationPredicateWhereClause>>;
};

export type Query_CompanyConnection = Connection & ConnectionWithTotal & {
  __typename: 'Query_CompanyConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<CompanyEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Company>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Query_CountryConnection = Connection & ConnectionWithTotal & {
  __typename: 'Query_CountryConnection';
  /** Gives the edge to the country with the specified `countryCode`. */
  byCountryCode?: Maybe<CountryEdge>;
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<CountryEdge>>>;
  /** The (paged) nodes in this connection. */
  nodes: Array<Country>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type Query_CountryConnectionByCountryCodeArgs = {
  countryCode: Scalars['CountryCode']['input'];
};

export type Query_ProductPredicateConnection = {
  __typename: 'Query_ProductPredicateConnection';
  edges?: Maybe<Array<Query_ProductPredicateEdge>>;
  nodes?: Maybe<Array<Maybe<ProductPredicate>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Query_ProductPredicateEdge = {
  __typename: 'Query_ProductPredicateEdge';
  cursor: Scalars['Cursor']['output'];
  node?: Maybe<ProductPredicate>;
};

export type Query_ProductPredicates_SearchInput = {
  query: Scalars['String']['input'];
};

export type Query_RegionConnection = Connection & ConnectionWithTotal & {
  __typename: 'Query_RegionConnection';
  /**
   * Gives the edge to the region with the specified `countryCode`.
   *
   * ### TODO: Not implemented
   *
   * *This feature is not (fully) implemented yet!*
   */
  byCountryCode?: Maybe<RegionEdge>;
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<RegionEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Region>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type Query_RegionConnectionByCountryCodeArgs = {
  code: Scalars['CountryCode']['input'];
};

export type Query_RiskConfigurationConnection = Connection & ConnectionWithTotal & {
  __typename: 'Query_RiskConfigurationConnection';
  /** The edge to the risk configuration with the provided slug value. */
  bySlug?: Maybe<RiskConfigurationEdge>;
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<RiskConfigurationEdge>>>;
  /** The risk configuration that is used as the global default. */
  globalDefault?: Maybe<RiskConfigurationEdge>;
  /**
   * Edge to the default risk configuration of the current team.
   *
   * ### TODO: Not implemented
   *
   * *This feature is not (fully) implemented yet!*
   */
  myTeamDefault?: Maybe<RiskConfigurationEdge>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<RiskConfiguration>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type Query_RiskConfigurationConnectionBySlugArgs = {
  slug: Scalars['Slug']['input'];
};

export type Query_SupplierReliabilityConnection = Connection & ConnectionWithTotal & {
  __typename: 'Query_SupplierReliabilityConnection';
  /** Retrieves teh supplier branch reliability using its slug. */
  bySlug?: Maybe<SupplierReliabilityEdge>;
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<SupplierReliabilityEdge>>>;
  /** The nodes in this connection. (Same as `edges.node`) */
  nodes: Array<Maybe<SupplierReliability>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type Query_SupplierReliabilityConnectionBySlugArgs = {
  slug: Scalars['Slug']['input'];
};

export type Query_TeamConnection = Connection & ConnectionWithTotal & {
  __typename: 'Query_TeamConnection';
  /** Retrieves the edge to the team with the provided slug. */
  bySlug?: Maybe<TeamEdge>;
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<TeamEdge>>>;
  /** Retrieves the edge ot the current team. */
  myTeam?: Maybe<TeamEdge>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Team>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type Query_TeamConnectionBySlugArgs = {
  slug: Scalars['Slug']['input'];
};

export type Query_VerificationActionConnection = Connection & ConnectionWithTotal & {
  __typename: 'Query_VerificationActionConnection';
  /** The edge to the risk configuration with the provided slug value. */
  bySlug?: Maybe<VerificationActionEdge>;
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<VerificationActionEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<VerificationAction>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type Query_VerificationActionConnectionBySlugArgs = {
  slug: Scalars['Slug']['input'];
};

export type Query_VerificationConfigurationConnection = Connection & ConnectionWithTotal & {
  __typename: 'Query_VerificationConfigurationConnection';
  /** The edge to the risk configuration with the provided slug value. */
  bySlug?: Maybe<VerificationConfigurationEdge>;
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<VerificationConfigurationEdge>>>;
  /** The risk configuration that is used as the global default. */
  globalDefault?: Maybe<VerificationConfigurationEdge>;
  /** Edge to the default risk configuration of the current team. */
  myTeamDefault?: Maybe<VerificationConfigurationEdge>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<VerificationConfiguration>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type Query_VerificationConfigurationConnectionBySlugArgs = {
  slug: Scalars['Slug']['input'];
};

export type QuestionPredicate = AnalysisEntryPredicate & Commentable & Node & Ownable & Predicate & ProductPredicate & SoftDelete & SoftDeleteUserstamped & Taggable & Timestamped & Usable & Userstamped & {
  __typename: 'QuestionPredicate';
  /** The comments for this `QuestionPredicate`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `QuestionPredicate`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `QuestionPredicate`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  defaultPredicateValue?: Maybe<PredicateValue>;
  /** Gives the moment on which this `QuestionPredicate`-object was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _deleted_ this `QuestionPredicate`-object.
   *
   * When this field is `null`, it can be the case that this object was not deleted or not deleted by a `User`. It will also
   * be `null` when the current user is not allowed to see the `User` that deleted this object.
   */
  destroyer?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `QuestionPredicate`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `QuestionPredicate`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `QuestionPredicate` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `QuestionPredicate` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `QuestionPredicate` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `QuestionPredicate` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `QuestionPredicate`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `QuestionPredicate` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `QuestionPredicate` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `QuestionPredicate` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `QuestionPredicate` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /** A reference to the owner that owns this `QuestionPredicate`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `QuestionPredicate` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  predicateQuestion?: Maybe<Scalars['HTML']['output']>;
  /** The products that have some value defined for this `QuestionPredicate`. */
  products?: Maybe<ProductConnection>;
  /** Connection to the tags that are assigned to this `QuestionPredicate`. */
  tags?: Maybe<TagConnection>;
  /** Will be `true` if this `QuestionPredicate` is soft-deleted, `false` otherwise. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** Gives the most recent moment on which this `QuestionPredicate`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Connection to the risks that uses this question predicate in its predicate expression. */
  usedByRisks?: Maybe<RiskConnection>;
  /** Connection to the verification configuration rules that use this predicate. */
  usedByVerificationConfigurationRules?: Maybe<VerificationConfigurationRuleConnection>;
  /** Connection to the verification configurations that use this verification predicate. */
  usedByVerificationConfigurations?: Maybe<VerificationConfigurationConnection>;
};


export type QuestionPredicateCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type QuestionPredicateIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type QuestionPredicateIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type QuestionPredicateIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type QuestionPredicateIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type QuestionPredicateIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type QuestionPredicateIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type QuestionPredicateOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type QuestionPredicateProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductOrderByClause>>;
  where?: InputMaybe<Array<ProductWhereClause>>;
};


export type QuestionPredicateTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};


export type QuestionPredicateUsedByRisksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskOrderByClause>>;
  where?: InputMaybe<Array<RiskWhereClause>>;
};


export type QuestionPredicateUsedByVerificationConfigurationRulesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationRuleOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationRuleWhereClause>>;
};


export type QuestionPredicateUsedByVerificationConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationWhereClause>>;
};

/**
 * A paged connection with `QuestionPredicateEdge` edges to `QuestionPredicate` nodes.
 *
 * This type was automatically generated from the `QuestionPredicateEdge` edge-type for the
 * `Risk.questionPredicates` field. (It might be possible that it is reused by other fields.)
 */
export type QuestionPredicateConnection = Connection & ConnectionWithTotal & {
  __typename: 'QuestionPredicateConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<QuestionPredicateEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<QuestionPredicate>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `QuestionPredicateConnection` connection that points to a `QuestionPredicate` node.
 *
 * This type was automatically generated from the `QuestionPredicate` node-type of the
 * `Risk.questionPredicates` field. (It might be possible that it is reused by other fields.)
 */
export type QuestionPredicateEdge = Edge & {
  __typename: 'QuestionPredicateEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: QuestionPredicate;
};

/**
 * Specifies how the edges to a `QuestionPredicate` will be ordered in a connection.
 *
 * This type was automatically generated from the `QuestionPredicateOrderByColumn` column-type used in the
 * `orderBy` argument of the `Product.questionPredicates` field. (It might be possible that it is reused by
 * other fields.)
 */
export type QuestionPredicateOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: QuestionPredicateOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `QuestionPredicateOrderByColumn`. */
export enum QuestionPredicateOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which the entities were deleted. */
  DeletedAt = 'DELETED_AT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type QuestionPredicateWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were soft-deleted. */
  deleted?: InputMaybe<StampedEventConstraints>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters on the total amount of risks that use this predicate. */
  totalUsedByRisks?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters on the total amount of verification configuration rules that use this predicate. */
  totalUsedByVerificationConfigurationRules?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RebuildSearchIndexesInput = {
  analysisReportEntries?: InputMaybe<Scalars['Boolean']['input']>;
  analysisReports?: InputMaybe<Scalars['Boolean']['input']>;
  comments?: InputMaybe<Scalars['Boolean']['input']>;
  companies?: InputMaybe<Scalars['Boolean']['input']>;
  contacts?: InputMaybe<Scalars['Boolean']['input']>;
  productCategories?: InputMaybe<Scalars['Boolean']['input']>;
  products?: InputMaybe<Scalars['Boolean']['input']>;
  questionPredicates?: InputMaybe<Scalars['Boolean']['input']>;
  regions?: InputMaybe<Scalars['Boolean']['input']>;
  riskColumns?: InputMaybe<Scalars['Boolean']['input']>;
  riskConfigurations?: InputMaybe<Scalars['Boolean']['input']>;
  risks?: InputMaybe<Scalars['Boolean']['input']>;
  supplierBranches?: InputMaybe<Scalars['Boolean']['input']>;
  suppliers?: InputMaybe<Scalars['Boolean']['input']>;
  teams?: InputMaybe<Scalars['Boolean']['input']>;
  threatCategories?: InputMaybe<Scalars['Boolean']['input']>;
  threats?: InputMaybe<Scalars['Boolean']['input']>;
  verificationActions?: InputMaybe<Scalars['Boolean']['input']>;
  verificationPredicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RebuildSearchIndexes_SuccessResult = MutationPayload & {
  __typename: 'RebuildSearchIndexes_SuccessResult';
  query: Query;
  typenames: Array<Scalars['String']['output']>;
};

export type Region = AnalysisEntryPredicate & Named & Node & Predicate & ProductPredicate & Selectable & SoftDelete & SoftDeleteUserstamped & Taggable & Timestamped & Usable & Userstamped & {
  __typename: 'Region';
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  /** Gives the `DateTime` on which this `Region`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `Region`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  defaultPredicateValue?: Maybe<PredicateValue>;
  /** Gives the moment on which this `Region`-object was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _deleted_ this `Region`-object.
   *
   * When this field is `null`, it can be the case that this object was not deleted or not deleted by a `User`. It will also
   * be `null` when the current user is not allowed to see the `User` that deleted this object.
   */
  destroyer?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `Region`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `Region`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `Region`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Region` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Region` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Region` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `Region` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Name>;
  predicateQuestion?: Maybe<Scalars['HTML']['output']>;
  products?: Maybe<ProductConnection>;
  /** Connection to the tags that are assigned to this `Region`. */
  tags?: Maybe<TagConnection>;
  /** Will be `true` if this `Region` is soft-deleted, `false` otherwise. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** Gives the most recent moment on which this `Region`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Connection to the risks that uses this question predicate in its predicate expression. */
  usedByRisks?: Maybe<RiskConnection>;
  /** Connection to the verification configuration rules that use this predicate. */
  usedByVerificationConfigurationRules?: Maybe<VerificationConfigurationRuleConnection>;
  /** Connection to the verification configurations that use this verification predicate. */
  usedByVerificationConfigurations?: Maybe<VerificationConfigurationConnection>;
};


export type RegionIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type RegionIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type RegionIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type RegionIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type RegionProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductOrderByClause>>;
  where?: InputMaybe<Array<ProductWhereClause>>;
};


export type RegionTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};


export type RegionUsedByRisksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskOrderByClause>>;
  where?: InputMaybe<Array<RiskWhereClause>>;
};


export type RegionUsedByVerificationConfigurationRulesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationRuleOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationRuleWhereClause>>;
};


export type RegionUsedByVerificationConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationWhereClause>>;
};

/**
 * A paged connection with `RegionEdge` edges to `Region` nodes.
 *
 * This type was automatically generated from the `RegionEdge` edge-type for the
 * `Risk.regions` field. (It might be possible that it is reused by other fields.)
 */
export type RegionConnection = Connection & ConnectionWithTotal & {
  __typename: 'RegionConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<RegionEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Region>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type RegionEdge = Edge & {
  __typename: 'RegionEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node at the end of this edge. */
  node: Region;
};

/**
 * Specifies how the edges to a `Region` will be ordered in a connection.
 *
 * This type was automatically generated from the `RegionOrderByColumn` column-type used in the
 * `orderBy` argument of the `Product.regions` field. (It might be possible that it is reused by
 * other fields.)
 */
export type RegionOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: RegionOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `RegionOrderByColumn`. */
export enum RegionOrderByColumn {
  /** Orders by the region-codes. */
  Code = 'CODE',
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which the entities were deleted. */
  DeletedAt = 'DELETED_AT',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type RegionWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were soft-deleted. */
  deleted?: InputMaybe<StampedEventConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on the total amount of risks that use this predicate. */
  totalUsedByRisks?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters on the total amount of verification configuration rules that use this predicate. */
  totalUsedByVerificationConfigurationRules?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
};

/**
 * Todo item that can be resolved by assigning a classical (`YES`/`NO`) predicate value to the product risk in the
 * `productRisk` field.
 */
export type ResolveAnalysisReportProductRiskPredicateValueTodo = Node & Todo & {
  __typename: 'ResolveAnalysisReportProductRiskPredicateValueTodo';
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this `Todo` item is considered to be done. */
  isDone?: Maybe<Scalars['Boolean']['output']>;
  /** The product risk that needs a classical (`YES`/`NO`) predicate value. */
  productRisk?: Maybe<AnalysisReportProductRisk>;
  /** The title for this todo item that can be used to display it in a todo list. */
  title?: Maybe<Scalars['String']['output']>;
};

export type Restore_SuccessResult = MutationPayload & {
  __typename: 'Restore_SuccessResult';
  node: Node;
  query: Query;
};

export type RetractAllTeamRolesInput = {
  team: Scalars['ID']['input'];
  user: Scalars['ID']['input'];
};

export type RetractAllUserRolesInput = {
  user: Scalars['ID']['input'];
};

export type RetractTeamRoleInput = {
  role: TeamRole;
  team: Scalars['ID']['input'];
  user: Scalars['ID']['input'];
};

export type RetractTeamRole_SuccessResult = MutationPayload & {
  __typename: 'RetractTeamRole_SuccessResult';
  query: Query;
  retractedRole: TeamRole;
  team: Team;
  user: User;
};

export type RetractTeamRolesInput = {
  roles: Array<TeamRole>;
  team: Scalars['ID']['input'];
  user: Scalars['ID']['input'];
};

export type RetractTeamRoles_SuccessResult = MutationPayload & {
  __typename: 'RetractTeamRoles_SuccessResult';
  query: Query;
  retractedRoles: Array<TeamRole>;
  team: Team;
  user: User;
};

export type RetractUserRoleInput = {
  role: UserRole;
  user: Scalars['ID']['input'];
};

export type RetractUserRole_SuccessResult = MutationPayload & {
  __typename: 'RetractUserRole_SuccessResult';
  query: Query;
  retractedRole: UserRole;
  user: User;
};

export type RetractUserRolesInput = {
  roles: Array<UserRole>;
  user: Scalars['ID']['input'];
};

export type RetractUserRoles_SuccessResult = MutationPayload & {
  __typename: 'RetractUserRoles_SuccessResult';
  query: Query;
  retractedRoles: Array<UserRole>;
  user: User;
};

export type Risk = Commentable & Named & Node & Ownable & Selectable & SoftDelete & SoftDeleteUserstamped & Taggable & Timestamped & Usable & Userstamped & {
  __typename: 'Risk';
  /** The comments for this `Risk`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `Risk`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `Risk`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** Gives the moment on which this `Risk`-object was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The description nof this risk, which defaults to the description of the associated `Threat`.
   *
   * This field is indexed for searching.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _deleted_ this `Risk`-object.
   *
   * When this field is `null`, it can be the case that this object was not deleted or not deleted by a `User`. It will also
   * be `null` when the current user is not allowed to see the `User` that deleted this object.
   */
  destroyer?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `Risk`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `Risk`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Risk` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Risk` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Risk` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `Risk` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `Risk`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Risk` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Risk` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Risk` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `Risk` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /** The name of this risk, which is equal to the name of the associated `Threat`. */
  name?: Maybe<EntityName>;
  /** A reference to the owner that owns this `Risk`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `Risk` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  predicateExpression?: Maybe<ProductPredicateExpression>;
  /**
   * Connection to all product categories to which this risk applies. These are all the `selectedProductCategories`
   * including their descendants, except for the `excludedProductCategories` and their descendants.
   */
  productCategories?: Maybe<Risk_ProductCategoryConnection>;
  /**
   * Extra information about the risk that is available for all users that can use this risk. This is the
   * *SPECIFIEK*-field in the legacy data-model.
   *
   * This field is *HUMAN-TEXT* and has no side-effects on the semantics of the data-model.
   */
  publicInfo?: Maybe<Scalars['HTML']['output']>;
  /**
   * Extra topical information about the risk that is available for all users that can use this risk. This is the
   * *ACTUEEL*-field in the legacy data-model.
   *
   * This field is *HUMAN-TEXT* and has no side-effects on the semantics of the data-model.
   */
  publicTopicalInfo?: Maybe<Scalars['HTML']['output']>;
  /** The question predicates used in the `predicateExpression` of this `Risk`. */
  questionPredicates?: Maybe<QuestionPredicateConnection>;
  /** The regions used in the `predicateExpression` of this `Risk`. */
  regions?: Maybe<RegionConnection>;
  riskColumns?: Maybe<Risk_RiskColumnConnection>;
  /** Connection to the risk configurations for which this `Risk` has `RiskValue`s defined. */
  riskConfigurations?: Maybe<Risk_RiskConfigurationConnection>;
  /** Connection to all the product categories to which this risk applies that were explicitly selected by the user. */
  selectedProductCategories?: Maybe<Risk_ProductCategoryConnection>;
  /** Connection to the tags that are assigned to this `Risk`. */
  tags?: Maybe<TagConnection>;
  /** The `Threat` behind this `Risk`. */
  threat?: Maybe<Threat>;
  /** Will be `true` if this `Risk` is soft-deleted, `false` otherwise. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** Gives the most recent moment on which this `Risk`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type RiskCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type RiskIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type RiskIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type RiskIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type RiskIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type RiskIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type RiskIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type RiskOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type RiskPredicateExpressionArgs = {
  substitute?: InputMaybe<Array<PredicateExpressionTermSubstitution>>;
};


export type RiskProductCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductCategoryOrderByClause>>;
  where?: InputMaybe<Array<Risk_ProductCategoryWhereClause>>;
};


export type RiskQuestionPredicatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QuestionPredicateOrderByClause>>;
  where?: InputMaybe<Array<QuestionPredicateWhereClause>>;
};


export type RiskRegionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegionOrderByClause>>;
  where?: InputMaybe<Array<RegionWhereClause>>;
};


export type RiskRiskColumnsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskColumnOrderByClause>>;
  where?: InputMaybe<Array<RiskColumnWhereClause>>;
};


export type RiskRiskConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskConfigurationOrderByClause>>;
  where?: InputMaybe<Array<RiskConfigurationWhereClause>>;
};


export type RiskSelectedProductCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductCategoryOrderByClause>>;
  trashed?: InputMaybe<Trashed>;
  where?: InputMaybe<Array<ProductCategoryWhereClause>>;
};


export type RiskTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

/** An `Audit`-node that tracks a mutation of a `Risk`-node. */
export type RiskAudit = Audit & Commentable & Node & Ownable & Taggable & Timestamped & Userstamped & {
  __typename: 'RiskAudit';
  /** The comments for this `RiskAudit`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `RiskAudit`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `RiskAudit`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** The client-application that the `creator` used at the moment when he/she generated this `RiskAudit`. */
  creatorClient?: Maybe<Client>;
  /** The IP-address of the `creator` at the moment when he/she generated this `RiskAudit`. */
  creatorIpAddress?: Maybe<Scalars['IpAddress']['output']>;
  /**
   * The team of the `creator` at the moment when he/she generated this `RiskAudit`.
   *
   * See the `Audit.creator`-field for more information.
   */
  creatorTeam?: Maybe<Team>;
  /** The user-agent of the `creator` at the moment when he/she generated this `RiskAudit`-node. */
  creatorUserAgent?: Maybe<Scalars['UserAgent']['output']>;
  /**
   * Gives the `User` that _updated_ this `RiskAudit`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /** The event type for which this `RiskAudit` was generated. */
  event?: Maybe<AuditedEvent>;
  /**
   * The name of the GraphQL operation that was responsible for this `RiskAudit`-node.
   *
   * Use this value in combination with the `client`-field to derive how this audit was created.
   */
  graphqlOperation?: Maybe<Scalars['String']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `RiskAudit`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskAudit` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskAudit` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskAudit` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `RiskAudit` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `RiskAudit`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** The predicate expression of the risk after the mutation was executed. */
  newPredicateExpression?: Maybe<ProductPredicateExpression>;
  /** The threat of the risk after the mutation was executed. */
  newThreat?: Maybe<Threat>;
  /** The predicate expression of the risk before the mutation was executed. */
  oldPredicateExpression?: Maybe<ProductPredicateExpression>;
  /** The threat of the risk before the mutation was executed. */
  oldThreat?: Maybe<Threat>;
  /** A reference to the owner that owns this `RiskAudit`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `RiskAudit` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the predicate expression on the risk was changed dueue to this mutation.
   *
   * This property implies that `RiskAudit.oldPredicateExpression == RiskAudit.newPredicateExpression`.
   */
  predicateExpressionChanged?: Maybe<Scalars['Boolean']['output']>;
  /** An HTML-formatted text containing some remarks about the mutation that generated this `RiskAudit`. */
  remarks?: Maybe<Scalars['HTML']['output']>;
  /** The risk for which this audit-node was generated. */
  risk?: Maybe<Risk>;
  /** Connection to the tags that are assigned to this `RiskAudit`. */
  tags?: Maybe<TagConnection>;
  /**
   * Whether the mutation represented by this `Audit`-node changed the threat of the risk in the
   * `RiskAudit.risk` field.
   *
   * This property implies that `RiskAudit.oldThreat == RiskAudit.newThreat`. Note that this
   * property is available, even if the current access token is not allowed to read the threats.
   */
  threatChanged?: Maybe<Scalars['Boolean']['output']>;
  /** Gives the most recent moment on which this `RiskAudit`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** An `Audit`-node that tracks a mutation of a `Risk`-node. */
export type RiskAuditCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


/** An `Audit`-node that tracks a mutation of a `Risk`-node. */
export type RiskAuditIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** An `Audit`-node that tracks a mutation of a `Risk`-node. */
export type RiskAuditIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


/** An `Audit`-node that tracks a mutation of a `Risk`-node. */
export type RiskAuditIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


/** An `Audit`-node that tracks a mutation of a `Risk`-node. */
export type RiskAuditIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** An `Audit`-node that tracks a mutation of a `Risk`-node. */
export type RiskAuditOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


/** An `Audit`-node that tracks a mutation of a `Risk`-node. */
export type RiskAuditTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

/**
 * A paged connection with `RiskAuditEdge` edges to `RiskAudit` nodes.
 *
 * This type was automatically generated from the `RiskAuditEdge` edge-type for the
 * `Query.riskAudits` field. (It might be possible that it is reused by other fields.)
 */
export type RiskAuditConnection = Connection & ConnectionWithTotal & {
  __typename: 'RiskAuditConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<RiskAuditEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<RiskAudit>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `RiskAuditConnection` connection that points to a `RiskAudit` node.
 *
 * This type was automatically generated from the `RiskAudit` node-type of the
 * `Query.riskAudits` field. (It might be possible that it is reused by other fields.)
 */
export type RiskAuditEdge = Edge & {
  __typename: 'RiskAuditEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: RiskAudit;
};

/**
 * Specifies how the edges to a `RiskAudit` will be ordered in a connection.
 *
 * This type was automatically generated from the `RiskAuditOrderByColumn` column-type used in the
 * `orderBy` argument of the `Query.riskAudits` field. (It might be possible that it is reused by
 * other fields.)
 */
export type RiskAuditOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: RiskAuditOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `RiskAuditOrderByColumn`. */
export enum RiskAuditOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type RiskAuditWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters on the event type of the audit entry. */
  event?: InputMaybe<AuditedEvent>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RiskColumn = Commentable & Named & Node & Ownable & Selectable & Taggable & Timestamped & Usable & Userstamped & {
  __typename: 'RiskColumn';
  /** The color of the RiskColumn. Should be used to generate exports or to present this column in the UI. */
  color?: Maybe<Color>;
  /** The comments for this `RiskColumn`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `RiskColumn`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `RiskColumn`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /**
   * A longer, plain-text value that helps the user to identify this node. When a collection of these nodes are
   * full-text searchable, it will also search over the values in this field.
   *
   * It is always safe to show in the GUI.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _updated_ this `RiskColumn`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `RiskColumn`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskColumn` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskColumn` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskColumn` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `RiskColumn` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this RiskColumn is considered to be public. The values of public columns can be seen by all users that
   * are able to see the Risk to which the value belongs. Values of internal columns are only meant to be seen
   * by the Précon Staff.
   */
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `RiskColumn`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskColumn` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskColumn` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskColumn` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `RiskColumn` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the risk column. It should also be used in the header of the column in a generated spreadsheet.
   *
   * It is always safe to show in the GUI.
   */
  name?: Maybe<Name>;
  /** A reference to the owner that owns this `RiskColumn`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `RiskColumn` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /** Connection to the risks that have values for this risk column. */
  risks?: Maybe<RiskConnection>;
  /** Connection to the tags that are assigned to this `RiskColumn`. */
  tags?: Maybe<TagConnection>;
  /** Gives the most recent moment on which this `RiskColumn`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type RiskColumnCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type RiskColumnIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type RiskColumnIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type RiskColumnIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type RiskColumnIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type RiskColumnIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type RiskColumnIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type RiskColumnOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type RiskColumnRisksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskOrderByClause>>;
  where?: InputMaybe<Array<RiskWhereClause>>;
};


export type RiskColumnTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

/**
 * A paged connection with `RiskColumnEdge` edges to `RiskColumn` nodes.
 *
 * This type was automatically generated from the `RiskColumnEdge` edge-type for the
 * `Team.ownedRiskColumns` field. (It might be possible that it is reused by other fields.)
 */
export type RiskColumnConnection = Connection & ConnectionWithTotal & {
  __typename: 'RiskColumnConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<RiskColumnEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<RiskColumn>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `RiskColumnConnection` connection that points to a `RiskColumn` node.
 *
 * This type was automatically generated from the `RiskColumn` node-type of the
 * `Team.ownedRiskColumns` field. (It might be possible that it is reused by other fields.)
 */
export type RiskColumnEdge = Edge & {
  __typename: 'RiskColumnEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: RiskColumn;
};

/**
 * Specifies how the edges to a `RiskColumn` will be ordered in a connection.
 *
 * This type was automatically generated from the `RiskColumnOrderByColumn` column-type used in the
 * `orderBy` argument of the `Risk.riskColumns` field. (It might be possible that it is reused by
 * other fields.)
 */
export type RiskColumnOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: RiskColumnOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `RiskColumnOrderByColumn`. */
export enum RiskColumnOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type RiskColumnValueInput = {
  riskColumn: ConnectRiskColumnInput;
  value?: InputMaybe<Scalars['HTML']['input']>;
};

export type RiskColumnWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RiskColumn_RiskConnection = Connection & ConnectionWithTotal & {
  __typename: 'RiskColumn_RiskConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<RiskColumn_RiskEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Risk>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type RiskColumn_RiskEdge = Edge & {
  __typename: 'RiskColumn_RiskEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /**
   * The node at the end of this edge.
   *
   * This value is `null` iff the current access token has no permission to see the value of this node, but does have
   * the permission to see the values on the edges.
   */
  node?: Maybe<Risk>;
  /** The value that the risk at the end of edge has for the risk column at the start. */
  value?: Maybe<Scalars['HTML']['output']>;
};

export type RiskConfiguration = Commentable & Named & Node & Ownable & Selectable & Sluggable & SoftDelete & SoftDeleteUserstamped & Taggable & Timestamped & Usable & Userstamped & {
  __typename: 'RiskConfiguration';
  /** The comments for this `RiskConfiguration`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `RiskConfiguration`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `RiskConfiguration`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** Gives the moment on which this `RiskConfiguration`-object was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The description of the risk configuration. Also used for full-text search.
   *
   * Safe to display to the user in a GUI.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _deleted_ this `RiskConfiguration`-object.
   *
   * When this field is `null`, it can be the case that this object was not deleted or not deleted by a `User`. It will also
   * be `null` when the current user is not allowed to see the `User` that deleted this object.
   */
  destroyer?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `RiskConfiguration`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /** Global identifier that can be used to resolve any Node implementation. */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `RiskConfiguration`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfiguration` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfiguration` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfiguration` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `RiskConfiguration` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this `RiskConfiguration` is the default custom risk configuration for the `Team` of the `team`-field.
   *
   * This value will always be `false` if this `RiskConfiguration` is not owned by a team.
   * @deprecated use `defaultRiskConfiguration` on a team instead.
   */
  isTeamDefault?: Maybe<Scalars['Boolean']['output']>;
  isTeamDefaultFor?: Maybe<Scalars['Boolean']['output']>;
  isTeamDefaultForCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  isTeamDefaultForCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `RiskConfiguration`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfiguration` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfiguration` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfiguration` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `RiskConfiguration` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /** The level segments of this risk configuration. */
  levels?: Maybe<RiskConfigurationLevelConnection>;
  /**
   * The name of the risk configuration.
   *
   * Safe to display to the user in a GUI.
   */
  name?: Maybe<Name>;
  /** A reference to the owner that owns this `RiskConfiguration`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `RiskConfiguration` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /** The probability segments of this risk configuration. */
  probabilities?: Maybe<RiskConfigurationProbabilityConnection>;
  /** The risks that have risk-values for this RiskConfiguration. */
  risks?: Maybe<RiskConfiguration_RiskConnection>;
  /** The severity segments of this risk configuration. */
  severities?: Maybe<RiskConfigurationSeverityConnection>;
  /**
   * The `slug`, which is an *url-* and *filename-*safe string that uniquely identifies a node with a specific type.
   * It's value is usually derived from the initial data of the node (so the data it had when it was created).
   *
   * There are some important differences with the `id`-field:
   * 1. The value of `id` is always set, the value of `slug` might sometimes be `null` even if the node itself does
   * exists. This happens for instance when the node is soft-deleted.
   * 2. The value of `id` is globally unique, the value of `slug` is only unique in combination with the `__typename`.
   * 3. The value of `id` always refers to the **current node and only the current node**. The value of `slug` might
   * refer to a different node over time. (Example: when an old node is soft-deleted and a new node with the same
   * name is created. The new node will have the same `slug`-value as the older node.)
   * 4. The `slug` is guaranteed to be *url-* and *filename-*safe. The `id`-field does not have these guarantees.
   *
   * When available, prefer the `slug`-field over the `id`-field for usage in urls. For caching and communication with
   * the api, you should always use the `id`-field over the `slug`-field.
   */
  slug?: Maybe<Scalars['Slug']['output']>;
  /** Connection to the tags that are assigned to this `RiskConfiguration`. */
  tags?: Maybe<TagConnection>;
  /** The threats that have severities for this RiskConfiguration. */
  threats?: Maybe<RiskConfiguration_ThreatConnection>;
  /** Will be `true` if this `RiskConfiguration` is soft-deleted, `false` otherwise. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** Gives the most recent moment on which this `RiskConfiguration`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Connection to the verification configuration rules that use the risk configuration segments of this risk
   * configuration.
   */
  usedByVerificationConfigurationRules?: Maybe<VerificationConfigurationRuleConnection>;
  /**
   * Connection to the verification configurations that has rules that use at least one of the risk configuration
   * segments of this risk configuration.
   */
  usedByVerificationConfigurations?: Maybe<VerificationConfigurationConnection>;
};


export type RiskConfigurationCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type RiskConfigurationIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type RiskConfigurationIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type RiskConfigurationIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type RiskConfigurationIsTeamDefaultForArgs = {
  team: Scalars['ID']['input'];
};


export type RiskConfigurationIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type RiskConfigurationIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type RiskConfigurationIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type RiskConfigurationLevelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskConfigurationLevelOrderByClause>>;
  where?: InputMaybe<Array<RiskConfigurationLevelWhereClause>>;
};


export type RiskConfigurationOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type RiskConfigurationProbabilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskConfigurationProbabilityOrderByClause>>;
  where?: InputMaybe<Array<RiskConfigurationProbabilityWhereClause>>;
};


export type RiskConfigurationRisksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskOrderByClause>>;
  where?: InputMaybe<Array<RiskWhereClause>>;
};


export type RiskConfigurationSeveritiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskConfigurationSeverityOrderByClause>>;
  where?: InputMaybe<Array<RiskConfigurationSeverityWhereClause>>;
};


export type RiskConfigurationTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};


export type RiskConfigurationThreatsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ThreatOrderByClause>>;
  where?: InputMaybe<Array<ThreatWhereClause>>;
};


export type RiskConfigurationUsedByVerificationConfigurationRulesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationRuleOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationRuleWhereClause>>;
};


export type RiskConfigurationUsedByVerificationConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationWhereClause>>;
};

export type RiskConfigurationConnection = Connection & ConnectionWithTotal & {
  __typename: 'RiskConfigurationConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<RiskConfigurationEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<RiskConfiguration>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type RiskConfigurationEdge = Edge & {
  __typename: 'RiskConfigurationEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node at the end of this edge. */
  node: RiskConfiguration;
};

export type RiskConfigurationLevel = AnalysisEntryPredicate & Named & Node & Ownable & Predicate & RiskConfigurationSegment & Selectable & Usable & {
  __typename: 'RiskConfigurationLevel';
  color?: Maybe<Color>;
  configuration?: Maybe<RiskConfiguration>;
  /**
   * The default value for a node that has no explicit value for this predicate set.
   *
   * See the `Predicate.defaultPredicateValue` field for more information.
   */
  defaultPredicateValue?: Maybe<PredicateValue>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Checks whether this `RiskConfigurationLevel` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfigurationLevel` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfigurationLevel` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `RiskConfigurationLevel` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfigurationLevel` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfigurationLevel` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfigurationLevel` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `RiskConfigurationLevel` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  lowerBound?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Name>;
  /** A reference to the owner that owns this `RiskConfigurationLevel`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `RiskConfigurationLevel` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /**
   * An HTML-formatted field with a closed-form question to the user to explain the predicate.
   *
   * This value is always safe to show in the GUI.
   *
   * See the `Predicate.predicateQuestion` field for more information.
   */
  predicateQuestion?: Maybe<Scalars['HTML']['output']>;
  /** @deprecated use `owner` instead */
  team?: Maybe<Team>;
  upperBound?: Maybe<Scalars['Float']['output']>;
  /** Connection to the verification configuration rules that use this predicate. */
  usedByVerificationConfigurationRules?: Maybe<VerificationConfigurationRuleConnection>;
  /** Connection to the verification configurations that use this verification predicate. */
  usedByVerificationConfigurations?: Maybe<VerificationConfigurationConnection>;
};


export type RiskConfigurationLevelIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type RiskConfigurationLevelIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type RiskConfigurationLevelIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type RiskConfigurationLevelIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type RiskConfigurationLevelOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type RiskConfigurationLevelUsedByVerificationConfigurationRulesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationRuleOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationRuleWhereClause>>;
};


export type RiskConfigurationLevelUsedByVerificationConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationWhereClause>>;
};

/**
 * A paged connection with `RiskConfigurationLevelEdge` edges to `RiskConfigurationLevel` nodes.
 *
 * This type was automatically generated from the `RiskConfigurationLevelEdge` edge-type for the
 * `RiskConfiguration.levels` field. (It might be possible that it is reused by other fields.)
 */
export type RiskConfigurationLevelConnection = Connection & ConnectionWithTotal & {
  __typename: 'RiskConfigurationLevelConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<RiskConfigurationLevelEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<RiskConfigurationLevel>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `RiskConfigurationLevelConnection` connection that points to a `RiskConfigurationLevel` node.
 *
 * This type was automatically generated from the `RiskConfigurationLevel` node-type of the
 * `RiskConfiguration.levels` field. (It might be possible that it is reused by other fields.)
 */
export type RiskConfigurationLevelEdge = Edge & {
  __typename: 'RiskConfigurationLevelEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: RiskConfigurationLevel;
};

/**
 * Specifies how the edges to a `RiskConfigurationLevel` will be ordered in a connection.
 *
 * This type was automatically generated from the `RiskConfigurationLevelOrderByColumn` column-type used in the
 * `orderBy` argument of the `RiskConfiguration.levels` field. (It might be possible that it is reused by
 * other fields.)
 */
export type RiskConfigurationLevelOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: RiskConfigurationLevelOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `RiskConfigurationLevelOrderByColumn`. */
export enum RiskConfigurationLevelOrderByColumn {
  /** Orders by the lower bound of this risk level segment. */
  LowerBound = 'LOWER_BOUND',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /**
   * Orders by the full name of the risk configuration to which the nodes belong.
   *
   *  Form owner-type `RiskConfiguration`.
   */
  RiskConfigurationNameFull = 'RISK_CONFIGURATION_NAME_FULL',
  /**
   * Orders by the short name of the risk configuration to which the nodes belong.
   *
   *  Form owner-type `RiskConfiguration`.
   */
  RiskConfigurationNameShort = 'RISK_CONFIGURATION_NAME_SHORT'
}

export type RiskConfigurationLevelWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on the total amount of verification configuration rules that use this predicate. */
  totalUsedByVerificationConfigurationRules?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Specifies how the edges to a `RiskConfiguration` will be ordered in a connection.
 *
 * This type was automatically generated from the `RiskConfigurationOrderByColumn` column-type used in the
 * `orderBy` argument of the `Risk.riskConfigurations` field. (It might be possible that it is reused by
 * other fields.)
 */
export type RiskConfigurationOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: RiskConfigurationOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `RiskConfigurationOrderByColumn`. */
export enum RiskConfigurationOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which the entities were deleted. */
  DeletedAt = 'DELETED_AT',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type RiskConfigurationProbability = AnalysisEntryPredicate & Named & Node & Ownable & Predicate & RiskConfigurationSegment & Selectable & Usable & {
  __typename: 'RiskConfigurationProbability';
  color?: Maybe<Color>;
  configuration?: Maybe<RiskConfiguration>;
  /**
   * The default value for a node that has no explicit value for this predicate set.
   *
   * See the `Predicate.defaultPredicateValue` field for more information.
   */
  defaultPredicateValue?: Maybe<PredicateValue>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Checks whether this `RiskConfigurationProbability` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfigurationProbability` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfigurationProbability` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `RiskConfigurationProbability` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfigurationProbability` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfigurationProbability` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfigurationProbability` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `RiskConfigurationProbability` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  lowerBound?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Name>;
  /** A reference to the owner that owns this `RiskConfigurationProbability`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `RiskConfigurationProbability` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /**
   * An HTML-formatted field with a closed-form question to the user to explain the predicate.
   *
   * This value is always safe to show in the GUI.
   *
   * See the `Predicate.predicateQuestion` field for more information.
   */
  predicateQuestion?: Maybe<Scalars['HTML']['output']>;
  /** @deprecated use `owner` instead */
  team?: Maybe<Team>;
  upperBound?: Maybe<Scalars['Float']['output']>;
  /** Connection to the verification configuration rules that use this predicate. */
  usedByVerificationConfigurationRules?: Maybe<VerificationConfigurationRuleConnection>;
  /** Connection to the verification configurations that use this verification predicate. */
  usedByVerificationConfigurations?: Maybe<VerificationConfigurationConnection>;
};


export type RiskConfigurationProbabilityIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type RiskConfigurationProbabilityIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type RiskConfigurationProbabilityIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type RiskConfigurationProbabilityIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type RiskConfigurationProbabilityOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type RiskConfigurationProbabilityUsedByVerificationConfigurationRulesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationRuleOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationRuleWhereClause>>;
};


export type RiskConfigurationProbabilityUsedByVerificationConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationWhereClause>>;
};

/**
 * A paged connection with `RiskConfigurationProbabilityEdge` edges to `RiskConfigurationProbability` nodes.
 *
 * This type was automatically generated from the `RiskConfigurationProbabilityEdge` edge-type for the
 * `RiskConfiguration.probabilities` field. (It might be possible that it is reused by other fields.)
 */
export type RiskConfigurationProbabilityConnection = Connection & ConnectionWithTotal & {
  __typename: 'RiskConfigurationProbabilityConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<RiskConfigurationProbabilityEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<RiskConfigurationProbability>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `RiskConfigurationProbabilityConnection` connection that points to a `RiskConfigurationProbability` node.
 *
 * This type was automatically generated from the `RiskConfigurationProbability` node-type of the
 * `RiskConfiguration.probabilities` field. (It might be possible that it is reused by other fields.)
 */
export type RiskConfigurationProbabilityEdge = Edge & {
  __typename: 'RiskConfigurationProbabilityEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: RiskConfigurationProbability;
};

/**
 * Specifies how the edges to a `RiskConfigurationProbability` will be ordered in a connection.
 *
 * This type was automatically generated from the `RiskConfigurationProbabilityOrderByColumn` column-type used in the
 * `orderBy` argument of the `RiskConfiguration.probabilities` field. (It might be possible that it is reused by
 * other fields.)
 */
export type RiskConfigurationProbabilityOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: RiskConfigurationProbabilityOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `RiskConfigurationProbabilityOrderByColumn`. */
export enum RiskConfigurationProbabilityOrderByColumn {
  /** Orders by the lower bound of this risk probability segment. */
  LowerBound = 'LOWER_BOUND',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /**
   * Orders by the full name of the risk configuration to which the nodes belong.
   *
   *  Form owner-type `RiskConfiguration`.
   */
  RiskConfigurationNameFull = 'RISK_CONFIGURATION_NAME_FULL',
  /**
   * Orders by the short name of the risk configuration to which the nodes belong.
   *
   *  Form owner-type `RiskConfiguration`.
   */
  RiskConfigurationNameShort = 'RISK_CONFIGURATION_NAME_SHORT'
}

export type RiskConfigurationProbabilityWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on the total amount of verification configuration rules that use this predicate. */
  totalUsedByVerificationConfigurationRules?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RiskConfigurationSegment = {
  color?: Maybe<Color>;
  configuration?: Maybe<RiskConfiguration>;
  /**
   * The default value for a node that has no explicit value for this predicate set.
   *
   * See the `Predicate.defaultPredicateValue` field for more information.
   */
  defaultPredicateValue?: Maybe<PredicateValue>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Checks whether this node is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this node is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this node is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this node has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this node is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this node is usable by the common GINO library team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this node is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this node is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id, which can save
   * an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  lowerBound?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Name>;
  /** A reference to the owner of this node. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this node can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(ownable: $ownable)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /**
   * An HTML-formatted field with a closed-form question to the user to explain the predicate.
   *
   * This value is always safe to show in the GUI.
   *
   * See the `Predicate.predicateQuestion` field for more information.
   */
  predicateQuestion?: Maybe<Scalars['HTML']['output']>;
  /** @deprecated use `owner` instead. */
  team?: Maybe<Team>;
  upperBound?: Maybe<Scalars['Float']['output']>;
  /** Connection to the verification configuration rules that use this predicate. */
  usedByVerificationConfigurationRules?: Maybe<VerificationConfigurationRuleConnection>;
  /** Connection to the verification configurations that use this verification predicate. */
  usedByVerificationConfigurations?: Maybe<VerificationConfigurationConnection>;
};


export type RiskConfigurationSegmentIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type RiskConfigurationSegmentIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type RiskConfigurationSegmentIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type RiskConfigurationSegmentIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type RiskConfigurationSegmentOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type RiskConfigurationSegmentUsedByVerificationConfigurationRulesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationRuleOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationRuleWhereClause>>;
};


export type RiskConfigurationSegmentUsedByVerificationConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationWhereClause>>;
};

export type RiskConfigurationSegmentConnection = {
  __typename: 'RiskConfigurationSegmentConnection';
  edges?: Maybe<Array<RiskConfigurationSegmentEdge>>;
  nodes?: Maybe<Array<Maybe<RiskConfigurationSegment>>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type RiskConfigurationSegmentEdge = {
  __typename: 'RiskConfigurationSegmentEdge';
  cursor: Scalars['Cursor']['output'];
  node?: Maybe<RiskConfigurationSegment>;
};

export type RiskConfigurationSeverity = AnalysisEntryPredicate & Named & Node & Ownable & Predicate & RiskConfigurationSegment & Selectable & Usable & {
  __typename: 'RiskConfigurationSeverity';
  color?: Maybe<Color>;
  configuration?: Maybe<RiskConfiguration>;
  /**
   * The default value for a node that has no explicit value for this predicate set.
   *
   * See the `Predicate.defaultPredicateValue` field for more information.
   */
  defaultPredicateValue?: Maybe<PredicateValue>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Checks whether this `RiskConfigurationSeverity` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfigurationSeverity` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfigurationSeverity` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `RiskConfigurationSeverity` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfigurationSeverity` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfigurationSeverity` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskConfigurationSeverity` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `RiskConfigurationSeverity` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  lowerBound?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Name>;
  /** A reference to the owner that owns this `RiskConfigurationSeverity`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `RiskConfigurationSeverity` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /**
   * An HTML-formatted field with a closed-form question to the user to explain the predicate.
   *
   * This value is always safe to show in the GUI.
   *
   * See the `Predicate.predicateQuestion` field for more information.
   */
  predicateQuestion?: Maybe<Scalars['HTML']['output']>;
  /** @deprecated use `owner` instead */
  team?: Maybe<Team>;
  upperBound?: Maybe<Scalars['Float']['output']>;
  /** Connection to the verification configuration rules that use this predicate. */
  usedByVerificationConfigurationRules?: Maybe<VerificationConfigurationRuleConnection>;
  /** Connection to the verification configurations that use this verification predicate. */
  usedByVerificationConfigurations?: Maybe<VerificationConfigurationConnection>;
};


export type RiskConfigurationSeverityIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type RiskConfigurationSeverityIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type RiskConfigurationSeverityIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type RiskConfigurationSeverityIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type RiskConfigurationSeverityOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type RiskConfigurationSeverityUsedByVerificationConfigurationRulesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationRuleOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationRuleWhereClause>>;
};


export type RiskConfigurationSeverityUsedByVerificationConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationWhereClause>>;
};

/**
 * A paged connection with `RiskConfigurationSeverityEdge` edges to `RiskConfigurationSeverity` nodes.
 *
 * This type was automatically generated from the `RiskConfigurationSeverityEdge` edge-type for the
 * `RiskConfiguration.severities` field. (It might be possible that it is reused by other fields.)
 */
export type RiskConfigurationSeverityConnection = Connection & ConnectionWithTotal & {
  __typename: 'RiskConfigurationSeverityConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<RiskConfigurationSeverityEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<RiskConfigurationSeverity>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `RiskConfigurationSeverityConnection` connection that points to a `RiskConfigurationSeverity` node.
 *
 * This type was automatically generated from the `RiskConfigurationSeverity` node-type of the
 * `RiskConfiguration.severities` field. (It might be possible that it is reused by other fields.)
 */
export type RiskConfigurationSeverityEdge = Edge & {
  __typename: 'RiskConfigurationSeverityEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: RiskConfigurationSeverity;
};

/**
 * Specifies how the edges to a `RiskConfigurationSeverity` will be ordered in a connection.
 *
 * This type was automatically generated from the `RiskConfigurationSeverityOrderByColumn` column-type used in the
 * `orderBy` argument of the `RiskConfiguration.severities` field. (It might be possible that it is reused by
 * other fields.)
 */
export type RiskConfigurationSeverityOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: RiskConfigurationSeverityOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `RiskConfigurationSeverityOrderByColumn`. */
export enum RiskConfigurationSeverityOrderByColumn {
  /** Orders by the lower bound of this risk severity segment. */
  LowerBound = 'LOWER_BOUND',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /**
   * Orders by the full name of the risk configuration to which the nodes belong.
   *
   *  Form owner-type `RiskConfiguration`.
   */
  RiskConfigurationNameFull = 'RISK_CONFIGURATION_NAME_FULL',
  /**
   * Orders by the short name of the risk configuration to which the nodes belong.
   *
   *  Form owner-type `RiskConfiguration`.
   */
  RiskConfigurationNameShort = 'RISK_CONFIGURATION_NAME_SHORT'
}

export type RiskConfigurationSeverityWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on the total amount of verification configuration rules that use this predicate. */
  totalUsedByVerificationConfigurationRules?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RiskConfigurationWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were soft-deleted. */
  deleted?: InputMaybe<StampedEventConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters the entries by the total amount of related items they have in the relation `analysisReports`. */
  totalAnalysisReports?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `levels`. */
  totalRiskLevelSegments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `probabilities`. */
  totalRiskProbabilitySegments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `severities`. */
  totalRiskSeveritySegments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `risks`. */
  totalRisks?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `threats`. */
  totalThreats?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usedByVerificationConfigurationRules`. */
  totalUsedByVerificationConfigurationRules?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usedByVerificationConfigurations`. */
  totalUsedByVerificationConfigurations?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A paged connection with `RiskConfiguration_RiskEdge` edges to `Risk` nodes.
 *
 * This type was automatically generated from the `RiskConfiguration_RiskEdge` edge-type for the
 * `RiskConfiguration.risks` field. (It might be possible that it is reused by other fields.)
 */
export type RiskConfiguration_RiskConnection = Connection & ConnectionWithTotal & {
  __typename: 'RiskConfiguration_RiskConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<RiskConfiguration_RiskEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Risk>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type RiskConfiguration_RiskEdge = Edge & {
  __typename: 'RiskConfiguration_RiskEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /**
   * The level of the `Risk` in the `node`-field for this `RiskConfiguration`.
   *
   * ### UNTESTED
   *
   * **This feature hasn't been tested jet and might not behave as expected!**
   */
  level?: Maybe<RiskLevel>;
  /** The `Risk` at the end of this edge. */
  node: Risk;
  /**
   * The probability of the `Risk` in the `node`-field for this `RiskConfiguration`.
   *
   * ### UNTESTED
   *
   * **This feature hasn't been tested jet and might not behave as expected!**
   */
  probability?: Maybe<RiskProbability>;
  /**
   * The severity of the `Risk` in the `node`-field for this `RiskConfiguration`.
   *
   * ### UNTESTED
   *
   * **This feature hasn't been tested jet and might not behave as expected!**
   */
  severity?: Maybe<RiskSeverity>;
};

/**
 * A paged connection with `RiskConfiguration_ThreatEdge` edges to `Threat` nodes.
 *
 * This type was automatically generated from the `RiskConfiguration_ThreatEdge` edge-type for the
 * `RiskConfiguration.threats` field. (It might be possible that it is reused by other fields.)
 */
export type RiskConfiguration_ThreatConnection = Connection & ConnectionWithTotal & {
  __typename: 'RiskConfiguration_ThreatConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<RiskConfiguration_ThreatEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Threat>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type RiskConfiguration_ThreatEdge = Edge & {
  __typename: 'RiskConfiguration_ThreatEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /** The `Threat` at the end of this edge. */
  node: Threat;
  /**
   * The severity of the `Threat` in the `node`-field for this `RiskConfiguration`.
   *
   * ### UNTESTED
   *
   * **This feature hasn't been tested jet and might not behave as expected!**
   */
  severity?: Maybe<RiskSeverity>;
};

/**
 * A paged connection with `RiskEdge` edges to `Risk` nodes.
 *
 * This type was automatically generated from the `RiskEdge` edge-type for the
 * `AnalysisReport.risks` field. (It might be possible that it is reused by other fields.)
 */
export type RiskConnection = Connection & ConnectionWithTotal & {
  __typename: 'RiskConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<RiskEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Risk>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `RiskConnection` connection that points to a `Risk` node.
 *
 * This type was automatically generated from the `Risk` node-type of the
 * `AnalysisReport.risks` field. (It might be possible that it is reused by other fields.)
 */
export type RiskEdge = Edge & {
  __typename: 'RiskEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: Risk;
};

export type RiskLevel = RiskValue & {
  __typename: 'RiskLevel';
  segment?: Maybe<RiskConfigurationLevel>;
  value?: Maybe<Scalars['Float']['output']>;
};

/**
 * Specifies how the edges to a `Risk` will be ordered in a connection.
 *
 * This type was automatically generated from the `RiskOrderByColumn` column-type used in the
 * `orderBy` argument of the `AnalysisReport.risks` field. (It might be possible that it is reused by
 * other fields.)
 */
export type RiskOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: RiskOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `RiskOrderByColumn`. */
export enum RiskOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which the entities were deleted. */
  DeletedAt = 'DELETED_AT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  /**
   * Alias for `NAME_FULL`.
   *
   *  Form owner-type `Threat`.
   */
  ThreatNameFull = 'THREAT_NAME_FULL',
  /**
   * Alias for `NAME_SHORT`.
   *
   *  Form owner-type `Threat`.
   */
  ThreatNameShort = 'THREAT_NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type RiskProbability = RiskValue & {
  __typename: 'RiskProbability';
  remarks?: Maybe<Scalars['HTML']['output']>;
  segment?: Maybe<RiskConfigurationProbability>;
  value?: Maybe<Scalars['Float']['output']>;
};

/**
 * An `Audit`-node that tracks a mutation that affects the probability on the edge between a `Risk` and a
 * `RiskConfiguration`.
 */
export type RiskProbabilityAudit = Audit & Commentable & Node & Ownable & Taggable & Timestamped & Userstamped & {
  __typename: 'RiskProbabilityAudit';
  /** The comments for this `RiskProbabilityAudit`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `RiskProbabilityAudit`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `RiskProbabilityAudit`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** The client-application that the `creator` used at the moment when he/she generated this `RiskProbabilityAudit`. */
  creatorClient?: Maybe<Client>;
  /** The IP-address of the `creator` at the moment when he/she generated this `RiskProbabilityAudit`. */
  creatorIpAddress?: Maybe<Scalars['IpAddress']['output']>;
  /**
   * The team of the `creator` at the moment when he/she generated this `RiskProbabilityAudit`.
   *
   * See the `Audit.creator`-field for more information.
   */
  creatorTeam?: Maybe<Team>;
  /** The user-agent of the `creator` at the moment when he/she generated this `RiskProbabilityAudit`-node. */
  creatorUserAgent?: Maybe<Scalars['UserAgent']['output']>;
  /**
   * Gives the `User` that _updated_ this `RiskProbabilityAudit`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /** The event type for which this `RiskProbabilityAudit` was generated. */
  event?: Maybe<AuditedEvent>;
  /**
   * The name of the GraphQL operation that was responsible for this `RiskProbabilityAudit`-node.
   *
   * Use this value in combination with the `client`-field to derive how this audit was created.
   */
  graphqlOperation?: Maybe<Scalars['String']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `RiskProbabilityAudit`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskProbabilityAudit` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskProbabilityAudit` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `RiskProbabilityAudit` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `RiskProbabilityAudit` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `RiskProbabilityAudit`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** The probability after the mutation was executed. */
  newProbability?: Maybe<RiskProbability>;
  /** The probability before the mutation was executed. */
  oldProbability?: Maybe<RiskProbability>;
  /** A reference to the owner that owns this `RiskProbabilityAudit`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `RiskProbabilityAudit` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the probability was changed dueue to this mutation.
   *
   * This field implies that `RiskProbabilityAudit.oldProbability !== RiskProbabilityAudit.newProbability`.
   */
  probabilityChanged?: Maybe<Scalars['Boolean']['output']>;
  /** An HTML-formatted text containing some remarks about the mutation that generated this `RiskProbabilityAudit`. */
  remarks?: Maybe<Scalars['HTML']['output']>;
  /** The risk that was affected by the mutation. */
  risk?: Maybe<Risk>;
  /** The risk configuration for which the probability changed */
  riskConfiguration?: Maybe<RiskConfiguration>;
  /** Connection to the tags that are assigned to this `RiskProbabilityAudit`. */
  tags?: Maybe<TagConnection>;
  /** Gives the most recent moment on which this `RiskProbabilityAudit`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/**
 * An `Audit`-node that tracks a mutation that affects the probability on the edge between a `Risk` and a
 * `RiskConfiguration`.
 */
export type RiskProbabilityAuditCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


/**
 * An `Audit`-node that tracks a mutation that affects the probability on the edge between a `Risk` and a
 * `RiskConfiguration`.
 */
export type RiskProbabilityAuditIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/**
 * An `Audit`-node that tracks a mutation that affects the probability on the edge between a `Risk` and a
 * `RiskConfiguration`.
 */
export type RiskProbabilityAuditIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


/**
 * An `Audit`-node that tracks a mutation that affects the probability on the edge between a `Risk` and a
 * `RiskConfiguration`.
 */
export type RiskProbabilityAuditIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


/**
 * An `Audit`-node that tracks a mutation that affects the probability on the edge between a `Risk` and a
 * `RiskConfiguration`.
 */
export type RiskProbabilityAuditIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/**
 * An `Audit`-node that tracks a mutation that affects the probability on the edge between a `Risk` and a
 * `RiskConfiguration`.
 */
export type RiskProbabilityAuditOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


/**
 * An `Audit`-node that tracks a mutation that affects the probability on the edge between a `Risk` and a
 * `RiskConfiguration`.
 */
export type RiskProbabilityAuditTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

/**
 * A paged connection with `RiskProbabilityAuditEdge` edges to `RiskProbabilityAudit` nodes.
 *
 * This type was automatically generated from the `RiskProbabilityAuditEdge` edge-type for the
 * `Query.riskProbabilityAudits` field. (It might be possible that it is reused by other fields.)
 */
export type RiskProbabilityAuditConnection = Connection & ConnectionWithTotal & {
  __typename: 'RiskProbabilityAuditConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<RiskProbabilityAuditEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<RiskProbabilityAudit>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `RiskProbabilityAuditConnection` connection that points to a `RiskProbabilityAudit` node.
 *
 * This type was automatically generated from the `RiskProbabilityAudit` node-type of the
 * `Query.riskProbabilityAudits` field. (It might be possible that it is reused by other fields.)
 */
export type RiskProbabilityAuditEdge = Edge & {
  __typename: 'RiskProbabilityAuditEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: RiskProbabilityAudit;
};

/**
 * Specifies how the edges to a `RiskProbabilityAudit` will be ordered in a connection.
 *
 * This type was automatically generated from the `RiskProbabilityAuditOrderByColumn` column-type used in the
 * `orderBy` argument of the `Query.riskProbabilityAudits` field. (It might be possible that it is reused by
 * other fields.)
 */
export type RiskProbabilityAuditOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: RiskProbabilityAuditOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `RiskProbabilityAuditOrderByColumn`. */
export enum RiskProbabilityAuditOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type RiskProbabilityAuditWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters on the event type of the audit entry. */
  event?: InputMaybe<AuditedEvent>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RiskSeverity = RiskValue & {
  __typename: 'RiskSeverity';
  remarks?: Maybe<Scalars['HTML']['output']>;
  segment?: Maybe<RiskConfigurationSeverity>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type RiskValue = {
  segment?: Maybe<RiskConfigurationSegment>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type RiskWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were soft-deleted. */
  deleted?: InputMaybe<StampedEventConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `predicateRequirements`. */
  totalUsedPredicates?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `questionPredicates`. */
  totalUsedQuestionPredicates?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `regions`. */
  totalUsedRegions?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Risk_ProductCategoryConnection = Connection & ConnectionWithTotal & {
  __typename: 'Risk_ProductCategoryConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<Risk_ProductCategoryEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<ProductCategory>>>;
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Risk_ProductCategoryEdge = Edge & {
  __typename: 'Risk_ProductCategoryEdge';
  cursor: Scalars['Cursor']['output'];
  derivedFrom?: Maybe<ProductCategory>;
  explicitlySelected: Scalars['Boolean']['output'];
  node: ProductCategory;
};

export type Risk_ProductCategoryWhereClause = {
  /** Filter entries based on the current active state. See the `WhereActive`-enum for more information. */
  active?: InputMaybe<WhereActive>;
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were deactivated. */
  deactivated?: InputMaybe<StampedEventConstraints>;
  /** Filters the entries by the meta-data about the moment they were soft-deleted. */
  deleted?: InputMaybe<StampedEventConstraints>;
  /**
   * Filter on the absolute depth in the tree (of nested-set nodes). This is equivalent to the total number of
   * ancestors.
   *
   * The absolute depth of a node X is defined by:
   *     - `X.depth := 0` if `X` has no parent (`X` is a root node)
   *     - `X.depth := X.parent.depth + 1` if `X` has a parent.
   *
   * Set this filter to `{equalTo: 0}` to get all root nodes.
   */
  depth?: InputMaybe<IntLinearOrderConstraints>;
  /**
   * Filters on the ProductCategories that were explicitly selected by the user. These product categories won't lose
   * their connection to the `Risk` when some parent category is detached.
   */
  explicitlySelected?: InputMaybe<Risk_WhereProductCategoryExplicitlySelected>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filters the product categories for which the connection to this risk was derived from the `ProductCategory` with
   * the provided id.
   */
  inclusionDerivedFrom?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Filters on whether the `NestedSetNode` is a leaf-node or not.
   *
   * A node is considered to be a leaf-node if it has no children.
   */
  leaves?: InputMaybe<WhereLeaves>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Filters on whether the `NestedSetNode` is a root-node or not.
   *
   * A node is considered to be a root-node if it has no parent.
   */
  roots?: InputMaybe<WhereRoots>;
  /**
   * Filters the entries by the total amount child-nodes.
   *
   * You get the leaves if you set this constraint to `{equalTo: 0 }`.
   *
   * See the `NestedSetNode.children`-field for more information.
   */
  totalChildren?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /**
   * Filters the entries by the total amount descendant-nodes. See the `descendants`-field of the `NestedSet` interface
   * for more information.
   *
   * This total does not include the node itself as its descendant! **Example:** You get the leaves if you set this
   * constraint to `{equalTo: 0 }`.
   *
   * See the `NestedSetNode.descendants`-field for more information.
   */
  totalDescendants?: InputMaybe<IntLinearOrderConstraints>;
  /**
   * Filters the entries by the total amount nodes in the bloodline. See the `bloodline`-field of the `NestedSet`
   * interface for more information.
   *
   * This total does include the node itself! **Example:** You no results if you set this constraint to `{equalTo: 0 }`.
   *
   * See the `NestedSetNode.bloodline`-field for more information.
   */
  totalNodesInBloodline?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `risks`. */
  totalRisks?: InputMaybe<IntLinearOrderConstraints>;
  /**
   * Filters the entries by the total amount sibling-nodes.
   *
   * This total does not include the node itself as its sibling! **Example:** You get all nodes without siblings when
   * you set the constraints to `{equalTo: 0 }`.
   *
   * See the `NestedSetNode.siblings`-field for more information.
   */
  totalSiblings?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Risk_RiskColumnConnection = Connection & ConnectionWithTotal & {
  __typename: 'Risk_RiskColumnConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<Risk_RiskColumnEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<RiskColumn>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Risk_RiskColumnEdge = Edge & {
  __typename: 'Risk_RiskColumnEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /**
   * The node at the end of this edge.
   *
   * This value is `null` iff the current access token has no permission to see the value of this node, but does have
   * the permission to see the values on the edges.
   */
  node?: Maybe<RiskColumn>;
  /** The value that the risk at the start of this edge has for the risk column at the end of this edge. */
  value?: Maybe<Scalars['HTML']['output']>;
};

/** Represents the connection between one `Risk` and the `RiskConfiguration`s in the data-graph. */
export type Risk_RiskConfigurationConnection = Connection & ConnectionWithTotal & {
  __typename: 'Risk_RiskConfigurationConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<Risk_RiskConfigurationEdge>>>;
  /** Edge to the *global default* `RiskConfiguration`. */
  globalDefault?: Maybe<Risk_RiskConfigurationEdge>;
  /**
   * Edge to the default `RiskConfiguration` of the team in the current access token.
   *
   * **NOTICE:** This is not the default value for the risk itself. See the `Risk.teams` field for that value!
   */
  myTeamDefault?: Maybe<Risk_RiskConfigurationEdge>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<RiskConfiguration>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** Represents an edge between a `Risk` and a `RiskConfiguration` */
export type Risk_RiskConfigurationEdge = Edge & {
  __typename: 'Risk_RiskConfigurationEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /** The level of this risk in the `RiskConfiguration` of the `node`-field. */
  level?: Maybe<RiskLevel>;
  /** The node at the end of this edge. */
  node: RiskConfiguration;
  /** The probability of this risk in the `RiskConfiguration` of the `node`-field. */
  probability?: Maybe<RiskProbability>;
  /** The severity of this risk in the `RiskConfiguration` of the `node`-field. */
  severity?: Maybe<RiskSeverity>;
};

export enum Risk_WhereProductCategoryExplicitlySelected {
  Only = 'ONLY',
  With = 'WITH',
  Without = 'WITHOUT'
}

/** All the explicit roles in the RBAC-configuration. */
export enum Role {
  /**
   * ### Access-control Administrator *[User]*
   *
   * Beheert de globale rollen van gebruikers.
   */
  AccessAdmin = 'ACCESS_ADMIN',
  /**
   * ### Commerciëel Accountmanager *[User]*
   *
   * Beheert de accounts en teams van klanten.
   */
  Com = 'COM',
  /** ### Consultant *[Team]* */
  Cs = 'CS',
  /**
   * ### Developer *[User]*
   *
   * Rol voor de developers van de applicatie. Een gebruiker met deze rol kan de technische statistieken en debug-logs van de applicatie inzien.
   */
  Dev = 'DEV',
  /**
   * ### Redacteur *[User]*
   *
   * Schrijft de content van de applicaties.
   */
  Editor = 'EDITOR',
  /** ### Inkoper *[Team]* */
  Ink = 'INK',
  /**
   * ### Job Worker *[Client]*
   *
   * Applicatie die achtergrondtaken afhandeld.
   */
  JobWorker = 'JOB_WORKER',
  /** ### Kwaliteitsverantwoordelijke *[Team]* */
  Kv = 'KV',
  /**
   * ### Technisch Onderhoud *[User]*
   *
   * Kan de technische staat van de applicatie inkijken, de database opschonen en periodieke acties instellen om de applicatie beter te laten werken.
   */
  Maintainer = 'MAINTAINER',
  /**
   * ### Producteigenaar *[User]*
   *
   * Kan inzien hoe de applicatie wordt gebruikt.
   */
  Po = 'PO',
  /**
   * ### Lezer *[User]*
   *
   * Mag alle default data lezen.
   */
  Reader = 'READER',
  /**
   * ### Superuser *[User]*
   *
   * Heeft elk mogelijke permissie in alle applicaties.
   */
  Super = 'SUPER',
  /**
   * ### Export-applicatie van systeemgegevens *[Client]*
   *
   * Export-applicatie die de globale data kan exporteren.
   */
  SystemExportApp = 'SYSTEM_EXPORT_APP',
  /** ### Team Administrator *[Team]* */
  TeamAdmin = 'TEAM_ADMIN',
  /**
   * ### Gast in Team *[Team]*
   *
   * Mag alleen de naam van het team zien.
   */
  TeamGuest = 'TEAM_GUEST',
  /**
   * ### Lezer van Team *[Team]*
   *
   * Mag alle gegevens van het team bekijken, maar niet bewerken.
   */
  TeamReader = 'TEAM_READER',
  /**
   * ### Test-data zaaimachine *[Client]*
   *
   * Applicatie die gegevens klaarzet in de database voor testdoeleinden.
   */
  TestDataSeeder = 'TEST_DATA_SEEDER',
  /**
   * ### Test applicatie *[Client]*
   *
   * Applicatie die de test-gegevens in de database manipuleert en beweringen over test-gegevens controleert.
   */
  TestExecutor = 'TEST_EXECUTOR',
  /**
   * ### Export-applicatie van gebruikersgegevens *[Client]*
   *
   * Applicatie die namens een gebruiker data exporteert.
   */
  UserExportApp = 'USER_EXPORT_APP',
  /**
   * ### Import-applicatie van gebruikersgegevens *[Client]*
   *
   * Applicatie die namens een gebruiker data kan importeert.
   */
  UserImportApp = 'USER_IMPORT_APP'
}

/** Todo item that can be resolved by selecting products for the analysis report in the `analysisReport` field. */
export type SelectAnalysisReportProductsTodo = Node & Todo & {
  __typename: 'SelectAnalysisReportProductsTodo';
  /** The analysis report for which the products should be selected. */
  analysisReport?: Maybe<AnalysisReport>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this `Todo` item is considered to be done. */
  isDone?: Maybe<Scalars['Boolean']['output']>;
  /** The title for this todo item that can be used to display it in a todo list. */
  title?: Maybe<Scalars['String']['output']>;
};

export type SelectProductsInput = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  where?: InputMaybe<Array<ProductWhereClause>>;
};

/**
 * An interface for nodes that have both a `name` and a `description` field. Nodes that implement this interface can be
 * shown in the UI as a list from which the user can pick one or several items (like in a "dropdown" or "select" menu.)
 */
export type Selectable = {
  /**
   * A longer, plain-text value that helps the user to identify this node. When a collection of these nodes are
   * full-text searchable, it will also search over the values in this field.
   *
   * It is always safe to show in the GUI.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * The name of the node, which should be enough for the user that is familiar with the data to identify this node.
   *
   * It is always safe to show in the GUI.
   */
  name?: Maybe<EntityName>;
};

export type SendNotificationInput = {
  /** The detailed message of the notification. */
  detail?: InputMaybe<Scalars['String']['input']>;
  /** The ID of a `Notifiable` node (like `Team` and `User`) that should receive the notification. */
  recipientId: Scalars['ID']['input'];
  /** The severity of the notification. Mainly used to determine the color of the notification in the UI. */
  severity?: InputMaybe<NotificationSeverity>;
  /** The summary massage of the notification. */
  summary: Scalars['String']['input'];
};

export type SendNotification_SuccessResult = MutationPayload & {
  __typename: 'SendNotification_SuccessResult';
  /** The notification that was send. May be set. */
  node?: Maybe<Notification>;
  query: Query;
};

export type SendUserInvitationInput = {
  /** The ID of the user invitation to send. */
  id: Scalars['ID']['input'];
};

export type SendUserInvitation_SuccessResult = MutationPayload & {
  __typename: 'SendUserInvitation_SuccessResult';
  node: UserInvitation;
  query: Query;
};

export type SetRiskConfigurationLevelInput = {
  color?: InputMaybe<Color>;
  description?: InputMaybe<Scalars['String']['input']>;
  lowerBound: Scalars['Float']['input'];
  name: NameInput;
};

export type SetRiskConfigurationProbabilityInput = {
  color?: InputMaybe<Color>;
  description?: InputMaybe<Scalars['String']['input']>;
  lowerBound: Scalars['Float']['input'];
  name: NameInput;
};

export type SetRiskConfigurationSeverityInput = {
  color?: InputMaybe<Color>;
  description?: InputMaybe<Scalars['String']['input']>;
  lowerBound: Scalars['Float']['input'];
  name: NameInput;
};

/** Todo item that can be resolved by assigning a probability value for `riskConfiguration` to the `risk`. */
export type SetRiskProbabilityValueForRiskConfigurationTodo = Node & Todo & {
  __typename: 'SetRiskProbabilityValueForRiskConfigurationTodo';
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this `Todo` item is considered to be done. */
  isDone?: Maybe<Scalars['Boolean']['output']>;
  /** The risk to which the probability value should be assigned. */
  risk?: Maybe<Risk>;
  /** The risk configuration for which the probability must be assigned. */
  riskConfiguration?: Maybe<RiskConfiguration>;
  /** The title for this todo item that can be used to display it in a todo list. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Todo item that can be resolved by assigning a severity value for `riskConfiguration` to the `threat`. */
export type SetThreatSeverityValueForRiskConfigurationTodo = Node & Todo & {
  __typename: 'SetThreatSeverityValueForRiskConfigurationTodo';
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this `Todo` item is considered to be done. */
  isDone?: Maybe<Scalars['Boolean']['output']>;
  /** The risk configuration to which the severity value applies. */
  riskConfiguration?: Maybe<RiskConfiguration>;
  /** The threat to which a severity value should be assigned. */
  threat?: Maybe<Threat>;
  /** The title for this todo item that can be used to display it in a todo list. */
  title?: Maybe<Scalars['String']['output']>;
};

/**
 * Provides the last interactive or non-interactive sign-in time for a specific user. Since signInActivity describes a
 * property of the user object, Azure AD stores sign in activity for your users for as long as the user object exists.
 *
 * For more information, see the [Microsoft Graph API Documentation](https://learn.microsoft.com/en-us/graph/api/resources/signinactivity?view=graph-rest-1.0).
 */
export type SignInActivity = {
  __typename: 'SignInActivity';
  lastNonInteractiveSignInAt?: Maybe<Scalars['DateTime']['output']>;
  lastNonInteractiveSignInRequestId?: Maybe<Scalars['String']['output']>;
  lastSignInAt?: Maybe<Scalars['DateTime']['output']>;
  lastSignInRequestId?: Maybe<Scalars['String']['output']>;
};

/**
 * Objects that implement this interface have a `slug`-field, which can be used to identify a node of a specific type in a
 * more human-readable way.
 *
 * See the `slug`-field on this interface for more information about the differences between the `id`-field and the
 * `slug`-field and how they should be used.
 */
export type Sluggable = {
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * The `slug`, which is an *url-* and *filename-*safe string that uniquely identifies a node with a specific type.
   * It's value is usually derived from the initial data of the node (so the data it had when it was created).
   *
   * There are some important differences with the `id`-field:
   * 1. The value of `id` is always set, the value of `slug` might sometimes be `null` even if the node itself does
   *    exists. This happens for instance when the node is soft-deleted.
   * 2. The value of `id` is globally unique, the value of `slug` is only unique in combination with the `__typename`.
   * 3. The value of `id` always refers to the **current node and only the current node**. The value of `slug` might
   *    refer to a different node over time. (Example: when an old node is soft-deleted and a new node with the same
   *    name is created. The new node will have the same `slug`-value as the older node.)
   * 4. The `slug` is guaranteed to be *url-* and *filename-*safe. The `id`-field does not have these guarantees.
   *
   * When available, prefer the `slug`-field over the `id`-field for usage in urls. For caching and communication with
   * the api, you should always use the `id`-field over the `slug`-field.
   */
  slug?: Maybe<Scalars['Slug']['output']>;
};

/**
 * Nodes that implement this interface can be soft-deleted. A soft-deleted node doesn't show up in connections by
 * default, but can still be referenced using the ids. The fields of these interface retrieve information on the
 * current soft-delete state of an object.
 *
 * Usually, soft-deleted nodes will be completely removed after no references from other nodes to the soft-deleted
 * node exist in the database.
 */
export type SoftDelete = {
  /** `DateTime` on which this node was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gives the `DateTime` on which this object was soft-deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this node is considered to be new. */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this node is considered to be updated. */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Will be `true` if this object is soft-deleted. When it is still available, it will give `false`. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** `DateTime` of the last moment on which this node was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/**
 * Nodes that implement this interface can be soft-deleted. A soft-deleted node doesn't show up in connections by
 * default, but can still be referenced using the ids. The fields of these interface retrieve information on the
 * current soft-delete state of an object.
 *
 * Usually, soft-deleted nodes will be completely removed after no references from other nodes to the soft-deleted
 * node exist in the database.
 */
export type SoftDeleteIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/**
 * Nodes that implement this interface can be soft-deleted. A soft-deleted node doesn't show up in connections by
 * default, but can still be referenced using the ids. The fields of these interface retrieve information on the
 * current soft-delete state of an object.
 *
 * Usually, soft-deleted nodes will be completely removed after no references from other nodes to the soft-deleted
 * node exist in the database.
 */
export type SoftDeleteIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};

/**
 * Nodes that implement this interface can be soft-deleted and also store the `User` that deleted this node.
 *
 * A soft-deleted node doesn't show up in connections by default, but can still be referenced using the ids. The fields
 * of these interface retrieve information on the current soft-delete state of an object.
 *
 * Usually, soft-deleted nodes will be completely removed after no references from other nodes to the soft-deleted
 * node exist in the database.
 *
 * For more information about soft-deletions, see the `SoftDelete`-interface.
 */
export type SoftDeleteUserstamped = {
  /** `DateTime` on which this node was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that created this object. This value is always in sync with the `createdAt`-field. */
  creator?: Maybe<User>;
  /** Gives the `DateTime` on which this object was soft-deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Gives the `User` that soft-deleted this object. */
  destroyer?: Maybe<User>;
  /** The last user that edited this object. This value is always in sync with the `updatedAt`-field. */
  editor?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this node is considered to be new. */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this node is considered to be updated. */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Will be `true` if this object is soft-deleted. When it is still available, it will give `false`. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** `DateTime` of the last moment on which this node was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/**
 * Nodes that implement this interface can be soft-deleted and also store the `User` that deleted this node.
 *
 * A soft-deleted node doesn't show up in connections by default, but can still be referenced using the ids. The fields
 * of these interface retrieve information on the current soft-delete state of an object.
 *
 * Usually, soft-deleted nodes will be completely removed after no references from other nodes to the soft-deleted
 * node exist in the database.
 *
 * For more information about soft-deletions, see the `SoftDelete`-interface.
 */
export type SoftDeleteUserstampedIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/**
 * Nodes that implement this interface can be soft-deleted and also store the `User` that deleted this node.
 *
 * A soft-deleted node doesn't show up in connections by default, but can still be referenced using the ids. The fields
 * of these interface retrieve information on the current soft-delete state of an object.
 *
 * Usually, soft-deleted nodes will be completely removed after no references from other nodes to the soft-deleted
 * node exist in the database.
 *
 * For more information about soft-deletions, see the `SoftDelete`-interface.
 */
export type SoftDeleteUserstampedIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export type StampConstraints = {
  /**
   * Filters only the entries where this event occurred after the provided timestamp.
   *
   * This field has no effect when `is` is set to `false`.
   */
  after?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Filters only the entries where this event occurred before the provided timestamp.
   *
   * This field has no effect when `is` is set to `false`.
   */
  before?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * When set, it will only show the entries for whom the event was triggered by at least one one of the `User`s, in the
   * provided array. You can also give an ID of a `Team`, `Contact` or `Company`.
   *
   * The results are *joined* (OR) together, so the result will always be empty if you provide an empty array.
   *
   * This field has no effect when `is` is set to `false`.
   */
  by?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Constraint for events that might not have happened yet. It also has fields that recorded which user triggered the
 * event.
 */
export type StampedEventConstraints = {
  /**
   * Filters only the entries where this event occurred after the provided timestamp.
   *
   * This field has no effect when `is` is set to `false`.
   */
  after?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * Filters only the entries where this event occurred before the provided timestamp.
   *
   * This field has no effect when `is` is set to `false`.
   */
  before?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * When set, it will only show the entries for whom the event was triggered by at least one one of the `User`s, in the
   * provided array. You can also give an ID of a `Team`, `Contact` or `Company`.
   *
   * The results are *joined* (OR) together, so the result will always be empty if you provide an empty array.
   *
   * This field has no effect when `is` is set to `false`.
   */
  by?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When set to `false`, it will only show entries where the event didn't happen (yet). */
  is?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StartJobInput = {
  /** The ID of the job to start. */
  id: Scalars['ID']['input'];
};

export type StartJob_SuccessResult = {
  __typename: 'StartJob_SuccessResult';
  node: Job;
};

export type Subscription = {
  __typename: 'Subscription';
  /** Emits when the state of the job with the provided ID changes. */
  jobStateChanged?: Maybe<Job>;
  notification?: Maybe<Notification>;
  taskCompleted?: Maybe<Scalars['String']['output']>;
  /** Emits when the state of a user invitation changed. */
  userInvitationStateChanged?: Maybe<UserInvitation>;
};


export type SubscriptionJobStateChangedArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionUserInvitationStateChangedArgs = {
  id: Scalars['ID']['input'];
};

export type Supplier = Activateable & Commentable & Named & Node & Ownable & Selectable & Sluggable & SoftDelete & SoftDeleteUserstamped & Taggable & Timestamped & Usable & Userstamped & {
  __typename: 'Supplier';
  address?: Maybe<Address>;
  clientRef?: Maybe<Scalars['String']['output']>;
  /** The comments for this `Supplier`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `Supplier`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `Supplier`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** Timestamp of when this `Supplier`-object was deactivated. */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that deactivated this `Supplier`-object. */
  deactivator?: Maybe<User>;
  /** Gives the moment on which this `Supplier`-object was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _deleted_ this `Supplier`-object.
   *
   * When this field is `null`, it can be the case that this object was not deleted or not deleted by a `User`. It will also
   * be `null` when the current user is not allowed to see the `User` that deleted this object.
   */
  destroyer?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `Supplier`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  email?: Maybe<Scalars['Email']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this `Supplier`-object is considered to be active. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `Supplier`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Supplier` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Supplier` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Supplier` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `Supplier` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `Supplier`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Supplier` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Supplier` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Supplier` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `Supplier` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Name>;
  /** A reference to the owner that owns this `Supplier`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `Supplier` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<PhoneNumber>;
  /**
   * The `slug`, which is an *url-* and *filename-*safe string that uniquely identifies a node with a specific type.
   * It's value is usually derived from the initial data of the node (so the data it had when it was created).
   *
   * There are some important differences with the `id`-field:
   * 1. The value of `id` is always set, the value of `slug` might sometimes be `null` even if the node itself does
   * exists. This happens for instance when the node is soft-deleted.
   * 2. The value of `id` is globally unique, the value of `slug` is only unique in combination with the `__typename`.
   * 3. The value of `id` always refers to the **current node and only the current node**. The value of `slug` might
   * refer to a different node over time. (Example: when an old node is soft-deleted and a new node with the same
   * name is created. The new node will have the same `slug`-value as the older node.)
   * 4. The `slug` is guaranteed to be *url-* and *filename-*safe. The `id`-field does not have these guarantees.
   *
   * When available, prefer the `slug`-field over the `id`-field for usage in urls. For caching and communication with
   * the api, you should always use the `id`-field over the `slug`-field.
   */
  slug?: Maybe<Scalars['Slug']['output']>;
  supplierBranches?: Maybe<SupplierBranchConnection>;
  /** Connection to the tags that are assigned to this `Supplier`. */
  tags?: Maybe<TagConnection>;
  /** Will be `true` if this `Supplier` is soft-deleted, `false` otherwise. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** Gives the most recent moment on which this `Supplier`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['URL']['output']>;
};


export type SupplierCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type SupplierIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type SupplierIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type SupplierIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type SupplierIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type SupplierIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type SupplierIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type SupplierOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type SupplierSupplierBranchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SupplierBranchOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<SupplierBranchWhereClause>>;
};


export type SupplierTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

export type SupplierBranch = Activateable & Commentable & Named & Node & Ownable & Selectable & Sluggable & SoftDelete & SoftDeleteUserstamped & Taggable & Timestamped & Usable & Userstamped & {
  __typename: 'SupplierBranch';
  address?: Maybe<Address>;
  /** The comments for this `SupplierBranch`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `SupplierBranch`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `SupplierBranch`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** Timestamp of when this `SupplierBranch`-object was deactivated. */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that deactivated this `SupplierBranch`-object. */
  deactivator?: Maybe<User>;
  /** Gives the moment on which this `SupplierBranch`-object was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _deleted_ this `SupplierBranch`-object.
   *
   * When this field is `null`, it can be the case that this object was not deleted or not deleted by a `User`. It will also
   * be `null` when the current user is not allowed to see the `User` that deleted this object.
   */
  destroyer?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `SupplierBranch`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  email?: Maybe<Scalars['Email']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this `SupplierBranch`-object is considered to be active. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `SupplierBranch`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `SupplierBranch` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `SupplierBranch` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `SupplierBranch` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `SupplierBranch` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `SupplierBranch`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `SupplierBranch` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `SupplierBranch` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `SupplierBranch` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `SupplierBranch` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Name>;
  /** A reference to the owner that owns this `SupplierBranch`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `SupplierBranch` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<PhoneNumber>;
  products?: Maybe<ProductConnection>;
  /** The reliability of this supplier branch. */
  reliability?: Maybe<SupplierReliability>;
  /**
   * The `slug`, which is an *url-* and *filename-*safe string that uniquely identifies a node with a specific type.
   * It's value is usually derived from the initial data of the node (so the data it had when it was created).
   *
   * There are some important differences with the `id`-field:
   * 1. The value of `id` is always set, the value of `slug` might sometimes be `null` even if the node itself does
   * exists. This happens for instance when the node is soft-deleted.
   * 2. The value of `id` is globally unique, the value of `slug` is only unique in combination with the `__typename`.
   * 3. The value of `id` always refers to the **current node and only the current node**. The value of `slug` might
   * refer to a different node over time. (Example: when an old node is soft-deleted and a new node with the same
   * name is created. The new node will have the same `slug`-value as the older node.)
   * 4. The `slug` is guaranteed to be *url-* and *filename-*safe. The `id`-field does not have these guarantees.
   *
   * When available, prefer the `slug`-field over the `id`-field for usage in urls. For caching and communication with
   * the api, you should always use the `id`-field over the `slug`-field.
   */
  slug?: Maybe<Scalars['Slug']['output']>;
  supplier?: Maybe<Supplier>;
  /** Connection to the tags that are assigned to this `SupplierBranch`. */
  tags?: Maybe<TagConnection>;
  /** Will be `true` if this `SupplierBranch` is soft-deleted, `false` otherwise. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** Gives the most recent moment on which this `SupplierBranch`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['URL']['output']>;
};


export type SupplierBranchCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type SupplierBranchIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type SupplierBranchIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type SupplierBranchIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type SupplierBranchIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type SupplierBranchIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type SupplierBranchIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type SupplierBranchOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type SupplierBranchProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductOrderByClause>>;
  where?: InputMaybe<Array<ProductWhereClause>>;
};


export type SupplierBranchTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

/**
 * A paged connection with `SupplierBranchEdge` edges to `SupplierBranch` nodes.
 *
 * This type was automatically generated from the `SupplierBranchEdge` edge-type for the
 * `Product.supplierBranches` field. (It might be possible that it is reused by other fields.)
 */
export type SupplierBranchConnection = Connection & ConnectionWithTotal & {
  __typename: 'SupplierBranchConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<SupplierBranchEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<SupplierBranch>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `SupplierBranchConnection` connection that points to a `SupplierBranch` node.
 *
 * This type was automatically generated from the `SupplierBranch` node-type of the
 * `Product.supplierBranches` field. (It might be possible that it is reused by other fields.)
 */
export type SupplierBranchEdge = Edge & {
  __typename: 'SupplierBranchEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: SupplierBranch;
};

/**
 * Specifies how the edges to a `SupplierBranch` will be ordered in a connection.
 *
 * This type was automatically generated from the `SupplierBranchOrderByColumn` column-type used in the
 * `orderBy` argument of the `Product.supplierBranches` field. (It might be possible that it is reused by
 * other fields.)
 */
export type SupplierBranchOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: SupplierBranchOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `SupplierBranchOrderByColumn`. */
export enum SupplierBranchOrderByColumn {
  AddressLine_1 = 'ADDRESS_LINE_1',
  AddressLine_2 = 'ADDRESS_LINE_2',
  AdministrativeArea = 'ADMINISTRATIVE_AREA',
  Country = 'COUNTRY',
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which an entity was deactivated. */
  DeactivatedAt = 'DEACTIVATED_AT',
  /** Orders by the moment on which the entities were deleted. */
  DeletedAt = 'DELETED_AT',
  DependentLocality = 'DEPENDENT_LOCALITY',
  Locality = 'LOCALITY',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  PostalCode = 'POSTAL_CODE',
  /** Orders by the reliability value of the `SupplierBranch`. */
  Reliability = 'RELIABILITY',
  SortingCode = 'SORTING_CODE',
  /**
   * Alias for `ADDRESS_LINE_1`.
   *
   *  Form owner-type `Supplier`.
   */
  SupplierAddressLine_1 = 'SUPPLIER_ADDRESS_LINE_1',
  /**
   * Alias for `ADDRESS_LINE_2`.
   *
   *  Form owner-type `Supplier`.
   */
  SupplierAddressLine_2 = 'SUPPLIER_ADDRESS_LINE_2',
  /**
   * Alias for `ADMINISTRATIVE_AREA`.
   *
   *  Form owner-type `Supplier`.
   */
  SupplierAdministrativeArea = 'SUPPLIER_ADMINISTRATIVE_AREA',
  /**
   * Alias for `CLIENT_REF`.
   *
   *  Form owner-type `Supplier`.
   */
  SupplierClientRef = 'SUPPLIER_CLIENT_REF',
  /**
   * Alias for `COUNTRY`.
   *
   *  Form owner-type `Supplier`.
   */
  SupplierCountry = 'SUPPLIER_COUNTRY',
  /**
   * Alias for `DEPENDENT_LOCALITY`.
   *
   *  Form owner-type `Supplier`.
   */
  SupplierDependentLocality = 'SUPPLIER_DEPENDENT_LOCALITY',
  /**
   * Alias for `LOCALITY`.
   *
   *  Form owner-type `Supplier`.
   */
  SupplierLocality = 'SUPPLIER_LOCALITY',
  /**
   * Alias for `NAME_FULL`.
   *
   *  Form owner-type `Supplier`.
   */
  SupplierNameFull = 'SUPPLIER_NAME_FULL',
  /**
   * Alias for `NAME_SHORT`.
   *
   *  Form owner-type `Supplier`.
   */
  SupplierNameShort = 'SUPPLIER_NAME_SHORT',
  /**
   * Alias for `POSTAL_CODE`.
   *
   *  Form owner-type `Supplier`.
   */
  SupplierPostalCode = 'SUPPLIER_POSTAL_CODE',
  /**
   * Alias for `SORTING_CODE`.
   *
   *  Form owner-type `Supplier`.
   */
  SupplierSortingCode = 'SUPPLIER_SORTING_CODE',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type SupplierBranchWhereClause = {
  /** Filter entries based on the current active state. See the `WhereActive`-enum for more information. */
  active?: InputMaybe<WhereActive>;
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were deactivated. */
  deactivated?: InputMaybe<StampedEventConstraints>;
  /** Filters the entries by the meta-data about the moment they were soft-deleted. */
  deleted?: InputMaybe<StampedEventConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters on the total amount of products that this `SupplierBranch` supplies. */
  totalSuppliedProducts?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A paged connection with `SupplierEdge` edges to `Supplier` nodes.
 *
 * This type was automatically generated from the `SupplierEdge` edge-type for the
 * `Product.suppliers` field. (It might be possible that it is reused by other fields.)
 */
export type SupplierConnection = Connection & ConnectionWithTotal & {
  __typename: 'SupplierConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<SupplierEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Supplier>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `SupplierConnection` connection that points to a `Supplier` node.
 *
 * This type was automatically generated from the `Supplier` node-type of the
 * `Product.suppliers` field. (It might be possible that it is reused by other fields.)
 */
export type SupplierEdge = Edge & {
  __typename: 'SupplierEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: Supplier;
};

/**
 * Specifies how the edges to a `Supplier` will be ordered in a connection.
 *
 * This type was automatically generated from the `SupplierOrderByColumn` column-type used in the
 * `orderBy` argument of the `Product.suppliers` field. (It might be possible that it is reused by
 * other fields.)
 */
export type SupplierOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: SupplierOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `SupplierOrderByColumn`. */
export enum SupplierOrderByColumn {
  AddressLine_1 = 'ADDRESS_LINE_1',
  AddressLine_2 = 'ADDRESS_LINE_2',
  AdministrativeArea = 'ADMINISTRATIVE_AREA',
  /** Orders by the reference that the customer uses. */
  ClientRef = 'CLIENT_REF',
  Country = 'COUNTRY',
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which an entity was deactivated. */
  DeactivatedAt = 'DEACTIVATED_AT',
  /** Orders by the moment on which the entities were deleted. */
  DeletedAt = 'DELETED_AT',
  DependentLocality = 'DEPENDENT_LOCALITY',
  Locality = 'LOCALITY',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  PostalCode = 'POSTAL_CODE',
  SortingCode = 'SORTING_CODE',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

/** Represents the reliability segment of a `SupplierBranch`. */
export type SupplierReliability = AnalysisEntryPredicate & Named & Node & Predicate & Selectable & Sluggable & Usable & {
  __typename: 'SupplierReliability';
  /**
   * The default value for a node that has no explicit value for this predicate set.
   *
   * See the `Predicate.defaultPredicateValue` field for more information.
   */
  defaultPredicateValue?: Maybe<PredicateValue>;
  /**
   * A longer, plain-text value that helps the user to identify this node. When a collection of these nodes are
   * full-text searchable, it will also search over the values in this field.
   *
   * It is always safe to show in the GUI.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   */
  id: Scalars['ID']['output'];
  /** Checks whether this `SupplierReliability` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `SupplierReliability` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `SupplierReliability` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `SupplierReliability` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the node, which should be enough for the user that is familiar with the data to identify this node.
   *
   * It is always safe to show in the GUI.
   */
  name?: Maybe<Name>;
  /**
   * An HTML-formatted field with a closed-form question to the user to explain the predicate.
   *
   * This value is always safe to show in the GUI.
   *
   * See the `Predicate.predicateQuestion` field for more information.
   */
  predicateQuestion?: Maybe<Scalars['HTML']['output']>;
  /**
   * The `slug`, which is an *url-* and *filename-*safe string that uniquely identifies a node with a specific type.
   * It's value is usually derived from the initial data of the node (so the data it had when it was created).
   *
   * There are some important differences with the `id`-field:
   * 1. The value of `id` is always set, the value of `slug` might sometimes be `null` even if the node itself does
   *    exists. This happens for instance when the node is soft-deleted.
   * 2. The value of `id` is globally unique, the value of `slug` is only unique in combination with the `__typename`.
   * 3. The value of `id` always refers to the **current node and only the current node**. The value of `slug` might
   *    refer to a different node over time. (Example: when an old node is soft-deleted and a new node with the same
   *    name is created. The new node will have the same `slug`-value as the older node.)
   * 4. The `slug` is guaranteed to be *url-* and *filename-*safe. The `id`-field does not have these guarantees.
   *
   * When available, prefer the `slug`-field over the `id`-field for usage in urls. For caching and communication with
   * the api, you should always use the `id`-field over the `slug`-field.
   */
  slug?: Maybe<Scalars['Slug']['output']>;
  /** Connection to the verification configuration rules that use this predicate. */
  usedByVerificationConfigurationRules?: Maybe<VerificationConfigurationRuleConnection>;
  /** Connection to the verification configurations that use this verification predicate. */
  usedByVerificationConfigurations?: Maybe<VerificationConfigurationConnection>;
};


/** Represents the reliability segment of a `SupplierBranch`. */
export type SupplierReliabilityIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


/** Represents the reliability segment of a `SupplierBranch`. */
export type SupplierReliabilityIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


/** Represents the reliability segment of a `SupplierBranch`. */
export type SupplierReliabilityUsedByVerificationConfigurationRulesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationRuleOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationRuleWhereClause>>;
};


/** Represents the reliability segment of a `SupplierBranch`. */
export type SupplierReliabilityUsedByVerificationConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationWhereClause>>;
};

export type SupplierReliabilityConnection = Connection & ConnectionWithTotal & {
  __typename: 'SupplierReliabilityConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<SupplierReliabilityEdge>>>;
  /** The nodes in this connection. (Same as `edges.node`) */
  nodes: Array<Maybe<SupplierReliability>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type SupplierReliabilityEdge = Edge & {
  __typename: 'SupplierReliabilityEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node at the end of this edge. */
  node: SupplierReliability;
};

/** Represents the reliability of a SupplierBranch. */
export enum SupplierReliabilityValue {
  High = 'HIGH',
  Low = 'LOW',
  Middle = 'MIDDLE'
}

export type SupplierWhereClause = {
  /** Filter entries based on the current active state. See the `WhereActive`-enum for more information. */
  active?: InputMaybe<WhereActive>;
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on the reference that the customer uses. */
  clientRefIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were deactivated. */
  deactivated?: InputMaybe<StampedEventConstraints>;
  /** Filters the entries by the meta-data about the moment they were soft-deleted. */
  deleted?: InputMaybe<StampedEventConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SyncUserTeamRolesInput = {
  /** The roles for this user in the team. The user will be removed from the team when an empty array is provided. */
  roles: Array<TeamRole>;
  /** The id of the user. */
  userId: Scalars['ID']['input'];
};

export type Tag = Named & Node & Ownable & Selectable & Timestamped & Usable & Userstamped & {
  __typename: 'Tag';
  color?: Maybe<Color>;
  /** Gives the `DateTime` on which this `Tag`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `Tag`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _updated_ this `Tag`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  icon?: Maybe<TagIcon>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `Tag`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Tag` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Tag` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Tag` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `Tag` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `Tag`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Tag` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Tag` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Tag` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `Tag` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Name>;
  /** A reference to the owner that owns this `Tag`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `Tag` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /** Gives the most recent moment on which this `Tag`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type TagIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type TagIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type TagIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type TagIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type TagIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type TagIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type TagOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};

/**
 * A paged connection with `TagEdge` edges to `Tag` nodes.
 *
 * This type was automatically generated from the `TagEdge` edge-type for the
 * `AnalysisReport.tags` field. (It might be possible that it is reused by other fields.)
 */
export type TagConnection = Connection & ConnectionWithTotal & {
  __typename: 'TagConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<TagEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Tag>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `TagConnection` connection that points to a `Tag` node.
 *
 * This type was automatically generated from the `Tag` node-type of the
 * `AnalysisReport.tags` field. (It might be possible that it is reused by other fields.)
 */
export type TagEdge = Edge & {
  __typename: 'TagEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: Tag;
};

/** The icon for a tag. Each GUI should map these values to icons. */
export enum TagIcon {
  Asterisk = 'ASTERISK',
  Bookmark = 'BOOKMARK',
  Box = 'BOX',
  Calendar = 'CALENDAR',
  Clock = 'CLOCK',
  Cloud = 'CLOUD',
  Code = 'CODE',
  Database = 'DATABASE',
  File = 'FILE',
  Flag = 'FLAG',
  Folder = 'FOLDER',
  Hashtag = 'HASHTAG',
  Heart = 'HEART',
  Megaphone = 'MEGAPHONE',
  Star = 'STAR',
  Verified = 'VERIFIED'
}

/**
 * Specifies how the edges to a `Tag` will be ordered in a connection.
 *
 * This type was automatically generated from the `TagOrderByColumn` column-type used in the
 * `orderBy` argument of the `AnalysisReport.tags` field. (It might be possible that it is reused by
 * other fields.)
 */
export type TagOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: TagOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `TagOrderByColumn`. */
export enum TagOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type TagWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Interface for objects that can have tags assigned to them. */
export type Taggable = {
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** The tags assigned to this node. */
  tags?: Maybe<TagConnection>;
};


/** Interface for objects that can have tags assigned to them. */
export type TaggableTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

export type Team = Activateable & Named & Node & Notifiable & Owner & Selectable & Sluggable & Taggable & Timestamped & Userstamped & {
  __typename: 'Team';
  /**
   * The analysis reports that are owned by this team
   * @deprecated use ownedAnalysisReports instead.
   */
  analysisReports?: Maybe<AnalysisReportConnection>;
  /** Whether this owner can use the provided usable node. */
  canUse?: Maybe<Scalars['Boolean']['output']>;
  /** The company of this team. */
  company?: Maybe<Company>;
  /** Gives the `DateTime` on which this `Team`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `Team`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** Timestamp of when this `Team`-object was deactivated. */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that deactivated this `Team`-object. */
  deactivator?: Maybe<User>;
  /** Connection to the default risk configuration of this team. */
  defaultRiskConfiguration?: Maybe<RiskConfiguration>;
  /** The default verification configuration of this team. */
  defaultVerificationConfiguration?: Maybe<VerificationConfiguration>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _updated_ this `Team`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this `Team`-object is considered to be active. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `Team`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `Team`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** The jobs triggered in context of this team. */
  jobs?: Maybe<JobConnection>;
  /** Connection to the licenses owned by this team. */
  licenses?: Maybe<TeamLicenseConnection>;
  name?: Maybe<Name>;
  /** The notifications for this `Team`-object. */
  notifications?: Maybe<NotificationConnection>;
  /** The analysis reports that are owned by this team */
  ownedAnalysisReports?: Maybe<AnalysisReportConnection>;
  /** Retrieves an owned product using its client ref. */
  ownedProductByClientRef?: Maybe<Product>;
  /** Connection to the product categories that are owned by this team. */
  ownedProductCategories?: Maybe<ProductCategoryConnection>;
  /** Retrieves the products owned by this team. */
  ownedProducts?: Maybe<ProductConnection>;
  /** The question predicates that are usable by this team. */
  ownedQuestionPredicates?: Maybe<QuestionPredicateConnection>;
  ownedRiskColumns?: Maybe<RiskColumnConnection>;
  /** Connection to the risk configurations owned by this team. */
  ownedRiskConfigurations?: Maybe<RiskConfigurationConnection>;
  /** Connection to the threats that are owned by this team. */
  ownedRisks?: Maybe<RiskConnection>;
  /** The supplier branches of the suppliers that are owned by this team. */
  ownedSupplierBranches?: Maybe<SupplierBranchConnection>;
  /** Retrieves an owned supplier of this team using the client reference. */
  ownedSupplierByClientRef?: Maybe<Supplier>;
  /** The suppliers that are owned by this team. */
  ownedSuppliers?: Maybe<SupplierConnection>;
  ownedTags?: Maybe<TagConnection>;
  /** Connection to the threat categories owned by this team. */
  ownedThreatCategories?: Maybe<ThreatCategoryConnection>;
  /** Connection to the risks that are owned by this team. */
  ownedThreats?: Maybe<ThreatConnection>;
  /** The verification actions owned by this team. */
  ownedVerificationActions?: Maybe<VerificationActionConnection>;
  /** The verification configurations that are owned by this team. */
  ownedVerificationConfigurations?: Maybe<VerificationConfigurationConnection>;
  /** The verification predicates owned by this team. */
  ownedVerificationPredicates?: Maybe<VerificationPredicateConnection>;
  /**
   * Retrieves the products owned by this team.
   * @deprecated use ownedProducts instead.
   */
  products?: Maybe<ProductConnection>;
  /**
   * The `slug`, which is an *url-* and *filename-*safe string that uniquely identifies a node with a specific type.
   * It's value is usually derived from the initial data of the node (so the data it had when it was created).
   *
   * There are some important differences with the `id`-field:
   * 1. The value of `id` is always set, the value of `slug` might sometimes be `null` even if the node itself does
   * exists. This happens for instance when the node is soft-deleted.
   * 2. The value of `id` is globally unique, the value of `slug` is only unique in combination with the `__typename`.
   * 3. The value of `id` always refers to the **current node and only the current node**. The value of `slug` might
   * refer to a different node over time. (Example: when an old node is soft-deleted and a new node with the same
   * name is created. The new node will have the same `slug`-value as the older node.)
   * 4. The `slug` is guaranteed to be *url-* and *filename-*safe. The `id`-field does not have these guarantees.
   *
   * When available, prefer the `slug`-field over the `id`-field for usage in urls. For caching and communication with
   * the api, you should always use the `id`-field over the `slug`-field.
   */
  slug?: Maybe<Scalars['Slug']['output']>;
  /**
   * The supplier branches of the suppliers that belong to this team.
   * @deprecated Use `ownedSupplierBranches` instead.
   */
  supplierBranches?: Maybe<SupplierBranchConnection>;
  /**
   * The suppliers that belong to this team.
   * @deprecated Use `ownedSuppliers` instead.
   */
  suppliers?: Maybe<Team_SupplierConnection>;
  /** Connection to the tags that are assigned to this `Team`. */
  tags?: Maybe<TagConnection>;
  /**
   * The type of this team. Used to modify the ui.
   *
   * Each team always has a type, so a `null` value here always means that the current AccessToken is not allowed to
   * see this value.
   * @deprecated Use Team roles instead!
   */
  teamType?: Maybe<TeamType>;
  /**
   * Connection to the threat categories owned by this team.
   * @deprecated use `ownedThreatCategories` instead.
   */
  threatCategories?: Maybe<ThreatCategoryConnection>;
  /** Gives the most recent moment on which this `Team`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  usableAnalysisEntryPredicates?: Maybe<AnalysisEntryPredicateConnection>;
  /** Connection to the product categories that are usable by the entities of this team. */
  usableProductCategories?: Maybe<ProductCategoryConnection>;
  usableProductPredicates?: Maybe<ProductPredicateConnection>;
  /** Retrieves the products that are usable by this team. */
  usableProducts?: Maybe<ProductConnection>;
  /** The question predicates that are usable by this team. */
  usableQuestionPredicates?: Maybe<QuestionPredicateConnection>;
  /** The regions that are usable by this team. */
  usableRegions?: Maybe<RegionConnection>;
  usableRiskColumns?: Maybe<RiskColumnConnection>;
  /** Connection to the risk configurations that are usable by this team. */
  usableRiskConfigurations?: Maybe<RiskConfigurationConnection>;
  /** Connection to the risks that are usable by this team. */
  usableRisks?: Maybe<RiskConnection>;
  /** The supplier branches of the suppliers that are owned by this team. */
  usableSupplierBranches?: Maybe<SupplierBranchConnection>;
  /** The supplier reliabilities that are usable by this team. */
  usableSupplierReliabilities?: Maybe<SupplierReliabilityConnection>;
  /** The suppliers that are usable by this team. */
  usableSuppliers?: Maybe<SupplierConnection>;
  usableTags?: Maybe<TagConnection>;
  /** Connection to the threat categories that are usable by this team. */
  usableThreatCategories?: Maybe<ThreatCategoryConnection>;
  /** Connection to the threats that are usable by this team. */
  usableThreats?: Maybe<ThreatConnection>;
  /** The verification actions that are usable by this team. */
  usableVerificationActions?: Maybe<VerificationActionConnection>;
  /** The verification configurations that can be used by this team. */
  usableVerificationConfigurations?: Maybe<VerificationConfigurationConnection>;
  /** The verification predicates that are usable in the verification configurations of this team. */
  usableVerificationPredicates?: Maybe<VerificationPredicateConnection>;
  /** Connection to the user invitations that can assign some team-role for this team. */
  userInvitations?: Maybe<Team_UserInvitationConnection>;
  /** The users of this team. */
  users?: Maybe<Team_UserConnection>;
  uuid: Scalars['ExternalKey']['output'];
};


export type TeamAnalysisReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AnalysisReportOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<AnalysisReportWhereClause>>;
};


export type TeamCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type TeamIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type TeamIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type TeamJobsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JobOrderByClause>>;
  where?: InputMaybe<Array<JobWhereClause>>;
};


export type TeamLicensesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamLicenseOrderByClause>>;
  where?: InputMaybe<Array<TeamLicenseWhereClause>>;
};


export type TeamNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NotificationOrderByClause>>;
  where?: InputMaybe<Array<NotificationWhereClause>>;
};


export type TeamOwnedAnalysisReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AnalysisReportOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<AnalysisReportWhereClause>>;
};


export type TeamOwnedProductByClientRefArgs = {
  clientRef: Scalars['String']['input'];
};


export type TeamOwnedProductCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductCategoryOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<ProductCategoryWhereClause>>;
};


export type TeamOwnedProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<ProductWhereClause>>;
};


export type TeamOwnedQuestionPredicatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QuestionPredicateOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<QuestionPredicateWhereClause>>;
};


export type TeamOwnedRiskColumnsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskColumnOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<RiskColumnWhereClause>>;
};


export type TeamOwnedRiskConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskConfigurationOrderByClause>>;
  where?: InputMaybe<Array<RiskConfigurationWhereClause>>;
};


export type TeamOwnedRisksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<RiskWhereClause>>;
};


export type TeamOwnedSupplierBranchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SupplierBranchOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<SupplierBranchWhereClause>>;
};


export type TeamOwnedSupplierByClientRefArgs = {
  clientRef: Scalars['String']['input'];
};


export type TeamOwnedSuppliersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SupplierOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<SupplierWhereClause>>;
};


export type TeamOwnedTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<TagWhereClause>>;
};


export type TeamOwnedThreatCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ThreatCategoryOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<ThreatCategoryWhereClause>>;
};


export type TeamOwnedThreatsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ThreatOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<ThreatWhereClause>>;
};


export type TeamOwnedVerificationActionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationActionOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<VerificationActionWhereClause>>;
};


export type TeamOwnedVerificationConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<VerificationConfigurationWhereClause>>;
};


export type TeamOwnedVerificationPredicatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationPredicateOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<VerificationPredicateWhereClause>>;
};


export type TeamProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<ProductWhereClause>>;
};


export type TeamSupplierBranchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SupplierBranchOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<SupplierBranchWhereClause>>;
};


export type TeamSuppliersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SupplierOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<SupplierWhereClause>>;
};


export type TeamTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};


export type TeamThreatCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ThreatCategoryOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<ThreatCategoryWhereClause>>;
};


export type TeamUsableProductCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductCategoryOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<ProductCategoryWhereClause>>;
};


export type TeamUsableProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<ProductWhereClause>>;
};


export type TeamUsableQuestionPredicatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QuestionPredicateOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<QuestionPredicateWhereClause>>;
};


export type TeamUsableRiskColumnsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskColumnOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<RiskColumnWhereClause>>;
};


export type TeamUsableRiskConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskConfigurationOrderByClause>>;
  where?: InputMaybe<Array<RiskConfigurationWhereClause>>;
};


export type TeamUsableRisksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<RiskWhereClause>>;
};


export type TeamUsableSupplierBranchesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SupplierBranchOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<SupplierBranchWhereClause>>;
};


export type TeamUsableSuppliersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SupplierOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<SupplierWhereClause>>;
};


export type TeamUsableTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<TagWhereClause>>;
};


export type TeamUsableThreatCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ThreatCategoryOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<ThreatCategoryWhereClause>>;
};


export type TeamUsableThreatsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ThreatOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<ThreatWhereClause>>;
};


export type TeamUsableVerificationActionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationActionOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<VerificationActionWhereClause>>;
};


export type TeamUsableVerificationConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<VerificationConfigurationWhereClause>>;
};


export type TeamUsableVerificationPredicatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationPredicateOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<VerificationPredicateWhereClause>>;
};


export type TeamUserInvitationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserInvitationOrderByClause>>;
  where?: InputMaybe<Array<UserInvitationWhereClause>>;
};


export type TeamUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A paged connection with `TeamEdge` edges to `Team` nodes.
 *
 * This type was automatically generated from the `TeamEdge` edge-type for the
 * `Company.teams` field. (It might be possible that it is reused by other fields.)
 */
export type TeamConnection = Connection & ConnectionWithTotal & {
  __typename: 'TeamConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<TeamEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Team>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type TeamEdge = Edge & {
  __typename: 'TeamEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node at the end of this edge. */
  node: Team;
};

export type TeamLicense = Activateable & Commentable & Node & Taggable & Timestamped & Userstamped & {
  __typename: 'TeamLicense';
  /** The class of this license. */
  class?: Maybe<TeamLicenseClass>;
  /** The comments for this `TeamLicense`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `TeamLicense`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `TeamLicense`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** Timestamp of when this `TeamLicense`-object was deactivated. */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that deactivated this `TeamLicense`-object. */
  deactivator?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `TeamLicense`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this `TeamLicense`-object is considered to be active. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this `TeamLicense` is expired. */
  isExpired?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `TeamLicense`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `TeamLicense`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this `TeamLicense` is valid. */
  isValid?: Maybe<Scalars['Boolean']['output']>;
  /** Connection to the tags that are assigned to this `TeamLicense`. */
  tags?: Maybe<TagConnection>;
  /** The `Team` that owns this `TeamLicense`. */
  team?: Maybe<Team>;
  /** Gives the most recent moment on which this `TeamLicense`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The moment after which this `TeamLicense` is valid. */
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  /** The moment after which this `TeamLicense` is expired. */
  validTill?: Maybe<Scalars['DateTime']['output']>;
};


export type TeamLicenseCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type TeamLicenseIsExpiredArgs = {
  at?: InputMaybe<Scalars['DateTime']['input']>;
};


export type TeamLicenseIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type TeamLicenseIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type TeamLicenseIsValidArgs = {
  at?: InputMaybe<Scalars['DateTime']['input']>;
};


export type TeamLicenseTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

export type TeamLicenseClass = Named & Node & Selectable & Taggable & Timestamped & Userstamped & {
  __typename: 'TeamLicenseClass';
  /** Gives the `DateTime` on which this `TeamLicenseClass`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `TeamLicenseClass`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** The default length of a valid license of this class. */
  defaultValidityPeriod?: Maybe<Scalars['DateTimeInterval']['output']>;
  /**
   * A longer, plain-text value that helps the user to identify this node. When a collection of these nodes are
   * full-text searchable, it will also search over the values in this field.
   *
   * It is always safe to show in the GUI.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _updated_ this `TeamLicenseClass`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `TeamLicenseClass`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `TeamLicenseClass`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Connection to the `TeamLicenses` of this `TeamLicenseClass`. */
  licenses?: Maybe<TeamLicenseConnection>;
  /**
   * The name of the node, which should be enough for the user that is familiar with the data to identify this node.
   *
   * It is always safe to show in the GUI.
   */
  name?: Maybe<Name>;
  /** Connection to the tags that are assigned to this `TeamLicenseClass`. */
  tags?: Maybe<TagConnection>;
  /** Gives the most recent moment on which this `TeamLicenseClass`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type TeamLicenseClassIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type TeamLicenseClassIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type TeamLicenseClassLicensesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamLicenseOrderByClause>>;
  where?: InputMaybe<Array<TeamLicenseWhereClause>>;
};


export type TeamLicenseClassTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

/**
 * A paged connection with `TeamLicenseClassEdge` edges to `TeamLicenseClass` nodes.
 *
 * This type was automatically generated from the `TeamLicenseClassEdge` edge-type for the
 * `Query.teamLicenseClasses` field. (It might be possible that it is reused by other fields.)
 */
export type TeamLicenseClassConnection = Connection & ConnectionWithTotal & {
  __typename: 'TeamLicenseClassConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<TeamLicenseClassEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<TeamLicenseClass>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `TeamLicenseClassConnection` connection that points to a `TeamLicenseClass` node.
 *
 * This type was automatically generated from the `TeamLicenseClass` node-type of the
 * `Query.teamLicenseClasses` field. (It might be possible that it is reused by other fields.)
 */
export type TeamLicenseClassEdge = Edge & {
  __typename: 'TeamLicenseClassEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: TeamLicenseClass;
};

/**
 * Specifies how the edges to a `TeamLicenseClass` will be ordered in a connection.
 *
 * This type was automatically generated from the `TeamLicenseClassOrderByColumn` column-type used in the
 * `orderBy` argument of the `Query.teamLicenseClasses` field. (It might be possible that it is reused by
 * other fields.)
 */
export type TeamLicenseClassOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: TeamLicenseClassOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `TeamLicenseClassOrderByColumn`. */
export enum TeamLicenseClassOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type TeamLicenseClassWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
};

/**
 * A paged connection with `TeamLicenseEdge` edges to `TeamLicense` nodes.
 *
 * This type was automatically generated from the `TeamLicenseEdge` edge-type for the
 * `Team.licenses` field. (It might be possible that it is reused by other fields.)
 */
export type TeamLicenseConnection = Connection & ConnectionWithTotal & {
  __typename: 'TeamLicenseConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<TeamLicenseEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<TeamLicense>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `TeamLicenseConnection` connection that points to a `TeamLicense` node.
 *
 * This type was automatically generated from the `TeamLicense` node-type of the
 * `Team.licenses` field. (It might be possible that it is reused by other fields.)
 */
export type TeamLicenseEdge = Edge & {
  __typename: 'TeamLicenseEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: TeamLicense;
};

/**
 * Specifies how the edges to a `TeamLicense` will be ordered in a connection.
 *
 * This type was automatically generated from the `TeamLicenseOrderByColumn` column-type used in the
 * `orderBy` argument of the `Team.licenses` field. (It might be possible that it is reused by
 * other fields.)
 */
export type TeamLicenseOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: TeamLicenseOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `TeamLicenseOrderByColumn`. */
export enum TeamLicenseOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which an entity was deactivated. */
  DeactivatedAt = 'DEACTIVATED_AT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT',
  ValidFrom = 'VALID_FROM',
  ValidTill = 'VALID_TILL'
}

export type TeamLicenseWhereClause = {
  /** Filter entries based on the current active state. See the `WhereActive`-enum for more information. */
  active?: InputMaybe<WhereActive>;
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were deactivated. */
  deactivated?: InputMaybe<StampedEventConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the team license is active. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the license has expired at this moment. */
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches only licenses that are expired at the provided moment. */
  isExpiredAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters on whether the license is valid at this moment. */
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches only licenses that are valid at the provided moment. */
  isValidAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
};

/**
 * Specifies how the edges to a `Team` will be ordered in a connection.
 *
 * This type was automatically generated from the `TeamOrderByColumn` column-type used in the
 * `orderBy` argument of the `Company.teams` field. (It might be possible that it is reused by
 * other fields.)
 */
export type TeamOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: TeamOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `TeamOrderByColumn`. */
export enum TeamOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which an entity was deactivated. */
  DeactivatedAt = 'DEACTIVATED_AT',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

/**
 * The explicit roles that can be assigned for a `User` in the context of a `Team`.
 *
 * An `AccessToken` only has access to the permissions of these roles if it has both the `User`
 * and the `Team` to which the role was assigned.
 */
export enum TeamRole {
  /** ### Consultant *[Team]* */
  Cs = 'CS',
  /** ### Inkoper *[Team]* */
  Ink = 'INK',
  /** ### Kwaliteitsverantwoordelijke *[Team]* */
  Kv = 'KV',
  /** ### Team Administrator *[Team]* */
  TeamAdmin = 'TEAM_ADMIN',
  /**
   * ### Gast in Team *[Team]*
   *
   * Mag alleen de naam van het team zien.
   */
  TeamGuest = 'TEAM_GUEST',
  /**
   * ### Lezer van Team *[Team]*
   *
   * Mag alle gegevens van het team bekijken, maar niet bewerken.
   */
  TeamReader = 'TEAM_READER'
}

/** Represents the different types of teams. */
export enum TeamType {
  /** Teams of this type handle the master-administration of the whole Précon-system. */
  Administrators = 'ADMINISTRATORS',
  Common = 'COMMON',
  /** Teams of this type should only manage their owned entities. */
  Consumers = 'CONSUMERS',
  /** Team used by developers. */
  Developers = 'DEVELOPERS',
  /** Teams of this type can only read. */
  Guests = 'GUESTS',
  /** Teams of this type write the global entities. */
  Redaction = 'REDACTION'
}

export type TeamWhereClause = {
  /** Filter entries based on the current active state. See the `WhereActive`-enum for more information. */
  active?: InputMaybe<WhereActive>;
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were deactivated. */
  deactivated?: InputMaybe<StampedEventConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the total amount of related items they have in the relation `analysisReports`. */
  totalAnalysisReports?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `ownedAnalysisReports`. */
  totalOwnedAnalysisReports?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `ownedProductCategories`. */
  totalOwnedProductCategories?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `ownedProducts`. */
  totalOwnedProducts?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `ownedQuestionPredicates`. */
  totalOwnedQuestionPredicates?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `ownedRiskColumns`. */
  totalOwnedRiskColumns?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `ownedRiskConfigurations`. */
  totalOwnedRiskConfigurations?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `ownedRisks`. */
  totalOwnedRisks?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `ownedSupplierBranches`. */
  totalOwnedSupplierBranches?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `ownedSuppliers`. */
  totalOwnedSuppliers?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `ownedThreatCategories`. */
  totalOwnedThreatCategories?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `ownedThreats`. */
  totalOwnedThreats?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `ownedVerificationActions`. */
  totalOwnedVerificationActions?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `ownedVerificationConfigurations`. */
  totalOwnedVerificationConfigurations?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `ownedVerificationPredicates`. */
  totalOwnedVerificationPredicates?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `productCategories`. */
  totalProductCategories?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `products`. */
  totalProducts?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `riskConfigurations`. */
  totalRiskConfigurations?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `supplierBranches`. */
  totalSupplierBranches?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `suppliers`. */
  totalSuppliers?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `threatCategories`. */
  totalThreatCategories?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usableProductCategories`. */
  totalUsableProductCategories?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usableProducts`. */
  totalUsableProducts?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usableQuestionPredicates`. */
  totalUsableQuestionPredicates?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usableRiskConfigurations`. */
  totalUsableRiskConfigurations?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usableRisks`. */
  totalUsableRisks?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usableSuppliers`. */
  totalUsableSuppliers?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usableThreatCategories`. */
  totalUsableThreatCategories?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usableThreats`. */
  totalUsableThreats?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usableVerificationActions`. */
  totalUsableVerificationActions?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usableVerificationConfigurations`. */
  totalUsableVerificationConfigurations?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usableVerificationPredicates`. */
  totalUsableVerificationPredicates?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `userInvitations`. */
  totalUserInvitations?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `verificationActions`. */
  totalVerificationActions?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `verificationConfigurations`. */
  totalVerificationConfigurations?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `verificationPredicates`. */
  totalVerificationPredicates?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
};

export type Team_ProductConnection = Connection & ConnectionWithTotal & {
  __typename: 'Team_ProductConnection';
  /**
   * Gets the product connected to this team using the `Product.clientRef` field.
   *
   * ### TODO: Not implemented
   *
   * *This feature is not (fully) implemented yet!*
   */
  byClientRef?: Maybe<Team_ProductEdge>;
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<Team_ProductEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Product>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type Team_ProductConnectionByClientRefArgs = {
  clientRef: Scalars['String']['input'];
};

export type Team_ProductEdge = Edge & {
  __typename: 'Team_ProductEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node at the end of this edge. */
  node: Product;
};

export type Team_RiskConfigurationConnection = Connection & ConnectionWithTotal & {
  __typename: 'Team_RiskConfigurationConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<Team_RiskConfigurationEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<RiskConfiguration>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The default risk-configuration for this team. */
  teamDefault?: Maybe<Team_RiskConfigurationEdge>;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Team_RiskConfigurationEdge = Edge & {
  __typename: 'Team_RiskConfigurationEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node at the end of this edge. */
  node: RiskConfiguration;
  /** Whether the `RiskConfiguration` of `node` is owned by the team at the start of this edge. */
  selfOwned?: Maybe<Scalars['Boolean']['output']>;
};

export type Team_SupplierConnection = Connection & ConnectionWithTotal & {
  __typename: 'Team_SupplierConnection';
  /**
   * Gets the product connected to this team using the `Supplier.clientRef` field.
   *
   * ### TODO: Not implemented
   *
   * *This feature is not (fully) implemented yet!*
   */
  byClientRef?: Maybe<Team_SupplierEdge>;
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<Team_SupplierEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Supplier>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};


export type Team_SupplierConnectionByClientRefArgs = {
  clientRef: Scalars['String']['input'];
};

export type Team_SupplierEdge = Edge & {
  __typename: 'Team_SupplierEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node at the end of this edge. */
  node: Supplier;
};

export type Team_UserConnection = Connection & ConnectionWithTotal & {
  __typename: 'Team_UserConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<Team_UserEdge>>>;
  /**
   * Edge to the user from the current access token.
   *
   * Will be `null` in the following cases:
   * - There is no access token.
   * - The current access token has no user.
   * - The current user is not in this team.
   */
  me?: Maybe<Team_UserEdge>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Team_UserEdge = Edge & {
  __typename: 'Team_UserEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /** Checks if the user from `node` has the provided role. (This includes implied roles.) */
  hasRole?: Maybe<Scalars['Boolean']['output']>;
  /** The user at the end of this edge. */
  node?: Maybe<User>;
  /** The roles that the user from `node` has in team at the root of this edge. */
  roles?: Maybe<Array<TeamRole>>;
};


export type Team_UserEdgeHasRoleArgs = {
  role: TeamRole;
};

export type Team_UserInvitationConnection = Connection & ConnectionWithTotal & {
  __typename: 'Team_UserInvitationConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<Team_UserInvitationEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<UserInvitation>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Team_UserInvitationEdge = Edge & {
  __typename: 'Team_UserInvitationEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /**
   * The node at the end of this edge.
   *
   * This value is `null` iff the current access token has no permission to see the value of this node, but does have
   * the permission to see the values on the edges.
   */
  node?: Maybe<UserInvitation>;
  /** The team role that a user will gain after accepting the invitation at the end of this edge. */
  roles?: Maybe<Array<TeamRole>>;
};

export type Team_UserWhereClause = {
  hasRoles?: InputMaybe<Array<Role>>;
};

export type Team_VerificationConfigurationConnection = Connection & ConnectionWithTotal & {
  __typename: 'Team_VerificationConfigurationConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<Team_VerificationConfigurationEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<VerificationConfiguration>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The default verification configuration used by the `Team` at the start of this connection. */
  teamDefault?: Maybe<Team_VerificationConfigurationEdge>;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Team_VerificationConfigurationEdge = Edge & {
  __typename: 'Team_VerificationConfigurationEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node at the end of this edge. */
  node: VerificationConfiguration;
  /** Whether the `VerificationConfiguration` of `node` is owned by the team at the start of this edge. */
  selfOwned?: Maybe<Scalars['Boolean']['output']>;
};

export enum TenantUserType {
  Guest = 'GUEST',
  Member = 'MEMBER'
}

export type Threat = Activateable & Commentable & Named & Node & Ownable & Selectable & Sluggable & SoftDelete & SoftDeleteUserstamped & Taggable & Timestamped & Usable & Userstamped & {
  __typename: 'Threat';
  /** The comments for this `Threat`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `Threat`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `Threat`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** Timestamp of when this `Threat`-object was deactivated. */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that deactivated this `Threat`-object. */
  deactivator?: Maybe<User>;
  /** Gives the moment on which this `Threat`-object was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _deleted_ this `Threat`-object.
   *
   * When this field is `null`, it can be the case that this object was not deleted or not deleted by a `User`. It will also
   * be `null` when the current user is not allowed to see the `User` that deleted this object.
   */
  destroyer?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `Threat`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this `Threat`-object is considered to be active. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `Threat`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Threat` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Threat` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Threat` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `Threat` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `Threat`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Threat` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Threat` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `Threat` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `Threat` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Name>;
  /** A reference to the owner that owns this `Threat`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `Threat` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Extra information about the threat that is available for all users that can see this treat. This is the *ALGEMEEN*
   * -field in the legacy data-model.
   *
   * This field is *HUMAN-TEXT* and has no side-effects on the semantics of the data-model.
   */
  publicInfo?: Maybe<Scalars['HTML']['output']>;
  /** The risk configurations that have severity values for this `Threat`. */
  riskConfigurations?: Maybe<Threat_RiskConfigurationConnection>;
  /** The `Risk`s of this `Threat`. */
  risks?: Maybe<RiskConnection>;
  /**
   * The `slug`, which is an *url-* and *filename-*safe string that uniquely identifies a node with a specific type.
   * It's value is usually derived from the initial data of the node (so the data it had when it was created).
   *
   * There are some important differences with the `id`-field:
   * 1. The value of `id` is always set, the value of `slug` might sometimes be `null` even if the node itself does
   * exists. This happens for instance when the node is soft-deleted.
   * 2. The value of `id` is globally unique, the value of `slug` is only unique in combination with the `__typename`.
   * 3. The value of `id` always refers to the **current node and only the current node**. The value of `slug` might
   * refer to a different node over time. (Example: when an old node is soft-deleted and a new node with the same
   * name is created. The new node will have the same `slug`-value as the older node.)
   * 4. The `slug` is guaranteed to be *url-* and *filename-*safe. The `id`-field does not have these guarantees.
   *
   * When available, prefer the `slug`-field over the `id`-field for usage in urls. For caching and communication with
   * the api, you should always use the `id`-field over the `slug`-field.
   */
  slug?: Maybe<Scalars['Slug']['output']>;
  /** Connection to the tags that are assigned to this `Threat`. */
  tags?: Maybe<TagConnection>;
  /** The `ThreatCategory` to which this `Threat` belongs. */
  threatCategory?: Maybe<ThreatCategory>;
  /** Will be `true` if this `Threat` is soft-deleted, `false` otherwise. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** Gives the most recent moment on which this `Threat`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ThreatCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type ThreatIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type ThreatIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type ThreatIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type ThreatIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type ThreatIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type ThreatIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type ThreatOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type ThreatRiskConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskConfigurationOrderByClause>>;
  where?: InputMaybe<Array<RiskConfigurationWhereClause>>;
};


export type ThreatRisksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskOrderByClause>>;
  where?: InputMaybe<Array<RiskWhereClause>>;
};


export type ThreatTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

/** An `Audit`-node that tracks mutations of a `Threat`-node. */
export type ThreatAudit = Audit & Commentable & Node & Ownable & Taggable & Timestamped & Userstamped & {
  __typename: 'ThreatAudit';
  /** The comments for this `ThreatAudit`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `ThreatAudit`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `ThreatAudit`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** The client-application that the `creator` used at the moment when he/she generated this `ThreatAudit`. */
  creatorClient?: Maybe<Client>;
  /** The IP-address of the `creator` at the moment when he/she generated this `ThreatAudit`. */
  creatorIpAddress?: Maybe<Scalars['IpAddress']['output']>;
  /**
   * The team of the `creator` at the moment when he/she generated this `ThreatAudit`.
   *
   * See the `Audit.creator`-field for more information.
   */
  creatorTeam?: Maybe<Team>;
  /** The user-agent of the `creator` at the moment when he/she generated this `ThreatAudit`-node. */
  creatorUserAgent?: Maybe<Scalars['UserAgent']['output']>;
  /**
   * Gives the `User` that _updated_ this `ThreatAudit`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /** The event type for which this `ThreatAudit` was generated. */
  event?: Maybe<AuditedEvent>;
  /**
   * The name of the GraphQL operation that was responsible for this `ThreatAudit`-node.
   *
   * Use this value in combination with the `client`-field to derive how this audit was created.
   */
  graphqlOperation?: Maybe<Scalars['String']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `ThreatAudit`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ThreatAudit` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ThreatAudit` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ThreatAudit` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `ThreatAudit` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `ThreatAudit`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** The threat category after the mutation was executed. */
  newThreatCategory?: Maybe<ThreatCategory>;
  /** The threat category before the mutation was executed. */
  oldThreatCategory?: Maybe<ThreatCategory>;
  /** A reference to the owner that owns this `ThreatAudit`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `ThreatAudit` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /** An HTML-formatted text containing some remarks about the mutation that generated this `ThreatAudit`. */
  remarks?: Maybe<Scalars['HTML']['output']>;
  /** Connection to the tags that are assigned to this `ThreatAudit`. */
  tags?: Maybe<TagConnection>;
  /** The threat that was affected by the mutation. */
  threat?: Maybe<Threat>;
  /**
   * Whether the mutation represented by this `Audit`-node changed the `threatCategory` of the threat in the
   * `ThreatAudit.threat` field.
   *
   * This property implies that `ThreatAudit.oldThreatCategory == ThreatAudit.newThreatCategory`. Note that this
   * property is available, even if the current access token is not allowed to read the parent.
   */
  threatCategoryChanged?: Maybe<Scalars['Boolean']['output']>;
  /** Gives the most recent moment on which this `ThreatAudit`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** An `Audit`-node that tracks mutations of a `Threat`-node. */
export type ThreatAuditCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


/** An `Audit`-node that tracks mutations of a `Threat`-node. */
export type ThreatAuditIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** An `Audit`-node that tracks mutations of a `Threat`-node. */
export type ThreatAuditIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


/** An `Audit`-node that tracks mutations of a `Threat`-node. */
export type ThreatAuditIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


/** An `Audit`-node that tracks mutations of a `Threat`-node. */
export type ThreatAuditIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** An `Audit`-node that tracks mutations of a `Threat`-node. */
export type ThreatAuditOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


/** An `Audit`-node that tracks mutations of a `Threat`-node. */
export type ThreatAuditTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

/**
 * A paged connection with `ThreatAuditEdge` edges to `ThreatAudit` nodes.
 *
 * This type was automatically generated from the `ThreatAuditEdge` edge-type for the
 * `Query.threatAudits` field. (It might be possible that it is reused by other fields.)
 */
export type ThreatAuditConnection = Connection & ConnectionWithTotal & {
  __typename: 'ThreatAuditConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<ThreatAuditEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<ThreatAudit>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `ThreatAuditConnection` connection that points to a `ThreatAudit` node.
 *
 * This type was automatically generated from the `ThreatAudit` node-type of the
 * `Query.threatAudits` field. (It might be possible that it is reused by other fields.)
 */
export type ThreatAuditEdge = Edge & {
  __typename: 'ThreatAuditEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: ThreatAudit;
};

/**
 * Specifies how the edges to a `ThreatAudit` will be ordered in a connection.
 *
 * This type was automatically generated from the `ThreatAuditOrderByColumn` column-type used in the
 * `orderBy` argument of the `Query.threatAudits` field. (It might be possible that it is reused by
 * other fields.)
 */
export type ThreatAuditOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: ThreatAuditOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `ThreatAuditOrderByColumn`. */
export enum ThreatAuditOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type ThreatAuditWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters on the event type of the audit entry. */
  event?: InputMaybe<AuditedEvent>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ThreatCategory = Commentable & Named & NestedSetNode & Node & Ownable & Selectable & SoftDelete & SoftDeleteUserstamped & Taggable & Timestamped & Usable & Userstamped & {
  __typename: 'ThreatCategory';
  /**
   * The ancestors of this `ThreatCategory`-node are all the parents, parents of parents etc.
   *
   * > This field is part of the `NestedSetNode`-behavior of `ThreatCategory` and was added by the
   * > `NestedSetMixin`. See the `NestedSetNode`-interface for more information.
   */
  ancestors?: Maybe<ThreatCategoryConnection>;
  /**
   * Union of all descendants and siblings of this `ThreatCategory`.
   *
   * This connection always contains this `ThreatCategory` itself.
   *
   * > This field is part of the `NestedSetNode`-behavior of `ThreatCategory` and was added by the
   * > `NestedSetMixin`. See the `NestedSetNode`-interface for more information.
   */
  bloodline?: Maybe<ThreatCategoryConnection>;
  /**
   * The direct children of this `ThreatCategory`.
   *
   * > This field is part of the `NestedSetNode`-behavior of `ThreatCategory` and was added by the
   * > `NestedSetMixin`. See the `NestedSetNode`-interface for more information.
   */
  children?: Maybe<ThreatCategoryConnection>;
  /** The comments for this `ThreatCategory`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `ThreatCategory`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `ThreatCategory`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** Gives the moment on which this `ThreatCategory`-object was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The depth of this `ThreatCategory`-object in its nested set as an integer.
   *
   * The following rules hold for this value:
   * - `depth == 0` **iff** `isRoot == true`
   * - `depth == parentKey.depth + 1`
   *
   * Therefore, you could also see this value *the amount of ancestors* of this object in the tree.
   *
   * > This field is part of the `NestedSetNode`-behavior of `ThreatCategory` and was added by the
   * > `NestedSetMixin`. See the `NestedSetNode`-interface for more information.
   */
  depth?: Maybe<Scalars['Int']['output']>;
  /**
   * The descendants of this `ThreatCategory`-node are all the children, children of children etc.
   *
   * > This field is part of the `NestedSetNode`-behavior of `ThreatCategory` and was added by the
   * > `NestedSetMixin`. See the `NestedSetNode`-interface for more information.
   */
  descendants?: Maybe<ThreatCategoryConnection>;
  /** A short description of this `ThreatCategory`. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _deleted_ this `ThreatCategory`-object.
   *
   * When this field is `null`, it can be the case that this object was not deleted or not deleted by a `User`. It will also
   * be `null` when the current user is not allowed to see the `User` that deleted this object.
   */
  destroyer?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `ThreatCategory`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Wheter this `ThreatCategory` is a *leaf*-node (or in other words, it has no children.)
   *
   * > This field is part of the `NestedSetNode`-behavior of `ThreatCategory` and was added by the
   * > `NestedSetMixin`. See the `NestedSetNode`-interface for more information.
   */
  isLeaf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `ThreatCategory`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ThreatCategory` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ThreatCategory` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ThreatCategory` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `ThreatCategory` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Wheter this `ThreatCategory` is a *root*-node (or in other words, when it has no parents.)
   *
   * > This field is part of the `NestedSetNode`-behavior of `ThreatCategory` and was added by the
   * > `NestedSetMixin`. See the `NestedSetNode`-interface for more information.
   */
  isRoot?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `ThreatCategory`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ThreatCategory` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ThreatCategory` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ThreatCategory` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `ThreatCategory` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of this `ThreatCategory`.
   *
   * This value is always safe to display in a GUI.
   */
  name?: Maybe<Name>;
  /** A reference to the owner that owns this `ThreatCategory`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `ThreatCategory` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The direct parent of this `ThreatCategory`.
   *
   * > This field is part of the `NestedSetNode`-behavior of `ThreatCategory` and was added by the
   * > `NestedSetMixin`. See the `NestedSetNode`-interface for more information.
   */
  parent?: Maybe<ThreatCategory>;
  /**
   * The siblings of this `ThreatCategory`. These the nodes that have the same parentKey as the current node, excluding
   * the current node itself.
   *
   * > This field is part of the `NestedSetNode`-behavior of `ThreatCategory` and was added by the
   * > `NestedSetMixin`. See the `NestedSetNode`-interface for more information.
   */
  siblings?: Maybe<ThreatCategoryConnection>;
  /** Connection to the tags that are assigned to this `ThreatCategory`. */
  tags?: Maybe<TagConnection>;
  /** The threats in this `ThreatCategory`. */
  threats?: Maybe<ThreatConnection>;
  /** Will be `true` if this `ThreatCategory` is soft-deleted, `false` otherwise. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** Gives the most recent moment on which this `ThreatCategory`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ThreatCategoryAncestorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ThreatCategoryOrderByClause>>;
  self?: InputMaybe<NestedSetIncludeSelf>;
  where?: InputMaybe<Array<ThreatCategoryWhereClause>>;
};


export type ThreatCategoryBloodlineArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ThreatCategoryOrderByClause>>;
  where?: InputMaybe<Array<ThreatCategoryWhereClause>>;
};


export type ThreatCategoryChildrenArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ThreatCategoryOrderByClause>>;
  where?: InputMaybe<Array<ThreatCategoryWhereClause>>;
};


export type ThreatCategoryCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type ThreatCategoryDescendantsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ThreatCategoryOrderByClause>>;
  self?: InputMaybe<NestedSetIncludeSelf>;
  where?: InputMaybe<Array<ThreatCategoryWhereClause>>;
};


export type ThreatCategoryIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type ThreatCategoryIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type ThreatCategoryIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type ThreatCategoryIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type ThreatCategoryIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type ThreatCategoryIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type ThreatCategoryOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type ThreatCategorySiblingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ThreatCategoryOrderByClause>>;
  self?: InputMaybe<NestedSetIncludeSelf>;
  where?: InputMaybe<Array<ThreatCategoryWhereClause>>;
};


export type ThreatCategoryTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};


export type ThreatCategoryThreatsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ThreatOrderByClause>>;
  where?: InputMaybe<Array<ThreatWhereClause>>;
};

/** An `Audit`-node that tracks a mutation of a `ThreatCategory`. */
export type ThreatCategoryAudit = Audit & Commentable & Node & Ownable & Taggable & Timestamped & Userstamped & {
  __typename: 'ThreatCategoryAudit';
  /** The comments for this `ThreatCategoryAudit`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `ThreatCategoryAudit`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `ThreatCategoryAudit`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** The client-application that the `creator` used at the moment when he/she generated this `ThreatCategoryAudit`. */
  creatorClient?: Maybe<Client>;
  /** The IP-address of the `creator` at the moment when he/she generated this `ThreatCategoryAudit`. */
  creatorIpAddress?: Maybe<Scalars['IpAddress']['output']>;
  /**
   * The team of the `creator` at the moment when he/she generated this `ThreatCategoryAudit`.
   *
   * See the `Audit.creator`-field for more information.
   */
  creatorTeam?: Maybe<Team>;
  /** The user-agent of the `creator` at the moment when he/she generated this `ThreatCategoryAudit`-node. */
  creatorUserAgent?: Maybe<Scalars['UserAgent']['output']>;
  /**
   * Gives the `User` that _updated_ this `ThreatCategoryAudit`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /** The event type for which this `ThreatCategoryAudit` was generated. */
  event?: Maybe<AuditedEvent>;
  /**
   * The name of the GraphQL operation that was responsible for this `ThreatCategoryAudit`-node.
   *
   * Use this value in combination with the `client`-field to derive how this audit was created.
   */
  graphqlOperation?: Maybe<Scalars['String']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `ThreatCategoryAudit`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ThreatCategoryAudit` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ThreatCategoryAudit` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ThreatCategoryAudit` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `ThreatCategoryAudit` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `ThreatCategoryAudit`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** The parent of the threat category after the mutation was executed. */
  newParent?: Maybe<ThreatCategory>;
  /** The parent of the threat category before the mutation was executed. */
  oldParent?: Maybe<ThreatCategory>;
  /** A reference to the owner that owns this `ThreatCategoryAudit`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `ThreatCategoryAudit` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the mutation represented by this `Audit`-node changed the parent of the product category in the
   * `ThreatCategoryAudit.productCategory` field.
   *
   * This property implies that `ThreatCategoryAudit.oldParent == ThreatCategoryAudit.newParent`. Note that this
   * property is available, even if the current access token is not allowed to read the parent.
   */
  parentChanged?: Maybe<Scalars['Boolean']['output']>;
  /** An HTML-formatted text containing some remarks about the mutation that generated this `ThreatCategoryAudit`. */
  remarks?: Maybe<Scalars['HTML']['output']>;
  /** Connection to the tags that are assigned to this `ThreatCategoryAudit`. */
  tags?: Maybe<TagConnection>;
  /** The threat category for which this `Audit`-node was generated. */
  threatCategory?: Maybe<ThreatCategory>;
  /** Gives the most recent moment on which this `ThreatCategoryAudit`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** An `Audit`-node that tracks a mutation of a `ThreatCategory`. */
export type ThreatCategoryAuditCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


/** An `Audit`-node that tracks a mutation of a `ThreatCategory`. */
export type ThreatCategoryAuditIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** An `Audit`-node that tracks a mutation of a `ThreatCategory`. */
export type ThreatCategoryAuditIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


/** An `Audit`-node that tracks a mutation of a `ThreatCategory`. */
export type ThreatCategoryAuditIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


/** An `Audit`-node that tracks a mutation of a `ThreatCategory`. */
export type ThreatCategoryAuditIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** An `Audit`-node that tracks a mutation of a `ThreatCategory`. */
export type ThreatCategoryAuditOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


/** An `Audit`-node that tracks a mutation of a `ThreatCategory`. */
export type ThreatCategoryAuditTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

/**
 * A paged connection with `ThreatCategoryAuditEdge` edges to `ThreatCategoryAudit` nodes.
 *
 * This type was automatically generated from the `ThreatCategoryAuditEdge` edge-type for the
 * `Query.threatCategoryAudits` field. (It might be possible that it is reused by other fields.)
 */
export type ThreatCategoryAuditConnection = Connection & ConnectionWithTotal & {
  __typename: 'ThreatCategoryAuditConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<ThreatCategoryAuditEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<ThreatCategoryAudit>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `ThreatCategoryAuditConnection` connection that points to a `ThreatCategoryAudit` node.
 *
 * This type was automatically generated from the `ThreatCategoryAudit` node-type of the
 * `Query.threatCategoryAudits` field. (It might be possible that it is reused by other fields.)
 */
export type ThreatCategoryAuditEdge = Edge & {
  __typename: 'ThreatCategoryAuditEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: ThreatCategoryAudit;
};

/**
 * Specifies how the edges to a `ThreatCategoryAudit` will be ordered in a connection.
 *
 * This type was automatically generated from the `ThreatCategoryAuditOrderByColumn` column-type used in the
 * `orderBy` argument of the `Query.threatCategoryAudits` field. (It might be possible that it is reused by
 * other fields.)
 */
export type ThreatCategoryAuditOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: ThreatCategoryAuditOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `ThreatCategoryAuditOrderByColumn`. */
export enum ThreatCategoryAuditOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type ThreatCategoryAuditWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters on the event type of the audit entry. */
  event?: InputMaybe<AuditedEvent>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ThreatCategoryConnection = Connection & ConnectionWithTotal & NestedSetConnection & {
  __typename: 'ThreatCategoryConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<ThreatCategoryEdge>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<ThreatCategory>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ThreatCategoryEdge = Edge & NestedSetEdge & {
  __typename: 'ThreatCategoryEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /**
   * The node at the end of this edge.
   *
   * This value is `null` iff the current access token has no permission to see the value of this node, but does have
   * the permission to see the values on the edges.
   */
  node?: Maybe<ThreatCategory>;
};

/**
 * Specifies how the edges to a `ThreatCategory` will be ordered in a connection.
 *
 * This type was automatically generated from the `ThreatCategoryOrderByColumn` column-type used in the
 * `orderBy` argument of the `Team.threatCategories` field. (It might be possible that it is reused by
 * other fields.)
 */
export type ThreatCategoryOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: ThreatCategoryOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `ThreatCategoryOrderByColumn`. */
export enum ThreatCategoryOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which the entities were deleted. */
  DeletedAt = 'DELETED_AT',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  /** Orders the nodes of a nested set by their *right value*, which corresponds to the post-order traversal of a tree. */
  PostOrderTraversal = 'POST_ORDER_TRAVERSAL',
  /** Orders the nodes of a nested set by their *left value*, which corresponds to the pre-order traversal of a tree. */
  PreOrderTraversal = 'PRE_ORDER_TRAVERSAL',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type ThreatCategoryWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were soft-deleted. */
  deleted?: InputMaybe<StampedEventConstraints>;
  /**
   * Filter on the absolute depth in the tree (of nested-set nodes). This is equivalent to the total number of
   * ancestors.
   *
   * The absolute depth of a node X is defined by:
   *     - `X.depth := 0` if `X` has no parent (`X` is a root node)
   *     - `X.depth := X.parent.depth + 1` if `X` has a parent.
   *
   * Set this filter to `{equalTo: 0}` to get all root nodes.
   */
  depth?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filters on whether the `NestedSetNode` is a leaf-node or not.
   *
   * A node is considered to be a leaf-node if it has no children.
   */
  leaves?: InputMaybe<WhereLeaves>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Filters on whether the `NestedSetNode` is a root-node or not.
   *
   * A node is considered to be a root-node if it has no parent.
   */
  roots?: InputMaybe<WhereRoots>;
  /**
   * Filters the entries by the total amount child-nodes.
   *
   * You get the leaves if you set this constraint to `{equalTo: 0 }`.
   *
   * See the `NestedSetNode.children`-field for more information.
   */
  totalChildren?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /**
   * Filters the entries by the total amount descendant-nodes. See the `descendants`-field of the `NestedSet` interface
   * for more information.
   *
   * This total does not include the node itself as its descendant! **Example:** You get the leaves if you set this
   * constraint to `{equalTo: 0 }`.
   *
   * See the `NestedSetNode.descendants`-field for more information.
   */
  totalDescendants?: InputMaybe<IntLinearOrderConstraints>;
  /**
   * Filters the entries by the total amount nodes in the bloodline. See the `bloodline`-field of the `NestedSet`
   * interface for more information.
   *
   * This total does include the node itself! **Example:** You no results if you set this constraint to `{equalTo: 0 }`.
   *
   * See the `NestedSetNode.bloodline`-field for more information.
   */
  totalNodesInBloodline?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters on the total amount of risks for the treats of each `ThreatCategory`. */
  totalRisks?: InputMaybe<IntLinearOrderConstraints>;
  /**
   * Filters the entries by the total amount sibling-nodes.
   *
   * This total does not include the node itself as its sibling! **Example:** You get all nodes without siblings when
   * you set the constraints to `{equalTo: 0 }`.
   *
   * See the `NestedSetNode.siblings`-field for more information.
   */
  totalSiblings?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `threats`. */
  totalThreats?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A paged connection with `ThreatEdge` edges to `Threat` nodes.
 *
 * This type was automatically generated from the `ThreatEdge` edge-type for the
 * `Team.ownedThreats` field. (It might be possible that it is reused by other fields.)
 */
export type ThreatConnection = Connection & ConnectionWithTotal & {
  __typename: 'ThreatConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<ThreatEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Threat>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `ThreatConnection` connection that points to a `Threat` node.
 *
 * This type was automatically generated from the `Threat` node-type of the
 * `Team.ownedThreats` field. (It might be possible that it is reused by other fields.)
 */
export type ThreatEdge = Edge & {
  __typename: 'ThreatEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: Threat;
};

/**
 * Specifies how the edges to a `Threat` will be ordered in a connection.
 *
 * This type was automatically generated from the `ThreatOrderByColumn` column-type used in the
 * `orderBy` argument of the `RiskConfiguration.threats` field. (It might be possible that it is reused by
 * other fields.)
 */
export type ThreatOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: ThreatOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `ThreatOrderByColumn`. */
export enum ThreatOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which an entity was deactivated. */
  DeactivatedAt = 'DEACTIVATED_AT',
  /** Orders by the moment on which the entities were deleted. */
  DeletedAt = 'DELETED_AT',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

/**
 * An `Audit`-node that tracks a mutation that affects the severity on the edge between a `Threat` and a
 * `RiskConfiguration`.
 */
export type ThreatSeverityAudit = Audit & Commentable & Node & Ownable & Taggable & Timestamped & Userstamped & {
  __typename: 'ThreatSeverityAudit';
  /** The comments for this `ThreatSeverityAudit`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `ThreatSeverityAudit`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `ThreatSeverityAudit`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** The client-application that the `creator` used at the moment when he/she generated this `ThreatSeverityAudit`. */
  creatorClient?: Maybe<Client>;
  /** The IP-address of the `creator` at the moment when he/she generated this `ThreatSeverityAudit`. */
  creatorIpAddress?: Maybe<Scalars['IpAddress']['output']>;
  /**
   * The team of the `creator` at the moment when he/she generated this `ThreatSeverityAudit`.
   *
   * See the `Audit.creator`-field for more information.
   */
  creatorTeam?: Maybe<Team>;
  /** The user-agent of the `creator` at the moment when he/she generated this `ThreatSeverityAudit`-node. */
  creatorUserAgent?: Maybe<Scalars['UserAgent']['output']>;
  /**
   * Gives the `User` that _updated_ this `ThreatSeverityAudit`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /** The event type for which this `ThreatSeverityAudit` was generated. */
  event?: Maybe<AuditedEvent>;
  /**
   * The name of the GraphQL operation that was responsible for this `ThreatSeverityAudit`-node.
   *
   * Use this value in combination with the `client`-field to derive how this audit was created.
   */
  graphqlOperation?: Maybe<Scalars['String']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `ThreatSeverityAudit`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ThreatSeverityAudit` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ThreatSeverityAudit` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `ThreatSeverityAudit` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `ThreatSeverityAudit` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `ThreatSeverityAudit`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** The severity after the mutation was executed. */
  newSeverity?: Maybe<RiskSeverity>;
  /** The severity before the mutation was executed. */
  oldSeverity?: Maybe<RiskSeverity>;
  /** A reference to the owner that owns this `ThreatSeverityAudit`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `ThreatSeverityAudit` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /** An HTML-formatted text containing some remarks about the mutation that generated this `ThreatSeverityAudit`. */
  remarks?: Maybe<Scalars['HTML']['output']>;
  /** The risk configuration for which the severity changed. */
  riskConfiguration?: Maybe<RiskConfiguration>;
  /**
   * Whether the severity was changed dueue to this mutation.
   *
   * This field implies that `ThreatSeverityAudit.oldSeverity !== ThreatSeverityAudit.newSeverity`.
   */
  severityChanged?: Maybe<Scalars['Boolean']['output']>;
  /** Connection to the tags that are assigned to this `ThreatSeverityAudit`. */
  tags?: Maybe<TagConnection>;
  /** The threat that was affected by the mutation. */
  threat?: Maybe<Threat>;
  /** Gives the most recent moment on which this `ThreatSeverityAudit`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/**
 * An `Audit`-node that tracks a mutation that affects the severity on the edge between a `Threat` and a
 * `RiskConfiguration`.
 */
export type ThreatSeverityAuditCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


/**
 * An `Audit`-node that tracks a mutation that affects the severity on the edge between a `Threat` and a
 * `RiskConfiguration`.
 */
export type ThreatSeverityAuditIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/**
 * An `Audit`-node that tracks a mutation that affects the severity on the edge between a `Threat` and a
 * `RiskConfiguration`.
 */
export type ThreatSeverityAuditIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


/**
 * An `Audit`-node that tracks a mutation that affects the severity on the edge between a `Threat` and a
 * `RiskConfiguration`.
 */
export type ThreatSeverityAuditIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


/**
 * An `Audit`-node that tracks a mutation that affects the severity on the edge between a `Threat` and a
 * `RiskConfiguration`.
 */
export type ThreatSeverityAuditIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/**
 * An `Audit`-node that tracks a mutation that affects the severity on the edge between a `Threat` and a
 * `RiskConfiguration`.
 */
export type ThreatSeverityAuditOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


/**
 * An `Audit`-node that tracks a mutation that affects the severity on the edge between a `Threat` and a
 * `RiskConfiguration`.
 */
export type ThreatSeverityAuditTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};

/**
 * A paged connection with `ThreatSeverityAuditEdge` edges to `ThreatSeverityAudit` nodes.
 *
 * This type was automatically generated from the `ThreatSeverityAuditEdge` edge-type for the
 * `Query.threatSeverityAudits` field. (It might be possible that it is reused by other fields.)
 */
export type ThreatSeverityAuditConnection = Connection & ConnectionWithTotal & {
  __typename: 'ThreatSeverityAuditConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<ThreatSeverityAuditEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<ThreatSeverityAudit>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `ThreatSeverityAuditConnection` connection that points to a `ThreatSeverityAudit` node.
 *
 * This type was automatically generated from the `ThreatSeverityAudit` node-type of the
 * `Query.threatSeverityAudits` field. (It might be possible that it is reused by other fields.)
 */
export type ThreatSeverityAuditEdge = Edge & {
  __typename: 'ThreatSeverityAuditEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: ThreatSeverityAudit;
};

/**
 * Specifies how the edges to a `ThreatSeverityAudit` will be ordered in a connection.
 *
 * This type was automatically generated from the `ThreatSeverityAuditOrderByColumn` column-type used in the
 * `orderBy` argument of the `Query.threatSeverityAudits` field. (It might be possible that it is reused by
 * other fields.)
 */
export type ThreatSeverityAuditOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: ThreatSeverityAuditOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `ThreatSeverityAuditOrderByColumn`. */
export enum ThreatSeverityAuditOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type ThreatSeverityAuditWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters on the event type of the audit entry. */
  event?: InputMaybe<AuditedEvent>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ThreatWhereClause = {
  /** Filter entries based on the current active state. See the `WhereActive`-enum for more information. */
  active?: InputMaybe<WhereActive>;
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were deactivated. */
  deactivated?: InputMaybe<StampedEventConstraints>;
  /** Filters the entries by the meta-data about the moment they were soft-deleted. */
  deleted?: InputMaybe<StampedEventConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Threat_RiskConfigurationConnection = Connection & ConnectionWithTotal & {
  __typename: 'Threat_RiskConfigurationConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<Threat_RiskConfigurationEdge>>>;
  /** The edge to the global default risk configuration. */
  globalDefault?: Maybe<Threat_RiskConfigurationEdge>;
  /** The edge to the default risk configuration of the team in the current access token. */
  myTeamDefault?: Maybe<Threat_RiskConfigurationEdge>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<RiskConfiguration>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Threat_RiskConfigurationEdge = Edge & {
  __typename: 'Threat_RiskConfigurationEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node at the end of this edge. */
  node: RiskConfiguration;
  /** The severity in this `RiskConfiguration` for the risks that belong to this threat. */
  severity?: Maybe<RiskSeverity>;
};

/** Represents an type that has timestamps that track the moment at which the node was created and/or updated. */
export type Timestamped = {
  /** `DateTime` on which this node was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this node is considered to be new. */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this node is considered to be updated. */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** `DateTime` of the last moment on which this node was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** Represents an type that has timestamps that track the moment at which the node was created and/or updated. */
export type TimestampedIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** Represents an type that has timestamps that track the moment at which the node was created and/or updated. */
export type TimestampedIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};

export type Todo = {
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this `Todo` item is considered to be done. */
  isDone?: Maybe<Scalars['Boolean']['output']>;
  /** The title for this todo item that can be used to display it in a todo list. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type UpdateAnalysisReportEntryInput = {
  /** Manage the comments on the `AnalysisReportEntry`. */
  comments?: InputMaybe<ConnectCommentsInput>;
  /** The ID of the `AnalysisReportEntry` you want to update. */
  id: Scalars['ID']['input'];
  /** Update the predicate values of the `AnalysisReportEntry`. */
  predicateValues?: InputMaybe<ManageAnalysisReportEntryPredicateValuesInput>;
  /**
   * Does nothing
   * @deprecated Irrelevant, Does nothing.
   */
  riskConfiguration?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Overwrite the risk probability value.
   * This will create a RiskProbabilityValueOverwriteEvent and not affect the risk associated with this entry.
   */
  riskProbability?: InputMaybe<AnalysisReportEntryRiskValueInput>;
  /**
   * Sets the risk probability value.
   *
   * This only affects the entry itself, not the risk associated with the entry.
   * @deprecated Use riskProbability instead
   */
  riskProbabilityValue?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Overwrite the risk severity value.
   * This will create a RiskSeverityValueOverwriteEvent and not affect the risk associated with this entry.
   */
  riskSeverity?: InputMaybe<AnalysisReportEntryRiskValueInput>;
  /**
   * Sets the risk severity value.
   *
   * This only affects the entry itself, not the threat associated with the entry.
   * @deprecated Use riskSeverity instead
   */
  riskSeverityValue?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Sets the reliability of this entry.
   *
   * This only affects the entry itself, not the supplier branch associated with the entry.
   */
  supplierReliability?: InputMaybe<ConnectSupplierReliabilityInput>;
};

export type UpdateAnalysisReportEntry_SuccessResult = MutationPayload & {
  __typename: 'UpdateAnalysisReportEntry_SuccessResult';
  node: AnalysisReportEntry;
  query: Query;
};

export type UpdateAnalysisReportInput = {
  /** Attach comments to the `AnalysisReport`. */
  comments?: InputMaybe<ConnectCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Manages the entries in this analysis report.
   *
   * An error is thrown if the entries weren't generated yet.
   */
  entries?: InputMaybe<ManageAnalysisReportEntriesInput>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<NameInputOptional>;
  /**
   * The moment after which the `AnalysisReport` is considered to be outdated.
   *
   * Set to `null` to ensure that the analysis report will never be considered to be outdated.
   */
  outdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Updates the product-selection of the `AnalysisReport`. This will overwrite the previous selection. */
  products?: InputMaybe<SelectProductsInput>;
  /** Updates the verification configuration of the `AnalysisReport`. */
  verificationConfiguration?: InputMaybe<ConnectVerificationConfigurationInput>;
};

export type UpdateAnalysisReportProductRiskInput = {
  /** The id of the `AnalysisReportProductRisk` that you want to update. */
  id: Scalars['ID']['input'];
  /** The new predicate value for the AnalysisReportProductRisk. */
  predicateValue?: InputMaybe<PredicateValue>;
};

export type UpdateAnalysisReportProductRisk_SuccessResult = MutationPayload & {
  __typename: 'UpdateAnalysisReportProductRisk_SuccessResult';
  node: AnalysisReportProductRisk;
  query: Query;
};

export type UpdateAnalysisReportProductRisksInput = {
  /** The ids of the `AnalysisReportProductRisks` that you want to update. */
  ids: Array<Scalars['ID']['input']>;
  /** The new predicate value for the AnalysisReportProductRisks. */
  predicateValue?: InputMaybe<PredicateValue>;
};

export type UpdateAnalysisReportProductRisks_SuccessResult = MutationPayload & {
  __typename: 'UpdateAnalysisReportProductRisks_SuccessResult';
  nodes: Array<AnalysisReportProductRisk>;
  query: Query;
};

export type UpdateAnalysisReport_SuccessResult = MutationPayload & {
  __typename: 'UpdateAnalysisReport_SuccessResult';
  node: AnalysisReport;
  query: Query;
};

export type UpdateAuditInput = {
  /** Manages the comments on the `Audit`-node. */
  comments?: InputMaybe<ConnectCommentsInput>;
  /** The ID of the `Audit`-node to update. */
  id: Scalars['ID']['input'];
  /** The new (HTML-formatted) remarks for the `Audit`-node. */
  remarks?: InputMaybe<Scalars['HTML']['input']>;
};

export type UpdateAudit_SuccessResult = MutationPayload & {
  __typename: 'UpdateAudit_SuccessResult';
  /** The updated `Audit`-node. */
  node: Audit;
  query: Query;
};

export type UpdateAuditsInput = {
  /** The IDs of the `Audit`-node to update. */
  ids: Array<Scalars['ID']['input']>;
  /** The new (HTML-formatted) remarks for the `Audit`-nodes. */
  remarks?: InputMaybe<Scalars['HTML']['input']>;
};

export type UpdateAudits_SuccessResult = MutationPayload & {
  __typename: 'UpdateAudits_SuccessResult';
  /** The updated `Audit`-nodes. */
  nodes: Array<Audit>;
  query: Query;
};

export type UpdateCommentInput = {
  comment?: InputMaybe<Scalars['HTML']['input']>;
  id: Scalars['ID']['input'];
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateComment_SuccessResult = MutationPayload & {
  __typename: 'UpdateComment_SuccessResult';
  node: Comment;
  query: Query;
};

export type UpdateCommentsInput = {
  ids: Array<Scalars['ID']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateComments_SuccessResult = MutationPayload & {
  __typename: 'UpdateComments_SuccessResult';
  nodes: Array<Comment>;
  query: Query;
};

export type UpdateCompaniesInput = {
  ids: Array<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCompanies_SuccessResult = MutationPayload & {
  __typename: 'UpdateCompanies_SuccessResult';
  nodes: Array<Company>;
  query: Query;
};

export type UpdateCompanyInput = {
  comments?: InputMaybe<ConnectCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameInputOptional>;
  number?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalAddress?: InputMaybe<AddressInput>;
  website?: InputMaybe<Scalars['URL']['input']>;
};

export type UpdateCompany_SuccessResult = MutationPayload & {
  __typename: 'UpdateCompany_SuccessResult';
  node: Company;
  query: Query;
};

export type UpdateContactInput = {
  accounts?: InputMaybe<ManageContactAccountsInput>;
  comments?: InputMaybe<ConnectCommentsInput>;
  company?: InputMaybe<ConnectCompanyInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<ContactNameInput>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContact_SuccessResult = MutationPayload & {
  __typename: 'UpdateContact_SuccessResult';
  node: Contact;
  query: Query;
};

export type UpdateContactsInput = {
  company?: InputMaybe<ConnectCompanyInput>;
  ids: Array<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateContacts_SuccessResult = MutationPayload & {
  __typename: 'UpdateContacts_SuccessResult';
  nodes: Array<Contact>;
  query: Query;
};

export type UpdateProductCategoryInput = {
  comments?: InputMaybe<ConnectCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<NameInputOptional>;
  parent?: InputMaybe<ConnectThreatCategoryInput>;
  risks?: InputMaybe<ConnectRisksInput>;
};

export type UpdateProductCategory_SuccessResult = MutationPayload & {
  __typename: 'UpdateProductCategory_SuccessResult';
  node: ProductCategory;
  query: Query;
};

export type UpdateProductInput = {
  clientRef?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<ConnectCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameInputOptional>;
  predicateValues?: InputMaybe<ManageProductPredicateValuesInput>;
  productCategories?: InputMaybe<ConnectProductCategoriesInput>;
  supplierBranches?: InputMaybe<ConnectSupplierBranchesInput>;
};

export type UpdateProduct_SuccessResult = MutationPayload & {
  __typename: 'UpdateProduct_SuccessResult';
  node: Product;
  query: Query;
};

export type UpdateProductsInput = {
  ids: Array<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  predicateValues?: InputMaybe<ManageProductPredicateValuesInput>;
  productCategories?: InputMaybe<ConnectProductCategoriesInput>;
  supplierBranches?: InputMaybe<ConnectSupplierBranchesInput>;
};

export type UpdateProducts_SuccessResult = MutationPayload & {
  __typename: 'UpdateProducts_SuccessResult';
  nodes: Array<Product>;
  query: Query;
};

export type UpdateQuestionPredicateInput = {
  defaultPredicateValue?: InputMaybe<PredicateValue>;
  id: Scalars['ID']['input'];
  predicateQuestion?: InputMaybe<Scalars['HTML']['input']>;
};

export type UpdateQuestionPredicate_SuccessResult = MutationPayload & {
  __typename: 'UpdateQuestionPredicate_SuccessResult';
  node: QuestionPredicate;
  query: Query;
};

export type UpdateRegionInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<NameInputOptional>;
};

export type UpdateRegion_SuccessResult = MutationPayload & {
  __typename: 'UpdateRegion_SuccessResult';
  node: Region;
  query: Query;
};

export type UpdateRiskColumnInput = {
  color?: InputMaybe<Color>;
  /** An optional argument to attach comments to this risk column. */
  comments?: InputMaybe<AttachCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** The global id of the `RiskColumn` that you want to update. */
  id: Scalars['ID']['input'];
  /** @deprecated not available */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Updates the name of the column. This value should also set the header of the column in generated spreadsheets. */
  name?: InputMaybe<NameInputOptional>;
};

export type UpdateRiskColumn_SuccessResult = MutationPayload & {
  __typename: 'UpdateRiskColumn_SuccessResult';
  node: RiskColumn;
  query: Query;
};

export type UpdateRiskConfigurationInput = {
  comments?: InputMaybe<ConnectCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  levels?: InputMaybe<UpdateRiskConfigurationInput_Levels>;
  name: NameInput;
  probabilities?: InputMaybe<UpdateRiskConfigurationInput_Probabilities>;
  severities?: InputMaybe<UpdateRiskConfigurationInput_Severities>;
};

export type UpdateRiskConfigurationInput_Levels = {
  delete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Upserts the provided segments (based on the `lower_bound`) and deletes all segments that do not occur in this list. */
  sync?: InputMaybe<Array<SetRiskConfigurationLevelInput>>;
  update?: InputMaybe<Array<UpdateRiskConfigurationLevelInput>>;
  upsert?: InputMaybe<Array<SetRiskConfigurationLevelInput>>;
};

export type UpdateRiskConfigurationInput_Probabilities = {
  delete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Upserts the provided segments (based on the `lower_bound`) and deletes all segments that do not occur in this list. */
  sync?: InputMaybe<Array<SetRiskConfigurationLevelInput>>;
  update?: InputMaybe<Array<UpdateRiskConfigurationProbabilityInput>>;
  upsert?: InputMaybe<Array<SetRiskConfigurationProbabilityInput>>;
};

export type UpdateRiskConfigurationInput_Severities = {
  delete?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Upserts the provided segments (based on the `lower_bound`) and deletes all segments that do not occur in this list. */
  sync?: InputMaybe<Array<SetRiskConfigurationLevelInput>>;
  update?: InputMaybe<Array<UpdateRiskConfigurationSeverityInput>>;
  upsert?: InputMaybe<Array<SetRiskConfigurationSeverityInput>>;
};

export type UpdateRiskConfigurationLevelInput = {
  color?: InputMaybe<Color>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lowerBound?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<NameInput>;
};

export type UpdateRiskConfigurationProbabilityInput = {
  color?: InputMaybe<Color>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lowerBound?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<NameInput>;
};

export type UpdateRiskConfigurationSeverityInput = {
  color?: InputMaybe<Color>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lowerBound?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<NameInput>;
};

export type UpdateRiskConfiguration_SuccessResult = MutationPayload & {
  __typename: 'UpdateRiskConfiguration_SuccessResult';
  node: RiskConfiguration;
  query: Query;
};

export type UpdateRiskInput = {
  comments?: InputMaybe<ConnectCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  predicateExpression?: InputMaybe<Scalars['MeetExpression']['input']>;
  probabilities?: InputMaybe<ConnectRiskValuesInput>;
  productCategories?: InputMaybe<ConnectProductCategoriesInput>;
  publicInfo?: InputMaybe<Scalars['HTML']['input']>;
  publicTopicalInfo?: InputMaybe<Scalars['HTML']['input']>;
  riskColumnValues?: InputMaybe<UpdateRiskInput_RiskColumnValues>;
  threat?: InputMaybe<ConnectThreatInput>;
};

export type UpdateRiskInput_RiskColumnValues = {
  delete?: InputMaybe<Array<Scalars['ID']['input']>>;
  upsert?: InputMaybe<Array<RiskColumnValueInput>>;
};

export type UpdateRiskValueInput = {
  configuration: Scalars['ID']['input'];
  remarks?: InputMaybe<Scalars['HTML']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateRisk_SuccessResult = {
  __typename: 'UpdateRisk_SuccessResult';
  node: Risk;
  query: Query;
};

export type UpdateRisksInput = {
  ids: Array<Scalars['ID']['input']>;
  productCategories?: InputMaybe<ConnectProductCategoriesInput>;
};

export type UpdateRisks_SuccessResult = MutationPayload & {
  __typename: 'UpdateRisks_SuccessResult';
  nodes: Array<Risk>;
  query: Query;
};

export type UpdateSupplierBranchInput = {
  address?: InputMaybe<AddressInput>;
  comments?: InputMaybe<ConnectCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameInputOptional>;
  phone?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<ConnectProductsInput>;
  reliability?: InputMaybe<ConnectSupplierReliabilityInput>;
  website?: InputMaybe<Scalars['URL']['input']>;
};

export type UpdateSupplierBranch_SuccessResult = MutationPayload & {
  __typename: 'UpdateSupplierBranch_SuccessResult';
  node: SupplierBranch;
  query: Query;
};

export type UpdateSupplierBranchesInput = {
  ids: Array<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  products?: InputMaybe<ConnectProductsInput>;
  reliability?: InputMaybe<ConnectSupplierReliabilityInput>;
};

export type UpdateSupplierBranches_SuccessResult = MutationPayload & {
  __typename: 'UpdateSupplierBranches_SuccessResult';
  nodes: Array<SupplierBranch>;
  query: Query;
};

export type UpdateSupplierInput = {
  address?: InputMaybe<AddressInput>;
  clientRef?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<ConnectCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameInputOptional>;
  phone?: InputMaybe<Scalars['String']['input']>;
  supplierBranches?: InputMaybe<CreateSupplierInputBranches>;
  website?: InputMaybe<Scalars['URL']['input']>;
};

export type UpdateSupplier_SuccessResult = MutationPayload & {
  __typename: 'UpdateSupplier_SuccessResult';
  node: Supplier;
  query: Query;
};

export type UpdateSuppliersInput = {
  ids: Array<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateSuppliers_SuccessResult = MutationPayload & {
  __typename: 'UpdateSuppliers_SuccessResult';
  nodes: Array<Supplier>;
  query: Query;
};

export type UpdateTagInput = {
  color?: InputMaybe<Color>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<TagIcon>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<NameInputOptional>;
};

export type UpdateTagPayload = UpdateTag_SuccessResult;

export type UpdateTag_SuccessResult = MutationPayload & {
  __typename: 'UpdateTag_SuccessResult';
  node: Tag;
  query: Query;
};

export type UpdateTeamInput = {
  /** Sets the company with whom the team should be associated. */
  company?: InputMaybe<ConnectCompanyInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameInputOptional>;
  products?: InputMaybe<UpdateTeam_ProductsInput>;
  suppliers?: InputMaybe<UpdateTeam_SuppliersInput>;
  teamType?: InputMaybe<TeamType>;
  users?: InputMaybe<Array<SyncUserTeamRolesInput>>;
};

export type UpdateTeamLicenseClassInput = {
  /** The default time-period in which a license of this class is valid. */
  defaultValidityPeriod?: InputMaybe<Scalars['DateTimeInterval']['input']>;
  /** The description for the license class. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The `id` of the license class you want to update. */
  id: Scalars['ID']['input'];
  /** The name for the license class. */
  name?: InputMaybe<NameInputOptional>;
};

export type UpdateTeamLicenseClass_SuccessResult = MutationPayload & {
  __typename: 'UpdateTeamLicenseClass_SuccessResult';
  node: TeamLicenseClass;
  query: Query;
};

export type UpdateTeamLicenseInput = {
  /** Attach comments to the team license. */
  comments?: InputMaybe<AttachCommentsInput>;
  /** The `id` of the team license you want to update. */
  id: Scalars['ID']['input'];
  /** The moment after which this license is valid. */
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** The moment when this license will expire. */
  validTill?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateTeamLicense_SuccessResult = MutationPayload & {
  __typename: 'UpdateTeamLicense_SuccessResult';
  node: TeamLicense;
  query: Query;
};

export type UpdateTeam_DeleteProductInput = {
  clientRef: Scalars['String']['input'];
};

export type UpdateTeam_DeleteSupplierInput = {
  clientRef: Scalars['String']['input'];
};

export type UpdateTeam_ProductInput = {
  clientRef?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<AttachCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  isActive?: Scalars['Boolean']['input'];
  name: NameInput;
  predicateValues?: InputMaybe<ManageProductPredicateValuesInput>;
  productCategories?: InputMaybe<AttachProductCategoriesInput>;
  supplierBranches?: InputMaybe<AttachSupplierBranchesInput>;
};

/**
 * Execution order:
 *  - sync
 *  - upsert
 *  - delete
 */
export type UpdateTeam_ProductsInput = {
  delete?: InputMaybe<Array<UpdateTeam_DeleteProductInput>>;
  sync?: InputMaybe<Array<UpdateTeam_ProductInput>>;
  upsert?: InputMaybe<Array<UpdateTeam_ProductInput>>;
};

export type UpdateTeam_SuccessResult = MutationPayload & {
  __typename: 'UpdateTeam_SuccessResult';
  node: Team;
  query: Query;
};

export type UpdateTeam_SupplierInput = {
  clientRef?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<AttachCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
  isActive?: Scalars['Boolean']['input'];
  name: NameInput;
  phone?: InputMaybe<Scalars['String']['input']>;
  supplierBranches?: InputMaybe<CreateSupplierInputBranches>;
  website?: InputMaybe<Scalars['URL']['input']>;
};

/**
 * Execution order:
 *  - sync
 *  - upsert
 *  - delete
 */
export type UpdateTeam_SuppliersInput = {
  delete?: InputMaybe<Array<UpdateTeam_DeleteSupplierInput>>;
  sync?: InputMaybe<Array<UpdateTeam_SupplierInput>>;
  upsert?: InputMaybe<Array<UpdateTeam_SupplierInput>>;
};

export type UpdateTeamsInput = {
  ids: Array<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTeams_SuccessResult = MutationPayload & {
  __typename: 'UpdateTeams_SuccessResult';
  nodes: Array<Team>;
  query: Query;
};

export type UpdateThreatCategoryInput = {
  comments?: InputMaybe<ConnectCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<NameInputOptional>;
  parent?: InputMaybe<ConnectThreatCategoryInput>;
};

export type UpdateThreatCategory_SuccessResult = MutationPayload & {
  __typename: 'UpdateThreatCategory_SuccessResult';
  node: ThreatCategory;
  query: Query;
};

export type UpdateThreatInput = {
  comments?: InputMaybe<ConnectCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameInputOptional>;
  publicInfo?: InputMaybe<Scalars['HTML']['input']>;
  severities?: InputMaybe<ConnectRiskValuesInput>;
  threatCategory?: InputMaybe<ConnectThreatCategoryInput>;
};

export type UpdateThreat_SuccessResult = MutationPayload & {
  __typename: 'UpdateThreat_SuccessResult';
  node: Threat;
  query: Query;
};

export type UpdateThreatsInput = {
  ids: Array<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  threatCategory?: InputMaybe<ConnectThreatCategoryInput>;
};

export type UpdateThreats_SuccessResult = MutationPayload & {
  __typename: 'UpdateThreats_SuccessResult';
  nodes: Array<Threat>;
  query: Query;
};

export type UpdateUserInput = {
  contact?: InputMaybe<ConnectContactInput>;
  email?: InputMaybe<Scalars['Email']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  userRoles?: InputMaybe<UpdateUserInput_UserRole>;
};

export type UpdateUserInput_UserRole = {
  /** Assigns the provided user roles of the updated user. */
  assign?: InputMaybe<Array<UserRole>>;
  /** Retracts the provided user roles of the updated user. */
  retract?: InputMaybe<Array<UserRole>>;
  /** Sets the users roles of the updated user to the provided roles. */
  sync?: InputMaybe<Array<UserRole>>;
};

export type UpdateUserInvitationInput = {
  /** Attaches commands to this user invitation. */
  comments?: InputMaybe<AttachCommentsInput>;
  /** The description for internal use. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The id of the user invitation you want to update. */
  id: Scalars['ID']['input'];
  /**
   * The message that will be displayed in the email to the contact. Will fail if the user invitation is not in the
   * `READY` state.
   */
  message?: InputMaybe<Scalars['HTML']['input']>;
  /**
   * The team that will be assigned to the user that accepts this user invitation. Will fail if the user invitation
   * is in a terminal state (`ACCEPTED`, `EXPIRED`, `CANCELLED` or `FAILED`).
   */
  teams?: InputMaybe<UpdateUserInvitationInput_Teams>;
  /**
   * The email address to which the user invitation will be sent. Will fail if the user invitation is not in the
   * `READY` state.
   */
  toEmail?: InputMaybe<Scalars['Email']['input']>;
  /**
   * The user roles that will be assigned to the user that accepts this user invitation. Will fail if the user invitation
   * is in a terminal state (`ACCEPTED`, `EXPIRED`, `CANCELLED` or `FAILED`).
   */
  userRoles?: InputMaybe<Array<UserRole>>;
};

export type UpdateUserInvitationInput_Teams = {
  /** The ids of the teams you want to detach from the user invitation. */
  detach?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Sets the teams of the invitation to the specified array. Will detach all other teams. */
  sync?: InputMaybe<Array<UserInvitationTeamInput>>;
  /** Adds or updates the team role assignments for a team. */
  upsert?: InputMaybe<Array<UserInvitationTeamInput>>;
};

export type UpdateUserInvitation_SuccessResult = MutationPayload & {
  __typename: 'UpdateUserInvitation_SuccessResult';
  /** The updated user invitation. */
  node: UserInvitation;
  query: Query;
};

export type UpdateUser_SuccessResult = MutationPayload & {
  __typename: 'UpdateUser_SuccessResult';
  node: User;
  query: Query;
};

export type UpdateUsersInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type UpdateUsers_SuccessResult = MutationPayload & {
  __typename: 'UpdateUsers_SuccessResult';
  nodes: Array<User>;
  query: Query;
};

export type UpdateVerificationActionInput = {
  comments?: InputMaybe<AttachCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameInput>;
};

export type UpdateVerificationAction_SuccessResult = MutationPayload & {
  __typename: 'UpdateVerificationAction_SuccessResult';
  node: VerificationAction;
  query: Query;
};

export type UpdateVerificationConfigurationInput = {
  /** THE ORDER HERE DOES MATTER! */
  actions?: InputMaybe<UpdateVerificationConfigurationInput_Action>;
  comments?: InputMaybe<AttachCommentsInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<NameInput>;
  rules?: InputMaybe<UpdateVerificationConfigurationInput_Rules>;
};

/**
 * Execution Order:
 *  - sync
 *  - upsert
 *  - detach
 */
export type UpdateVerificationConfigurationInput_Action = {
  detach?: InputMaybe<Array<Scalars['ID']['input']>>;
  sync?: InputMaybe<Array<UpdateVerificationConfigurationInput_Action_Sync>>;
  upsert?: InputMaybe<Array<UpdateVerificationConfigurationInput_Action_Upsert>>;
};

export type UpdateVerificationConfigurationInput_Action_Sync = {
  action: ConnectVerificationAction;
  defaultValue?: InputMaybe<PredicateValue>;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVerificationConfigurationInput_Action_Upsert = {
  action: ConnectVerificationAction;
  /**
   * The position to insert/move the action.
   *
   *  - A non-positive value will insert/move the action to the start.
   *  - A positive value `i` will put the action at `i`. All other actions with position `j >= i` will get new position
   *    `j + 1`.
   *  - Any positive value `i` higher than the current amount of actions will put the value at the end of the list.
   *    So if there are `l` actions and you set this value to `n > l`, then the new position will be `l`.
   *  - Omitting this property or setting it to `null` will put the action at the end of the list if the action was
   *    not yet connected to the verification configuration. Otherwise, it will just update the action edge and leave
   *    the position as it was.
   */
  atPosition?: InputMaybe<Scalars['Int']['input']>;
  defaultValue?: InputMaybe<PredicateValue>;
  remarks?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVerificationConfigurationInput_Rules = {
  insert?: InputMaybe<Array<InsertVerificationConfigurationRuleInput>>;
};

export type UpdateVerificationConfigurationRuleInput = {
  actions?: InputMaybe<UpdateVerificationConfigurationRuleInput_Actions>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<NameInput>;
  precedence?: InputMaybe<Scalars['Int']['input']>;
  predicateExpression?: InputMaybe<Scalars['MeetExpression']['input']>;
};

export type UpdateVerificationConfigurationRuleInput_Actions = {
  detach?: InputMaybe<Array<Scalars['ID']['input']>>;
  upsert?: InputMaybe<Array<UpsertVerificationConfigurationRuleAction>>;
};

export type UpdateVerificationConfigurationRule_SuccessResult = MutationPayload & {
  __typename: 'UpdateVerificationConfigurationRule_SuccessResult';
  node: VerificationConfigurationRule;
  query: Query;
};

export type UpdateVerificationConfiguration_SuccessResult = MutationPayload & {
  __typename: 'UpdateVerificationConfiguration_SuccessResult';
  insertedActions: Array<VerificationAction>;
  insertedRules: Array<VerificationConfigurationRule>;
  node: VerificationConfiguration;
  query: Query;
};

/** The input for the `updateVerificationPredicate` mutation. */
export type UpdateVerificationPredicateInput = {
  /** The default value of the verification predicate. */
  defaultPredicateValue?: InputMaybe<PredicateValue>;
  /** A short description of the verification predicate. Will be used in the search engine. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the verification predicate you want to update. */
  id: Scalars['ID']['input'];
  /** The name for the verification predicate. */
  name?: InputMaybe<NameInputOptional>;
  /** A question representing the verification predicate. */
  predicateQuestion?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVerificationPredicate_SuccessResult = MutationPayload & {
  __typename: 'UpdateVerificationPredicate_SuccessResult';
  /** The updated verification predicate. */
  node: VerificationPredicate;
  query: Query;
};

export type UploadFile_SuccessResult = MutationPayload & {
  __typename: 'UploadFile_SuccessResult';
  query: Query;
  request: BlobClientRequest;
};

export type UpsertAnalysisReportEntryPredicateValueInput = {
  /** The ID of the predicate for which you want to set the value. */
  predicate: Scalars['ID']['input'];
  /** The new value of the predicate. Will be set to the default value of the predicate if omitted or set to `null`. */
  value?: InputMaybe<PredicateValue>;
};

export type UpsertContactInput = {
  comments?: InputMaybe<ConnectCommentsInput>;
  company?: InputMaybe<ConnectCompanyInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<ContactNameInput>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertProductPredicateValueInput = {
  /** The ID of the predicate for which you want to set the value. */
  predicate: Scalars['ID']['input'];
  /** Some optional HTML-formatted remarks that are stored with the predicate value of the product. */
  remarks?: InputMaybe<Scalars['HTML']['input']>;
  /** The new value of the predicate. Will be set to the default value of the predicate if omitted or set to `null`. */
  value?: InputMaybe<PredicateValue>;
};

export type UpsertVerificationConfigurationRuleAction = {
  action: ConnectVerificationAction;
  assignmentType?: InputMaybe<ActionAssignmentType>;
};

/**
 * Interface for nodes that have a concept of being "usable" by an `Owner`.
 *
 * A node is considered to be "usable" if an owner can use references to this node in its owned entities. This allows
 * an owner to reference to entities which it does not own itself.
 */
export type Usable = {
  /**
   * The globally unique identifier that can be used in the `node` and `nodes` queries to retrieve this
   * object. See the `Node` interface for more information.
   */
  id: Scalars['ID']['output'];
  /** Checks whether this node is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this node is usable by the common GINO library team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this node is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this node is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id, which can save
   * an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
};


/**
 * Interface for nodes that have a concept of being "usable" by an `Owner`.
 *
 * A node is considered to be "usable" if an owner can use references to this node in its owned entities. This allows
 * an owner to reference to entities which it does not own itself.
 */
export type UsableIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


/**
 * Interface for nodes that have a concept of being "usable" by an `Owner`.
 *
 * A node is considered to be "usable" if an owner can use references to this node in its owned entities. This allows
 * an owner to reference to entities which it does not own itself.
 */
export type UsableIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};

/**
 * Represents an Azure Active Directory (Azure AD) user account.
 *
 * For more information, see the [Microsoft Graph API Documentation](https://learn.microsoft.com/en-us/graph/api/resources/user?view=graph-rest-1.0).
 */
export type User = Named & Node & {
  __typename: 'User';
  /** `true` if the account is enabled; otherwise, `false`. */
  accountEnabled?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Address>;
  businessPhone?: Maybe<PhoneNumber>;
  /**
   * The company name which the user is associated. This property can be useful for describing the company that an
   * external user comes from. The maximum length is 64 characters.
   */
  companyName?: Maybe<Scalars['String']['output']>;
  /**
   * The Contact-information of this user.
   * @deprecated The connection between contact and User is hard to achieve from AzureAD. It is also not necessary, as most
   * of the essential information can already be found on the user itself. This value will always return `null`
   * from now on.
   */
  contact?: Maybe<Contact>;
  contacts?: Maybe<ContactConnection>;
  /**
   * The date and time the user was create. The value cannot be modified and is automatically populated when the entity
   * is created.
   *
   * This value was mapped from the `createdDateTime` property in the *Microsoft Graph API* so that it conforms better
   * to our GraphQL-conventions.
   */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Indicates whether the user account was created through one of the methods described in the `UserCreationType` enum. */
  creationType?: Maybe<UserCreationType>;
  /**
   * The date and time the user was deleted.
   *
   * This value was mapped from the `deletedDateTime` property in the *Microsoft Graph API* so that it conforms better
   * to our GraphQL-conventions.
   */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The name for the department in which the user works. Maximum length is 64 characters. */
  department?: Maybe<Scalars['String']['output']>;
  /**
   * The main email address associated with this account.
   *
   * Added for backwards compatibility reasons. This value will be the `mail`-property or the first item of the
   * `otherMails` property if `mail` is `null`.
   */
  email?: Maybe<Scalars['Email']['output']>;
  /**
   * List of known email-addresses for this account.
   *
   * This value gives the combination of the `mail` and `otherMails` properties of the *Microsoft Graph API*.
   */
  emailAddresses?: Maybe<Array<Scalars['Email']['output']>>;
  /**
   * For an external user invited to the tenant using the invitation API, this property represents the invited user's
   * invitation status. For invited users, the state can be `PENDING_ACCEPTANCE` or `ACCEPTED`, or `null` for all other
   * users.
   */
  externalUserState?: Maybe<ExternalUserState>;
  /**
   * Shows the timestamp for the latest change to the `externalUserState` property.
   *
   * This value was mapped from the `externalUserStateChangeDateTime` property in the *Microsoft Graph API* so that it
   * conforms better to our GraphQL-conventions.
   */
  externalUserStateChangedAt?: Maybe<Scalars['DateTime']['output']>;
  faxNumber?: Maybe<PhoneNumber>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Represents the identities that can be used to sign in to this user account. An identity can be provided by
   * Microsoft (also known as a local account), by organizations, or by social identity providers such as Facebook,
   * Google, and Microsoft, and tied to a user account. May contain multiple items with the same signInType value.
   */
  identities?: Maybe<Array<ObjectIdentity>>;
  /** The user's job title. Maximum length is 128 characters. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  jobs?: Maybe<JobConnection>;
  /**
   * The mail alias for the user. This property must be specified when a user is created. Maximum length is
   * 64 characters.
   */
  mailNickname?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<PhoneNumber>;
  /** The name of the user. */
  name?: Maybe<UserName>;
  objectId: Scalars['ExternalKey']['output'];
  /** The office location in the user's place of business. */
  officeLocation?: Maybe<Scalars['String']['output']>;
  /**
   * The time when this Azure AD user last changed their password or when their password was created, whichever date the
   * latest action was performed.
   *
   * This value was mapped from the `lastPasswordChangeDateTime` property in the *Microsoft Graph API* so that it
   * conforms better to our GraphQL-conventions.
   */
  passwordChangedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The city in which the user is located. Maximum length is 128 characters. */
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  /** Get the last signed-in date and request ID of the sign-in for a given user. */
  signInActivity?: Maybe<SignInActivity>;
  teams?: Maybe<User_TeamConnection>;
  /**
   * The user principal name (UPN) of the user. The UPN is an Internet-style login name for the user based on the
   * Internet standard RFC 822. By convention, this should map to the user's email name. The general format is
   * alias@domain, where domain must be present in the tenant's collection of verified domains.
   *
   * NOTE: This property cannot contain accent characters. Only the following characters are allowed:
   * `[A-Za-z0-9.-_!#^~]`. For the complete list of allowed characters, see
   * [username policies]((https://learn.microsoft.com/en-us/azure/active-directory/authentication/concept-sspr-policy#userprincipalname-policies-that-apply-to-all-user-accounts).
   */
  userPrincipalName?: Maybe<Scalars['String']['output']>;
  /** Lists the current user roles of this user. */
  userRoles?: Maybe<Array<UserRole>>;
};


/**
 * Represents an Azure Active Directory (Azure AD) user account.
 *
 * For more information, see the [Microsoft Graph API Documentation](https://learn.microsoft.com/en-us/graph/api/resources/user?view=graph-rest-1.0).
 */
export type UserContactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContactOrderByClause>>;
  where?: InputMaybe<Array<ContactWhereClause>>;
};


/**
 * Represents an Azure Active Directory (Azure AD) user account.
 *
 * For more information, see the [Microsoft Graph API Documentation](https://learn.microsoft.com/en-us/graph/api/resources/user?view=graph-rest-1.0).
 */
export type UserJobsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JobOrderByClause>>;
  where?: InputMaybe<Array<JobWhereClause>>;
};


/**
 * Represents an Azure Active Directory (Azure AD) user account.
 *
 * For more information, see the [Microsoft Graph API Documentation](https://learn.microsoft.com/en-us/graph/api/resources/user?view=graph-rest-1.0).
 */
export type UserTeamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamOrderByClause>>;
  where?: InputMaybe<Array<TeamWhereClause>>;
};

/** Connection to `User`-nodes. */
export type UserConnection = Connection & {
  __typename: 'UserConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
};

/** The different ways a user account could have been created. */
export enum UserCreationType {
  /** Through self-service sign-up by an internal user using email verification. */
  EmailVerified = 'EMAIL_VERIFIED',
  /** As an external account invited to join the AzureAD-tenant. */
  Invitation = 'INVITATION',
  /** As a local account for an Azure Active Directory B2C tenant. */
  LocalAccount = 'LOCAL_ACCOUNT',
  /** Through self-service sign-up by an external user signing up through a link that is part of a user flow. */
  SelfServiceSignUp = 'SELF_SERVICE_SIGN_UP'
}

/** An edge in a `UserCollection`. */
export type UserEdge = Edge & {
  __typename: 'UserEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /**
   * The node at the end of this edge.
   *
   * This value is `null` iff the current access token has no permission to see the value of this node, but does have
   * the permission to see the values on the edges.
   */
  node?: Maybe<User>;
};

/** Represents an invitation to a contact to create a new user or to join a team. */
export type UserInvitation = Node & Timestamped & Userstamped & {
  __typename: 'UserInvitation';
  /** The moment on which this user invitation was accepted. */
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that accepted this user invitation. */
  acceptor?: Maybe<User>;
  /** The moment on which this user invitation was cancelled. */
  cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that cancelled this user invitation. */
  cancellor?: Maybe<User>;
  /** The contact to which this invitation will be send. */
  contact?: Maybe<Contact>;
  /** Gives the `DateTime` on which this `UserInvitation`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `UserInvitation`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** An internal description for this user invitation. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _updated_ this `UserInvitation`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /** The moment on which this user invitation will be expired. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The moment on which the user invitation failed. */
  failedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `UserInvitation`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `UserInvitation`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** A message that would appear in the invitation email that is send to the contact. */
  message?: Maybe<Scalars['HTML']['output']>;
  /** The moment on which the task to send this invitation was queued. */
  queuedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The moment on which this user invitation was sent to the `contact`. */
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  /** The current state of this invitation. */
  state?: Maybe<UserInvitationState>;
  /**
   * The teams to which a user will be added after accepting this invitation.
   *
   * The team-roles that this user will gain can be found on the edges of this connection.
   */
  teams?: Maybe<UserInvitation_TeamConnection>;
  /** The email address to which the invitation was send. */
  toEmail?: Maybe<Scalars['Email']['output']>;
  /** Gives the most recent moment on which this `UserInvitation`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user roles that a user will gain after accepting this invitation. */
  userRoles?: Maybe<Array<UserRole>>;
};


/** Represents an invitation to a contact to create a new user or to join a team. */
export type UserInvitationIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** Represents an invitation to a contact to create a new user or to join a team. */
export type UserInvitationIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** Represents an invitation to a contact to create a new user or to join a team. */
export type UserInvitationTeamsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TeamOrderByClause>>;
  where?: InputMaybe<Array<TeamWhereClause>>;
};

export type UserInvitationConnection = Connection & ConnectionWithTotal & {
  __typename: 'UserInvitationConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<UserInvitationEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<UserInvitation>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserInvitationEdge = Edge & {
  __typename: 'UserInvitationEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /**
   * The node at the end of this edge.
   *
   * This value is `null` iff the current access token has no permission to see the value of this node, but does have
   * the permission to see the values on the edges.
   */
  node?: Maybe<UserInvitation>;
};

/**
 * Specifies how the edges to a `UserInvitation` will be ordered in a connection.
 *
 * This type was automatically generated from the `UserInvitationOrderByColumn` column-type used in the
 * `orderBy` argument of the `Contact.userInvitations` field. (It might be possible that it is reused by
 * other fields.)
 */
export type UserInvitationOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: UserInvitationOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `UserInvitationOrderByColumn`. */
export enum UserInvitationOrderByColumn {
  /**
   * Alias for `JOB_TITLE`.
   *
   *  Form owner-type `Contact`.
   */
  ContactJobTitle = 'CONTACT_JOB_TITLE',
  /**
   * Alias for `NAME_FIRST`.
   *
   *  Form owner-type `Contact`.
   */
  ContactNameFirst = 'CONTACT_NAME_FIRST',
  /**
   * Alias for `NAME_LAST`.
   *
   *  Form owner-type `Contact`.
   */
  ContactNameLast = 'CONTACT_NAME_LAST',
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

/** Represents the state of a background-job. */
export enum UserInvitationState {
  /**
   * State when the invitation was accepted by the contact.
   *
   * This is a terminal state.
   */
  Accepted = 'ACCEPTED',
  /**
   * State when the invitation was cancelled. It cannot be accepted by the contact anymore, even if it was already
   * sent.
   *
   * This is a terminal state.
   */
  Cancelled = 'CANCELLED',
  /**
   * State when the invitation expired. It cannot be accepted by the contact anymore.
   *
   * This is a terminal state.
   */
  Expired = 'EXPIRED',
  /**
   * State when something went wrong with the invitation.
   *
   * This is a terminal state.
   */
  Failed = 'FAILED',
  /**
   * State when the task to send the invitation is queued.
   *
   * The next state can be `SEND`, `CANCELLED`, `EXPIRED` or `FAILED`.
   */
  Queued = 'QUEUED',
  /**
   * State when the invitation is ready to send.
   *
   * You may still update the message if the invitation is in this state.
   *
   * The next state can be `QUEUED` or `CANCELLED`.
   */
  Ready = 'READY',
  /**
   * State when the invitation was sent to the contact. The invitation is now waiting for a response of the contact.
   *
   * The next state can be `ACCEPTED`, `CANCELLED`, `EXPIRED` or `FAILED`.
   */
  Sent = 'SENT'
}

export type UserInvitationTeamInput = {
  /**
   * The team roles that will be assigned to the user that accepts this user invitation. An empty array will remove the
   * team from the assignments.
   */
  roles: Array<TeamRole>;
  /** The id of the team for which you want to assign the team roles. */
  teamId: Scalars['ID']['input'];
};

export type UserInvitationWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filter on the current state of the user invitation. */
  state?: InputMaybe<UserInvitationState>;
  /** Filters the entries by the total amount of related items they have in the relation `teamRoleAssignments`. */
  totalTeamRoleAssignments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `teams`. */
  totalTeams?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `userRoleAssignments`. */
  totalUserRoleAssignments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
};

export type UserInvitation_TeamConnection = Connection & ConnectionWithTotal & {
  __typename: 'UserInvitation_TeamConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<UserInvitation_TeamEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Team>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserInvitation_TeamEdge = Edge & {
  __typename: 'UserInvitation_TeamEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /**
   * The node at the end of this edge.
   *
   * This value is `null` iff the current access token has no permission to see the value of this node, but does have
   * the permission to see the values on the edges.
   */
  node?: Maybe<Team>;
  /** The team-roles that a user will gain after accepting the user invitation at the start of this edge. */
  roles?: Maybe<Array<TeamRole>>;
};

export type UserName = EntityName & {
  __typename: 'UserName';
  /** @deprecated use `given` instead. */
  casual?: Maybe<Scalars['String']['output']>;
  family?: Maybe<Scalars['String']['output']>;
  /** @deprecated use 'given' instead */
  first?: Maybe<Scalars['String']['output']>;
  formal?: Maybe<Scalars['String']['output']>;
  full?: Maybe<Scalars['String']['output']>;
  given?: Maybe<Scalars['String']['output']>;
  /** @deprecated data not available in b2c tenant */
  honorific: ContactNameHonorific;
  /** @deprecated data not available in b2c tenant */
  initials?: Maybe<Scalars['String']['output']>;
  /** @deprecated data not available in b2c tenant */
  last: ContactNameLast;
  /** @deprecated data not available in b2c tenant */
  middle?: Maybe<Scalars['String']['output']>;
  short?: Maybe<Scalars['String']['output']>;
  /** @deprecated use `User.mailNickname` instead. */
  username?: Maybe<Scalars['String']['output']>;
};

/**
 * Specifies how the edges to a `User` will be ordered in a connection.
 *
 * This type was automatically generated from the `UserOrderByColumn` column-type used in the
 * `orderBy` argument of the `Contact.users` field. (It might be possible that it is reused by
 * other fields.)
 */
export type UserOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: UserOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

export enum UserOrderByColumn {
  DisplayName = 'DISPLAY_NAME',
  UserPrincipalName = 'USER_PRINCIPAL_NAME'
}

/**
 * The explicit roles that can be assigned to a `User`.
 *
 * The difference between these roles and the roles of `TeamRole` is that these will always
 * be available for any `AccessToken` associated with the `User`. They do not depend on
 * the value of `AccessToken.team`.
 */
export enum UserRole {
  /**
   * ### Access-control Administrator *[User]*
   *
   * Beheert de globale rollen van gebruikers.
   */
  AccessAdmin = 'ACCESS_ADMIN',
  /**
   * ### Commerciëel Accountmanager *[User]*
   *
   * Beheert de accounts en teams van klanten.
   */
  Com = 'COM',
  /**
   * ### Developer *[User]*
   *
   * Rol voor de developers van de applicatie. Een gebruiker met deze rol kan de technische statistieken en debug-logs van de applicatie inzien.
   */
  Dev = 'DEV',
  /**
   * ### Redacteur *[User]*
   *
   * Schrijft de content van de applicaties.
   */
  Editor = 'EDITOR',
  /**
   * ### Technisch Onderhoud *[User]*
   *
   * Kan de technische staat van de applicatie inkijken, de database opschonen en periodieke acties instellen om de applicatie beter te laten werken.
   */
  Maintainer = 'MAINTAINER',
  /**
   * ### Producteigenaar *[User]*
   *
   * Kan inzien hoe de applicatie wordt gebruikt.
   */
  Po = 'PO',
  /**
   * ### Lezer *[User]*
   *
   * Mag alle default data lezen.
   */
  Reader = 'READER',
  /**
   * ### Superuser *[User]*
   *
   * Heeft elk mogelijke permissie in alle applicaties.
   */
  Super = 'SUPER'
}

export type User_TeamConnection = Connection & ConnectionWithTotal & {
  __typename: 'User_TeamConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<User_TeamEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<Team>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type User_TeamEdge = Edge & {
  __typename: 'User_TeamEdge';
  cursor: Scalars['Cursor']['output'];
  node: Team;
  roles?: Maybe<Array<TeamRole>>;
};

/** Implemented by nodes that store both the moment and the user of the create- and update- events. */
export type Userstamped = {
  /** `DateTime` on which this node was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that created this object. This value is always in sync with the `createdAt`-field. */
  creator?: Maybe<User>;
  /** The last user that edited this object. This value is always in sync with the `updatedAt`-field. */
  editor?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Whether this node is considered to be new.
   *
   * This feature was inherited from the `Shared Robotics`-project. It is left in as it might be useful in the future.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this node is considered to be updated.
   *
   * This feature was inherited from the `Shared Robotics`-project. It is left in as it might be useful in the future.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** `DateTime` of the last moment on which this node was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** Implemented by nodes that store both the moment and the user of the create- and update- events. */
export type UserstampedIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


/** Implemented by nodes that store both the moment and the user of the create- and update- events. */
export type UserstampedIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};

export type VerificationAction = Activateable & Commentable & Named & Node & Ownable & Selectable & Sluggable & SoftDelete & SoftDeleteUserstamped & Taggable & Timestamped & Usable & Userstamped & {
  __typename: 'VerificationAction';
  /** The comments for this `VerificationAction`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `VerificationAction`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `VerificationAction`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** Timestamp of when this `VerificationAction`-object was deactivated. */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that deactivated this `VerificationAction`-object. */
  deactivator?: Maybe<User>;
  /** Gives the moment on which this `VerificationAction`-object was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _deleted_ this `VerificationAction`-object.
   *
   * When this field is `null`, it can be the case that this object was not deleted or not deleted by a `User`. It will also
   * be `null` when the current user is not allowed to see the `User` that deleted this object.
   */
  destroyer?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `VerificationAction`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this `VerificationAction`-object is considered to be active. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `VerificationAction`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationAction` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationAction` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationAction` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `VerificationAction` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `VerificationAction`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationAction` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationAction` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationAction` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `VerificationAction` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Name>;
  /** A reference to the owner that owns this `VerificationAction`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `VerificationAction` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The `slug`, which is an *url-* and *filename-*safe string that uniquely identifies a node with a specific type.
   * It's value is usually derived from the initial data of the node (so the data it had when it was created).
   *
   * There are some important differences with the `id`-field:
   * 1. The value of `id` is always set, the value of `slug` might sometimes be `null` even if the node itself does
   * exists. This happens for instance when the node is soft-deleted.
   * 2. The value of `id` is globally unique, the value of `slug` is only unique in combination with the `__typename`.
   * 3. The value of `id` always refers to the **current node and only the current node**. The value of `slug` might
   * refer to a different node over time. (Example: when an old node is soft-deleted and a new node with the same
   * name is created. The new node will have the same `slug`-value as the older node.)
   * 4. The `slug` is guaranteed to be *url-* and *filename-*safe. The `id`-field does not have these guarantees.
   *
   * When available, prefer the `slug`-field over the `id`-field for usage in urls. For caching and communication with
   * the api, you should always use the `id`-field over the `slug`-field.
   */
  slug?: Maybe<Scalars['Slug']['output']>;
  /** Connection to the tags that are assigned to this `VerificationAction`. */
  tags?: Maybe<TagConnection>;
  /** Will be `true` if this `VerificationAction` is soft-deleted, `false` otherwise. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** Gives the most recent moment on which this `VerificationAction`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The verification configurations that use this action. */
  verificationConfigurations?: Maybe<VerificationConfigurationConnection>;
};


export type VerificationActionCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type VerificationActionIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type VerificationActionIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type VerificationActionIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type VerificationActionIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type VerificationActionIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type VerificationActionIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type VerificationActionOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type VerificationActionTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};


export type VerificationActionVerificationConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationWhereClause>>;
};

/**
 * A paged connection with `VerificationActionEdge` edges to `VerificationAction` nodes.
 *
 * This type was automatically generated from the `VerificationActionEdge` edge-type for the
 * `Team.ownedVerificationActions` field. (It might be possible that it is reused by other fields.)
 */
export type VerificationActionConnection = Connection & ConnectionWithTotal & {
  __typename: 'VerificationActionConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<VerificationActionEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<VerificationAction>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `VerificationActionConnection` connection that points to a `VerificationAction` node.
 *
 * This type was automatically generated from the `VerificationAction` node-type of the
 * `Team.ownedVerificationActions` field. (It might be possible that it is reused by other fields.)
 */
export type VerificationActionEdge = Edge & {
  __typename: 'VerificationActionEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: VerificationAction;
};

/**
 * Specifies how the edges to a `VerificationAction` will be ordered in a connection.
 *
 * This type was automatically generated from the `VerificationActionOrderByColumn` column-type used in the
 * `orderBy` argument of the `AnalysisReportEntry.verificationActions` field. (It might be possible that it is reused by
 * other fields.)
 */
export type VerificationActionOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: VerificationActionOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `VerificationActionOrderByColumn`. */
export enum VerificationActionOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which an entity was deactivated. */
  DeactivatedAt = 'DEACTIVATED_AT',
  /** Orders by the moment on which the entities were deleted. */
  DeletedAt = 'DELETED_AT',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type VerificationActionWhereClause = {
  /** Filter entries based on the current active state. See the `WhereActive`-enum for more information. */
  active?: InputMaybe<WhereActive>;
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were deactivated. */
  deactivated?: InputMaybe<StampedEventConstraints>;
  /** Filters the entries by the meta-data about the moment they were soft-deleted. */
  deleted?: InputMaybe<StampedEventConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters on the total amount of verification configuration rules that have an `INCLUDE`/`EXCLUDE` definition for the action. */
  totalVerificationConfigurationRuleDefinitions?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VerificationConfiguration = Commentable & Named & Node & Ownable & Selectable & Sluggable & SoftDelete & SoftDeleteUserstamped & Taggable & Timestamped & Usable & Userstamped & {
  __typename: 'VerificationConfiguration';
  /** The verification actions defined for this verification configuration. */
  actions?: Maybe<VerificationConfiguration_VerificationActionConnection>;
  /** The comments for this `VerificationConfiguration`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `VerificationConfiguration`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `VerificationConfiguration`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** Gives the moment on which this `VerificationConfiguration`-object was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The description of the verification configuration. Also used for full-text search.
   *
   * Safe to display to the user in a GUI.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _deleted_ this `VerificationConfiguration`-object.
   *
   * When this field is `null`, it can be the case that this object was not deleted or not deleted by a `User`. It will also
   * be `null` when the current user is not allowed to see the `User` that deleted this object.
   */
  destroyer?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `VerificationConfiguration`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `VerificationConfiguration`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationConfiguration` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationConfiguration` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationConfiguration` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `VerificationConfiguration` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether this `RiskConfiguration` is the default custom risk configuration for the `Team` of the `team`-field.
   *
   * This value will always be `false` if this `RiskConfiguration` is not owned by a team.
   * @deprecated use `defaultRiskConfiguration` on a team instead.
   */
  isTeamDefault?: Maybe<Scalars['Boolean']['output']>;
  isTeamDefaultFor?: Maybe<Scalars['Boolean']['output']>;
  isTeamDefaultForCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  isTeamDefaultForCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `VerificationConfiguration`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationConfiguration` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationConfiguration` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationConfiguration` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `VerificationConfiguration` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the verification configuration.
   *
   * Safe to display to the user in a GUI.
   */
  name?: Maybe<Name>;
  /** A reference to the owner that owns this `VerificationConfiguration`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `VerificationConfiguration` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /** Connection to the rules of this verification configuration. */
  rules?: Maybe<VerificationConfigurationRuleConnection>;
  /**
   * The `slug`, which is an *url-* and *filename-*safe string that uniquely identifies a node with a specific type.
   * It's value is usually derived from the initial data of the node (so the data it had when it was created).
   *
   * There are some important differences with the `id`-field:
   * 1. The value of `id` is always set, the value of `slug` might sometimes be `null` even if the node itself does
   * exists. This happens for instance when the node is soft-deleted.
   * 2. The value of `id` is globally unique, the value of `slug` is only unique in combination with the `__typename`.
   * 3. The value of `id` always refers to the **current node and only the current node**. The value of `slug` might
   * refer to a different node over time. (Example: when an old node is soft-deleted and a new node with the same
   * name is created. The new node will have the same `slug`-value as the older node.)
   * 4. The `slug` is guaranteed to be *url-* and *filename-*safe. The `id`-field does not have these guarantees.
   *
   * When available, prefer the `slug`-field over the `id`-field for usage in urls. For caching and communication with
   * the api, you should always use the `id`-field over the `slug`-field.
   */
  slug?: Maybe<Scalars['Slug']['output']>;
  /** Connection to the tags that are assigned to this `VerificationConfiguration`. */
  tags?: Maybe<TagConnection>;
  /** Will be `true` if this `VerificationConfiguration` is soft-deleted, `false` otherwise. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** Gives the most recent moment on which this `VerificationConfiguration`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The question predicates used in this rule. */
  usedQuestionPredicates?: Maybe<QuestionPredicateConnection>;
  /** The regions used by this rule. */
  usedRegions?: Maybe<RegionConnection>;
  /** The risk configuration levels used by this rule. */
  usedRiskConfigurationLevels?: Maybe<RiskConfigurationLevelConnection>;
  /** The risk configuration probabilities used by this rule. */
  usedRiskConfigurationProbabilities?: Maybe<RiskConfigurationProbabilityConnection>;
  /** The risk configuration probabilities used by this rule. */
  usedRiskConfigurationSeverities?: Maybe<RiskConfigurationSeverityConnection>;
  /**
   * The risk configurations from which at least one risk configuration segment is used in at least one rule of this
   * verification configuration.
   */
  usedRiskConfigurations?: Maybe<RiskConfigurationConnection>;
  /** The verification predicates used by this rule. */
  usedVerificationPredicates?: Maybe<VerificationPredicateConnection>;
};


export type VerificationConfigurationActionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationActionOrderByClause>>;
  where?: InputMaybe<Array<VerificationActionWhereClause>>;
};


export type VerificationConfigurationCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type VerificationConfigurationIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type VerificationConfigurationIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type VerificationConfigurationIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type VerificationConfigurationIsTeamDefaultForArgs = {
  team: Scalars['ID']['input'];
};


export type VerificationConfigurationIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type VerificationConfigurationIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type VerificationConfigurationIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type VerificationConfigurationOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type VerificationConfigurationRulesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationRuleOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationRuleWhereClause>>;
};


export type VerificationConfigurationTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};


export type VerificationConfigurationUsedQuestionPredicatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QuestionPredicateOrderByClause>>;
  where?: InputMaybe<Array<QuestionPredicateWhereClause>>;
};


export type VerificationConfigurationUsedRegionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegionOrderByClause>>;
  where?: InputMaybe<Array<RegionWhereClause>>;
};


export type VerificationConfigurationUsedRiskConfigurationLevelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskConfigurationLevelOrderByClause>>;
  where?: InputMaybe<Array<RiskConfigurationLevelWhereClause>>;
};


export type VerificationConfigurationUsedRiskConfigurationProbabilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskConfigurationProbabilityOrderByClause>>;
  where?: InputMaybe<Array<RiskConfigurationProbabilityWhereClause>>;
};


export type VerificationConfigurationUsedRiskConfigurationSeveritiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskConfigurationSeverityOrderByClause>>;
  where?: InputMaybe<Array<RiskConfigurationSeverityWhereClause>>;
};


export type VerificationConfigurationUsedRiskConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskConfigurationOrderByClause>>;
  where?: InputMaybe<Array<RiskConfigurationWhereClause>>;
};


export type VerificationConfigurationUsedVerificationPredicatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationPredicateOrderByClause>>;
  where?: InputMaybe<Array<VerificationPredicateWhereClause>>;
};

export type VerificationConfigurationConnection = Connection & ConnectionWithTotal & {
  __typename: 'VerificationConfigurationConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<VerificationConfigurationEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<VerificationConfiguration>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type VerificationConfigurationEdge = Edge & {
  __typename: 'VerificationConfigurationEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /**
   * The node at the end of this edge.
   *
   * This value is `null` iff the current access token has no permission to see the value of this node, but does have
   * the permission to see the values on the edges.
   */
  node?: Maybe<VerificationConfiguration>;
};

/** Specifies how the edges to a `VerificationConfiguration` will be ordered in a connection. */
export type VerificationConfigurationOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: VerificationConfigurationOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `VerificationConfigurationOrderByColumn`. */
export enum VerificationConfigurationOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which the entities were deleted. */
  DeletedAt = 'DELETED_AT',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type VerificationConfigurationRule = Activateable & Commentable & Named & Node & Ownable & Selectable & Taggable & Timestamped & Usable & Userstamped & {
  __typename: 'VerificationConfigurationRule';
  /** The comments for this `VerificationConfigurationRule`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `VerificationConfigurationRule`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `VerificationConfigurationRule`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /** Timestamp of when this `VerificationConfigurationRule`-object was deactivated. */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user that deactivated this `VerificationConfigurationRule`-object. */
  deactivator?: Maybe<User>;
  /** The description of the rule. */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _updated_ this `VerificationConfigurationRule`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   *
   * See the `Node.id` field for more information.
   */
  id: Scalars['ID']['output'];
  /** Whether this `VerificationConfigurationRule`-object is considered to be active. */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `VerificationConfigurationRule`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationConfigurationRule` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationConfigurationRule` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationConfigurationRule` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `VerificationConfigurationRule` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `VerificationConfigurationRule`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationConfigurationRule` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationConfigurationRule` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationConfigurationRule` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `VerificationConfigurationRule` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the rule. Can be `null` if the rule has no name. */
  name?: Maybe<Name>;
  /** A reference to the owner that owns this `VerificationConfigurationRule`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `VerificationConfigurationRule` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /** The precedence of this rule. A rule with an higher precedence will overwrite a rule with a lower precedence. */
  precedence?: Maybe<Scalars['Int']['output']>;
  /** The predicate expression of this rule. it must evaluate to `YES` for this rule to apply. */
  predicateExpression?: Maybe<AnalysisEntryPredicateExpression>;
  /** Connection to the tags that are assigned to this `VerificationConfigurationRule`. */
  tags?: Maybe<TagConnection>;
  /** Gives the most recent moment on which this `VerificationConfigurationRule`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The question predicates used in this rule. */
  usedQuestionPredicates?: Maybe<QuestionPredicateConnection>;
  /** The regions used by this rule. */
  usedRegions?: Maybe<RegionConnection>;
  /** The risk configuration levels used by this rule. */
  usedRiskConfigurationLevels?: Maybe<RiskConfigurationLevelConnection>;
  /** The risk configuration probabilities used by this rule. */
  usedRiskConfigurationProbabilities?: Maybe<RiskConfigurationProbabilityConnection>;
  /** The risk configuration probabilities used by this rule. */
  usedRiskConfigurationSeverity?: Maybe<RiskConfigurationSeverityConnection>;
  /** The risk configurations from which this rule uses at least one risk configuration segment. */
  usedRiskConfigurations?: Maybe<RiskConfigurationConnection>;
  /** The verification predicates used by this rule. */
  usedVerificationPredicates?: Maybe<VerificationPredicateConnection>;
  /** Connection to the verification actions that this rule assigns. */
  verificationActions?: Maybe<VerificationConfigurationRule_VerificationActionConnection>;
  /** The verification configuration to which this rule belongs. */
  verificationConfiguration?: Maybe<VerificationConfiguration>;
};


export type VerificationConfigurationRuleCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type VerificationConfigurationRuleIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type VerificationConfigurationRuleIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type VerificationConfigurationRuleIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type VerificationConfigurationRuleIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type VerificationConfigurationRuleIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type VerificationConfigurationRuleIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type VerificationConfigurationRuleOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type VerificationConfigurationRulePredicateExpressionArgs = {
  substitute?: InputMaybe<Array<PredicateExpressionTermSubstitution>>;
};


export type VerificationConfigurationRuleTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};


export type VerificationConfigurationRuleUsedQuestionPredicatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<QuestionPredicateOrderByClause>>;
  where?: InputMaybe<Array<QuestionPredicateWhereClause>>;
};


export type VerificationConfigurationRuleUsedRegionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RegionOrderByClause>>;
  where?: InputMaybe<Array<RegionWhereClause>>;
};


export type VerificationConfigurationRuleUsedRiskConfigurationLevelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskConfigurationLevelOrderByClause>>;
  where?: InputMaybe<Array<RiskConfigurationLevelWhereClause>>;
};


export type VerificationConfigurationRuleUsedRiskConfigurationProbabilitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskConfigurationProbabilityOrderByClause>>;
  where?: InputMaybe<Array<RiskConfigurationProbabilityWhereClause>>;
};


export type VerificationConfigurationRuleUsedRiskConfigurationSeverityArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskConfigurationSeverityOrderByClause>>;
  where?: InputMaybe<Array<RiskConfigurationSeverityWhereClause>>;
};


export type VerificationConfigurationRuleUsedRiskConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RiskConfigurationOrderByClause>>;
  where?: InputMaybe<Array<RiskConfigurationWhereClause>>;
};


export type VerificationConfigurationRuleUsedVerificationPredicatesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationPredicateOrderByClause>>;
  where?: InputMaybe<Array<VerificationPredicateWhereClause>>;
};


export type VerificationConfigurationRuleVerificationActionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationActionOrderByClause>>;
  where?: InputMaybe<Array<VerificationActionWhereClause>>;
};

/**
 * A paged connection with `VerificationConfigurationRuleEdge` edges to `VerificationConfigurationRule` nodes.
 *
 * This type was automatically generated from the `VerificationConfigurationRuleEdge` edge-type for the
 * `AnalysisReport.applicableVerificationRules` field. (It might be possible that it is reused by other fields.)
 */
export type VerificationConfigurationRuleConnection = Connection & ConnectionWithTotal & {
  __typename: 'VerificationConfigurationRuleConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<VerificationConfigurationRuleEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<VerificationConfigurationRule>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An edge in the `VerificationConfigurationRuleConnection` connection that points to a `VerificationConfigurationRule` node.
 *
 * This type was automatically generated from the `VerificationConfigurationRule` node-type of the
 * `AnalysisReport.applicableVerificationRules` field. (It might be possible that it is reused by other fields.)
 */
export type VerificationConfigurationRuleEdge = Edge & {
  __typename: 'VerificationConfigurationRuleEdge';
  /**
   * An opaque string that can be used in the `after`/`before` arguments to load the elements before/after
   * this field.
   *
   * **IMPORTANT!** This cursor will only work when the `orderBy` field of the connection is set to the same
   * value as the current connection.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node to which this edge points. */
  node: VerificationConfigurationRule;
};

/**
 * Specifies how the edges to a `VerificationConfigurationRule` will be ordered in a connection.
 *
 * This type was automatically generated from the `VerificationConfigurationRuleOrderByColumn` column-type used in the
 * `orderBy` argument of the `AnalysisReport.applicableVerificationRules` field. (It might be possible that it is reused by
 * other fields.)
 */
export type VerificationConfigurationRuleOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: VerificationConfigurationRuleOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `VerificationConfigurationRuleOrderByColumn`. */
export enum VerificationConfigurationRuleOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which an entity was deactivated. */
  DeactivatedAt = 'DEACTIVATED_AT',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /** order by the precedence field. */
  Precedence = 'PRECEDENCE',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT',
  /**
   * Orders by the full name of the verification configuration to which the nodes belong.
   *
   *  Form owner-type `VerificationConfiguration`.
   */
  VerificationConfigurationNameFull = 'VERIFICATION_CONFIGURATION_NAME_FULL',
  /**
   * Orders by the short name of the verification configuration to which the nodes belong.
   *
   *  Form owner-type `VerificationConfiguration`.
   */
  VerificationConfigurationNameShort = 'VERIFICATION_CONFIGURATION_NAME_SHORT'
}

export type VerificationConfigurationRuleWhereClause = {
  /** Filter entries based on the current active state. See the `WhereActive`-enum for more information. */
  active?: InputMaybe<WhereActive>;
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were deactivated. */
  deactivated?: InputMaybe<StampedEventConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usedQuestionPredicates`. */
  totalUsedQuestionPredicates?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usedRegions`. */
  totalUsedRegions?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usedRiskConfigurationLevels`. */
  totalUsedRiskConfigurationLevels?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usedRiskConfigurationProbabilities`. */
  totalUsedRiskConfigurationProbabilities?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usedRiskConfigurationSeverities`. */
  totalUsedRiskConfigurationSeverities?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usedRiskConfigurations`. */
  totalUsedRiskConfigurations?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usedVerificationPredicates`. */
  totalUsedVerificationPredicates?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `verificationActions`. */
  totalVerificationActions?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VerificationConfigurationRule_VerificationActionConnection = Connection & ConnectionWithTotal & {
  __typename: 'VerificationConfigurationRule_VerificationActionConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<VerificationConfigurationRule_VerificationActionEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<VerificationAction>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type VerificationConfigurationRule_VerificationActionEdge = Edge & {
  __typename: 'VerificationConfigurationRule_VerificationActionEdge';
  /** The assignment type for this action. */
  assignmentType?: Maybe<ActionAssignmentType>;
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /** The node at the end of this edge. */
  node: VerificationAction;
};

export type VerificationConfigurationWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were soft-deleted. */
  deleted?: InputMaybe<StampedEventConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters the entries by the total amount of related items they have in the relation `analysisReports`. */
  totalAnalysisReports?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usedQuestionPredicates`. */
  totalUsedQuestionPredicates?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usedRegions`. */
  totalUsedRegions?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usedRiskConfigurationLevels`. */
  totalUsedRiskConfigurationLevels?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usedRiskConfigurationProbabilities`. */
  totalUsedRiskConfigurationProbabilities?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usedRiskConfigurationSeverities`. */
  totalUsedRiskConfigurationSeverities?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usedRiskConfigurations`. */
  totalUsedRiskConfigurations?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `usedVerificationPredicates`. */
  totalUsedVerificationPredicates?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `actions`. */
  totalVerificationActions?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the total amount of related items they have in the relation `rules`. */
  totalVerificationConfigurationRules?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A paged connection with `VerificationConfiguration_VerificationActionEdge` edges to `VerificationAction` nodes.
 *
 * This type was automatically generated from the `VerificationConfiguration_VerificationActionEdge` edge-type for the
 * `VerificationConfiguration.actions` field. (It might be possible that it is reused by other fields.)
 */
export type VerificationConfiguration_VerificationActionConnection = Connection & ConnectionWithTotal & {
  __typename: 'VerificationConfiguration_VerificationActionConnection';
  /** The edges of the current page in this connection. */
  edges?: Maybe<Array<Maybe<VerificationConfiguration_VerificationActionEdge>>>;
  /** The nodes of the current page in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<VerificationAction>>>;
  /** Information about page currently shown in the `edges`-field. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the shown page). */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type VerificationConfiguration_VerificationActionEdge = Edge & {
  __typename: 'VerificationConfiguration_VerificationActionEdge';
  cursor: Scalars['Cursor']['output'];
  defaultValue?: Maybe<PredicateValue>;
  node: VerificationAction;
  order: Scalars['Int']['output'];
  remarks?: Maybe<Scalars['HTML']['output']>;
};

export type VerificationPredicate = AnalysisEntryPredicate & Commentable & Named & Node & Ownable & Predicate & Selectable & SoftDelete & SoftDeleteUserstamped & Taggable & Timestamped & Usable & Userstamped & {
  __typename: 'VerificationPredicate';
  /** The comments for this `VerificationPredicate`-object. */
  comments?: Maybe<CommentConnection>;
  /** Gives the `DateTime` on which this `VerificationPredicate`-object was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Gives the `User` that _created_ this `VerificationPredicate`-object.
   *
   * When this field is `null`, it can be the case that this object was not created by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that created this object.
   */
  creator?: Maybe<User>;
  /**
   * The default value for a node that has no explicit value for this predicate set.
   *
   * See the `Predicate.defaultPredicateValue` field for more information.
   */
  defaultPredicateValue?: Maybe<PredicateValue>;
  /** Gives the moment on which this `VerificationPredicate`-object was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * A longer, plain-text value that helps the user to identify this node. When a collection of these nodes are
   * full-text searchable, it will also search over the values in this field.
   *
   * It is always safe to show in the GUI.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * Gives the `User` that _deleted_ this `VerificationPredicate`-object.
   *
   * When this field is `null`, it can be the case that this object was not deleted or not deleted by a `User`. It will also
   * be `null` when the current user is not allowed to see the `User` that deleted this object.
   */
  destroyer?: Maybe<User>;
  /**
   * Gives the `User` that _updated_ this `VerificationPredicate`-object.
   *
   * When this field is `null`, it can be the case that this object was not updated by a `User`. It will also be `null` when
   * the current user is not allowed to see the `User` that updated this object.
   */
  editor?: Maybe<User>;
  /**
   * An globally unique identifier that can be used in de `node` and `nodes` queries to retrieve this object. This
   * value is also often used in arguments to reference to his object.
   */
  id: Scalars['ID']['output'];
  /**
   * Gives whether this `VerificationPredicate`-object is considered to be _new_.
   *
   * An object is considered to be _new_ if the `DateTime` of the `created_at` field is less then a certain interval ago (see
   * the `interval`-argument on this field for more information). The default interval is _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is created or when the creation
   * moment is unknown due to legacy reasons.
   */
  isNew?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationPredicate` is owned by the owner with the provided id. */
  isOwnedBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationPredicate` is owned by the common GINO library Team. */
  isOwnedByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationPredicate` is owned by the currently authenticated team. */
  isOwnedByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `VerificationPredicate` has the same owner as the ownable with the provided id.
   *
   * Using this field is preferred over `isOwnedBy` if it saves a query to retrieve the required owner-id.
   */
  isOwnedByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Gives whether this `VerificationPredicate`-object is considered to be _updated_.
   *
   * An object is considered to be _updated_ if the `DateTime` of the `updated_at` field is less then a certain interval ago
   * (see the `interval`-argument on this field for more information). The default interval is
   * _(2 weeks)_.
   *
   * This value will be `null` if the current user is not allowed know when this object is updated or when the last update
   * moment is unknown due to legacy reasons.
   */
  isUpdated?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationPredicate` is usable by the owner with the provided id. */
  isUsableBy?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationPredicate` is usable by the common GINO team. */
  isUsableByCommonGinoTeam?: Maybe<Scalars['Boolean']['output']>;
  /** Checks whether this `VerificationPredicate` is usable by the currently authenticated team. */
  isUsableByCurrentTeam?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Checks whether this `VerificationPredicate` is usable by the owner of the ownable node with the provided id.
   *
   * This allows for checking usability of a `Usable` node without knowing the actual underlying owner id,
   * which can save an extra fetch step.
   */
  isUsableByOwnerOf?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The name of the node, which should be enough for the user that is familiar with the data to identify this node.
   *
   * It is always safe to show in the GUI.
   */
  name?: Maybe<EntityName>;
  /** A reference to the owner that owns this `VerificationPredicate`. */
  owner?: Maybe<Owner>;
  /**
   * Checks whether the owner of this `VerificationPredicate` can use the usable with the provided id.
   *
   * This field is functionally the same as `owner.canUse(usable: ID!)`. However, using this field if possible
   * is preferred, as the result can be loaded more efficiently, especially when retrieving a large set of
   * ownables.
   */
  ownerCanUse?: Maybe<Scalars['Boolean']['output']>;
  /**
   * An HTML-formatted field with a closed-form question to the user to explain the predicate.
   *
   * This value is always safe to show in the GUI.
   *
   * See the `Predicate.predicateQuestion` field for more information.
   */
  predicateQuestion?: Maybe<Scalars['HTML']['output']>;
  /** Connection to the tags that are assigned to this `VerificationPredicate`. */
  tags?: Maybe<TagConnection>;
  /** Will be `true` if this `VerificationPredicate` is soft-deleted, `false` otherwise. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** Gives the most recent moment on which this `VerificationPredicate`-object was updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Connection to the verification configuration rules that use this predicate. */
  usedByVerificationConfigurationRules?: Maybe<VerificationConfigurationRuleConnection>;
  /** Connection to the verification configurations that use this verification predicate. */
  usedByVerificationConfigurations?: Maybe<VerificationConfigurationConnection>;
};


export type VerificationPredicateCommentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CommentOrderByClause>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Array<CommentWhereClause>>;
};


export type VerificationPredicateIsNewArgs = {
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type VerificationPredicateIsOwnedByArgs = {
  owner: Scalars['ID']['input'];
};


export type VerificationPredicateIsOwnedByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type VerificationPredicateIsUpdatedArgs = {
  allowNew?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['DateTimeInterval']['input']>;
};


export type VerificationPredicateIsUsableByArgs = {
  owner: Scalars['ID']['input'];
};


export type VerificationPredicateIsUsableByOwnerOfArgs = {
  ownable: Scalars['ID']['input'];
};


export type VerificationPredicateOwnerCanUseArgs = {
  usable: Scalars['ID']['input'];
};


export type VerificationPredicateTagsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TagOrderByClause>>;
  where?: InputMaybe<Array<TagWhereClause>>;
};


export type VerificationPredicateUsedByVerificationConfigurationRulesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationRuleOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationRuleWhereClause>>;
};


export type VerificationPredicateUsedByVerificationConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VerificationConfigurationOrderByClause>>;
  where?: InputMaybe<Array<VerificationConfigurationWhereClause>>;
};

export type VerificationPredicateConnection = Connection & ConnectionWithTotal & {
  __typename: 'VerificationPredicateConnection';
  /** The (paged) edges in this connection. */
  edges?: Maybe<Array<Maybe<VerificationPredicateEdge>>>;
  /** The (paged) nodes in this connection. Equivalent to `edges.node`. */
  nodes?: Maybe<Array<Maybe<VerificationPredicate>>>;
  /** Information about the edges shown on the current page. */
  pageInfo: PageInfo;
  /** The total amount of edges in this connection (not just the edges shown on this page.) */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type VerificationPredicateEdge = Edge & {
  __typename: 'VerificationPredicateEdge';
  /**
   * A cursor which is used to page through a connection. It's value is unique for the whole collection, but it's value
   * depends on the `orderBy`-argument.
   */
  cursor: Scalars['Cursor']['output'];
  /**
   * The node at the end of this edge.
   *
   * This value is `null` iff the current access token has no permission to see the value of this node, but does have
   * the permission to see the values on the edges.
   */
  node?: Maybe<VerificationPredicate>;
};

/**
 * Specifies how the edges to a `VerificationPredicate` will be ordered in a connection.
 *
 * This type was automatically generated from the `VerificationPredicateOrderByColumn` column-type used in the
 * `orderBy` argument of the `AnalysisReportEntry.verificationPredicates` field. (It might be possible that it is reused by
 * other fields.)
 */
export type VerificationPredicateOrderByClause = {
  /** The orderable column on which the nodes will be sorted. */
  column: VerificationPredicateOrderByColumn;
  /**
   * The order in which the records will be sorted. Set this value to `DESC` to reverse the default ordering
   * of the specified column.
   */
  order?: SortOrder;
};

/** Represents a column of the entity that can be used to order a connection of edges to an `VerificationPredicateOrderByColumn`. */
export enum VerificationPredicateOrderByColumn {
  /** Orders by the moment on which each entity was created. */
  CreatedAt = 'CREATED_AT',
  /** Orders by the moment on which the entities were deleted. */
  DeletedAt = 'DELETED_AT',
  /** Orders by the full name of the entities. (see the `name.full` field.) */
  NameFull = 'NAME_FULL',
  /** Orders by the short name of the entities. (see the `name.short` field.) */
  NameShort = 'NAME_SHORT',
  /**
   * Orders by the full name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameFull = 'OWNER_NAME_FULL',
  /**
   * Orders by the short name of the owner of each node.
   *
   *  Form owner-type `Team`.
   */
  OwnerNameShort = 'OWNER_NAME_SHORT',
  /** Orders by the moment on which each entity was last updated. */
  UpdatedAt = 'UPDATED_AT'
}

export type VerificationPredicateWhereClause = {
  /**
   * Filters on entries that belong to all the nodes in the provided array.
   *
   * Whether an entry `X` (in the result) belongs to node `Y` (provided in this argument) roughly follows
   * the following rule:
   *
   * > `X` belongs to `Y` iff there is some path (in the GraphQL-API) from `Y` to `X` that contains
   * > *at least one* connection-type. The shortest path is used when there are multiple paths possible.
   *
   * There are some restrictions on whether `X` is considered to belong to `Y`:
   *     1. If `Y` uniquely determines `X`, it can never be the case that `X` belongs to `Y`.
   *        ( *Example:* A `SupplierBranch` can belong to a `Supplier`, but a `Supplier` never belongs to a
   *        `SupplierBranch`)
   *     2. The information barrier between `Product`s and `Risk`s can never be resolved. (This is mainly
   *        due to performance issues. This means that `belongsTo` cannot be used as a substitute for an
   *        `AnalysisReport`)
   *
   * See the `belongsTo`-matrix in the documentation for the full list of rules (work in progress).
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entries by the creation meta-data. */
  created?: InputMaybe<StampConstraints>;
  /** Filters the entries by the meta-data about the moment they were soft-deleted. */
  deleted?: InputMaybe<StampedEventConstraints>;
  /** Filters the entities that have at least one the provided tags assigned to them. */
  hasAnyTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the entities that have *all* the provided tags assigned to them. */
  hasEachTagIn?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on whether the owner of the entity is the common ADMIN team. */
  ownedByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common DEV team. */
  ownedByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common FLG team. */
  ownedByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the common GINO team. */
  ownedByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the current team. */
  ownedByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the owner of the entity is the SYS team. */
  ownedBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters by the amount of comments made to the entity. */
  totalComments?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters on the total amount of verification configuration rules that use this predicate. */
  totalUsedByVerificationConfigurationRules?: InputMaybe<IntLinearOrderConstraints>;
  /** Filters the entries by the meta-data about the last update. */
  updated?: InputMaybe<StampConstraints>;
  /** Filters on whether the entity is the usable by the common ADMIN team. */
  usableByCommonAdminTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common DEV team. */
  usableByCommonDevTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common FLG team. */
  usableByCommonFlgTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the common GINO team. */
  usableByCommonGinoTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether of the entity is usable by the current team. */
  usableByCurrentTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters on whether the entity is usable by the SYS team. */
  usableBySystemTeam?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VerifyAnalysisReportEntriesHaveNeededVerificationPredicateValuesResult = {
  __typename: 'VerifyAnalysisReportEntriesHaveNeededVerificationPredicateValuesResult';
  node: AnalysisReport;
};

export type VerifyAnalysisReportProductRiskValuesResult = {
  __typename: 'VerifyAnalysisReportProductRiskValuesResult';
  node: AnalysisReport;
};

export type VerifyAnalysisReportProductsBelongToProductCategoriesResult = {
  __typename: 'VerifyAnalysisReportProductsBelongToProductCategoriesResult';
  node: AnalysisReport;
};

export type VerifyAnalysisReportProductsHaveNeededPredicateValuesResult = {
  __typename: 'VerifyAnalysisReportProductsHaveNeededPredicateValuesResult';
  node: AnalysisReport;
};

export type VerifyAnalysisReportProductsHaveSupplierBranchesResult = {
  __typename: 'VerifyAnalysisReportProductsHaveSupplierBranchesResult';
  node: AnalysisReport;
};

export type Warning = {
  message: Message;
};

/**
 * Configures how the activated records should be shown in the result. See the `Activateble`-interface for more
 * information.
 */
export enum WhereActive {
  /** Only show records that are active. Hide all inactive records. */
  Only = 'ONLY',
  /** Show both active and inactive records. */
  With = 'WITH',
  /** Only show records that are deactivated. Hide all active records. */
  Without = 'WITHOUT'
}

export enum WhereCountrySupport {
  Only = 'ONLY',
  With = 'WITH',
  Without = 'WITHOUT'
}

/**
 * Describes how the results of `NestedSetNode`s should be filtered based on whether they are leaf nodes or not.
 *
 * A `NestedSetNode` is considered to be a leaf if it has no children.
 */
export enum WhereLeaves {
  /** Only shows nodes that are leaves, hides all non-leaf nodes. */
  Only = 'ONLY',
  /** Shows both the leaf nodes and non-leaf nodes. */
  With = 'WITH',
  /** Hides all leaf nodes. */
  Without = 'WITHOUT'
}

export type WhereProductClause = {
  /**
   * Filter that passes for products that belong to all of the given nodes.
   *
   * Whether a product belongs to a certain node is dependent on the type of that node. A product belongs to a
   *  - `Team`            iff the `Product.team` is that team.
   *  - `Company`         iff `Product.team.company` is that company.
   *  - `AnalysisReport`  iff `AnalysisReport.products` contains that product.
   *  - `ProductCategory` iff that `ProductCategory` is in `Product.categoriesWithAncestors`.
   *  - `Tag`             iff that `Tag` is in `Product.tags`.
   *  - `SupplierBranch`  iff that `SupplierBranch` is in `Product.supplierBranches`.
   *  - `Supplier`        iff there is a `SupplierBranch` in `Product.supplierBranches` such that
   *                          `SupplierBranch.supplier` is that supplier.
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters on the total amount of predicate values of the product. */
  totalPredicateValues?: InputMaybe<IntLinearOrderConstraints>;
  /** Filter on the amount of `ProductCategory`s to which a `Product` belongs. */
  totalProductCategories?: InputMaybe<IntLinearOrderConstraints>;
  /** Filter on the amount of `SupplierBranch`es that are associated with the product. */
  totalSupplierBranches?: InputMaybe<IntLinearOrderConstraints>;
};

export type WhereRiskClause = {
  /**
   * Filter that passes for risks that belong to all of the given nodes.
   *
   * Whether a risk belongs to a certain node is dependent on the type of that node. A risk belongs to a
   * - `Threat`          iff `Risk.threat` is that threat
   * - `ProductCategory` iff that `ProductCategory` is in `Risk.productCategories`.
   * - `Tag`             iff that `Tag` is in `Product.tags`.
   */
  belongsTo?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Describes how the results of `NestedSetNode`s should be filtered based on whether they are root nodes or not.
 *
 * A `NestedSetNode` is considered to be a root if it has no parent.
 */
export enum WhereRoots {
  /** Only shows nodes that are roots, hides all non-root nodes. */
  Only = 'ONLY',
  /** Shows both the root nodes and non-root nodes. */
  With = 'WITH',
  /** Hides all root nodes. */
  Without = 'WITHOUT'
}


export interface ObjectTypes {
    AccessToken: AccessToken
    AccountConnection: AccountConnection
    AccountEdge: AccountEdge
    ActivateMany_SuccessResult: ActivateMany_SuccessResult
    Activate_SuccessResult: Activate_SuccessResult
    Address: Address
    AddressFormat: AddressFormat
    AffineTransformation: AffineTransformation
    AnalysisEntryPredicateConnection: AnalysisEntryPredicateConnection
    AnalysisEntryPredicateEdge: AnalysisEntryPredicateEdge
    AnalysisEntryPredicateExpression: AnalysisEntryPredicateExpression
    AnalysisReport: AnalysisReport
    AnalysisReportConnection: AnalysisReportConnection
    AnalysisReportEdge: AnalysisReportEdge
    AnalysisReportEntry: AnalysisReportEntry
    AnalysisReportEntryConnection: AnalysisReportEntryConnection
    AnalysisReportEntryEdge: AnalysisReportEntryEdge
    AnalysisReportEntryProbability: AnalysisReportEntryProbability
    AnalysisReportEntryProbabilityOverwriteEvent: AnalysisReportEntryProbabilityOverwriteEvent
    AnalysisReportEntryRiskLevel: AnalysisReportEntryRiskLevel
    AnalysisReportEntrySeverity: AnalysisReportEntrySeverity
    AnalysisReportEntrySeverityOverwriteEvent: AnalysisReportEntrySeverityOverwriteEvent
    AnalysisReportEntry_ProbabilityOverwriteEventConnection: AnalysisReportEntry_ProbabilityOverwriteEventConnection
    AnalysisReportEntry_ProbabilityOverwriteEventEdge: AnalysisReportEntry_ProbabilityOverwriteEventEdge
    AnalysisReportEntry_SeverityOverwriteEventConnection: AnalysisReportEntry_SeverityOverwriteEventConnection
    AnalysisReportEntry_SeverityOverwriteEventEdge: AnalysisReportEntry_SeverityOverwriteEventEdge
    AnalysisReportEntry_VerificationActionConnection: AnalysisReportEntry_VerificationActionConnection
    AnalysisReportEntry_VerificationActionEdge: AnalysisReportEntry_VerificationActionEdge
    AnalysisReportEntry_VerificationPredicateConnection: AnalysisReportEntry_VerificationPredicateConnection
    AnalysisReportEntry_VerificationPredicateEdge: AnalysisReportEntry_VerificationPredicateEdge
    AnalysisReportInvalidStateException: AnalysisReportInvalidStateException
    AnalysisReportProductRisk: AnalysisReportProductRisk
    AnalysisReportProductRiskConnection: AnalysisReportProductRiskConnection
    AnalysisReportProductRiskEdge: AnalysisReportProductRiskEdge
    AnalysisReportProductRisk_ProductPredicateConnection: AnalysisReportProductRisk_ProductPredicateConnection
    AnalysisReportProductRisk_ProductPredicateEdge: AnalysisReportProductRisk_ProductPredicateEdge
    AnalysisReportRiskConfigurationChangedWarning: AnalysisReportRiskConfigurationChangedWarning
    AnalysisReportTodoConnection: AnalysisReportTodoConnection
    AnalysisReportTodoEdge: AnalysisReportTodoEdge
    AnalysisReportTodoListNotEmptyException: AnalysisReportTodoListNotEmptyException
    AnalysisReportVerificationConfigurationChangedWarning: AnalysisReportVerificationConfigurationChangedWarning
    AnalysisReport_RiskConfigurationConnection: AnalysisReport_RiskConfigurationConnection
    AnalysisReport_RiskConfigurationEdge: AnalysisReport_RiskConfigurationEdge
    AssignProductCategoryToProductTodo: AssignProductCategoryToProductTodo
    AssignSupplierBranchToProductTodo: AssignSupplierBranchToProductTodo
    AssignTeamRole_SuccessResult: AssignTeamRole_SuccessResult
    AssignTeamRoles_SuccessResult: AssignTeamRoles_SuccessResult
    AssignUserRole_SuccessResult: AssignUserRole_SuccessResult
    AssignUserRoles_SuccessResult: AssignUserRoles_SuccessResult
    AttachTags_SuccessResult: AttachTags_SuccessResult
    AuditConnection: AuditConnection
    AuditEdge: AuditEdge
    AzureBlobStorageFileUploadRequest: AzureBlobStorageFileUploadRequest
    BlobClientRequest: BlobClientRequest
    CancelUserInvitation_SuccessResult: CancelUserInvitation_SuccessResult
    ClearAnalysisReportEntries_SuccessResult: ClearAnalysisReportEntries_SuccessResult
    ClearAnalysisReportEntryVerificationActionsResult: ClearAnalysisReportEntryVerificationActionsResult
    ClearAnalysisReportEntryVerificationPredicateValues_SuccessResult: ClearAnalysisReportEntryVerificationPredicateValues_SuccessResult
    ClearAnalysisReportProductRisks_SuccessResult: ClearAnalysisReportProductRisks_SuccessResult
    ClearAnalysisReportProducts_SuccessResult: ClearAnalysisReportProducts_SuccessResult
    ClearAnalysisReportRiskConfigurations_SuccessResult: ClearAnalysisReportRiskConfigurations_SuccessResult
    Client: Client
    Comment: Comment
    CommentConnection: CommentConnection
    CommentEdge: CommentEdge
    Company: Company
    CompanyConnection: CompanyConnection
    CompanyEdge: CompanyEdge
    Company_ContactConnection: Company_ContactConnection
    Company_ContactEdge: Company_ContactEdge
    Contact: Contact
    ContactConnection: ContactConnection
    ContactEdge: ContactEdge
    ContactName: ContactName
    ContactNameHonorific: ContactNameHonorific
    ContactNameLast: ContactNameLast
    Country: Country
    CountryEdge: CountryEdge
    CreateAnalysisReport_SuccessResult: CreateAnalysisReport_SuccessResult
    CreateComment_SuccessResult: CreateComment_SuccessResult
    CreateCompany_SuccessResult: CreateCompany_SuccessResult
    CreateContact_SuccessResult: CreateContact_SuccessResult
    CreateMeiliSearch_SuccessResult: CreateMeiliSearch_SuccessResult
    CreateProductCategory_SuccessResult: CreateProductCategory_SuccessResult
    CreateProduct_SuccessResult: CreateProduct_SuccessResult
    CreateQuestionPredicate_SuccessResult: CreateQuestionPredicate_SuccessResult
    CreateRegion_SuccessResult: CreateRegion_SuccessResult
    CreateRiskColumn_SuccessResult: CreateRiskColumn_SuccessResult
    CreateRiskConfiguration_SuccessResult: CreateRiskConfiguration_SuccessResult
    CreateRisk_SuccessResult: CreateRisk_SuccessResult
    CreateSupplierBranch_SuccessResult: CreateSupplierBranch_SuccessResult
    CreateSupplier_SuccessResult: CreateSupplier_SuccessResult
    CreateTag_SuccessResult: CreateTag_SuccessResult
    CreateTeamLicenseClass_SuccessResult: CreateTeamLicenseClass_SuccessResult
    CreateTeamLicense_SuccessResult: CreateTeamLicense_SuccessResult
    CreateTeam_SuccessResult: CreateTeam_SuccessResult
    CreateThreatCategory_SuccessResult: CreateThreatCategory_SuccessResult
    CreateThreat_SuccessResult: CreateThreat_SuccessResult
    CreateUserInvitation_SuccessResult: CreateUserInvitation_SuccessResult
    CreateUser_SuccessResult: CreateUser_SuccessResult
    CreateVerificationAction_SuccessResult: CreateVerificationAction_SuccessResult
    CreateVerificationConfiguration_SuccessResult: CreateVerificationConfiguration_SuccessResult
    CreateVerificationPredicate_SuccessResult: CreateVerificationPredicate_SuccessResult
    DateTimePeriod: DateTimePeriod
    DeactivateMany_SuccessResult: DeactivateMany_SuccessResult
    Deactivate_SuccessResult: Deactivate_SuccessResult
    Delete_SuccessResult: Delete_SuccessResult
    DetachTags_SuccessResult: DetachTags_SuccessResult
    EchoFilesJob: EchoFilesJob
    EchoFiles_FileDescription: EchoFiles_FileDescription
    ExportAnalysisReportEntriesJob: ExportAnalysisReportEntriesJob
    ExportProductsSpreadsheetJob: ExportProductsSpreadsheetJob
    ExportSupplierBranchesSpreadsheetJob: ExportSupplierBranchesSpreadsheetJob
    ExportSupplierVCardsJob: ExportSupplierVCardsJob
    ExportSuppliersSpreadsheetJob: ExportSuppliersSpreadsheetJob
    FailJob_SuccessResult: FailJob_SuccessResult
    File: File
    FileConnection: FileConnection
    FileEdge: FileEdge
    FinishJob_SuccessResult: FinishJob_SuccessResult
    ForceDelete_SuccessResult: ForceDelete_SuccessResult
    GeneralAudit: GeneralAudit
    GenerateAnalysisReportEntriesResult: GenerateAnalysisReportEntriesResult
    GenerateAnalysisReportEntryVerificationActionsResult: GenerateAnalysisReportEntryVerificationActionsResult
    GenerateAnalysisReportProductRisksResult: GenerateAnalysisReportProductRisksResult
    GenerateAnalysisReport_SuccessResult: GenerateAnalysisReport_SuccessResult
    GenerateNeededAnalysisReportEntryVerificationPredicateValuesResult: GenerateNeededAnalysisReportEntryVerificationPredicateValuesResult
    GenerateNeededAnalysisReportProductPredicateValuesResult: GenerateNeededAnalysisReportProductPredicateValuesResult
    GenericFileUploadRequest: GenericFileUploadRequest
    JobConnection: JobConnection
    JobEdge: JobEdge
    MeiliSearchTokenResponse: MeiliSearchTokenResponse
    Message: Message
    Mutation: Mutation
    Name: Name
    Notification: Notification
    NotificationConnection: NotificationConnection
    NotificationEdge: NotificationEdge
    ObjectIdentity: ObjectIdentity
    PageInfo: PageInfo
    PhoneNumber: PhoneNumber
    PhoneNumberFormat: PhoneNumberFormat
    PredicateValueSet: PredicateValueSet
    Product: Product
    ProductCategory: ProductCategory
    ProductCategoryAudit: ProductCategoryAudit
    ProductCategoryAuditConnection: ProductCategoryAuditConnection
    ProductCategoryAuditEdge: ProductCategoryAuditEdge
    ProductCategoryConnection: ProductCategoryConnection
    ProductCategoryEdge: ProductCategoryEdge
    ProductCategory_RiskConnection: ProductCategory_RiskConnection
    ProductCategory_RiskEdge: ProductCategory_RiskEdge
    ProductConnection: ProductConnection
    ProductEdge: ProductEdge
    ProductPredicateExpression: ProductPredicateExpression
    ProductPredicateRequirement: ProductPredicateRequirement
    ProductPredicateRequirementConnection: ProductPredicateRequirementConnection
    ProductPredicateRequirementDemandingContextConnection: ProductPredicateRequirementDemandingContextConnection
    ProductPredicateRequirementDemandingContextEdge: ProductPredicateRequirementDemandingContextEdge
    ProductPredicateRequirementEdge: ProductPredicateRequirementEdge
    Product_PredicateConnection: Product_PredicateConnection
    Product_PredicateEdge: Product_PredicateEdge
    Product_QuestionPredicateConnection: Product_QuestionPredicateConnection
    Product_QuestionPredicateEdge: Product_QuestionPredicateEdge
    Product_RegionConnection: Product_RegionConnection
    Product_RegionEdge: Product_RegionEdge
    Product_RiskConnection: Product_RiskConnection
    Product_RiskEdge: Product_RiskEdge
    ProvideRequiredProductPredicateValuesTodo: ProvideRequiredProductPredicateValuesTodo
    Query: Query
    Query_CompanyConnection: Query_CompanyConnection
    Query_CountryConnection: Query_CountryConnection
    Query_ProductPredicateConnection: Query_ProductPredicateConnection
    Query_ProductPredicateEdge: Query_ProductPredicateEdge
    Query_RegionConnection: Query_RegionConnection
    Query_RiskConfigurationConnection: Query_RiskConfigurationConnection
    Query_SupplierReliabilityConnection: Query_SupplierReliabilityConnection
    Query_TeamConnection: Query_TeamConnection
    Query_VerificationActionConnection: Query_VerificationActionConnection
    Query_VerificationConfigurationConnection: Query_VerificationConfigurationConnection
    QuestionPredicate: QuestionPredicate
    QuestionPredicateConnection: QuestionPredicateConnection
    QuestionPredicateEdge: QuestionPredicateEdge
    RebuildSearchIndexes_SuccessResult: RebuildSearchIndexes_SuccessResult
    Region: Region
    RegionConnection: RegionConnection
    RegionEdge: RegionEdge
    ResolveAnalysisReportProductRiskPredicateValueTodo: ResolveAnalysisReportProductRiskPredicateValueTodo
    Restore_SuccessResult: Restore_SuccessResult
    RetractTeamRole_SuccessResult: RetractTeamRole_SuccessResult
    RetractTeamRoles_SuccessResult: RetractTeamRoles_SuccessResult
    RetractUserRole_SuccessResult: RetractUserRole_SuccessResult
    RetractUserRoles_SuccessResult: RetractUserRoles_SuccessResult
    Risk: Risk
    RiskAudit: RiskAudit
    RiskAuditConnection: RiskAuditConnection
    RiskAuditEdge: RiskAuditEdge
    RiskColumn: RiskColumn
    RiskColumnConnection: RiskColumnConnection
    RiskColumnEdge: RiskColumnEdge
    RiskColumn_RiskConnection: RiskColumn_RiskConnection
    RiskColumn_RiskEdge: RiskColumn_RiskEdge
    RiskConfiguration: RiskConfiguration
    RiskConfigurationConnection: RiskConfigurationConnection
    RiskConfigurationEdge: RiskConfigurationEdge
    RiskConfigurationLevel: RiskConfigurationLevel
    RiskConfigurationLevelConnection: RiskConfigurationLevelConnection
    RiskConfigurationLevelEdge: RiskConfigurationLevelEdge
    RiskConfigurationProbability: RiskConfigurationProbability
    RiskConfigurationProbabilityConnection: RiskConfigurationProbabilityConnection
    RiskConfigurationProbabilityEdge: RiskConfigurationProbabilityEdge
    RiskConfigurationSegmentConnection: RiskConfigurationSegmentConnection
    RiskConfigurationSegmentEdge: RiskConfigurationSegmentEdge
    RiskConfigurationSeverity: RiskConfigurationSeverity
    RiskConfigurationSeverityConnection: RiskConfigurationSeverityConnection
    RiskConfigurationSeverityEdge: RiskConfigurationSeverityEdge
    RiskConfiguration_RiskConnection: RiskConfiguration_RiskConnection
    RiskConfiguration_RiskEdge: RiskConfiguration_RiskEdge
    RiskConfiguration_ThreatConnection: RiskConfiguration_ThreatConnection
    RiskConfiguration_ThreatEdge: RiskConfiguration_ThreatEdge
    RiskConnection: RiskConnection
    RiskEdge: RiskEdge
    RiskLevel: RiskLevel
    RiskProbability: RiskProbability
    RiskProbabilityAudit: RiskProbabilityAudit
    RiskProbabilityAuditConnection: RiskProbabilityAuditConnection
    RiskProbabilityAuditEdge: RiskProbabilityAuditEdge
    RiskSeverity: RiskSeverity
    Risk_ProductCategoryConnection: Risk_ProductCategoryConnection
    Risk_ProductCategoryEdge: Risk_ProductCategoryEdge
    Risk_RiskColumnConnection: Risk_RiskColumnConnection
    Risk_RiskColumnEdge: Risk_RiskColumnEdge
    Risk_RiskConfigurationConnection: Risk_RiskConfigurationConnection
    Risk_RiskConfigurationEdge: Risk_RiskConfigurationEdge
    SelectAnalysisReportProductsTodo: SelectAnalysisReportProductsTodo
    SendNotification_SuccessResult: SendNotification_SuccessResult
    SendUserInvitation_SuccessResult: SendUserInvitation_SuccessResult
    SetRiskProbabilityValueForRiskConfigurationTodo: SetRiskProbabilityValueForRiskConfigurationTodo
    SetThreatSeverityValueForRiskConfigurationTodo: SetThreatSeverityValueForRiskConfigurationTodo
    SignInActivity: SignInActivity
    StartJob_SuccessResult: StartJob_SuccessResult
    Subscription: Subscription
    Supplier: Supplier
    SupplierBranch: SupplierBranch
    SupplierBranchConnection: SupplierBranchConnection
    SupplierBranchEdge: SupplierBranchEdge
    SupplierConnection: SupplierConnection
    SupplierEdge: SupplierEdge
    SupplierReliability: SupplierReliability
    SupplierReliabilityConnection: SupplierReliabilityConnection
    SupplierReliabilityEdge: SupplierReliabilityEdge
    Tag: Tag
    TagConnection: TagConnection
    TagEdge: TagEdge
    Team: Team
    TeamConnection: TeamConnection
    TeamEdge: TeamEdge
    TeamLicense: TeamLicense
    TeamLicenseClass: TeamLicenseClass
    TeamLicenseClassConnection: TeamLicenseClassConnection
    TeamLicenseClassEdge: TeamLicenseClassEdge
    TeamLicenseConnection: TeamLicenseConnection
    TeamLicenseEdge: TeamLicenseEdge
    Team_ProductConnection: Team_ProductConnection
    Team_ProductEdge: Team_ProductEdge
    Team_RiskConfigurationConnection: Team_RiskConfigurationConnection
    Team_RiskConfigurationEdge: Team_RiskConfigurationEdge
    Team_SupplierConnection: Team_SupplierConnection
    Team_SupplierEdge: Team_SupplierEdge
    Team_UserConnection: Team_UserConnection
    Team_UserEdge: Team_UserEdge
    Team_UserInvitationConnection: Team_UserInvitationConnection
    Team_UserInvitationEdge: Team_UserInvitationEdge
    Team_VerificationConfigurationConnection: Team_VerificationConfigurationConnection
    Team_VerificationConfigurationEdge: Team_VerificationConfigurationEdge
    Threat: Threat
    ThreatAudit: ThreatAudit
    ThreatAuditConnection: ThreatAuditConnection
    ThreatAuditEdge: ThreatAuditEdge
    ThreatCategory: ThreatCategory
    ThreatCategoryAudit: ThreatCategoryAudit
    ThreatCategoryAuditConnection: ThreatCategoryAuditConnection
    ThreatCategoryAuditEdge: ThreatCategoryAuditEdge
    ThreatCategoryConnection: ThreatCategoryConnection
    ThreatCategoryEdge: ThreatCategoryEdge
    ThreatConnection: ThreatConnection
    ThreatEdge: ThreatEdge
    ThreatSeverityAudit: ThreatSeverityAudit
    ThreatSeverityAuditConnection: ThreatSeverityAuditConnection
    ThreatSeverityAuditEdge: ThreatSeverityAuditEdge
    Threat_RiskConfigurationConnection: Threat_RiskConfigurationConnection
    Threat_RiskConfigurationEdge: Threat_RiskConfigurationEdge
    UpdateAnalysisReportEntry_SuccessResult: UpdateAnalysisReportEntry_SuccessResult
    UpdateAnalysisReportProductRisk_SuccessResult: UpdateAnalysisReportProductRisk_SuccessResult
    UpdateAnalysisReportProductRisks_SuccessResult: UpdateAnalysisReportProductRisks_SuccessResult
    UpdateAnalysisReport_SuccessResult: UpdateAnalysisReport_SuccessResult
    UpdateAudit_SuccessResult: UpdateAudit_SuccessResult
    UpdateAudits_SuccessResult: UpdateAudits_SuccessResult
    UpdateComment_SuccessResult: UpdateComment_SuccessResult
    UpdateComments_SuccessResult: UpdateComments_SuccessResult
    UpdateCompanies_SuccessResult: UpdateCompanies_SuccessResult
    UpdateCompany_SuccessResult: UpdateCompany_SuccessResult
    UpdateContact_SuccessResult: UpdateContact_SuccessResult
    UpdateContacts_SuccessResult: UpdateContacts_SuccessResult
    UpdateProductCategory_SuccessResult: UpdateProductCategory_SuccessResult
    UpdateProduct_SuccessResult: UpdateProduct_SuccessResult
    UpdateProducts_SuccessResult: UpdateProducts_SuccessResult
    UpdateQuestionPredicate_SuccessResult: UpdateQuestionPredicate_SuccessResult
    UpdateRegion_SuccessResult: UpdateRegion_SuccessResult
    UpdateRiskColumn_SuccessResult: UpdateRiskColumn_SuccessResult
    UpdateRiskConfiguration_SuccessResult: UpdateRiskConfiguration_SuccessResult
    UpdateRisk_SuccessResult: UpdateRisk_SuccessResult
    UpdateRisks_SuccessResult: UpdateRisks_SuccessResult
    UpdateSupplierBranch_SuccessResult: UpdateSupplierBranch_SuccessResult
    UpdateSupplierBranches_SuccessResult: UpdateSupplierBranches_SuccessResult
    UpdateSupplier_SuccessResult: UpdateSupplier_SuccessResult
    UpdateSuppliers_SuccessResult: UpdateSuppliers_SuccessResult
    UpdateTag_SuccessResult: UpdateTag_SuccessResult
    UpdateTeamLicenseClass_SuccessResult: UpdateTeamLicenseClass_SuccessResult
    UpdateTeamLicense_SuccessResult: UpdateTeamLicense_SuccessResult
    UpdateTeam_SuccessResult: UpdateTeam_SuccessResult
    UpdateTeams_SuccessResult: UpdateTeams_SuccessResult
    UpdateThreatCategory_SuccessResult: UpdateThreatCategory_SuccessResult
    UpdateThreat_SuccessResult: UpdateThreat_SuccessResult
    UpdateThreats_SuccessResult: UpdateThreats_SuccessResult
    UpdateUserInvitation_SuccessResult: UpdateUserInvitation_SuccessResult
    UpdateUser_SuccessResult: UpdateUser_SuccessResult
    UpdateUsers_SuccessResult: UpdateUsers_SuccessResult
    UpdateVerificationAction_SuccessResult: UpdateVerificationAction_SuccessResult
    UpdateVerificationConfigurationRule_SuccessResult: UpdateVerificationConfigurationRule_SuccessResult
    UpdateVerificationConfiguration_SuccessResult: UpdateVerificationConfiguration_SuccessResult
    UpdateVerificationPredicate_SuccessResult: UpdateVerificationPredicate_SuccessResult
    UploadFile_SuccessResult: UploadFile_SuccessResult
    User: User
    UserConnection: UserConnection
    UserEdge: UserEdge
    UserInvitation: UserInvitation
    UserInvitationConnection: UserInvitationConnection
    UserInvitationEdge: UserInvitationEdge
    UserInvitation_TeamConnection: UserInvitation_TeamConnection
    UserInvitation_TeamEdge: UserInvitation_TeamEdge
    UserName: UserName
    User_TeamConnection: User_TeamConnection
    User_TeamEdge: User_TeamEdge
    VerificationAction: VerificationAction
    VerificationActionConnection: VerificationActionConnection
    VerificationActionEdge: VerificationActionEdge
    VerificationConfiguration: VerificationConfiguration
    VerificationConfigurationConnection: VerificationConfigurationConnection
    VerificationConfigurationEdge: VerificationConfigurationEdge
    VerificationConfigurationRule: VerificationConfigurationRule
    VerificationConfigurationRuleConnection: VerificationConfigurationRuleConnection
    VerificationConfigurationRuleEdge: VerificationConfigurationRuleEdge
    VerificationConfigurationRule_VerificationActionConnection: VerificationConfigurationRule_VerificationActionConnection
    VerificationConfigurationRule_VerificationActionEdge: VerificationConfigurationRule_VerificationActionEdge
    VerificationConfiguration_VerificationActionConnection: VerificationConfiguration_VerificationActionConnection
    VerificationConfiguration_VerificationActionEdge: VerificationConfiguration_VerificationActionEdge
    VerificationPredicate: VerificationPredicate
    VerificationPredicateConnection: VerificationPredicateConnection
    VerificationPredicateEdge: VerificationPredicateEdge
    VerifyAnalysisReportEntriesHaveNeededVerificationPredicateValuesResult: VerifyAnalysisReportEntriesHaveNeededVerificationPredicateValuesResult
    VerifyAnalysisReportProductRiskValuesResult: VerifyAnalysisReportProductRiskValuesResult
    VerifyAnalysisReportProductsBelongToProductCategoriesResult: VerifyAnalysisReportProductsBelongToProductCategoriesResult
    VerifyAnalysisReportProductsHaveNeededPredicateValuesResult: VerifyAnalysisReportProductsHaveNeededPredicateValuesResult
    VerifyAnalysisReportProductsHaveSupplierBranchesResult: VerifyAnalysisReportProductsHaveSupplierBranchesResult
}


export interface InterfaceTypes {
    Activateable: Activateable
    AnalysisEntry: AnalysisEntry
    AnalysisEntryPredicate: AnalysisEntryPredicate
    AnalysisReportEntryRiskValue: AnalysisReportEntryRiskValue
    AnalysisReportEntryRiskValueOverwriteEvent: AnalysisReportEntryRiskValueOverwriteEvent
    Audit: Audit
    Commentable: Commentable
    Connection: Connection
    ConnectionWithTotal: ConnectionWithTotal
    Edge: Edge
    EntityName: EntityName
    Exception: Exception
    FileUploadRequest: FileUploadRequest
    HasFiles: HasFiles
    Hashed: Hashed
    Job: Job
    MutationPayload: MutationPayload
    Named: Named
    NestedSetConnection: NestedSetConnection
    NestedSetEdge: NestedSetEdge
    NestedSetNode: NestedSetNode
    Node: Node
    Notifiable: Notifiable
    Ownable: Ownable
    Owner: Owner
    PersonName: PersonName
    PersonNameHonorific: PersonNameHonorific
    PersonNameLast: PersonNameLast
    Predicate: Predicate
    PredicateExpression: PredicateExpression
    PredicateProductConnection: PredicateProductConnection
    PredicateProductEdge: PredicateProductEdge
    PredicateRequirement: PredicateRequirement
    PredicateRiskConnection: PredicateRiskConnection
    PredicateRiskEdge: PredicateRiskEdge
    ProductPredicate: ProductPredicate
    ProductPredicateConnection: ProductPredicateConnection
    ProductPredicateEdge: ProductPredicateEdge
    RiskConfigurationSegment: RiskConfigurationSegment
    RiskValue: RiskValue
    Selectable: Selectable
    Sluggable: Sluggable
    SoftDelete: SoftDelete
    SoftDeleteUserstamped: SoftDeleteUserstamped
    Taggable: Taggable
    Timestamped: Timestamped
    Todo: Todo
    Usable: Usable
    Userstamped: Userstamped
    Warning: Warning
}


export interface InputTypes {
    AddressInput: AddressInput
    AnalysisReportEntryOrderByClause: AnalysisReportEntryOrderByClause
    AnalysisReportEntryProbabilityOverwriteEventOrderByClause: AnalysisReportEntryProbabilityOverwriteEventOrderByClause
    AnalysisReportEntryProbabilityOverwriteEventWhereClause: AnalysisReportEntryProbabilityOverwriteEventWhereClause
    AnalysisReportEntryRiskValueInput: AnalysisReportEntryRiskValueInput
    AnalysisReportEntrySelectionInput: AnalysisReportEntrySelectionInput
    AnalysisReportEntrySeverityOverwriteEventOrderByClause: AnalysisReportEntrySeverityOverwriteEventOrderByClause
    AnalysisReportEntrySeverityOverwriteEventWhereClause: AnalysisReportEntrySeverityOverwriteEventWhereClause
    AnalysisReportEntryWhereClause: AnalysisReportEntryWhereClause
    AnalysisReportOrderByClause: AnalysisReportOrderByClause
    AnalysisReportProductRiskOrderByClause: AnalysisReportProductRiskOrderByClause
    AnalysisReportProductRiskWhereClause: AnalysisReportProductRiskWhereClause
    AnalysisReportWhereClause: AnalysisReportWhereClause
    AssignTeamRoleInput: AssignTeamRoleInput
    AssignTeamRolesInput: AssignTeamRolesInput
    AssignUserRoleInput: AssignUserRoleInput
    AssignUserRolesInput: AssignUserRolesInput
    AttachCommentsInput: AttachCommentsInput
    AttachCommentsInputAttach: AttachCommentsInputAttach
    AttachProductCategoriesInput: AttachProductCategoriesInput
    AttachProductsInput: AttachProductsInput
    AttachRegionsInput: AttachRegionsInput
    AttachRiskValueInput: AttachRiskValueInput
    AttachRiskValuesInput: AttachRiskValuesInput
    AttachSupplierBranchesInput: AttachSupplierBranchesInput
    AttachTagsInput: AttachTagsInput
    AuditMessageInput: AuditMessageInput
    AuditOrderByClause: AuditOrderByClause
    AuditWhereClause: AuditWhereClause
    CancelUserInvitationInput: CancelUserInvitationInput
    CommentOrderByClause: CommentOrderByClause
    CommentWhereClause: CommentWhereClause
    CompanyOrderByClause: CompanyOrderByClause
    CompanyWhereClause: CompanyWhereClause
    ConnectCommentsInput: ConnectCommentsInput
    ConnectCompanyInput: ConnectCompanyInput
    ConnectContactInput: ConnectContactInput
    ConnectContactInputWithUpsert: ConnectContactInputWithUpsert
    ConnectProductCategoriesInput: ConnectProductCategoriesInput
    ConnectProductCategoryInput: ConnectProductCategoryInput
    ConnectProductInput: ConnectProductInput
    ConnectProductsInput: ConnectProductsInput
    ConnectRegionInput: ConnectRegionInput
    ConnectRegionsInput: ConnectRegionsInput
    ConnectRiskColumnInput: ConnectRiskColumnInput
    ConnectRiskConfigurationInput: ConnectRiskConfigurationInput
    ConnectRiskConfigurationsInput: ConnectRiskConfigurationsInput
    ConnectRiskInput: ConnectRiskInput
    ConnectRiskValuesInput: ConnectRiskValuesInput
    ConnectRisksInput: ConnectRisksInput
    ConnectSupplierBranchInput: ConnectSupplierBranchInput
    ConnectSupplierBranchesInput: ConnectSupplierBranchesInput
    ConnectSupplierInput: ConnectSupplierInput
    ConnectSupplierReliabilityInput: ConnectSupplierReliabilityInput
    ConnectTeamInput: ConnectTeamInput
    ConnectThreatCategoryInput: ConnectThreatCategoryInput
    ConnectThreatInput: ConnectThreatInput
    ConnectUserInput: ConnectUserInput
    ConnectVerificationAction: ConnectVerificationAction
    ConnectVerificationConfigurationInput: ConnectVerificationConfigurationInput
    ConnectVerificationConfigurationsInput: ConnectVerificationConfigurationsInput
    ContactNameHonorificInput: ContactNameHonorificInput
    ContactNameInput: ContactNameInput
    ContactNameLastInput: ContactNameLastInput
    ContactOrderByClause: ContactOrderByClause
    ContactWhereClause: ContactWhereClause
    CountryWhereClause: CountryWhereClause
    CreateAnalysisReportInput: CreateAnalysisReportInput
    CreateCommentInput: CreateCommentInput
    CreateCompanyInput: CreateCompanyInput
    CreateCompanyInputContacts: CreateCompanyInputContacts
    CreateCompanyInputContactsAttach: CreateCompanyInputContactsAttach
    CreateContactInput: CreateContactInput
    CreateProductCategoryInput: CreateProductCategoryInput
    CreateProductInput: CreateProductInput
    CreateQuestionPredicateInput: CreateQuestionPredicateInput
    CreateRegionInput: CreateRegionInput
    CreateRiskColumnInput: CreateRiskColumnInput
    CreateRiskConfigurationInput: CreateRiskConfigurationInput
    CreateRiskConfigurationTeamInput: CreateRiskConfigurationTeamInput
    CreateRiskInput: CreateRiskInput
    CreateSupplierBranchInput: CreateSupplierBranchInput
    CreateSupplierInput: CreateSupplierInput
    CreateSupplierInputBranches: CreateSupplierInputBranches
    CreateSupplierInputBranchesAttach: CreateSupplierInputBranchesAttach
    CreateTagInput: CreateTagInput
    CreateTeamInput: CreateTeamInput
    CreateTeamLicenseClassInput: CreateTeamLicenseClassInput
    CreateTeamLicenseInput: CreateTeamLicenseInput
    CreateTeamLicenseInput_Class: CreateTeamLicenseInput_Class
    CreateTeam_AnalysisReportsInput: CreateTeam_AnalysisReportsInput
    CreateTeam_ProductsInput: CreateTeam_ProductsInput
    CreateTeam_SuppliersInput: CreateTeam_SuppliersInput
    CreateThreatCategoryInput: CreateThreatCategoryInput
    CreateThreatInput: CreateThreatInput
    CreateUserInput: CreateUserInput
    CreateUserInvitationInput: CreateUserInvitationInput
    CreateVerificationActionInput: CreateVerificationActionInput
    CreateVerificationConfigurationInput: CreateVerificationConfigurationInput
    CreateVerificationConfigurationInput_Action: CreateVerificationConfigurationInput_Action
    CreateVerificationPredicateInput: CreateVerificationPredicateInput
    DateTimeConstraints: DateTimeConstraints
    DateTimeEventConstraints: DateTimeEventConstraints
    DetachTagsInput: DetachTagsInput
    EchoFilesOptions: EchoFilesOptions
    EchoFilesOptions_FileDescription: EchoFilesOptions_FileDescription
    ExportAnalysisReportEntriesOptions: ExportAnalysisReportEntriesOptions
    ExportProductsSpreadsheetOptions: ExportProductsSpreadsheetOptions
    ExportProductsSpreadsheetOptions_ProductSelection: ExportProductsSpreadsheetOptions_ProductSelection
    ExportSupplierBranchesSpreadsheetOptions: ExportSupplierBranchesSpreadsheetOptions
    ExportSupplierVCardsOptions: ExportSupplierVCardsOptions
    ExportSuppliersBranchesSpreadsheetOptions_SupplierBranchSelection: ExportSuppliersBranchesSpreadsheetOptions_SupplierBranchSelection
    ExportSuppliersSpreadsheetOptions: ExportSuppliersSpreadsheetOptions
    ExportSuppliersSpreadsheetOptions_SupplierSelection: ExportSuppliersSpreadsheetOptions_SupplierSelection
    FailJobInput: FailJobInput
    FinishJobInput: FinishJobInput
    FloatLinearBoundsInput: FloatLinearBoundsInput
    FloatLinearOrderConstraints: FloatLinearOrderConstraints
    GenerateAnalysisReportEntriesInput: GenerateAnalysisReportEntriesInput
    GenerateAnalysisReportEntryVerificationActionsInput: GenerateAnalysisReportEntryVerificationActionsInput
    GenerateAnalysisReportInput: GenerateAnalysisReportInput
    GenerateAnalysisReportProductRisksInput: GenerateAnalysisReportProductRisksInput
    GenerateNeededAnalysisReportEntryVerificationPredicateValuesInput: GenerateNeededAnalysisReportEntryVerificationPredicateValuesInput
    GenerateNeededAnalysisReportProductPredicateValuesInput: GenerateNeededAnalysisReportProductPredicateValuesInput
    HTMLTag: HtmlTag
    HTMLTagAttribute: HtmlTagAttribute
    InsertVerificationConfigurationRuleInput: InsertVerificationConfigurationRuleInput
    IntLinearOrderConstraints: IntLinearOrderConstraints
    JobOrderByClause: JobOrderByClause
    JobWhereClause: JobWhereClause
    MakeFileUploadRequestInput: MakeFileUploadRequestInput
    ManageAnalysisReportEntriesInput: ManageAnalysisReportEntriesInput
    ManageAnalysisReportEntriesInput_Delete: ManageAnalysisReportEntriesInput_Delete
    ManageAnalysisReportEntriesInput_Update: ManageAnalysisReportEntriesInput_Update
    ManageAnalysisReportEntriesInput_Update_Values: ManageAnalysisReportEntriesInput_Update_Values
    ManageAnalysisReportEntriesInput_Upsert: ManageAnalysisReportEntriesInput_Upsert
    ManageAnalysisReportEntryPredicateValuesInput: ManageAnalysisReportEntryPredicateValuesInput
    ManageContactAccountsInput: ManageContactAccountsInput
    ManageProductPredicateValuesInput: ManageProductPredicateValuesInput
    ManageTagsInput: ManageTagsInput
    NameInput: NameInput
    NameInputOptional: NameInputOptional
    NotificationOrderByClause: NotificationOrderByClause
    NotificationWhereClause: NotificationWhereClause
    OrderByClause: OrderByClause
    PredicateExpressionTermSubstitution: PredicateExpressionTermSubstitution
    ProductCategoryAuditOrderByClause: ProductCategoryAuditOrderByClause
    ProductCategoryAuditWhereClause: ProductCategoryAuditWhereClause
    ProductCategoryOrderByClause: ProductCategoryOrderByClause
    ProductCategoryWhereClause: ProductCategoryWhereClause
    ProductOrderByClause: ProductOrderByClause
    ProductWhereClause: ProductWhereClause
    Product_PredicateWhereClause: Product_PredicateWhereClause
    Product_QuestionPredicateWhereClause: Product_QuestionPredicateWhereClause
    Product_RegionWhereClause: Product_RegionWhereClause
    Query_ProductPredicates_SearchInput: Query_ProductPredicates_SearchInput
    QuestionPredicateOrderByClause: QuestionPredicateOrderByClause
    QuestionPredicateWhereClause: QuestionPredicateWhereClause
    RebuildSearchIndexesInput: RebuildSearchIndexesInput
    RegionOrderByClause: RegionOrderByClause
    RegionWhereClause: RegionWhereClause
    RetractAllTeamRolesInput: RetractAllTeamRolesInput
    RetractAllUserRolesInput: RetractAllUserRolesInput
    RetractTeamRoleInput: RetractTeamRoleInput
    RetractTeamRolesInput: RetractTeamRolesInput
    RetractUserRoleInput: RetractUserRoleInput
    RetractUserRolesInput: RetractUserRolesInput
    RiskAuditOrderByClause: RiskAuditOrderByClause
    RiskAuditWhereClause: RiskAuditWhereClause
    RiskColumnOrderByClause: RiskColumnOrderByClause
    RiskColumnValueInput: RiskColumnValueInput
    RiskColumnWhereClause: RiskColumnWhereClause
    RiskConfigurationLevelOrderByClause: RiskConfigurationLevelOrderByClause
    RiskConfigurationLevelWhereClause: RiskConfigurationLevelWhereClause
    RiskConfigurationOrderByClause: RiskConfigurationOrderByClause
    RiskConfigurationProbabilityOrderByClause: RiskConfigurationProbabilityOrderByClause
    RiskConfigurationProbabilityWhereClause: RiskConfigurationProbabilityWhereClause
    RiskConfigurationSeverityOrderByClause: RiskConfigurationSeverityOrderByClause
    RiskConfigurationSeverityWhereClause: RiskConfigurationSeverityWhereClause
    RiskConfigurationWhereClause: RiskConfigurationWhereClause
    RiskOrderByClause: RiskOrderByClause
    RiskProbabilityAuditOrderByClause: RiskProbabilityAuditOrderByClause
    RiskProbabilityAuditWhereClause: RiskProbabilityAuditWhereClause
    RiskWhereClause: RiskWhereClause
    Risk_ProductCategoryWhereClause: Risk_ProductCategoryWhereClause
    SelectProductsInput: SelectProductsInput
    SendNotificationInput: SendNotificationInput
    SendUserInvitationInput: SendUserInvitationInput
    SetRiskConfigurationLevelInput: SetRiskConfigurationLevelInput
    SetRiskConfigurationProbabilityInput: SetRiskConfigurationProbabilityInput
    SetRiskConfigurationSeverityInput: SetRiskConfigurationSeverityInput
    StampConstraints: StampConstraints
    StampedEventConstraints: StampedEventConstraints
    StartJobInput: StartJobInput
    SupplierBranchOrderByClause: SupplierBranchOrderByClause
    SupplierBranchWhereClause: SupplierBranchWhereClause
    SupplierOrderByClause: SupplierOrderByClause
    SupplierWhereClause: SupplierWhereClause
    SyncUserTeamRolesInput: SyncUserTeamRolesInput
    TagOrderByClause: TagOrderByClause
    TagWhereClause: TagWhereClause
    TeamLicenseClassOrderByClause: TeamLicenseClassOrderByClause
    TeamLicenseClassWhereClause: TeamLicenseClassWhereClause
    TeamLicenseOrderByClause: TeamLicenseOrderByClause
    TeamLicenseWhereClause: TeamLicenseWhereClause
    TeamOrderByClause: TeamOrderByClause
    TeamWhereClause: TeamWhereClause
    Team_UserWhereClause: Team_UserWhereClause
    ThreatAuditOrderByClause: ThreatAuditOrderByClause
    ThreatAuditWhereClause: ThreatAuditWhereClause
    ThreatCategoryAuditOrderByClause: ThreatCategoryAuditOrderByClause
    ThreatCategoryAuditWhereClause: ThreatCategoryAuditWhereClause
    ThreatCategoryOrderByClause: ThreatCategoryOrderByClause
    ThreatCategoryWhereClause: ThreatCategoryWhereClause
    ThreatOrderByClause: ThreatOrderByClause
    ThreatSeverityAuditOrderByClause: ThreatSeverityAuditOrderByClause
    ThreatSeverityAuditWhereClause: ThreatSeverityAuditWhereClause
    ThreatWhereClause: ThreatWhereClause
    UpdateAnalysisReportEntryInput: UpdateAnalysisReportEntryInput
    UpdateAnalysisReportInput: UpdateAnalysisReportInput
    UpdateAnalysisReportProductRiskInput: UpdateAnalysisReportProductRiskInput
    UpdateAnalysisReportProductRisksInput: UpdateAnalysisReportProductRisksInput
    UpdateAuditInput: UpdateAuditInput
    UpdateAuditsInput: UpdateAuditsInput
    UpdateCommentInput: UpdateCommentInput
    UpdateCommentsInput: UpdateCommentsInput
    UpdateCompaniesInput: UpdateCompaniesInput
    UpdateCompanyInput: UpdateCompanyInput
    UpdateContactInput: UpdateContactInput
    UpdateContactsInput: UpdateContactsInput
    UpdateProductCategoryInput: UpdateProductCategoryInput
    UpdateProductInput: UpdateProductInput
    UpdateProductsInput: UpdateProductsInput
    UpdateQuestionPredicateInput: UpdateQuestionPredicateInput
    UpdateRegionInput: UpdateRegionInput
    UpdateRiskColumnInput: UpdateRiskColumnInput
    UpdateRiskConfigurationInput: UpdateRiskConfigurationInput
    UpdateRiskConfigurationInput_Levels: UpdateRiskConfigurationInput_Levels
    UpdateRiskConfigurationInput_Probabilities: UpdateRiskConfigurationInput_Probabilities
    UpdateRiskConfigurationInput_Severities: UpdateRiskConfigurationInput_Severities
    UpdateRiskConfigurationLevelInput: UpdateRiskConfigurationLevelInput
    UpdateRiskConfigurationProbabilityInput: UpdateRiskConfigurationProbabilityInput
    UpdateRiskConfigurationSeverityInput: UpdateRiskConfigurationSeverityInput
    UpdateRiskInput: UpdateRiskInput
    UpdateRiskInput_RiskColumnValues: UpdateRiskInput_RiskColumnValues
    UpdateRiskValueInput: UpdateRiskValueInput
    UpdateRisksInput: UpdateRisksInput
    UpdateSupplierBranchInput: UpdateSupplierBranchInput
    UpdateSupplierBranchesInput: UpdateSupplierBranchesInput
    UpdateSupplierInput: UpdateSupplierInput
    UpdateSuppliersInput: UpdateSuppliersInput
    UpdateTagInput: UpdateTagInput
    UpdateTeamInput: UpdateTeamInput
    UpdateTeamLicenseClassInput: UpdateTeamLicenseClassInput
    UpdateTeamLicenseInput: UpdateTeamLicenseInput
    UpdateTeam_DeleteProductInput: UpdateTeam_DeleteProductInput
    UpdateTeam_DeleteSupplierInput: UpdateTeam_DeleteSupplierInput
    UpdateTeam_ProductInput: UpdateTeam_ProductInput
    UpdateTeam_ProductsInput: UpdateTeam_ProductsInput
    UpdateTeam_SupplierInput: UpdateTeam_SupplierInput
    UpdateTeam_SuppliersInput: UpdateTeam_SuppliersInput
    UpdateTeamsInput: UpdateTeamsInput
    UpdateThreatCategoryInput: UpdateThreatCategoryInput
    UpdateThreatInput: UpdateThreatInput
    UpdateThreatsInput: UpdateThreatsInput
    UpdateUserInput: UpdateUserInput
    UpdateUserInput_UserRole: UpdateUserInput_UserRole
    UpdateUserInvitationInput: UpdateUserInvitationInput
    UpdateUserInvitationInput_Teams: UpdateUserInvitationInput_Teams
    UpdateUsersInput: UpdateUsersInput
    UpdateVerificationActionInput: UpdateVerificationActionInput
    UpdateVerificationConfigurationInput: UpdateVerificationConfigurationInput
    UpdateVerificationConfigurationInput_Action: UpdateVerificationConfigurationInput_Action
    UpdateVerificationConfigurationInput_Action_Sync: UpdateVerificationConfigurationInput_Action_Sync
    UpdateVerificationConfigurationInput_Action_Upsert: UpdateVerificationConfigurationInput_Action_Upsert
    UpdateVerificationConfigurationInput_Rules: UpdateVerificationConfigurationInput_Rules
    UpdateVerificationConfigurationRuleInput: UpdateVerificationConfigurationRuleInput
    UpdateVerificationConfigurationRuleInput_Actions: UpdateVerificationConfigurationRuleInput_Actions
    UpdateVerificationPredicateInput: UpdateVerificationPredicateInput
    UpsertAnalysisReportEntryPredicateValueInput: UpsertAnalysisReportEntryPredicateValueInput
    UpsertContactInput: UpsertContactInput
    UpsertProductPredicateValueInput: UpsertProductPredicateValueInput
    UpsertVerificationConfigurationRuleAction: UpsertVerificationConfigurationRuleAction
    UserInvitationOrderByClause: UserInvitationOrderByClause
    UserInvitationTeamInput: UserInvitationTeamInput
    UserInvitationWhereClause: UserInvitationWhereClause
    UserOrderByClause: UserOrderByClause
    VerificationActionOrderByClause: VerificationActionOrderByClause
    VerificationActionWhereClause: VerificationActionWhereClause
    VerificationConfigurationOrderByClause: VerificationConfigurationOrderByClause
    VerificationConfigurationRuleOrderByClause: VerificationConfigurationRuleOrderByClause
    VerificationConfigurationRuleWhereClause: VerificationConfigurationRuleWhereClause
    VerificationConfigurationWhereClause: VerificationConfigurationWhereClause
    VerificationPredicateOrderByClause: VerificationPredicateOrderByClause
    VerificationPredicateWhereClause: VerificationPredicateWhereClause
    WhereProductClause: WhereProductClause
    WhereRiskClause: WhereRiskClause
}
